var Gl = Object.defineProperty;
var $l = (M, t, e) => t in M ? Gl(M, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : M[t] = e;
var o = (M, t, e) => $l(M, typeof t != "symbol" ? t + "" : t, e);
import { makeObservable as c0, override as Vl, action as I, observable as r, runInAction as i0, computed as Y, reaction as pO } from "mobx";
import Kl from "axios";
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var W3;
function R() {
  return W3.apply(null, arguments);
}
function Ql(M) {
  W3 = M;
}
function x2(M) {
  return M instanceof Array || Object.prototype.toString.call(M) === "[object Array]";
}
function At(M) {
  return M != null && Object.prototype.toString.call(M) === "[object Object]";
}
function U0(M, t) {
  return Object.prototype.hasOwnProperty.call(M, t);
}
function Rc(M) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(M).length === 0;
  var t;
  for (t in M)
    if (U0(M, t))
      return !1;
  return !0;
}
function b2(M) {
  return M === void 0;
}
function Re(M) {
  return typeof M == "number" || Object.prototype.toString.call(M) === "[object Number]";
}
function cb(M) {
  return M instanceof Date || Object.prototype.toString.call(M) === "[object Date]";
}
function h3(M, t) {
  var e = [], p, c = M.length;
  for (p = 0; p < c; ++p)
    e.push(t(M[p], p));
  return e;
}
function Ye(M, t) {
  for (var e in t)
    U0(t, e) && (M[e] = t[e]);
  return U0(t, "toString") && (M.toString = t.toString), U0(t, "valueOf") && (M.valueOf = t.valueOf), M;
}
function te(M, t, e, p) {
  return J3(M, t, e, p, !0).utc();
}
function Zl() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function B0(M) {
  return M._pf == null && (M._pf = Zl()), M._pf;
}
var ac;
Array.prototype.some ? ac = Array.prototype.some : ac = function(M) {
  var t = Object(this), e = t.length >>> 0, p;
  for (p = 0; p < e; p++)
    if (p in t && M.call(this, t[p], p, t))
      return !0;
  return !1;
};
function Lc(M) {
  var t = null, e = !1, p = M._d && !isNaN(M._d.getTime());
  if (p && (t = B0(M), e = ac.call(t.parsedDateParts, function(c) {
    return c != null;
  }), p = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && e), M._strict && (p = p && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(M))
    M._isValid = p;
  else
    return p;
  return M._isValid;
}
function Bp(M) {
  var t = te(NaN);
  return M != null ? Ye(B0(t), M) : B0(t).userInvalidated = !0, t;
}
var zO = R.momentProperties = [], ao = !1;
function gc(M, t) {
  var e, p, c, i = zO.length;
  if (b2(t._isAMomentObject) || (M._isAMomentObject = t._isAMomentObject), b2(t._i) || (M._i = t._i), b2(t._f) || (M._f = t._f), b2(t._l) || (M._l = t._l), b2(t._strict) || (M._strict = t._strict), b2(t._tzm) || (M._tzm = t._tzm), b2(t._isUTC) || (M._isUTC = t._isUTC), b2(t._offset) || (M._offset = t._offset), b2(t._pf) || (M._pf = B0(t)), b2(t._locale) || (M._locale = t._locale), i > 0)
    for (e = 0; e < i; e++)
      p = zO[e], c = t[p], b2(c) || (M[p] = c);
  return M;
}
function nb(M) {
  gc(this, M), this._d = new Date(M._d != null ? M._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), ao === !1 && (ao = !0, R.updateOffset(this), ao = !1);
}
function F2(M) {
  return M instanceof nb || M != null && M._isAMomentObject != null;
}
function m3(M) {
  R.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + M);
}
function T2(M, t) {
  var e = !0;
  return Ye(function() {
    if (R.deprecationHandler != null && R.deprecationHandler(null, M), e) {
      var p = [], c, i, s, u = arguments.length;
      for (i = 0; i < u; i++) {
        if (c = "", typeof arguments[i] == "object") {
          c += `
[` + i + "] ";
          for (s in arguments[0])
            U0(arguments[0], s) && (c += s + ": " + arguments[0][s] + ", ");
          c = c.slice(0, -2);
        } else
          c = arguments[i];
        p.push(c);
      }
      m3(
        M + `
Arguments: ` + Array.prototype.slice.call(p).join("") + `
` + new Error().stack
      ), e = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var oO = {};
function R3(M, t) {
  R.deprecationHandler != null && R.deprecationHandler(M, t), oO[M] || (m3(t), oO[M] = !0);
}
R.suppressDeprecationWarnings = !1;
R.deprecationHandler = null;
function Me(M) {
  return typeof Function < "u" && M instanceof Function || Object.prototype.toString.call(M) === "[object Function]";
}
function jl(M) {
  var t, e;
  for (e in M)
    U0(M, e) && (t = M[e], Me(t) ? this[e] = t : this["_" + e] = t);
  this._config = M, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function sc(M, t) {
  var e = Ye({}, M), p;
  for (p in t)
    U0(t, p) && (At(M[p]) && At(t[p]) ? (e[p] = {}, Ye(e[p], M[p]), Ye(e[p], t[p])) : t[p] != null ? e[p] = t[p] : delete e[p]);
  for (p in M)
    U0(M, p) && !U0(t, p) && At(M[p]) && (e[p] = Ye({}, e[p]));
  return e;
}
function yc(M) {
  M != null && this.set(M);
}
var Ac;
Object.keys ? Ac = Object.keys : Ac = function(M) {
  var t, e = [];
  for (t in M)
    U0(M, t) && e.push(t);
  return e;
};
var ef = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function tf(M, t, e) {
  var p = this._calendar[M] || this._calendar.sameElse;
  return Me(p) ? p.call(t, e) : p;
}
function j2(M, t, e) {
  var p = "" + Math.abs(M), c = t - p.length, i = M >= 0;
  return (i ? e ? "+" : "" : "-") + Math.pow(10, Math.max(0, c)).toString().substr(1) + p;
}
var Nc = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ip = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, so = {}, MM = {};
function a0(M, t, e, p) {
  var c = p;
  typeof p == "string" && (c = function() {
    return this[p]();
  }), M && (MM[M] = c), t && (MM[t[0]] = function() {
    return j2(c.apply(this, arguments), t[1], t[2]);
  }), e && (MM[e] = function() {
    return this.localeData().ordinal(
      c.apply(this, arguments),
      M
    );
  });
}
function Mf(M) {
  return M.match(/\[[\s\S]/) ? M.replace(/^\[|\]$/g, "") : M.replace(/\\/g, "");
}
function bf(M) {
  var t = M.match(Nc), e, p;
  for (e = 0, p = t.length; e < p; e++)
    MM[t[e]] ? t[e] = MM[t[e]] : t[e] = Mf(t[e]);
  return function(c) {
    var i = "", s;
    for (s = 0; s < p; s++)
      i += Me(t[s]) ? t[s].call(c, M) : t[s];
    return i;
  };
}
function ap(M, t) {
  return M.isValid() ? (t = L3(t, M.localeData()), so[t] = so[t] || bf(t), so[t](M)) : M.localeData().invalidDate();
}
function L3(M, t) {
  var e = 5;
  function p(c) {
    return t.longDateFormat(c) || c;
  }
  for (ip.lastIndex = 0; e >= 0 && ip.test(M); )
    M = M.replace(
      ip,
      p
    ), ip.lastIndex = 0, e -= 1;
  return M;
}
var pf = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function zf(M) {
  var t = this._longDateFormat[M], e = this._longDateFormat[M.toUpperCase()];
  return t || !e ? t : (this._longDateFormat[M] = e.match(Nc).map(function(p) {
    return p === "MMMM" || p === "MM" || p === "DD" || p === "dddd" ? p.slice(1) : p;
  }).join(""), this._longDateFormat[M]);
}
var of = "Invalid date";
function cf() {
  return this._invalidDate;
}
var nf = "%d", rf = /\d{1,2}/;
function Of(M) {
  return this._ordinal.replace("%d", M);
}
var af = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function sf(M, t, e, p) {
  var c = this._relativeTime[e];
  return Me(c) ? c(M, t, e, p) : c.replace(/%d/i, M);
}
function Af(M, t) {
  var e = this._relativeTime[M > 0 ? "future" : "past"];
  return Me(e) ? e(t) : e.replace(/%s/i, t);
}
var cO = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function _2(M) {
  return typeof M == "string" ? cO[M] || cO[M.toLowerCase()] : void 0;
}
function Bc(M) {
  var t = {}, e, p;
  for (p in M)
    U0(M, p) && (e = _2(p), e && (t[e] = M[p]));
  return t;
}
var df = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function uf(M) {
  var t = [], e;
  for (e in M)
    U0(M, e) && t.push({ unit: e, priority: df[e] });
  return t.sort(function(p, c) {
    return p.priority - c.priority;
  }), t;
}
var g3 = /\d/, d2 = /\d\d/, y3 = /\d{3}/, vc = /\d{4}/, vp = /[+-]?\d{6}/, s1 = /\d\d?/, N3 = /\d\d\d\d?/, B3 = /\d\d\d\d\d\d?/, Tp = /\d{1,3}/, Tc = /\d{1,4}/, _p = /[+-]?\d{1,6}/, nM = /\d+/, wp = /[+-]?\d+/, qf = /Z|[+-]\d\d:?\d\d/gi, Xp = /Z|[+-]\d\d(?::?\d\d)?/gi, lf = /[+-]?\d+(\.\d{1,3})?/, ib = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, iM = /^[1-9]\d?/, _c = /^([1-9]\d|\d)/, qp;
qp = {};
function o0(M, t, e) {
  qp[M] = Me(t) ? t : function(p, c) {
    return p && e ? e : t;
  };
}
function ff(M, t) {
  return U0(qp, M) ? qp[M](t._strict, t._locale) : new RegExp(Wf(M));
}
function Wf(M) {
  return We(
    M.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, e, p, c, i) {
        return e || p || c || i;
      }
    )
  );
}
function We(M) {
  return M.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function N2(M) {
  return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
}
function C0(M) {
  var t = +M, e = 0;
  return t !== 0 && isFinite(t) && (e = N2(t)), e;
}
var dc = {};
function e1(M, t) {
  var e, p = t, c;
  for (typeof M == "string" && (M = [M]), Re(t) && (p = function(i, s) {
    s[t] = C0(i);
  }), c = M.length, e = 0; e < c; e++)
    dc[M[e]] = p;
}
function rb(M, t) {
  e1(M, function(e, p, c, i) {
    c._w = c._w || {}, t(e, c._w, c, i);
  });
}
function hf(M, t, e) {
  t != null && U0(dc, M) && dc[M](t, e._a, e, M);
}
function Sp(M) {
  return M % 4 === 0 && M % 100 !== 0 || M % 400 === 0;
}
var J1 = 0, le = 1, Q2 = 2, S1 = 3, P2 = 4, fe = 5, st = 6, mf = 7, Rf = 8;
a0("Y", 0, 0, function() {
  var M = this.year();
  return M <= 9999 ? j2(M, 4) : "+" + M;
});
a0(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
a0(0, ["YYYY", 4], 0, "year");
a0(0, ["YYYYY", 5], 0, "year");
a0(0, ["YYYYYY", 6, !0], 0, "year");
o0("Y", wp);
o0("YY", s1, d2);
o0("YYYY", Tc, vc);
o0("YYYYY", _p, vp);
o0("YYYYYY", _p, vp);
e1(["YYYYY", "YYYYYY"], J1);
e1("YYYY", function(M, t) {
  t[J1] = M.length === 2 ? R.parseTwoDigitYear(M) : C0(M);
});
e1("YY", function(M, t) {
  t[J1] = R.parseTwoDigitYear(M);
});
e1("Y", function(M, t) {
  t[J1] = parseInt(M, 10);
});
function HM(M) {
  return Sp(M) ? 366 : 365;
}
R.parseTwoDigitYear = function(M) {
  return C0(M) + (C0(M) > 68 ? 1900 : 2e3);
};
var v3 = rM("FullYear", !0);
function Lf() {
  return Sp(this.year());
}
function rM(M, t) {
  return function(e) {
    return e != null ? (T3(this, M, e), R.updateOffset(this, t), this) : VM(this, M);
  };
}
function VM(M, t) {
  if (!M.isValid())
    return NaN;
  var e = M._d, p = M._isUTC;
  switch (t) {
    case "Milliseconds":
      return p ? e.getUTCMilliseconds() : e.getMilliseconds();
    case "Seconds":
      return p ? e.getUTCSeconds() : e.getSeconds();
    case "Minutes":
      return p ? e.getUTCMinutes() : e.getMinutes();
    case "Hours":
      return p ? e.getUTCHours() : e.getHours();
    case "Date":
      return p ? e.getUTCDate() : e.getDate();
    case "Day":
      return p ? e.getUTCDay() : e.getDay();
    case "Month":
      return p ? e.getUTCMonth() : e.getMonth();
    case "FullYear":
      return p ? e.getUTCFullYear() : e.getFullYear();
    default:
      return NaN;
  }
}
function T3(M, t, e) {
  var p, c, i, s, u;
  if (!(!M.isValid() || isNaN(e))) {
    switch (p = M._d, c = M._isUTC, t) {
      case "Milliseconds":
        return void (c ? p.setUTCMilliseconds(e) : p.setMilliseconds(e));
      case "Seconds":
        return void (c ? p.setUTCSeconds(e) : p.setSeconds(e));
      case "Minutes":
        return void (c ? p.setUTCMinutes(e) : p.setMinutes(e));
      case "Hours":
        return void (c ? p.setUTCHours(e) : p.setHours(e));
      case "Date":
        return void (c ? p.setUTCDate(e) : p.setDate(e));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    i = e, s = M.month(), u = M.date(), u = u === 29 && s === 1 && !Sp(i) ? 28 : u, c ? p.setUTCFullYear(i, s, u) : p.setFullYear(i, s, u);
  }
}
function gf(M) {
  return M = _2(M), Me(this[M]) ? this[M]() : this;
}
function yf(M, t) {
  if (typeof M == "object") {
    M = Bc(M);
    var e = uf(M), p, c = e.length;
    for (p = 0; p < c; p++)
      this[e[p].unit](M[e[p].unit]);
  } else if (M = _2(M), Me(this[M]))
    return this[M](t);
  return this;
}
function Nf(M, t) {
  return (M % t + t) % t;
}
var B1;
Array.prototype.indexOf ? B1 = Array.prototype.indexOf : B1 = function(M) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === M)
      return t;
  return -1;
};
function wc(M, t) {
  if (isNaN(M) || isNaN(t))
    return NaN;
  var e = Nf(t, 12);
  return M += (t - e) / 12, e === 1 ? Sp(M) ? 29 : 28 : 31 - e % 7 % 2;
}
a0("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
a0("MMM", 0, 0, function(M) {
  return this.localeData().monthsShort(this, M);
});
a0("MMMM", 0, 0, function(M) {
  return this.localeData().months(this, M);
});
o0("M", s1, iM);
o0("MM", s1, d2);
o0("MMM", function(M, t) {
  return t.monthsShortRegex(M);
});
o0("MMMM", function(M, t) {
  return t.monthsRegex(M);
});
e1(["M", "MM"], function(M, t) {
  t[le] = C0(M) - 1;
});
e1(["MMM", "MMMM"], function(M, t, e, p) {
  var c = e._locale.monthsParse(M, p, e._strict);
  c != null ? t[le] = c : B0(e).invalidMonth = M;
});
var Bf = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), _3 = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), w3 = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, vf = ib, Tf = ib;
function _f(M, t) {
  return M ? x2(this._months) ? this._months[M.month()] : this._months[(this._months.isFormat || w3).test(t) ? "format" : "standalone"][M.month()] : x2(this._months) ? this._months : this._months.standalone;
}
function wf(M, t) {
  return M ? x2(this._monthsShort) ? this._monthsShort[M.month()] : this._monthsShort[w3.test(t) ? "format" : "standalone"][M.month()] : x2(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function Xf(M, t, e) {
  var p, c, i, s = M.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], p = 0; p < 12; ++p)
      i = te([2e3, p]), this._shortMonthsParse[p] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[p] = this.months(i, "").toLocaleLowerCase();
  return e ? t === "MMM" ? (c = B1.call(this._shortMonthsParse, s), c !== -1 ? c : null) : (c = B1.call(this._longMonthsParse, s), c !== -1 ? c : null) : t === "MMM" ? (c = B1.call(this._shortMonthsParse, s), c !== -1 ? c : (c = B1.call(this._longMonthsParse, s), c !== -1 ? c : null)) : (c = B1.call(this._longMonthsParse, s), c !== -1 ? c : (c = B1.call(this._shortMonthsParse, s), c !== -1 ? c : null));
}
function Sf(M, t, e) {
  var p, c, i;
  if (this._monthsParseExact)
    return Xf.call(this, M, t, e);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), p = 0; p < 12; p++) {
    if (c = te([2e3, p]), e && !this._longMonthsParse[p] && (this._longMonthsParse[p] = new RegExp(
      "^" + this.months(c, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[p] = new RegExp(
      "^" + this.monthsShort(c, "").replace(".", "") + "$",
      "i"
    )), !e && !this._monthsParse[p] && (i = "^" + this.months(c, "") + "|^" + this.monthsShort(c, ""), this._monthsParse[p] = new RegExp(i.replace(".", ""), "i")), e && t === "MMMM" && this._longMonthsParse[p].test(M))
      return p;
    if (e && t === "MMM" && this._shortMonthsParse[p].test(M))
      return p;
    if (!e && this._monthsParse[p].test(M))
      return p;
  }
}
function X3(M, t) {
  if (!M.isValid())
    return M;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = C0(t);
    else if (t = M.localeData().monthsParse(t), !Re(t))
      return M;
  }
  var e = t, p = M.date();
  return p = p < 29 ? p : Math.min(p, wc(M.year(), e)), M._isUTC ? M._d.setUTCMonth(e, p) : M._d.setMonth(e, p), M;
}
function S3(M) {
  return M != null ? (X3(this, M), R.updateOffset(this, !0), this) : VM(this, "Month");
}
function Df() {
  return wc(this.year(), this.month());
}
function Cf(M) {
  return this._monthsParseExact ? (U0(this, "_monthsRegex") || D3.call(this), M ? this._monthsShortStrictRegex : this._monthsShortRegex) : (U0(this, "_monthsShortRegex") || (this._monthsShortRegex = vf), this._monthsShortStrictRegex && M ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function If(M) {
  return this._monthsParseExact ? (U0(this, "_monthsRegex") || D3.call(this), M ? this._monthsStrictRegex : this._monthsRegex) : (U0(this, "_monthsRegex") || (this._monthsRegex = Tf), this._monthsStrictRegex && M ? this._monthsStrictRegex : this._monthsRegex);
}
function D3() {
  function M(l, W) {
    return W.length - l.length;
  }
  var t = [], e = [], p = [], c, i, s, u;
  for (c = 0; c < 12; c++)
    i = te([2e3, c]), s = We(this.monthsShort(i, "")), u = We(this.months(i, "")), t.push(s), e.push(u), p.push(u), p.push(s);
  t.sort(M), e.sort(M), p.sort(M), this._monthsRegex = new RegExp("^(" + p.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function kf(M, t, e, p, c, i, s) {
  var u;
  return M < 100 && M >= 0 ? (u = new Date(M + 400, t, e, p, c, i, s), isFinite(u.getFullYear()) && u.setFullYear(M)) : u = new Date(M, t, e, p, c, i, s), u;
}
function KM(M) {
  var t, e;
  return M < 100 && M >= 0 ? (e = Array.prototype.slice.call(arguments), e[0] = M + 400, t = new Date(Date.UTC.apply(null, e)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(M)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function lp(M, t, e) {
  var p = 7 + t - e, c = (7 + KM(M, 0, p).getUTCDay() - t) % 7;
  return -c + p - 1;
}
function C3(M, t, e, p, c) {
  var i = (7 + e - p) % 7, s = lp(M, p, c), u = 1 + 7 * (t - 1) + i + s, l, W;
  return u <= 0 ? (l = M - 1, W = HM(l) + u) : u > HM(M) ? (l = M + 1, W = u - HM(M)) : (l = M, W = u), {
    year: l,
    dayOfYear: W
  };
}
function QM(M, t, e) {
  var p = lp(M.year(), t, e), c = Math.floor((M.dayOfYear() - p - 1) / 7) + 1, i, s;
  return c < 1 ? (s = M.year() - 1, i = c + he(s, t, e)) : c > he(M.year(), t, e) ? (i = c - he(M.year(), t, e), s = M.year() + 1) : (s = M.year(), i = c), {
    week: i,
    year: s
  };
}
function he(M, t, e) {
  var p = lp(M, t, e), c = lp(M + 1, t, e);
  return (HM(M) - p + c) / 7;
}
a0("w", ["ww", 2], "wo", "week");
a0("W", ["WW", 2], "Wo", "isoWeek");
o0("w", s1, iM);
o0("ww", s1, d2);
o0("W", s1, iM);
o0("WW", s1, d2);
rb(
  ["w", "ww", "W", "WW"],
  function(M, t, e, p) {
    t[p.substr(0, 1)] = C0(M);
  }
);
function Pf(M) {
  return QM(M, this._week.dow, this._week.doy).week;
}
var Ef = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function xf() {
  return this._week.dow;
}
function Ff() {
  return this._week.doy;
}
function Uf(M) {
  var t = this.localeData().week(this);
  return M == null ? t : this.add((M - t) * 7, "d");
}
function Jf(M) {
  var t = QM(this, 1, 4).week;
  return M == null ? t : this.add((M - t) * 7, "d");
}
a0("d", 0, "do", "day");
a0("dd", 0, 0, function(M) {
  return this.localeData().weekdaysMin(this, M);
});
a0("ddd", 0, 0, function(M) {
  return this.localeData().weekdaysShort(this, M);
});
a0("dddd", 0, 0, function(M) {
  return this.localeData().weekdays(this, M);
});
a0("e", 0, 0, "weekday");
a0("E", 0, 0, "isoWeekday");
o0("d", s1);
o0("e", s1);
o0("E", s1);
o0("dd", function(M, t) {
  return t.weekdaysMinRegex(M);
});
o0("ddd", function(M, t) {
  return t.weekdaysShortRegex(M);
});
o0("dddd", function(M, t) {
  return t.weekdaysRegex(M);
});
rb(["dd", "ddd", "dddd"], function(M, t, e, p) {
  var c = e._locale.weekdaysParse(M, p, e._strict);
  c != null ? t.d = c : B0(e).invalidWeekday = M;
});
rb(["d", "e", "E"], function(M, t, e, p) {
  t[p] = C0(M);
});
function Hf(M, t) {
  return typeof M != "string" ? M : isNaN(M) ? (M = t.weekdaysParse(M), typeof M == "number" ? M : null) : parseInt(M, 10);
}
function Yf(M, t) {
  return typeof M == "string" ? t.weekdaysParse(M) % 7 || 7 : isNaN(M) ? null : M;
}
function Xc(M, t) {
  return M.slice(t, 7).concat(M.slice(0, t));
}
var Gf = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), I3 = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), $f = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Vf = ib, Kf = ib, Qf = ib;
function Zf(M, t) {
  var e = x2(this._weekdays) ? this._weekdays : this._weekdays[M && M !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return M === !0 ? Xc(e, this._week.dow) : M ? e[M.day()] : e;
}
function jf(M) {
  return M === !0 ? Xc(this._weekdaysShort, this._week.dow) : M ? this._weekdaysShort[M.day()] : this._weekdaysShort;
}
function e5(M) {
  return M === !0 ? Xc(this._weekdaysMin, this._week.dow) : M ? this._weekdaysMin[M.day()] : this._weekdaysMin;
}
function t5(M, t, e) {
  var p, c, i, s = M.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], p = 0; p < 7; ++p)
      i = te([2e3, 1]).day(p), this._minWeekdaysParse[p] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[p] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[p] = this.weekdays(i, "").toLocaleLowerCase();
  return e ? t === "dddd" ? (c = B1.call(this._weekdaysParse, s), c !== -1 ? c : null) : t === "ddd" ? (c = B1.call(this._shortWeekdaysParse, s), c !== -1 ? c : null) : (c = B1.call(this._minWeekdaysParse, s), c !== -1 ? c : null) : t === "dddd" ? (c = B1.call(this._weekdaysParse, s), c !== -1 || (c = B1.call(this._shortWeekdaysParse, s), c !== -1) ? c : (c = B1.call(this._minWeekdaysParse, s), c !== -1 ? c : null)) : t === "ddd" ? (c = B1.call(this._shortWeekdaysParse, s), c !== -1 || (c = B1.call(this._weekdaysParse, s), c !== -1) ? c : (c = B1.call(this._minWeekdaysParse, s), c !== -1 ? c : null)) : (c = B1.call(this._minWeekdaysParse, s), c !== -1 || (c = B1.call(this._weekdaysParse, s), c !== -1) ? c : (c = B1.call(this._shortWeekdaysParse, s), c !== -1 ? c : null));
}
function M5(M, t, e) {
  var p, c, i;
  if (this._weekdaysParseExact)
    return t5.call(this, M, t, e);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), p = 0; p < 7; p++) {
    if (c = te([2e3, 1]).day(p), e && !this._fullWeekdaysParse[p] && (this._fullWeekdaysParse[p] = new RegExp(
      "^" + this.weekdays(c, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[p] = new RegExp(
      "^" + this.weekdaysShort(c, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[p] = new RegExp(
      "^" + this.weekdaysMin(c, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[p] || (i = "^" + this.weekdays(c, "") + "|^" + this.weekdaysShort(c, "") + "|^" + this.weekdaysMin(c, ""), this._weekdaysParse[p] = new RegExp(i.replace(".", ""), "i")), e && t === "dddd" && this._fullWeekdaysParse[p].test(M))
      return p;
    if (e && t === "ddd" && this._shortWeekdaysParse[p].test(M))
      return p;
    if (e && t === "dd" && this._minWeekdaysParse[p].test(M))
      return p;
    if (!e && this._weekdaysParse[p].test(M))
      return p;
  }
}
function b5(M) {
  if (!this.isValid())
    return M != null ? this : NaN;
  var t = VM(this, "Day");
  return M != null ? (M = Hf(M, this.localeData()), this.add(M - t, "d")) : t;
}
function p5(M) {
  if (!this.isValid())
    return M != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return M == null ? t : this.add(M - t, "d");
}
function z5(M) {
  if (!this.isValid())
    return M != null ? this : NaN;
  if (M != null) {
    var t = Yf(M, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function o5(M) {
  return this._weekdaysParseExact ? (U0(this, "_weekdaysRegex") || Sc.call(this), M ? this._weekdaysStrictRegex : this._weekdaysRegex) : (U0(this, "_weekdaysRegex") || (this._weekdaysRegex = Vf), this._weekdaysStrictRegex && M ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function c5(M) {
  return this._weekdaysParseExact ? (U0(this, "_weekdaysRegex") || Sc.call(this), M ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (U0(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Kf), this._weekdaysShortStrictRegex && M ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function n5(M) {
  return this._weekdaysParseExact ? (U0(this, "_weekdaysRegex") || Sc.call(this), M ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (U0(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Qf), this._weekdaysMinStrictRegex && M ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Sc() {
  function M(L, m) {
    return m.length - L.length;
  }
  var t = [], e = [], p = [], c = [], i, s, u, l, W;
  for (i = 0; i < 7; i++)
    s = te([2e3, 1]).day(i), u = We(this.weekdaysMin(s, "")), l = We(this.weekdaysShort(s, "")), W = We(this.weekdays(s, "")), t.push(u), e.push(l), p.push(W), c.push(u), c.push(l), c.push(W);
  t.sort(M), e.sort(M), p.sort(M), c.sort(M), this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + p.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Dc() {
  return this.hours() % 12 || 12;
}
function i5() {
  return this.hours() || 24;
}
a0("H", ["HH", 2], 0, "hour");
a0("h", ["hh", 2], 0, Dc);
a0("k", ["kk", 2], 0, i5);
a0("hmm", 0, 0, function() {
  return "" + Dc.apply(this) + j2(this.minutes(), 2);
});
a0("hmmss", 0, 0, function() {
  return "" + Dc.apply(this) + j2(this.minutes(), 2) + j2(this.seconds(), 2);
});
a0("Hmm", 0, 0, function() {
  return "" + this.hours() + j2(this.minutes(), 2);
});
a0("Hmmss", 0, 0, function() {
  return "" + this.hours() + j2(this.minutes(), 2) + j2(this.seconds(), 2);
});
function k3(M, t) {
  a0(M, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
k3("a", !0);
k3("A", !1);
function P3(M, t) {
  return t._meridiemParse;
}
o0("a", P3);
o0("A", P3);
o0("H", s1, _c);
o0("h", s1, iM);
o0("k", s1, iM);
o0("HH", s1, d2);
o0("hh", s1, d2);
o0("kk", s1, d2);
o0("hmm", N3);
o0("hmmss", B3);
o0("Hmm", N3);
o0("Hmmss", B3);
e1(["H", "HH"], S1);
e1(["k", "kk"], function(M, t, e) {
  var p = C0(M);
  t[S1] = p === 24 ? 0 : p;
});
e1(["a", "A"], function(M, t, e) {
  e._isPm = e._locale.isPM(M), e._meridiem = M;
});
e1(["h", "hh"], function(M, t, e) {
  t[S1] = C0(M), B0(e).bigHour = !0;
});
e1("hmm", function(M, t, e) {
  var p = M.length - 2;
  t[S1] = C0(M.substr(0, p)), t[P2] = C0(M.substr(p)), B0(e).bigHour = !0;
});
e1("hmmss", function(M, t, e) {
  var p = M.length - 4, c = M.length - 2;
  t[S1] = C0(M.substr(0, p)), t[P2] = C0(M.substr(p, 2)), t[fe] = C0(M.substr(c)), B0(e).bigHour = !0;
});
e1("Hmm", function(M, t, e) {
  var p = M.length - 2;
  t[S1] = C0(M.substr(0, p)), t[P2] = C0(M.substr(p));
});
e1("Hmmss", function(M, t, e) {
  var p = M.length - 4, c = M.length - 2;
  t[S1] = C0(M.substr(0, p)), t[P2] = C0(M.substr(p, 2)), t[fe] = C0(M.substr(c));
});
function r5(M) {
  return (M + "").toLowerCase().charAt(0) === "p";
}
var O5 = /[ap]\.?m?\.?/i, a5 = rM("Hours", !0);
function s5(M, t, e) {
  return M > 11 ? e ? "pm" : "PM" : e ? "am" : "AM";
}
var E3 = {
  calendar: ef,
  longDateFormat: pf,
  invalidDate: of,
  ordinal: nf,
  dayOfMonthOrdinalParse: rf,
  relativeTime: af,
  months: Bf,
  monthsShort: _3,
  week: Ef,
  weekdays: Gf,
  weekdaysMin: $f,
  weekdaysShort: I3,
  meridiemParse: O5
}, q1 = {}, EM = {}, ZM;
function A5(M, t) {
  var e, p = Math.min(M.length, t.length);
  for (e = 0; e < p; e += 1)
    if (M[e] !== t[e])
      return e;
  return p;
}
function nO(M) {
  return M && M.toLowerCase().replace("_", "-");
}
function d5(M) {
  for (var t = 0, e, p, c, i; t < M.length; ) {
    for (i = nO(M[t]).split("-"), e = i.length, p = nO(M[t + 1]), p = p ? p.split("-") : null; e > 0; ) {
      if (c = Dp(i.slice(0, e).join("-")), c)
        return c;
      if (p && p.length >= e && A5(i, p) >= e - 1)
        break;
      e--;
    }
    t++;
  }
  return ZM;
}
function u5(M) {
  return !!(M && M.match("^[^/\\\\]*$"));
}
function Dp(M) {
  var t = null, e;
  if (q1[M] === void 0 && typeof module < "u" && module && module.exports && u5(M))
    try {
      t = ZM._abbr, e = require, e("./locale/" + M), $e(t);
    } catch {
      q1[M] = null;
    }
  return q1[M];
}
function $e(M, t) {
  var e;
  return M && (b2(t) ? e = ge(M) : e = Cc(M, t), e ? ZM = e : typeof console < "u" && console.warn && console.warn(
    "Locale " + M + " not found. Did you forget to load it?"
  )), ZM._abbr;
}
function Cc(M, t) {
  if (t !== null) {
    var e, p = E3;
    if (t.abbr = M, q1[M] != null)
      R3(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), p = q1[M]._config;
    else if (t.parentLocale != null)
      if (q1[t.parentLocale] != null)
        p = q1[t.parentLocale]._config;
      else if (e = Dp(t.parentLocale), e != null)
        p = e._config;
      else
        return EM[t.parentLocale] || (EM[t.parentLocale] = []), EM[t.parentLocale].push({
          name: M,
          config: t
        }), null;
    return q1[M] = new yc(sc(p, t)), EM[M] && EM[M].forEach(function(c) {
      Cc(c.name, c.config);
    }), $e(M), q1[M];
  } else
    return delete q1[M], null;
}
function q5(M, t) {
  if (t != null) {
    var e, p, c = E3;
    q1[M] != null && q1[M].parentLocale != null ? q1[M].set(sc(q1[M]._config, t)) : (p = Dp(M), p != null && (c = p._config), t = sc(c, t), p == null && (t.abbr = M), e = new yc(t), e.parentLocale = q1[M], q1[M] = e), $e(M);
  } else
    q1[M] != null && (q1[M].parentLocale != null ? (q1[M] = q1[M].parentLocale, M === $e() && $e(M)) : q1[M] != null && delete q1[M]);
  return q1[M];
}
function ge(M) {
  var t;
  if (M && M._locale && M._locale._abbr && (M = M._locale._abbr), !M)
    return ZM;
  if (!x2(M)) {
    if (t = Dp(M), t)
      return t;
    M = [M];
  }
  return d5(M);
}
function l5() {
  return Ac(q1);
}
function Ic(M) {
  var t, e = M._a;
  return e && B0(M).overflow === -2 && (t = e[le] < 0 || e[le] > 11 ? le : e[Q2] < 1 || e[Q2] > wc(e[J1], e[le]) ? Q2 : e[S1] < 0 || e[S1] > 24 || e[S1] === 24 && (e[P2] !== 0 || e[fe] !== 0 || e[st] !== 0) ? S1 : e[P2] < 0 || e[P2] > 59 ? P2 : e[fe] < 0 || e[fe] > 59 ? fe : e[st] < 0 || e[st] > 999 ? st : -1, B0(M)._overflowDayOfYear && (t < J1 || t > Q2) && (t = Q2), B0(M)._overflowWeeks && t === -1 && (t = mf), B0(M)._overflowWeekday && t === -1 && (t = Rf), B0(M).overflow = t), M;
}
var f5 = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, W5 = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, h5 = /Z|[+-]\d\d(?::?\d\d)?/, rp = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Ao = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], m5 = /^\/?Date\((-?\d+)/i, R5 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, L5 = {
  UT: 0,
  GMT: 0,
  EDT: -240,
  EST: -300,
  CDT: -300,
  CST: -360,
  MDT: -360,
  MST: -420,
  PDT: -420,
  PST: -480
};
function x3(M) {
  var t, e, p = M._i, c = f5.exec(p) || W5.exec(p), i, s, u, l, W = rp.length, L = Ao.length;
  if (c) {
    for (B0(M).iso = !0, t = 0, e = W; t < e; t++)
      if (rp[t][1].exec(c[1])) {
        s = rp[t][0], i = rp[t][2] !== !1;
        break;
      }
    if (s == null) {
      M._isValid = !1;
      return;
    }
    if (c[3]) {
      for (t = 0, e = L; t < e; t++)
        if (Ao[t][1].exec(c[3])) {
          u = (c[2] || " ") + Ao[t][0];
          break;
        }
      if (u == null) {
        M._isValid = !1;
        return;
      }
    }
    if (!i && u != null) {
      M._isValid = !1;
      return;
    }
    if (c[4])
      if (h5.exec(c[4]))
        l = "Z";
      else {
        M._isValid = !1;
        return;
      }
    M._f = s + (u || "") + (l || ""), Pc(M);
  } else
    M._isValid = !1;
}
function g5(M, t, e, p, c, i) {
  var s = [
    y5(M),
    _3.indexOf(t),
    parseInt(e, 10),
    parseInt(p, 10),
    parseInt(c, 10)
  ];
  return i && s.push(parseInt(i, 10)), s;
}
function y5(M) {
  var t = parseInt(M, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function N5(M) {
  return M.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function B5(M, t, e) {
  if (M) {
    var p = I3.indexOf(M), c = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (p !== c)
      return B0(e).weekdayMismatch = !0, e._isValid = !1, !1;
  }
  return !0;
}
function v5(M, t, e) {
  if (M)
    return L5[M];
  if (t)
    return 0;
  var p = parseInt(e, 10), c = p % 100, i = (p - c) / 100;
  return i * 60 + c;
}
function F3(M) {
  var t = R5.exec(N5(M._i)), e;
  if (t) {
    if (e = g5(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !B5(t[1], e, M))
      return;
    M._a = e, M._tzm = v5(t[8], t[9], t[10]), M._d = KM.apply(null, M._a), M._d.setUTCMinutes(M._d.getUTCMinutes() - M._tzm), B0(M).rfc2822 = !0;
  } else
    M._isValid = !1;
}
function T5(M) {
  var t = m5.exec(M._i);
  if (t !== null) {
    M._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (x3(M), M._isValid === !1)
    delete M._isValid;
  else
    return;
  if (F3(M), M._isValid === !1)
    delete M._isValid;
  else
    return;
  M._strict ? M._isValid = !1 : R.createFromInputFallback(M);
}
R.createFromInputFallback = T2(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(M) {
    M._d = /* @__PURE__ */ new Date(M._i + (M._useUTC ? " UTC" : ""));
  }
);
function Kt(M, t, e) {
  return M ?? t ?? e;
}
function _5(M) {
  var t = new Date(R.now());
  return M._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function kc(M) {
  var t, e, p = [], c, i, s;
  if (!M._d) {
    for (c = _5(M), M._w && M._a[Q2] == null && M._a[le] == null && w5(M), M._dayOfYear != null && (s = Kt(M._a[J1], c[J1]), (M._dayOfYear > HM(s) || M._dayOfYear === 0) && (B0(M)._overflowDayOfYear = !0), e = KM(s, 0, M._dayOfYear), M._a[le] = e.getUTCMonth(), M._a[Q2] = e.getUTCDate()), t = 0; t < 3 && M._a[t] == null; ++t)
      M._a[t] = p[t] = c[t];
    for (; t < 7; t++)
      M._a[t] = p[t] = M._a[t] == null ? t === 2 ? 1 : 0 : M._a[t];
    M._a[S1] === 24 && M._a[P2] === 0 && M._a[fe] === 0 && M._a[st] === 0 && (M._nextDay = !0, M._a[S1] = 0), M._d = (M._useUTC ? KM : kf).apply(
      null,
      p
    ), i = M._useUTC ? M._d.getUTCDay() : M._d.getDay(), M._tzm != null && M._d.setUTCMinutes(M._d.getUTCMinutes() - M._tzm), M._nextDay && (M._a[S1] = 24), M._w && typeof M._w.d < "u" && M._w.d !== i && (B0(M).weekdayMismatch = !0);
  }
}
function w5(M) {
  var t, e, p, c, i, s, u, l, W;
  t = M._w, t.GG != null || t.W != null || t.E != null ? (i = 1, s = 4, e = Kt(
    t.GG,
    M._a[J1],
    QM(a1(), 1, 4).year
  ), p = Kt(t.W, 1), c = Kt(t.E, 1), (c < 1 || c > 7) && (l = !0)) : (i = M._locale._week.dow, s = M._locale._week.doy, W = QM(a1(), i, s), e = Kt(t.gg, M._a[J1], W.year), p = Kt(t.w, W.week), t.d != null ? (c = t.d, (c < 0 || c > 6) && (l = !0)) : t.e != null ? (c = t.e + i, (t.e < 0 || t.e > 6) && (l = !0)) : c = i), p < 1 || p > he(e, i, s) ? B0(M)._overflowWeeks = !0 : l != null ? B0(M)._overflowWeekday = !0 : (u = C3(e, p, c, i, s), M._a[J1] = u.year, M._dayOfYear = u.dayOfYear);
}
R.ISO_8601 = function() {
};
R.RFC_2822 = function() {
};
function Pc(M) {
  if (M._f === R.ISO_8601) {
    x3(M);
    return;
  }
  if (M._f === R.RFC_2822) {
    F3(M);
    return;
  }
  M._a = [], B0(M).empty = !0;
  var t = "" + M._i, e, p, c, i, s, u = t.length, l = 0, W, L;
  for (c = L3(M._f, M._locale).match(Nc) || [], L = c.length, e = 0; e < L; e++)
    i = c[e], p = (t.match(ff(i, M)) || [])[0], p && (s = t.substr(0, t.indexOf(p)), s.length > 0 && B0(M).unusedInput.push(s), t = t.slice(
      t.indexOf(p) + p.length
    ), l += p.length), MM[i] ? (p ? B0(M).empty = !1 : B0(M).unusedTokens.push(i), hf(i, p, M)) : M._strict && !p && B0(M).unusedTokens.push(i);
  B0(M).charsLeftOver = u - l, t.length > 0 && B0(M).unusedInput.push(t), M._a[S1] <= 12 && B0(M).bigHour === !0 && M._a[S1] > 0 && (B0(M).bigHour = void 0), B0(M).parsedDateParts = M._a.slice(0), B0(M).meridiem = M._meridiem, M._a[S1] = X5(
    M._locale,
    M._a[S1],
    M._meridiem
  ), W = B0(M).era, W !== null && (M._a[J1] = M._locale.erasConvertYear(W, M._a[J1])), kc(M), Ic(M);
}
function X5(M, t, e) {
  var p;
  return e == null ? t : M.meridiemHour != null ? M.meridiemHour(t, e) : (M.isPM != null && (p = M.isPM(e), p && t < 12 && (t += 12), !p && t === 12 && (t = 0)), t);
}
function S5(M) {
  var t, e, p, c, i, s, u = !1, l = M._f.length;
  if (l === 0) {
    B0(M).invalidFormat = !0, M._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (c = 0; c < l; c++)
    i = 0, s = !1, t = gc({}, M), M._useUTC != null && (t._useUTC = M._useUTC), t._f = M._f[c], Pc(t), Lc(t) && (s = !0), i += B0(t).charsLeftOver, i += B0(t).unusedTokens.length * 10, B0(t).score = i, u ? i < p && (p = i, e = t) : (p == null || i < p || s) && (p = i, e = t, s && (u = !0));
  Ye(M, e || t);
}
function D5(M) {
  if (!M._d) {
    var t = Bc(M._i), e = t.day === void 0 ? t.date : t.day;
    M._a = h3(
      [t.year, t.month, e, t.hour, t.minute, t.second, t.millisecond],
      function(p) {
        return p && parseInt(p, 10);
      }
    ), kc(M);
  }
}
function C5(M) {
  var t = new nb(Ic(U3(M)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function U3(M) {
  var t = M._i, e = M._f;
  return M._locale = M._locale || ge(M._l), t === null || e === void 0 && t === "" ? Bp({ nullInput: !0 }) : (typeof t == "string" && (M._i = t = M._locale.preparse(t)), F2(t) ? new nb(Ic(t)) : (cb(t) ? M._d = t : x2(e) ? S5(M) : e ? Pc(M) : I5(M), Lc(M) || (M._d = null), M));
}
function I5(M) {
  var t = M._i;
  b2(t) ? M._d = new Date(R.now()) : cb(t) ? M._d = new Date(t.valueOf()) : typeof t == "string" ? T5(M) : x2(t) ? (M._a = h3(t.slice(0), function(e) {
    return parseInt(e, 10);
  }), kc(M)) : At(t) ? D5(M) : Re(t) ? M._d = new Date(t) : R.createFromInputFallback(M);
}
function J3(M, t, e, p, c) {
  var i = {};
  return (t === !0 || t === !1) && (p = t, t = void 0), (e === !0 || e === !1) && (p = e, e = void 0), (At(M) && Rc(M) || x2(M) && M.length === 0) && (M = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = c, i._l = e, i._i = M, i._f = t, i._strict = p, C5(i);
}
function a1(M, t, e, p) {
  return J3(M, t, e, p, !1);
}
var k5 = T2(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var M = a1.apply(null, arguments);
    return this.isValid() && M.isValid() ? M < this ? this : M : Bp();
  }
), P5 = T2(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var M = a1.apply(null, arguments);
    return this.isValid() && M.isValid() ? M > this ? this : M : Bp();
  }
);
function H3(M, t) {
  var e, p;
  if (t.length === 1 && x2(t[0]) && (t = t[0]), !t.length)
    return a1();
  for (e = t[0], p = 1; p < t.length; ++p)
    (!t[p].isValid() || t[p][M](e)) && (e = t[p]);
  return e;
}
function E5() {
  var M = [].slice.call(arguments, 0);
  return H3("isBefore", M);
}
function x5() {
  var M = [].slice.call(arguments, 0);
  return H3("isAfter", M);
}
var F5 = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, xM = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function U5(M) {
  var t, e = !1, p, c = xM.length;
  for (t in M)
    if (U0(M, t) && !(B1.call(xM, t) !== -1 && (M[t] == null || !isNaN(M[t]))))
      return !1;
  for (p = 0; p < c; ++p)
    if (M[xM[p]]) {
      if (e)
        return !1;
      parseFloat(M[xM[p]]) !== C0(M[xM[p]]) && (e = !0);
    }
  return !0;
}
function J5() {
  return this._isValid;
}
function H5() {
  return U2(NaN);
}
function Cp(M) {
  var t = Bc(M), e = t.year || 0, p = t.quarter || 0, c = t.month || 0, i = t.week || t.isoWeek || 0, s = t.day || 0, u = t.hour || 0, l = t.minute || 0, W = t.second || 0, L = t.millisecond || 0;
  this._isValid = U5(t), this._milliseconds = +L + W * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  u * 1e3 * 60 * 60, this._days = +s + i * 7, this._months = +c + p * 3 + e * 12, this._data = {}, this._locale = ge(), this._bubble();
}
function sp(M) {
  return M instanceof Cp;
}
function uc(M) {
  return M < 0 ? Math.round(-1 * M) * -1 : Math.round(M);
}
function Y5(M, t, e) {
  var p = Math.min(M.length, t.length), c = Math.abs(M.length - t.length), i = 0, s;
  for (s = 0; s < p; s++)
    C0(M[s]) !== C0(t[s]) && i++;
  return i + c;
}
function Y3(M, t) {
  a0(M, 0, 0, function() {
    var e = this.utcOffset(), p = "+";
    return e < 0 && (e = -e, p = "-"), p + j2(~~(e / 60), 2) + t + j2(~~e % 60, 2);
  });
}
Y3("Z", ":");
Y3("ZZ", "");
o0("Z", Xp);
o0("ZZ", Xp);
e1(["Z", "ZZ"], function(M, t, e) {
  e._useUTC = !0, e._tzm = Ec(Xp, M);
});
var G5 = /([\+\-]|\d\d)/gi;
function Ec(M, t) {
  var e = (t || "").match(M), p, c, i;
  return e === null ? null : (p = e[e.length - 1] || [], c = (p + "").match(G5) || ["-", 0, 0], i = +(c[1] * 60) + C0(c[2]), i === 0 ? 0 : c[0] === "+" ? i : -i);
}
function xc(M, t) {
  var e, p;
  return t._isUTC ? (e = t.clone(), p = (F2(M) || cb(M) ? M.valueOf() : a1(M).valueOf()) - e.valueOf(), e._d.setTime(e._d.valueOf() + p), R.updateOffset(e, !1), e) : a1(M).local();
}
function qc(M) {
  return -Math.round(M._d.getTimezoneOffset());
}
R.updateOffset = function() {
};
function $5(M, t, e) {
  var p = this._offset || 0, c;
  if (!this.isValid())
    return M != null ? this : NaN;
  if (M != null) {
    if (typeof M == "string") {
      if (M = Ec(Xp, M), M === null)
        return this;
    } else Math.abs(M) < 16 && !e && (M = M * 60);
    return !this._isUTC && t && (c = qc(this)), this._offset = M, this._isUTC = !0, c != null && this.add(c, "m"), p !== M && (!t || this._changeInProgress ? V3(
      this,
      U2(M - p, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, R.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? p : qc(this);
}
function V5(M, t) {
  return M != null ? (typeof M != "string" && (M = -M), this.utcOffset(M, t), this) : -this.utcOffset();
}
function K5(M) {
  return this.utcOffset(0, M);
}
function Q5(M) {
  return this._isUTC && (this.utcOffset(0, M), this._isUTC = !1, M && this.subtract(qc(this), "m")), this;
}
function Z5() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var M = Ec(qf, this._i);
    M != null ? this.utcOffset(M) : this.utcOffset(0, !0);
  }
  return this;
}
function j5(M) {
  return this.isValid() ? (M = M ? a1(M).utcOffset() : 0, (this.utcOffset() - M) % 60 === 0) : !1;
}
function eW() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function tW() {
  if (!b2(this._isDSTShifted))
    return this._isDSTShifted;
  var M = {}, t;
  return gc(M, this), M = U3(M), M._a ? (t = M._isUTC ? te(M._a) : a1(M._a), this._isDSTShifted = this.isValid() && Y5(M._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function MW() {
  return this.isValid() ? !this._isUTC : !1;
}
function bW() {
  return this.isValid() ? this._isUTC : !1;
}
function G3() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var pW = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, zW = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function U2(M, t) {
  var e = M, p = null, c, i, s;
  return sp(M) ? e = {
    ms: M._milliseconds,
    d: M._days,
    M: M._months
  } : Re(M) || !isNaN(+M) ? (e = {}, t ? e[t] = +M : e.milliseconds = +M) : (p = pW.exec(M)) ? (c = p[1] === "-" ? -1 : 1, e = {
    y: 0,
    d: C0(p[Q2]) * c,
    h: C0(p[S1]) * c,
    m: C0(p[P2]) * c,
    s: C0(p[fe]) * c,
    ms: C0(uc(p[st] * 1e3)) * c
    // the millisecond decimal point is included in the match
  }) : (p = zW.exec(M)) ? (c = p[1] === "-" ? -1 : 1, e = {
    y: it(p[2], c),
    M: it(p[3], c),
    w: it(p[4], c),
    d: it(p[5], c),
    h: it(p[6], c),
    m: it(p[7], c),
    s: it(p[8], c)
  }) : e == null ? e = {} : typeof e == "object" && ("from" in e || "to" in e) && (s = oW(
    a1(e.from),
    a1(e.to)
  ), e = {}, e.ms = s.milliseconds, e.M = s.months), i = new Cp(e), sp(M) && U0(M, "_locale") && (i._locale = M._locale), sp(M) && U0(M, "_isValid") && (i._isValid = M._isValid), i;
}
U2.fn = Cp.prototype;
U2.invalid = H5;
function it(M, t) {
  var e = M && parseFloat(M.replace(",", "."));
  return (isNaN(e) ? 0 : e) * t;
}
function iO(M, t) {
  var e = {};
  return e.months = t.month() - M.month() + (t.year() - M.year()) * 12, M.clone().add(e.months, "M").isAfter(t) && --e.months, e.milliseconds = +t - +M.clone().add(e.months, "M"), e;
}
function oW(M, t) {
  var e;
  return M.isValid() && t.isValid() ? (t = xc(t, M), M.isBefore(t) ? e = iO(M, t) : (e = iO(t, M), e.milliseconds = -e.milliseconds, e.months = -e.months), e) : { milliseconds: 0, months: 0 };
}
function $3(M, t) {
  return function(e, p) {
    var c, i;
    return p !== null && !isNaN(+p) && (R3(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = e, e = p, p = i), c = U2(e, p), V3(this, c, M), this;
  };
}
function V3(M, t, e, p) {
  var c = t._milliseconds, i = uc(t._days), s = uc(t._months);
  M.isValid() && (p = p ?? !0, s && X3(M, VM(M, "Month") + s * e), i && T3(M, "Date", VM(M, "Date") + i * e), c && M._d.setTime(M._d.valueOf() + c * e), p && R.updateOffset(M, i || s));
}
var cW = $3(1, "add"), nW = $3(-1, "subtract");
function K3(M) {
  return typeof M == "string" || M instanceof String;
}
function iW(M) {
  return F2(M) || cb(M) || K3(M) || Re(M) || OW(M) || rW(M) || M === null || M === void 0;
}
function rW(M) {
  var t = At(M) && !Rc(M), e = !1, p = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], c, i, s = p.length;
  for (c = 0; c < s; c += 1)
    i = p[c], e = e || U0(M, i);
  return t && e;
}
function OW(M) {
  var t = x2(M), e = !1;
  return t && (e = M.filter(function(p) {
    return !Re(p) && K3(M);
  }).length === 0), t && e;
}
function aW(M) {
  var t = At(M) && !Rc(M), e = !1, p = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], c, i;
  for (c = 0; c < p.length; c += 1)
    i = p[c], e = e || U0(M, i);
  return t && e;
}
function sW(M, t) {
  var e = M.diff(t, "days", !0);
  return e < -6 ? "sameElse" : e < -1 ? "lastWeek" : e < 0 ? "lastDay" : e < 1 ? "sameDay" : e < 2 ? "nextDay" : e < 7 ? "nextWeek" : "sameElse";
}
function AW(M, t) {
  arguments.length === 1 && (arguments[0] ? iW(arguments[0]) ? (M = arguments[0], t = void 0) : aW(arguments[0]) && (t = arguments[0], M = void 0) : (M = void 0, t = void 0));
  var e = M || a1(), p = xc(e, this).startOf("day"), c = R.calendarFormat(this, p) || "sameElse", i = t && (Me(t[c]) ? t[c].call(this, e) : t[c]);
  return this.format(
    i || this.localeData().calendar(c, this, a1(e))
  );
}
function dW() {
  return new nb(this);
}
function uW(M, t) {
  var e = F2(M) ? M : a1(M);
  return this.isValid() && e.isValid() ? (t = _2(t) || "millisecond", t === "millisecond" ? this.valueOf() > e.valueOf() : e.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function qW(M, t) {
  var e = F2(M) ? M : a1(M);
  return this.isValid() && e.isValid() ? (t = _2(t) || "millisecond", t === "millisecond" ? this.valueOf() < e.valueOf() : this.clone().endOf(t).valueOf() < e.valueOf()) : !1;
}
function lW(M, t, e, p) {
  var c = F2(M) ? M : a1(M), i = F2(t) ? t : a1(t);
  return this.isValid() && c.isValid() && i.isValid() ? (p = p || "()", (p[0] === "(" ? this.isAfter(c, e) : !this.isBefore(c, e)) && (p[1] === ")" ? this.isBefore(i, e) : !this.isAfter(i, e))) : !1;
}
function fW(M, t) {
  var e = F2(M) ? M : a1(M), p;
  return this.isValid() && e.isValid() ? (t = _2(t) || "millisecond", t === "millisecond" ? this.valueOf() === e.valueOf() : (p = e.valueOf(), this.clone().startOf(t).valueOf() <= p && p <= this.clone().endOf(t).valueOf())) : !1;
}
function WW(M, t) {
  return this.isSame(M, t) || this.isAfter(M, t);
}
function hW(M, t) {
  return this.isSame(M, t) || this.isBefore(M, t);
}
function mW(M, t, e) {
  var p, c, i;
  if (!this.isValid())
    return NaN;
  if (p = xc(M, this), !p.isValid())
    return NaN;
  switch (c = (p.utcOffset() - this.utcOffset()) * 6e4, t = _2(t), t) {
    case "year":
      i = Ap(this, p) / 12;
      break;
    case "month":
      i = Ap(this, p);
      break;
    case "quarter":
      i = Ap(this, p) / 3;
      break;
    case "second":
      i = (this - p) / 1e3;
      break;
    // 1000
    case "minute":
      i = (this - p) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      i = (this - p) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      i = (this - p - c) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      i = (this - p - c) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      i = this - p;
  }
  return e ? i : N2(i);
}
function Ap(M, t) {
  if (M.date() < t.date())
    return -Ap(t, M);
  var e = (t.year() - M.year()) * 12 + (t.month() - M.month()), p = M.clone().add(e, "months"), c, i;
  return t - p < 0 ? (c = M.clone().add(e - 1, "months"), i = (t - p) / (p - c)) : (c = M.clone().add(e + 1, "months"), i = (t - p) / (c - p)), -(e + i) || 0;
}
R.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
R.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function RW() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function LW(M) {
  if (!this.isValid())
    return null;
  var t = M !== !0, e = t ? this.clone().utc() : this;
  return e.year() < 0 || e.year() > 9999 ? ap(
    e,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Me(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", ap(e, "Z")) : ap(
    e,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function gW() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var M = "moment", t = "", e, p, c, i;
  return this.isLocal() || (M = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), e = "[" + M + '("]', p = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", c = "-MM-DD[T]HH:mm:ss.SSS", i = t + '[")]', this.format(e + p + c + i);
}
function yW(M) {
  M || (M = this.isUtc() ? R.defaultFormatUtc : R.defaultFormat);
  var t = ap(this, M);
  return this.localeData().postformat(t);
}
function NW(M, t) {
  return this.isValid() && (F2(M) && M.isValid() || a1(M).isValid()) ? U2({ to: this, from: M }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function BW(M) {
  return this.from(a1(), M);
}
function vW(M, t) {
  return this.isValid() && (F2(M) && M.isValid() || a1(M).isValid()) ? U2({ from: this, to: M }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function TW(M) {
  return this.to(a1(), M);
}
function Q3(M) {
  var t;
  return M === void 0 ? this._locale._abbr : (t = ge(M), t != null && (this._locale = t), this);
}
var Z3 = T2(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(M) {
    return M === void 0 ? this.localeData() : this.locale(M);
  }
);
function j3() {
  return this._locale;
}
var fp = 1e3, bM = 60 * fp, Wp = 60 * bM, ea = (365 * 400 + 97) * 24 * Wp;
function pM(M, t) {
  return (M % t + t) % t;
}
function ta(M, t, e) {
  return M < 100 && M >= 0 ? new Date(M + 400, t, e) - ea : new Date(M, t, e).valueOf();
}
function Ma(M, t, e) {
  return M < 100 && M >= 0 ? Date.UTC(M + 400, t, e) - ea : Date.UTC(M, t, e);
}
function _W(M) {
  var t, e;
  if (M = _2(M), M === void 0 || M === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? Ma : ta, M) {
    case "year":
      t = e(this.year(), 0, 1);
      break;
    case "quarter":
      t = e(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = e(this.year(), this.month(), 1);
      break;
    case "week":
      t = e(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = e(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= pM(
        t + (this._isUTC ? 0 : this.utcOffset() * bM),
        Wp
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= pM(t, bM);
      break;
    case "second":
      t = this._d.valueOf(), t -= pM(t, fp);
      break;
  }
  return this._d.setTime(t), R.updateOffset(this, !0), this;
}
function wW(M) {
  var t, e;
  if (M = _2(M), M === void 0 || M === "millisecond" || !this.isValid())
    return this;
  switch (e = this._isUTC ? Ma : ta, M) {
    case "year":
      t = e(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = e(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = e(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = e(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = e(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = e(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Wp - pM(
        t + (this._isUTC ? 0 : this.utcOffset() * bM),
        Wp
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += bM - pM(t, bM) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += fp - pM(t, fp) - 1;
      break;
  }
  return this._d.setTime(t), R.updateOffset(this, !0), this;
}
function XW() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function SW() {
  return Math.floor(this.valueOf() / 1e3);
}
function DW() {
  return new Date(this.valueOf());
}
function CW() {
  var M = this;
  return [
    M.year(),
    M.month(),
    M.date(),
    M.hour(),
    M.minute(),
    M.second(),
    M.millisecond()
  ];
}
function IW() {
  var M = this;
  return {
    years: M.year(),
    months: M.month(),
    date: M.date(),
    hours: M.hours(),
    minutes: M.minutes(),
    seconds: M.seconds(),
    milliseconds: M.milliseconds()
  };
}
function kW() {
  return this.isValid() ? this.toISOString() : null;
}
function PW() {
  return Lc(this);
}
function EW() {
  return Ye({}, B0(this));
}
function xW() {
  return B0(this).overflow;
}
function FW() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
a0("N", 0, 0, "eraAbbr");
a0("NN", 0, 0, "eraAbbr");
a0("NNN", 0, 0, "eraAbbr");
a0("NNNN", 0, 0, "eraName");
a0("NNNNN", 0, 0, "eraNarrow");
a0("y", ["y", 1], "yo", "eraYear");
a0("y", ["yy", 2], 0, "eraYear");
a0("y", ["yyy", 3], 0, "eraYear");
a0("y", ["yyyy", 4], 0, "eraYear");
o0("N", Fc);
o0("NN", Fc);
o0("NNN", Fc);
o0("NNNN", jW);
o0("NNNNN", e6);
e1(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(M, t, e, p) {
    var c = e._locale.erasParse(M, p, e._strict);
    c ? B0(e).era = c : B0(e).invalidEra = M;
  }
);
o0("y", nM);
o0("yy", nM);
o0("yyy", nM);
o0("yyyy", nM);
o0("yo", t6);
e1(["y", "yy", "yyy", "yyyy"], J1);
e1(["yo"], function(M, t, e, p) {
  var c;
  e._locale._eraYearOrdinalRegex && (c = M.match(e._locale._eraYearOrdinalRegex)), e._locale.eraYearOrdinalParse ? t[J1] = e._locale.eraYearOrdinalParse(M, c) : t[J1] = parseInt(M, 10);
});
function UW(M, t) {
  var e, p, c, i = this._eras || ge("en")._eras;
  for (e = 0, p = i.length; e < p; ++e) {
    switch (typeof i[e].since) {
      case "string":
        c = R(i[e].since).startOf("day"), i[e].since = c.valueOf();
        break;
    }
    switch (typeof i[e].until) {
      case "undefined":
        i[e].until = 1 / 0;
        break;
      case "string":
        c = R(i[e].until).startOf("day").valueOf(), i[e].until = c.valueOf();
        break;
    }
  }
  return i;
}
function JW(M, t, e) {
  var p, c, i = this.eras(), s, u, l;
  for (M = M.toUpperCase(), p = 0, c = i.length; p < c; ++p)
    if (s = i[p].name.toUpperCase(), u = i[p].abbr.toUpperCase(), l = i[p].narrow.toUpperCase(), e)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (u === M)
            return i[p];
          break;
        case "NNNN":
          if (s === M)
            return i[p];
          break;
        case "NNNNN":
          if (l === M)
            return i[p];
          break;
      }
    else if ([s, u, l].indexOf(M) >= 0)
      return i[p];
}
function HW(M, t) {
  var e = M.since <= M.until ? 1 : -1;
  return t === void 0 ? R(M.since).year() : R(M.since).year() + (t - M.offset) * e;
}
function YW() {
  var M, t, e, p = this.localeData().eras();
  for (M = 0, t = p.length; M < t; ++M)
    if (e = this.clone().startOf("day").valueOf(), p[M].since <= e && e <= p[M].until || p[M].until <= e && e <= p[M].since)
      return p[M].name;
  return "";
}
function GW() {
  var M, t, e, p = this.localeData().eras();
  for (M = 0, t = p.length; M < t; ++M)
    if (e = this.clone().startOf("day").valueOf(), p[M].since <= e && e <= p[M].until || p[M].until <= e && e <= p[M].since)
      return p[M].narrow;
  return "";
}
function $W() {
  var M, t, e, p = this.localeData().eras();
  for (M = 0, t = p.length; M < t; ++M)
    if (e = this.clone().startOf("day").valueOf(), p[M].since <= e && e <= p[M].until || p[M].until <= e && e <= p[M].since)
      return p[M].abbr;
  return "";
}
function VW() {
  var M, t, e, p, c = this.localeData().eras();
  for (M = 0, t = c.length; M < t; ++M)
    if (e = c[M].since <= c[M].until ? 1 : -1, p = this.clone().startOf("day").valueOf(), c[M].since <= p && p <= c[M].until || c[M].until <= p && p <= c[M].since)
      return (this.year() - R(c[M].since).year()) * e + c[M].offset;
  return this.year();
}
function KW(M) {
  return U0(this, "_erasNameRegex") || Uc.call(this), M ? this._erasNameRegex : this._erasRegex;
}
function QW(M) {
  return U0(this, "_erasAbbrRegex") || Uc.call(this), M ? this._erasAbbrRegex : this._erasRegex;
}
function ZW(M) {
  return U0(this, "_erasNarrowRegex") || Uc.call(this), M ? this._erasNarrowRegex : this._erasRegex;
}
function Fc(M, t) {
  return t.erasAbbrRegex(M);
}
function jW(M, t) {
  return t.erasNameRegex(M);
}
function e6(M, t) {
  return t.erasNarrowRegex(M);
}
function t6(M, t) {
  return t._eraYearOrdinalRegex || nM;
}
function Uc() {
  var M = [], t = [], e = [], p = [], c, i, s, u, l, W = this.eras();
  for (c = 0, i = W.length; c < i; ++c)
    s = We(W[c].name), u = We(W[c].abbr), l = We(W[c].narrow), t.push(s), M.push(u), e.push(l), p.push(s), p.push(u), p.push(l);
  this._erasRegex = new RegExp("^(" + p.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + M.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
a0(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
a0(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Ip(M, t) {
  a0(0, [M, M.length], 0, t);
}
Ip("gggg", "weekYear");
Ip("ggggg", "weekYear");
Ip("GGGG", "isoWeekYear");
Ip("GGGGG", "isoWeekYear");
o0("G", wp);
o0("g", wp);
o0("GG", s1, d2);
o0("gg", s1, d2);
o0("GGGG", Tc, vc);
o0("gggg", Tc, vc);
o0("GGGGG", _p, vp);
o0("ggggg", _p, vp);
rb(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(M, t, e, p) {
    t[p.substr(0, 2)] = C0(M);
  }
);
rb(["gg", "GG"], function(M, t, e, p) {
  t[p] = R.parseTwoDigitYear(M);
});
function M6(M) {
  return ba.call(
    this,
    M,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function b6(M) {
  return ba.call(
    this,
    M,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function p6() {
  return he(this.year(), 1, 4);
}
function z6() {
  return he(this.isoWeekYear(), 1, 4);
}
function o6() {
  var M = this.localeData()._week;
  return he(this.year(), M.dow, M.doy);
}
function c6() {
  var M = this.localeData()._week;
  return he(this.weekYear(), M.dow, M.doy);
}
function ba(M, t, e, p, c) {
  var i;
  return M == null ? QM(this, p, c).year : (i = he(M, p, c), t > i && (t = i), n6.call(this, M, t, e, p, c));
}
function n6(M, t, e, p, c) {
  var i = C3(M, t, e, p, c), s = KM(i.year, 0, i.dayOfYear);
  return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this;
}
a0("Q", 0, "Qo", "quarter");
o0("Q", g3);
e1("Q", function(M, t) {
  t[le] = (C0(M) - 1) * 3;
});
function i6(M) {
  return M == null ? Math.ceil((this.month() + 1) / 3) : this.month((M - 1) * 3 + this.month() % 3);
}
a0("D", ["DD", 2], "Do", "date");
o0("D", s1, iM);
o0("DD", s1, d2);
o0("Do", function(M, t) {
  return M ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
e1(["D", "DD"], Q2);
e1("Do", function(M, t) {
  t[Q2] = C0(M.match(s1)[0]);
});
var pa = rM("Date", !0);
a0("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
o0("DDD", Tp);
o0("DDDD", y3);
e1(["DDD", "DDDD"], function(M, t, e) {
  e._dayOfYear = C0(M);
});
function r6(M) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return M == null ? t : this.add(M - t, "d");
}
a0("m", ["mm", 2], 0, "minute");
o0("m", s1, _c);
o0("mm", s1, d2);
e1(["m", "mm"], P2);
var O6 = rM("Minutes", !1);
a0("s", ["ss", 2], 0, "second");
o0("s", s1, _c);
o0("ss", s1, d2);
e1(["s", "ss"], fe);
var a6 = rM("Seconds", !1);
a0("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
a0(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
a0(0, ["SSS", 3], 0, "millisecond");
a0(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
a0(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
a0(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
a0(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
a0(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
a0(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
o0("S", Tp, g3);
o0("SS", Tp, d2);
o0("SSS", Tp, y3);
var Ge, za;
for (Ge = "SSSS"; Ge.length <= 9; Ge += "S")
  o0(Ge, nM);
function s6(M, t) {
  t[st] = C0(("0." + M) * 1e3);
}
for (Ge = "S"; Ge.length <= 9; Ge += "S")
  e1(Ge, s6);
za = rM("Milliseconds", !1);
a0("z", 0, 0, "zoneAbbr");
a0("zz", 0, 0, "zoneName");
function A6() {
  return this._isUTC ? "UTC" : "";
}
function d6() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Q = nb.prototype;
Q.add = cW;
Q.calendar = AW;
Q.clone = dW;
Q.diff = mW;
Q.endOf = wW;
Q.format = yW;
Q.from = NW;
Q.fromNow = BW;
Q.to = vW;
Q.toNow = TW;
Q.get = gf;
Q.invalidAt = xW;
Q.isAfter = uW;
Q.isBefore = qW;
Q.isBetween = lW;
Q.isSame = fW;
Q.isSameOrAfter = WW;
Q.isSameOrBefore = hW;
Q.isValid = PW;
Q.lang = Z3;
Q.locale = Q3;
Q.localeData = j3;
Q.max = P5;
Q.min = k5;
Q.parsingFlags = EW;
Q.set = yf;
Q.startOf = _W;
Q.subtract = nW;
Q.toArray = CW;
Q.toObject = IW;
Q.toDate = DW;
Q.toISOString = LW;
Q.inspect = gW;
typeof Symbol < "u" && Symbol.for != null && (Q[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Q.toJSON = kW;
Q.toString = RW;
Q.unix = SW;
Q.valueOf = XW;
Q.creationData = FW;
Q.eraName = YW;
Q.eraNarrow = GW;
Q.eraAbbr = $W;
Q.eraYear = VW;
Q.year = v3;
Q.isLeapYear = Lf;
Q.weekYear = M6;
Q.isoWeekYear = b6;
Q.quarter = Q.quarters = i6;
Q.month = S3;
Q.daysInMonth = Df;
Q.week = Q.weeks = Uf;
Q.isoWeek = Q.isoWeeks = Jf;
Q.weeksInYear = o6;
Q.weeksInWeekYear = c6;
Q.isoWeeksInYear = p6;
Q.isoWeeksInISOWeekYear = z6;
Q.date = pa;
Q.day = Q.days = b5;
Q.weekday = p5;
Q.isoWeekday = z5;
Q.dayOfYear = r6;
Q.hour = Q.hours = a5;
Q.minute = Q.minutes = O6;
Q.second = Q.seconds = a6;
Q.millisecond = Q.milliseconds = za;
Q.utcOffset = $5;
Q.utc = K5;
Q.local = Q5;
Q.parseZone = Z5;
Q.hasAlignedHourOffset = j5;
Q.isDST = eW;
Q.isLocal = MW;
Q.isUtcOffset = bW;
Q.isUtc = G3;
Q.isUTC = G3;
Q.zoneAbbr = A6;
Q.zoneName = d6;
Q.dates = T2(
  "dates accessor is deprecated. Use date instead.",
  pa
);
Q.months = T2(
  "months accessor is deprecated. Use month instead",
  S3
);
Q.years = T2(
  "years accessor is deprecated. Use year instead",
  v3
);
Q.zone = T2(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  V5
);
Q.isDSTShifted = T2(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  tW
);
function u6(M) {
  return a1(M * 1e3);
}
function q6() {
  return a1.apply(null, arguments).parseZone();
}
function oa(M) {
  return M;
}
var J0 = yc.prototype;
J0.calendar = tf;
J0.longDateFormat = zf;
J0.invalidDate = cf;
J0.ordinal = Of;
J0.preparse = oa;
J0.postformat = oa;
J0.relativeTime = sf;
J0.pastFuture = Af;
J0.set = jl;
J0.eras = UW;
J0.erasParse = JW;
J0.erasConvertYear = HW;
J0.erasAbbrRegex = QW;
J0.erasNameRegex = KW;
J0.erasNarrowRegex = ZW;
J0.months = _f;
J0.monthsShort = wf;
J0.monthsParse = Sf;
J0.monthsRegex = If;
J0.monthsShortRegex = Cf;
J0.week = Pf;
J0.firstDayOfYear = Ff;
J0.firstDayOfWeek = xf;
J0.weekdays = Zf;
J0.weekdaysMin = e5;
J0.weekdaysShort = jf;
J0.weekdaysParse = M5;
J0.weekdaysRegex = o5;
J0.weekdaysShortRegex = c5;
J0.weekdaysMinRegex = n5;
J0.isPM = r5;
J0.meridiem = s5;
function hp(M, t, e, p) {
  var c = ge(), i = te().set(p, t);
  return c[e](i, M);
}
function ca(M, t, e) {
  if (Re(M) && (t = M, M = void 0), M = M || "", t != null)
    return hp(M, t, e, "month");
  var p, c = [];
  for (p = 0; p < 12; p++)
    c[p] = hp(M, p, e, "month");
  return c;
}
function Jc(M, t, e, p) {
  typeof M == "boolean" ? (Re(t) && (e = t, t = void 0), t = t || "") : (t = M, e = t, M = !1, Re(t) && (e = t, t = void 0), t = t || "");
  var c = ge(), i = M ? c._week.dow : 0, s, u = [];
  if (e != null)
    return hp(t, (e + i) % 7, p, "day");
  for (s = 0; s < 7; s++)
    u[s] = hp(t, (s + i) % 7, p, "day");
  return u;
}
function l6(M, t) {
  return ca(M, t, "months");
}
function f6(M, t) {
  return ca(M, t, "monthsShort");
}
function W6(M, t, e) {
  return Jc(M, t, e, "weekdays");
}
function h6(M, t, e) {
  return Jc(M, t, e, "weekdaysShort");
}
function m6(M, t, e) {
  return Jc(M, t, e, "weekdaysMin");
}
$e("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(M) {
    var t = M % 10, e = C0(M % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return M + e;
  }
});
R.lang = T2(
  "moment.lang is deprecated. Use moment.locale instead.",
  $e
);
R.langData = T2(
  "moment.langData is deprecated. Use moment.localeData instead.",
  ge
);
var ue = Math.abs;
function R6() {
  var M = this._data;
  return this._milliseconds = ue(this._milliseconds), this._days = ue(this._days), this._months = ue(this._months), M.milliseconds = ue(M.milliseconds), M.seconds = ue(M.seconds), M.minutes = ue(M.minutes), M.hours = ue(M.hours), M.months = ue(M.months), M.years = ue(M.years), this;
}
function na(M, t, e, p) {
  var c = U2(t, e);
  return M._milliseconds += p * c._milliseconds, M._days += p * c._days, M._months += p * c._months, M._bubble();
}
function L6(M, t) {
  return na(this, M, t, 1);
}
function g6(M, t) {
  return na(this, M, t, -1);
}
function rO(M) {
  return M < 0 ? Math.floor(M) : Math.ceil(M);
}
function y6() {
  var M = this._milliseconds, t = this._days, e = this._months, p = this._data, c, i, s, u, l;
  return M >= 0 && t >= 0 && e >= 0 || M <= 0 && t <= 0 && e <= 0 || (M += rO(lc(e) + t) * 864e5, t = 0, e = 0), p.milliseconds = M % 1e3, c = N2(M / 1e3), p.seconds = c % 60, i = N2(c / 60), p.minutes = i % 60, s = N2(i / 60), p.hours = s % 24, t += N2(s / 24), l = N2(ia(t)), e += l, t -= rO(lc(l)), u = N2(e / 12), e %= 12, p.days = t, p.months = e, p.years = u, this;
}
function ia(M) {
  return M * 4800 / 146097;
}
function lc(M) {
  return M * 146097 / 4800;
}
function N6(M) {
  if (!this.isValid())
    return NaN;
  var t, e, p = this._milliseconds;
  if (M = _2(M), M === "month" || M === "quarter" || M === "year")
    switch (t = this._days + p / 864e5, e = this._months + ia(t), M) {
      case "month":
        return e;
      case "quarter":
        return e / 3;
      case "year":
        return e / 12;
    }
  else
    switch (t = this._days + Math.round(lc(this._months)), M) {
      case "week":
        return t / 7 + p / 6048e5;
      case "day":
        return t + p / 864e5;
      case "hour":
        return t * 24 + p / 36e5;
      case "minute":
        return t * 1440 + p / 6e4;
      case "second":
        return t * 86400 + p / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(t * 864e5) + p;
      default:
        throw new Error("Unknown unit " + M);
    }
}
function ye(M) {
  return function() {
    return this.as(M);
  };
}
var ra = ye("ms"), B6 = ye("s"), v6 = ye("m"), T6 = ye("h"), _6 = ye("d"), w6 = ye("w"), X6 = ye("M"), S6 = ye("Q"), D6 = ye("y"), C6 = ra;
function I6() {
  return U2(this);
}
function k6(M) {
  return M = _2(M), this.isValid() ? this[M + "s"]() : NaN;
}
function Bt(M) {
  return function() {
    return this.isValid() ? this._data[M] : NaN;
  };
}
var P6 = Bt("milliseconds"), E6 = Bt("seconds"), x6 = Bt("minutes"), F6 = Bt("hours"), U6 = Bt("days"), J6 = Bt("months"), H6 = Bt("years");
function Y6() {
  return N2(this.days() / 7);
}
var qe = Math.round, jt = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function G6(M, t, e, p, c) {
  return c.relativeTime(t || 1, !!e, M, p);
}
function $6(M, t, e, p) {
  var c = U2(M).abs(), i = qe(c.as("s")), s = qe(c.as("m")), u = qe(c.as("h")), l = qe(c.as("d")), W = qe(c.as("M")), L = qe(c.as("w")), m = qe(c.as("y")), X = i <= e.ss && ["s", i] || i < e.s && ["ss", i] || s <= 1 && ["m"] || s < e.m && ["mm", s] || u <= 1 && ["h"] || u < e.h && ["hh", u] || l <= 1 && ["d"] || l < e.d && ["dd", l];
  return e.w != null && (X = X || L <= 1 && ["w"] || L < e.w && ["ww", L]), X = X || W <= 1 && ["M"] || W < e.M && ["MM", W] || m <= 1 && ["y"] || ["yy", m], X[2] = t, X[3] = +M > 0, X[4] = p, G6.apply(null, X);
}
function V6(M) {
  return M === void 0 ? qe : typeof M == "function" ? (qe = M, !0) : !1;
}
function K6(M, t) {
  return jt[M] === void 0 ? !1 : t === void 0 ? jt[M] : (jt[M] = t, M === "s" && (jt.ss = t - 1), !0);
}
function Q6(M, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = !1, p = jt, c, i;
  return typeof M == "object" && (t = M, M = !1), typeof M == "boolean" && (e = M), typeof t == "object" && (p = Object.assign({}, jt, t), t.s != null && t.ss == null && (p.ss = t.s - 1)), c = this.localeData(), i = $6(this, !e, p, c), e && (i = c.pastFuture(+this, i)), c.postformat(i);
}
var uo = Math.abs;
function Gt(M) {
  return (M > 0) - (M < 0) || +M;
}
function kp() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var M = uo(this._milliseconds) / 1e3, t = uo(this._days), e = uo(this._months), p, c, i, s, u = this.asSeconds(), l, W, L, m;
  return u ? (p = N2(M / 60), c = N2(p / 60), M %= 60, p %= 60, i = N2(e / 12), e %= 12, s = M ? M.toFixed(3).replace(/\.?0+$/, "") : "", l = u < 0 ? "-" : "", W = Gt(this._months) !== Gt(u) ? "-" : "", L = Gt(this._days) !== Gt(u) ? "-" : "", m = Gt(this._milliseconds) !== Gt(u) ? "-" : "", l + "P" + (i ? W + i + "Y" : "") + (e ? W + e + "M" : "") + (t ? L + t + "D" : "") + (c || p || M ? "T" : "") + (c ? m + c + "H" : "") + (p ? m + p + "M" : "") + (M ? m + s + "S" : "")) : "P0D";
}
var P0 = Cp.prototype;
P0.isValid = J5;
P0.abs = R6;
P0.add = L6;
P0.subtract = g6;
P0.as = N6;
P0.asMilliseconds = ra;
P0.asSeconds = B6;
P0.asMinutes = v6;
P0.asHours = T6;
P0.asDays = _6;
P0.asWeeks = w6;
P0.asMonths = X6;
P0.asQuarters = S6;
P0.asYears = D6;
P0.valueOf = C6;
P0._bubble = y6;
P0.clone = I6;
P0.get = k6;
P0.milliseconds = P6;
P0.seconds = E6;
P0.minutes = x6;
P0.hours = F6;
P0.days = U6;
P0.weeks = Y6;
P0.months = J6;
P0.years = H6;
P0.humanize = Q6;
P0.toISOString = kp;
P0.toString = kp;
P0.toJSON = kp;
P0.locale = Q3;
P0.localeData = j3;
P0.toIsoString = T2(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  kp
);
P0.lang = Z3;
a0("X", 0, 0, "unix");
a0("x", 0, 0, "valueOf");
o0("x", wp);
o0("X", lf);
e1("X", function(M, t, e) {
  e._d = new Date(parseFloat(M) * 1e3);
});
e1("x", function(M, t, e) {
  e._d = new Date(C0(M));
});
//! moment.js
R.version = "2.30.1";
Ql(a1);
R.fn = Q;
R.min = E5;
R.max = x5;
R.now = F5;
R.utc = te;
R.unix = u6;
R.months = l6;
R.isDate = cb;
R.locale = $e;
R.invalid = Bp;
R.duration = U2;
R.isMoment = F2;
R.weekdays = W6;
R.parseZone = q6;
R.localeData = ge;
R.isDuration = sp;
R.monthsShort = f6;
R.weekdaysMin = m6;
R.defineLocale = Cc;
R.updateLocale = q5;
R.locales = l5;
R.weekdaysShort = h6;
R.normalizeUnits = _2;
R.relativeTimeRounding = V6;
R.relativeTimeThreshold = K6;
R.calendarFormat = sW;
R.prototype = Q;
R.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Z6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R
}, Symbol.toStringTag, { value: "Module" }));
class H1 {
  update(t, e = !1) {
    if (t != null)
      for (const p in t)
        t.hasOwnProperty(p) && (e ? this[p] = t[p] : t[p] !== void 0 && (this[p] = t[p]));
  }
  clone() {
    throw new Error("Method not implemented.");
  }
}
class M0 extends H1 {
  constructor() {
    super(...arguments);
    o(this, "id");
    o(this, "softDeleted");
    o(this, "softDeletedDate");
  }
}
class dt extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "offset");
    e && this.update(e);
  }
  get offsetAsText() {
    if (!this.offset) return "";
    const e = this.offset.asMilliseconds() < 0, p = Math.floor(Math.abs(this.offset.asHours())), c = Math.abs(this.offset.asMinutes()) - p * 60, i = p.toString().padStart(2, "0") + ":" + c.toString().padStart(2, "0");
    return e ? `-${i}` : `+${i}`;
  }
  update(e) {
    super.update(e);
  }
  clone() {
    return new dt({
      id: this.id,
      offset: this.offset,
      name: this.name
    });
  }
  static fromJson(e) {
    return new dt({
      id: e.id,
      offset: R.duration(e.offset ?? "00:00"),
      name: e.name
    });
  }
  static utc() {
    return new dt({
      id: "UTC",
      offset: R.duration("00:00")
    });
  }
}
var mp = /* @__PURE__ */ ((M) => (M.ru = "ru", M.en = "en", M.id = "id", M.uk = "uk", M.es = "es", M.zhtw = "zhtw", M.zhcn = "zhcn", M.lt = "lt", M.pt = "pt", M))(mp || {});
class j6 {
  constructor() {
    o(this, "listeners", {});
  }
  on(t, e) {
    this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push(e);
  }
  off(t, e) {
    this.listeners[t] && (this.listeners[t] = this.listeners[t].filter(
      (p) => p !== e
    ));
  }
  once(t, e) {
    const p = (c) => {
      e(c), this.off(t, p);
    };
    this.on(t, p);
  }
  emit(t, e) {
    this.listeners[t] && this.listeners[t].forEach((p) => p(e));
  }
}
class I0 {
  constructor(t) {
    o(this, "skip", 0);
    o(this, "take", 25);
    o(this, "itemsTotal", 0);
    o(this, "search");
    o(this, "sortName");
    o(this, "sortType");
    o(this, "filters");
    o(this, "softDeleted", !1);
    o(this, "useSort", !0);
    o(this, "useBaseFilter", !0);
    o(this, "useItemsTotal", !0);
    o(this, "ids");
    o(this, "extendedFilterId");
    o(this, "extendedFilter");
    o(this, "fields");
    t && this.update(t);
  }
  get page() {
    return this.skip / Math.max(1, this.take) + 1;
  }
  set page(t) {
    this.skip = (t - 1) * Math.max(1, this.take);
  }
  get pageTotal() {
    return Math.ceil(this.itemsTotal / Math.max(1, this.take));
  }
  update(t) {
    for (const e in t)
      t.hasOwnProperty(e) && (this[e] = t[e] === null ? void 0 : t[e]);
    t.softDeleted === null && (this.softDeleted = null);
  }
}
class Ob {
  constructor(t = "paging") {
    o(this, "inited", !1);
    o(this, "hasError", !1);
    o(this, "fetching", !1);
    o(this, "items", []);
    o(this, "filter");
    o(this, "mode", "paging");
    c0(this, {
      inited: r,
      hasError: r,
      fetching: r,
      items: r,
      filter: r,
      mode: r,
      isEmpty: Y,
      hasMore: Y,
      moreCount: Y,
      setItems: I,
      processResponse: I,
      updateFilter: I,
      setFilter: I,
      reset: I,
      insertItems: I,
      updateItems: I,
      replaceItems: I,
      removeItems: I
    }), this.filter = this.createFilter({}), this.mode = t;
  }
  get isEmpty() {
    return this.inited && this.filter.itemsTotal == 0;
  }
  get hasMore() {
    if (this.filter.itemsTotal === void 0) return !0;
    switch (this.mode) {
      case "paging":
        return this.filter.page * this.filter.take < this.filter.itemsTotal;
      case "infinity":
        return this.filter.itemsTotal > this.items.length;
    }
  }
  get moreCount() {
    switch (this.mode) {
      case "paging":
        return Math.max(this.filter.itemsTotal - this.filter.page * this.filter.take, 0);
      case "infinity":
        return this.filter.itemsTotal - this.items.length;
    }
  }
  setItems(t) {
    this.items = t;
  }
  async fetch(t) {
    i0(() => {
      this.fetching = !0;
    });
    const e = await this.fetchItems(t ?? this.filter);
    if (e.success) {
      const p = e.body.items ?? [], c = e.body.filter;
      this.processResponse(p, c);
    }
    return i0(() => {
      this.inited = !0, this.hasError = !e.success, this.fetching = !1;
    }), e;
  }
  /**
   * fetch with no pagination
   * @param fields 
   * @returns 
   */
  async fetchAll(t = !1) {
    const e = this.createFilter({
      useBaseFilter: !1,
      softDeleted: t ? null : this.filter.softDeleted
    });
    return await this.fetch(e);
  }
  processResponse(t, e) {
    switch (this.mode) {
      case "paging": {
        this.items = t;
        break;
      }
      case "infinity": {
        const p = this.items.slice();
        let c = e.skip;
        for (const i of t)
          p[c] || (p[c] = i), c++;
        this.items = p;
        break;
      }
    }
    if (!e) {
      console.warn("[ListStore] No filter in response");
      return;
    }
    this.filter = this.createFilter({ ...this.filter, itemsTotal: e.itemsTotal });
  }
  updateFilter(t, e = !0) {
    e && (this.filter.page = 1), this.filter = this.createFilter(t);
  }
  setFilter(t) {
    this.filter = t;
  }
  createFilter(t) {
    return new I0({ ...this.filter, ...t });
  }
  reset() {
    this.items = [], this.hasError = !1, this.filter = this.createFilter({}), this.inited = !1;
  }
  insertItems(...t) {
    this.items = [...t, ...this.items], this.updateFilter({ itemsTotal: Math.max(this.filter.itemsTotal + t.length, 0) });
  }
  updateItems(...t) {
    for (const e of t) {
      const p = this.items.findIndex((c) => c.id === e.id);
      p !== -1 && this.items[p].update(e);
    }
  }
  replaceItems(...t) {
    for (const e of t) {
      const p = this.items.findIndex((c) => c.id === e.id);
      p !== -1 && (this.items[p] = e);
    }
  }
  removeItems(...t) {
    this.items = this.items.filter((e) => !t.some((p) => p.id === e.id)), this.updateFilter({ itemsTotal: Math.max(this.filter.itemsTotal - t.length, 0) });
  }
}
class z2 extends Ob {
  constructor(e = "paging") {
    super(e);
    o(this, "creating", !1);
    o(this, "saving", !1);
    o(this, "deleting", !1);
    c0(this, {
      creating: r,
      saving: r,
      deleting: r,
      create: I,
      save: I,
      savePartial: I,
      saveCustom: I,
      delete: I,
      fetchItem: I,
      updateFilter: Vl
    });
  }
  async create(e) {
    this.creating = !0;
    const p = await this.crudApi.create(e);
    return p.success && (typeof p.body == "string" ? e.update({ id: p.body }) : e.update(p.body)), i0(() => {
      this.creating = !1;
    }), p;
  }
  async save(e) {
    this.saving = !0;
    const p = await this.crudApi.save(e.toJson());
    return i0(() => {
      this.saving = !1;
    }), p;
  }
  async savePartial(e, p) {
    this.saving = !0;
    const c = await this.crudApi.save({ id: p.id, ...e });
    return c.success && p.update(e), i0(() => {
      this.saving = !1;
    }), c;
  }
  async saveCustom(e) {
    this.saving = !0;
    const p = await this.crudApi.save(e);
    return i0(() => {
      this.saving = !1;
    }), p;
  }
  async delete(e, p = !0) {
    this.deleting = !0;
    const c = await this.crudApi.delete(e);
    return c.success && p && await this.fetch(), i0(() => {
      this.deleting = !1;
    }), c;
  }
  async fetchItem(e, p) {
    this.fetching = !0;
    const c = await this.crudApi.fetchItem(e, p);
    return i0(() => {
      this.fetching = !1;
    }), c;
  }
  async fetchItems(e, p) {
    return this.crudApi.fetch(p, e ?? this.filter);
  }
  updateFilter(e, p = !0) {
    p && (this.filter.page = 1), this.filter = { ...this.filter, ...e };
  }
}
class eh {
  constructor() {
    o(this, "stack", []);
  }
  get length() {
    return this.stack.length;
  }
  push(t) {
    if (t == null) throw new Error("[DisposableStack] func is null");
    if (t.dispose != null) {
      this.stack.push(t.dispose.bind(t));
      return;
    }
    if (typeof t != "function") throw new Error("[DisposableStack] func is not a function");
    this.stack.push(t);
  }
  dispose() {
    for (; this.stack.length > 0; )
      this.stack.pop()();
  }
}
class ab {
  constructor() {
    o(this, "stack");
    this.stack = new eh();
  }
  toDispose(t) {
    this.stack.push(t);
  }
  dispose() {
    this.stack.dispose();
  }
}
var th = /* @__PURE__ */ ((M) => (M[M.Day = 24] = "Day", M))(th || {}), Mh = /* @__PURE__ */ ((M) => (M[M.Hour = 60] = "Hour", M[M.Day = 1440] = "Day", M))(Mh || {}), bh = /* @__PURE__ */ ((M) => (M[M.Minute = 60] = "Minute", M[M.Hour = 3600] = "Hour", M[M.Day = 86400] = "Day", M))(bh || {}), ph = /* @__PURE__ */ ((M) => (M[M.Second = 1e3] = "Second", M[M.Minute = 6e4] = "Minute", M[M.Hour = 36e5] = "Hour", M[M.Day = 864e5] = "Day", M))(ph || {}), zh = /* @__PURE__ */ ((M) => (M[M.Millisecond = 1e4] = "Millisecond", M[M.Second = 1e7] = "Second", M[M.Minute = 6e8] = "Minute", M[M.Hour = 36e9] = "Hour", M[M.Day = 864e9] = "Day", M))(zh || {}), oh = /* @__PURE__ */ ((M) => (M[M.Ticks = 0] = "Ticks", M[M.Milliseconds = 1] = "Milliseconds", M[M.Seconds = 2] = "Seconds", M[M.Minutes = 3] = "Minutes", M[M.Hours = 4] = "Hours", M[M.Days = 5] = "Days", M))(oh || {});
class ch {
  static toMilliseconds(t, e = 1) {
    switch (e) {
      //@ts-ignore
      case 5:
        t *= 24;
      //@ts-ignore
      case 4:
        t *= 60;
      //@ts-ignore
      case 3:
        t *= 60;
      //@ts-ignore
      case 2:
        t *= 1e3;
      case 1:
        return t;
      case 0:
        return t / 1e4;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
  static fromMilliseconds(t, e) {
    switch (e) {
      case 5:
        return t / 864e5;
      case 4:
        return t / 36e5;
      case 3:
        return t / 6e4;
      case 2:
        return t / 1e3;
      case 1:
        return t;
      case 0:
        return t * 1e4;
      default:
        throw new Error("Invalid TimeUnit.");
    }
  }
}
class c1 {
  constructor(t, e = 1) {
    o(this, "ticks");
    o(this, "milliseconds");
    o(this, "seconds");
    o(this, "minutes");
    o(this, "hours");
    o(this, "days");
    const p = ch.toMilliseconds(t, e);
    this.ticks = p * 1e4, this.milliseconds = p, this.seconds = p / 1e3, this.minutes = p / 6e4, this.hours = p / 36e5, this.days = p / 864e5;
  }
  add(t) {
    return c1.fromMilliseconds(this.milliseconds + t.milliseconds);
  }
  substract(t) {
    return c1.fromMilliseconds(this.milliseconds - t.milliseconds);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.ticks == 0;
  }
  static from(t, e) {
    return new c1(t, e);
  }
  static fromDays(t) {
    return new c1(
      t,
      5
      /* Days */
    );
  }
  static fromHours(t) {
    return new c1(
      t,
      4
      /* Hours */
    );
  }
  static fromMinutes(t) {
    return new c1(
      t,
      3
      /* Minutes */
    );
  }
  static fromSeconds(t) {
    return new c1(
      t,
      2
      /* Seconds */
    );
  }
  static fromMilliseconds(t) {
    return new c1(
      t,
      1
      /* Milliseconds */
    );
  }
  static fromMs(t) {
    return new c1(
      t,
      1
      /* Milliseconds */
    );
  }
  static fromTicks(t) {
    return new c1(
      t,
      0
      /* Ticks */
    );
  }
  static fromTimeMeasure(t, e) {
    switch (e) {
      case "seconds":
        return c1.fromSeconds(t);
      case "minutes":
        return c1.fromMinutes(t);
      case "hours":
        return c1.fromHours(t);
      case "days":
        return c1.fromDays(t);
      case "weeks":
        return c1.fromDays(t * 7);
      case "months":
        return c1.fromDays(t * 30);
      default:
        throw new Error("Invalid TimeMeasure.");
    }
  }
  static get zero() {
    return new c1(0);
  }
}
c1.prototype.toString = function() {
  return this.milliseconds.toString();
};
c1.prototype.valueOf = function() {
  return this.milliseconds;
};
var eM = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hc(M) {
  return M && M.__esModule && Object.prototype.hasOwnProperty.call(M, "default") ? M.default : M;
}
function Oa(M) {
  if (Object.prototype.hasOwnProperty.call(M, "__esModule")) return M;
  var t = M.default;
  if (typeof t == "function") {
    var e = function p() {
      return this instanceof p ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    e.prototype = t.prototype;
  } else e = {};
  return Object.defineProperty(e, "__esModule", { value: !0 }), Object.keys(M).forEach(function(p) {
    var c = Object.getOwnPropertyDescriptor(M, p);
    Object.defineProperty(e, p, c.get ? c : {
      enumerable: !0,
      get: function() {
        return M[p];
      }
    });
  }), e;
}
var FM = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var nh = FM.exports, OO;
function ih() {
  return OO || (OO = 1, (function(M, t) {
    (function() {
      var e, p = "4.17.21", c = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", u = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", W = 500, L = "__lodash_placeholder__", m = 1, X = 2, D = 4, y = 1, S = 2, B = 1, Z = 2, H = 4, e0 = 8, r0 = 16, G = 32, j = 64, v = 128, E = 256, K = 512, p0 = 30, O0 = "...", s0 = 800, E0 = 16, l0 = 1, Q0 = 2, W0 = 3, $0 = 1 / 0, $ = 9007199254740991, x0 = 17976931348623157e292, f1 = NaN, n1 = 4294967295, u2 = n1 - 1, q2 = n1 >>> 1, Z1 = [
        ["ary", v],
        ["bind", B],
        ["bindKey", Z],
        ["curry", e0],
        ["curryRight", r0],
        ["flip", K],
        ["partial", G],
        ["partialRight", j],
        ["rearg", E]
      ], v1 = "[object Arguments]", i1 = "[object Array]", S0 = "[object AsyncFunction]", b1 = "[object Boolean]", p1 = "[object Date]", _0 = "[object DOMException]", Z0 = "[object Error]", w0 = "[object Function]", f = "[object GeneratorFunction]", C = "[object Map]", k = "[object Number]", V = "[object Null]", b0 = "[object Object]", q0 = "[object Promise]", V0 = "[object Proxy]", h0 = "[object RegExp]", f0 = "[object Set]", o2 = "[object String]", w2 = "[object Symbol]", Be = "[object Undefined]", Ve = "[object WeakMap]", jp = "[object WeakSet]", ve = "[object ArrayBuffer]", Te = "[object DataView]", pe = "[object Float32Array]", Ke = "[object Float64Array]", vt = "[object Int8Array]", uM = "[object Int16Array]", qM = "[object Int32Array]", Qe = "[object Uint8Array]", _e = "[object Uint8ClampedArray]", T = "[object Uint16Array]", _ = "[object Uint32Array]", F0 = /\b__p \+= '';/g, j0 = /\b(__p \+=) '' \+/g, t1 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, g0 = /&(?:amp|lt|gt|quot|#39);/g, X2 = /[&<>"']/g, ze = RegExp(g0.source), Y1 = RegExp(X2.source), J2 = /<%-([\s\S]+?)%>/g, lM = /<%([\s\S]+?)%>/g, oe = /<%=([\s\S]+?)%>/g, c2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, db = /^\w*$/, ub = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Tt = /[\\^$.*+?()[\]{}|]/g, Ze = RegExp(Tt.source), je = /^\s+/, _t = /\s/, fM = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, WM = /\{\n\/\* \[wrapped with (.+)\] \*/, qb = /,? & /, lb = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, hM = /[()=,{}\[\]\/\s]/, fb = /\\(\\)?/g, mM = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, RM = /\w*$/, ez = /^[-+]0x[0-9a-f]+$/i, LM = /^0b[01]+$/i, we = /^\[object .+?Constructor\]$/, wt = /^0o[0-7]+$/i, tz = /^(?:0|[1-9]\d*)$/, Wb = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, hb = /($^)/, Pa = /['\n\r\u2028\u2029\\]/g, mb = "\\ud800-\\udfff", Ea = "\\u0300-\\u036f", xa = "\\ufe20-\\ufe2f", Fa = "\\u20d0-\\u20ff", Xn = Ea + xa + Fa, Sn = "\\u2700-\\u27bf", Dn = "a-z\\xdf-\\xf6\\xf8-\\xff", Ua = "\\xac\\xb1\\xd7\\xf7", Ja = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ha = "\\u2000-\\u206f", Ya = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Cn = "A-Z\\xc0-\\xd6\\xd8-\\xde", In = "\\ufe0e\\ufe0f", kn = Ua + Ja + Ha + Ya, Mz = "['’]", Ga = "[" + mb + "]", Pn = "[" + kn + "]", Rb = "[" + Xn + "]", En = "\\d+", $a = "[" + Sn + "]", xn = "[" + Dn + "]", Fn = "[^" + mb + kn + En + Sn + Dn + Cn + "]", bz = "\\ud83c[\\udffb-\\udfff]", Va = "(?:" + Rb + "|" + bz + ")", Un = "[^" + mb + "]", pz = "(?:\\ud83c[\\udde6-\\uddff]){2}", zz = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xt = "[" + Cn + "]", Jn = "\\u200d", Hn = "(?:" + xn + "|" + Fn + ")", Ka = "(?:" + Xt + "|" + Fn + ")", Yn = "(?:" + Mz + "(?:d|ll|m|re|s|t|ve))?", Gn = "(?:" + Mz + "(?:D|LL|M|RE|S|T|VE))?", $n = Va + "?", Vn = "[" + In + "]?", Qa = "(?:" + Jn + "(?:" + [Un, pz, zz].join("|") + ")" + Vn + $n + ")*", Za = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ja = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Kn = Vn + $n + Qa, es = "(?:" + [$a, pz, zz].join("|") + ")" + Kn, ts = "(?:" + [Un + Rb + "?", Rb, pz, zz, Ga].join("|") + ")", Ms = RegExp(Mz, "g"), bs = RegExp(Rb, "g"), oz = RegExp(bz + "(?=" + bz + ")|" + ts + Kn, "g"), ps = RegExp([
        Xt + "?" + xn + "+" + Yn + "(?=" + [Pn, Xt, "$"].join("|") + ")",
        Ka + "+" + Gn + "(?=" + [Pn, Xt + Hn, "$"].join("|") + ")",
        Xt + "?" + Hn + "+" + Yn,
        Xt + "+" + Gn,
        ja,
        Za,
        En,
        es
      ].join("|"), "g"), zs = RegExp("[" + Jn + mb + Xn + In + "]"), os = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, cs = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ns = -1, r1 = {};
      r1[pe] = r1[Ke] = r1[vt] = r1[uM] = r1[qM] = r1[Qe] = r1[_e] = r1[T] = r1[_] = !0, r1[v1] = r1[i1] = r1[ve] = r1[b1] = r1[Te] = r1[p1] = r1[Z0] = r1[w0] = r1[C] = r1[k] = r1[b0] = r1[h0] = r1[f0] = r1[o2] = r1[Ve] = !1;
      var z1 = {};
      z1[v1] = z1[i1] = z1[ve] = z1[Te] = z1[b1] = z1[p1] = z1[pe] = z1[Ke] = z1[vt] = z1[uM] = z1[qM] = z1[C] = z1[k] = z1[b0] = z1[h0] = z1[f0] = z1[o2] = z1[w2] = z1[Qe] = z1[_e] = z1[T] = z1[_] = !0, z1[Z0] = z1[w0] = z1[Ve] = !1;
      var is = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, rs = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Os = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, as = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, ss = parseFloat, As = parseInt, Qn = typeof eM == "object" && eM && eM.Object === Object && eM, ds = typeof self == "object" && self && self.Object === Object && self, k1 = Qn || ds || Function("return this")(), cz = t && !t.nodeType && t, et = cz && !0 && M && !M.nodeType && M, Zn = et && et.exports === cz, nz = Zn && Qn.process, l2 = (function() {
        try {
          var g = et && et.require && et.require("util").types;
          return g || nz && nz.binding && nz.binding("util");
        } catch {
        }
      })(), jn = l2 && l2.isArrayBuffer, ei = l2 && l2.isDate, ti = l2 && l2.isMap, Mi = l2 && l2.isRegExp, bi = l2 && l2.isSet, pi = l2 && l2.isTypedArray;
      function n2(g, P, w) {
        switch (w.length) {
          case 0:
            return g.call(P);
          case 1:
            return g.call(P, w[0]);
          case 2:
            return g.call(P, w[0], w[1]);
          case 3:
            return g.call(P, w[0], w[1], w[2]);
        }
        return g.apply(P, w);
      }
      function us(g, P, w, z0) {
        for (var m0 = -1, H0 = g == null ? 0 : g.length; ++m0 < H0; ) {
          var w1 = g[m0];
          P(z0, w1, w(w1), g);
        }
        return z0;
      }
      function f2(g, P) {
        for (var w = -1, z0 = g == null ? 0 : g.length; ++w < z0 && P(g[w], w, g) !== !1; )
          ;
        return g;
      }
      function qs(g, P) {
        for (var w = g == null ? 0 : g.length; w-- && P(g[w], w, g) !== !1; )
          ;
        return g;
      }
      function zi(g, P) {
        for (var w = -1, z0 = g == null ? 0 : g.length; ++w < z0; )
          if (!P(g[w], w, g))
            return !1;
        return !0;
      }
      function Xe(g, P) {
        for (var w = -1, z0 = g == null ? 0 : g.length, m0 = 0, H0 = []; ++w < z0; ) {
          var w1 = g[w];
          P(w1, w, g) && (H0[m0++] = w1);
        }
        return H0;
      }
      function Lb(g, P) {
        var w = g == null ? 0 : g.length;
        return !!w && St(g, P, 0) > -1;
      }
      function iz(g, P, w) {
        for (var z0 = -1, m0 = g == null ? 0 : g.length; ++z0 < m0; )
          if (w(P, g[z0]))
            return !0;
        return !1;
      }
      function A1(g, P) {
        for (var w = -1, z0 = g == null ? 0 : g.length, m0 = Array(z0); ++w < z0; )
          m0[w] = P(g[w], w, g);
        return m0;
      }
      function Se(g, P) {
        for (var w = -1, z0 = P.length, m0 = g.length; ++w < z0; )
          g[m0 + w] = P[w];
        return g;
      }
      function rz(g, P, w, z0) {
        var m0 = -1, H0 = g == null ? 0 : g.length;
        for (z0 && H0 && (w = g[++m0]); ++m0 < H0; )
          w = P(w, g[m0], m0, g);
        return w;
      }
      function ls(g, P, w, z0) {
        var m0 = g == null ? 0 : g.length;
        for (z0 && m0 && (w = g[--m0]); m0--; )
          w = P(w, g[m0], m0, g);
        return w;
      }
      function Oz(g, P) {
        for (var w = -1, z0 = g == null ? 0 : g.length; ++w < z0; )
          if (P(g[w], w, g))
            return !0;
        return !1;
      }
      var fs = az("length");
      function Ws(g) {
        return g.split("");
      }
      function hs(g) {
        return g.match(lb) || [];
      }
      function oi(g, P, w) {
        var z0;
        return w(g, function(m0, H0, w1) {
          if (P(m0, H0, w1))
            return z0 = H0, !1;
        }), z0;
      }
      function gb(g, P, w, z0) {
        for (var m0 = g.length, H0 = w + (z0 ? 1 : -1); z0 ? H0-- : ++H0 < m0; )
          if (P(g[H0], H0, g))
            return H0;
        return -1;
      }
      function St(g, P, w) {
        return P === P ? Xs(g, P, w) : gb(g, ci, w);
      }
      function ms(g, P, w, z0) {
        for (var m0 = w - 1, H0 = g.length; ++m0 < H0; )
          if (z0(g[m0], P))
            return m0;
        return -1;
      }
      function ci(g) {
        return g !== g;
      }
      function ni(g, P) {
        var w = g == null ? 0 : g.length;
        return w ? Az(g, P) / w : f1;
      }
      function az(g) {
        return function(P) {
          return P == null ? e : P[g];
        };
      }
      function sz(g) {
        return function(P) {
          return g == null ? e : g[P];
        };
      }
      function ii(g, P, w, z0, m0) {
        return m0(g, function(H0, w1, M1) {
          w = z0 ? (z0 = !1, H0) : P(w, H0, w1, M1);
        }), w;
      }
      function Rs(g, P) {
        var w = g.length;
        for (g.sort(P); w--; )
          g[w] = g[w].value;
        return g;
      }
      function Az(g, P) {
        for (var w, z0 = -1, m0 = g.length; ++z0 < m0; ) {
          var H0 = P(g[z0]);
          H0 !== e && (w = w === e ? H0 : w + H0);
        }
        return w;
      }
      function dz(g, P) {
        for (var w = -1, z0 = Array(g); ++w < g; )
          z0[w] = P(w);
        return z0;
      }
      function Ls(g, P) {
        return A1(P, function(w) {
          return [w, g[w]];
        });
      }
      function ri(g) {
        return g && g.slice(0, Ai(g) + 1).replace(je, "");
      }
      function i2(g) {
        return function(P) {
          return g(P);
        };
      }
      function uz(g, P) {
        return A1(P, function(w) {
          return g[w];
        });
      }
      function gM(g, P) {
        return g.has(P);
      }
      function Oi(g, P) {
        for (var w = -1, z0 = g.length; ++w < z0 && St(P, g[w], 0) > -1; )
          ;
        return w;
      }
      function ai(g, P) {
        for (var w = g.length; w-- && St(P, g[w], 0) > -1; )
          ;
        return w;
      }
      function gs(g, P) {
        for (var w = g.length, z0 = 0; w--; )
          g[w] === P && ++z0;
        return z0;
      }
      var ys = sz(is), Ns = sz(rs);
      function Bs(g) {
        return "\\" + as[g];
      }
      function vs(g, P) {
        return g == null ? e : g[P];
      }
      function Dt(g) {
        return zs.test(g);
      }
      function Ts(g) {
        return os.test(g);
      }
      function _s(g) {
        for (var P, w = []; !(P = g.next()).done; )
          w.push(P.value);
        return w;
      }
      function qz(g) {
        var P = -1, w = Array(g.size);
        return g.forEach(function(z0, m0) {
          w[++P] = [m0, z0];
        }), w;
      }
      function si(g, P) {
        return function(w) {
          return g(P(w));
        };
      }
      function De(g, P) {
        for (var w = -1, z0 = g.length, m0 = 0, H0 = []; ++w < z0; ) {
          var w1 = g[w];
          (w1 === P || w1 === L) && (g[w] = L, H0[m0++] = w);
        }
        return H0;
      }
      function yb(g) {
        var P = -1, w = Array(g.size);
        return g.forEach(function(z0) {
          w[++P] = z0;
        }), w;
      }
      function ws(g) {
        var P = -1, w = Array(g.size);
        return g.forEach(function(z0) {
          w[++P] = [z0, z0];
        }), w;
      }
      function Xs(g, P, w) {
        for (var z0 = w - 1, m0 = g.length; ++z0 < m0; )
          if (g[z0] === P)
            return z0;
        return -1;
      }
      function Ss(g, P, w) {
        for (var z0 = w + 1; z0--; )
          if (g[z0] === P)
            return z0;
        return z0;
      }
      function Ct(g) {
        return Dt(g) ? Cs(g) : fs(g);
      }
      function S2(g) {
        return Dt(g) ? Is(g) : Ws(g);
      }
      function Ai(g) {
        for (var P = g.length; P-- && _t.test(g.charAt(P)); )
          ;
        return P;
      }
      var Ds = sz(Os);
      function Cs(g) {
        for (var P = oz.lastIndex = 0; oz.test(g); )
          ++P;
        return P;
      }
      function Is(g) {
        return g.match(oz) || [];
      }
      function ks(g) {
        return g.match(ps) || [];
      }
      var Ps = (function g(P) {
        P = P == null ? k1 : It.defaults(k1.Object(), P, It.pick(k1, cs));
        var w = P.Array, z0 = P.Date, m0 = P.Error, H0 = P.Function, w1 = P.Math, M1 = P.Object, lz = P.RegExp, Es = P.String, W2 = P.TypeError, Nb = w.prototype, xs = H0.prototype, kt = M1.prototype, Bb = P["__core-js_shared__"], vb = xs.toString, K0 = kt.hasOwnProperty, Fs = 0, di = (function() {
          var b = /[^.]+$/.exec(Bb && Bb.keys && Bb.keys.IE_PROTO || "");
          return b ? "Symbol(src)_1." + b : "";
        })(), Tb = kt.toString, Us = vb.call(M1), Js = k1._, Hs = lz(
          "^" + vb.call(K0).replace(Tt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), _b = Zn ? P.Buffer : e, Ce = P.Symbol, wb = P.Uint8Array, ui = _b ? _b.allocUnsafe : e, Xb = si(M1.getPrototypeOf, M1), qi = M1.create, li = kt.propertyIsEnumerable, Sb = Nb.splice, fi = Ce ? Ce.isConcatSpreadable : e, yM = Ce ? Ce.iterator : e, tt = Ce ? Ce.toStringTag : e, Db = (function() {
          try {
            var b = ot(M1, "defineProperty");
            return b({}, "", {}), b;
          } catch {
          }
        })(), Ys = P.clearTimeout !== k1.clearTimeout && P.clearTimeout, Gs = z0 && z0.now !== k1.Date.now && z0.now, $s = P.setTimeout !== k1.setTimeout && P.setTimeout, Cb = w1.ceil, Ib = w1.floor, fz = M1.getOwnPropertySymbols, Vs = _b ? _b.isBuffer : e, Wi = P.isFinite, Ks = Nb.join, Qs = si(M1.keys, M1), X1 = w1.max, E1 = w1.min, Zs = z0.now, js = P.parseInt, hi = w1.random, eA = Nb.reverse, Wz = ot(P, "DataView"), NM = ot(P, "Map"), hz = ot(P, "Promise"), Pt = ot(P, "Set"), BM = ot(P, "WeakMap"), vM = ot(M1, "create"), kb = BM && new BM(), Et = {}, tA = ct(Wz), MA = ct(NM), bA = ct(hz), pA = ct(Pt), zA = ct(BM), Pb = Ce ? Ce.prototype : e, TM = Pb ? Pb.valueOf : e, mi = Pb ? Pb.toString : e;
        function A(b) {
          if (R1(b) && !R0(b) && !(b instanceof D0)) {
            if (b instanceof h2)
              return b;
            if (K0.call(b, "__wrapped__"))
              return Rr(b);
          }
          return new h2(b);
        }
        var xt = /* @__PURE__ */ (function() {
          function b() {
          }
          return function(z) {
            if (!W1(z))
              return {};
            if (qi)
              return qi(z);
            b.prototype = z;
            var n = new b();
            return b.prototype = e, n;
          };
        })();
        function Eb() {
        }
        function h2(b, z) {
          this.__wrapped__ = b, this.__actions__ = [], this.__chain__ = !!z, this.__index__ = 0, this.__values__ = e;
        }
        A.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: J2,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: lM,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: oe,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: A
          }
        }, A.prototype = Eb.prototype, A.prototype.constructor = A, h2.prototype = xt(Eb.prototype), h2.prototype.constructor = h2;
        function D0(b) {
          this.__wrapped__ = b, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = n1, this.__views__ = [];
        }
        function oA() {
          var b = new D0(this.__wrapped__);
          return b.__actions__ = j1(this.__actions__), b.__dir__ = this.__dir__, b.__filtered__ = this.__filtered__, b.__iteratees__ = j1(this.__iteratees__), b.__takeCount__ = this.__takeCount__, b.__views__ = j1(this.__views__), b;
        }
        function cA() {
          if (this.__filtered__) {
            var b = new D0(this);
            b.__dir__ = -1, b.__filtered__ = !0;
          } else
            b = this.clone(), b.__dir__ *= -1;
          return b;
        }
        function nA() {
          var b = this.__wrapped__.value(), z = this.__dir__, n = R0(b), O = z < 0, a = n ? b.length : 0, d = Wd(0, a, this.__views__), q = d.start, h = d.end, N = h - q, F = O ? h : q - 1, U = this.__iteratees__, J = U.length, t0 = 0, n0 = E1(N, this.__takeCount__);
          if (!n || !O && a == N && n0 == N)
            return Yi(b, this.__actions__);
          var d0 = [];
          e:
            for (; N-- && t0 < n0; ) {
              F += z;
              for (var v0 = -1, u0 = b[F]; ++v0 < J; ) {
                var X0 = U[v0], k0 = X0.iteratee, a2 = X0.type, V1 = k0(u0);
                if (a2 == Q0)
                  u0 = V1;
                else if (!V1) {
                  if (a2 == l0)
                    continue e;
                  break e;
                }
              }
              d0[t0++] = u0;
            }
          return d0;
        }
        D0.prototype = xt(Eb.prototype), D0.prototype.constructor = D0;
        function Mt(b) {
          var z = -1, n = b == null ? 0 : b.length;
          for (this.clear(); ++z < n; ) {
            var O = b[z];
            this.set(O[0], O[1]);
          }
        }
        function iA() {
          this.__data__ = vM ? vM(null) : {}, this.size = 0;
        }
        function rA(b) {
          var z = this.has(b) && delete this.__data__[b];
          return this.size -= z ? 1 : 0, z;
        }
        function OA(b) {
          var z = this.__data__;
          if (vM) {
            var n = z[b];
            return n === l ? e : n;
          }
          return K0.call(z, b) ? z[b] : e;
        }
        function aA(b) {
          var z = this.__data__;
          return vM ? z[b] !== e : K0.call(z, b);
        }
        function sA(b, z) {
          var n = this.__data__;
          return this.size += this.has(b) ? 0 : 1, n[b] = vM && z === e ? l : z, this;
        }
        Mt.prototype.clear = iA, Mt.prototype.delete = rA, Mt.prototype.get = OA, Mt.prototype.has = aA, Mt.prototype.set = sA;
        function ce(b) {
          var z = -1, n = b == null ? 0 : b.length;
          for (this.clear(); ++z < n; ) {
            var O = b[z];
            this.set(O[0], O[1]);
          }
        }
        function AA() {
          this.__data__ = [], this.size = 0;
        }
        function dA(b) {
          var z = this.__data__, n = xb(z, b);
          if (n < 0)
            return !1;
          var O = z.length - 1;
          return n == O ? z.pop() : Sb.call(z, n, 1), --this.size, !0;
        }
        function uA(b) {
          var z = this.__data__, n = xb(z, b);
          return n < 0 ? e : z[n][1];
        }
        function qA(b) {
          return xb(this.__data__, b) > -1;
        }
        function lA(b, z) {
          var n = this.__data__, O = xb(n, b);
          return O < 0 ? (++this.size, n.push([b, z])) : n[O][1] = z, this;
        }
        ce.prototype.clear = AA, ce.prototype.delete = dA, ce.prototype.get = uA, ce.prototype.has = qA, ce.prototype.set = lA;
        function ne(b) {
          var z = -1, n = b == null ? 0 : b.length;
          for (this.clear(); ++z < n; ) {
            var O = b[z];
            this.set(O[0], O[1]);
          }
        }
        function fA() {
          this.size = 0, this.__data__ = {
            hash: new Mt(),
            map: new (NM || ce)(),
            string: new Mt()
          };
        }
        function WA(b) {
          var z = jb(this, b).delete(b);
          return this.size -= z ? 1 : 0, z;
        }
        function hA(b) {
          return jb(this, b).get(b);
        }
        function mA(b) {
          return jb(this, b).has(b);
        }
        function RA(b, z) {
          var n = jb(this, b), O = n.size;
          return n.set(b, z), this.size += n.size == O ? 0 : 1, this;
        }
        ne.prototype.clear = fA, ne.prototype.delete = WA, ne.prototype.get = hA, ne.prototype.has = mA, ne.prototype.set = RA;
        function bt(b) {
          var z = -1, n = b == null ? 0 : b.length;
          for (this.__data__ = new ne(); ++z < n; )
            this.add(b[z]);
        }
        function LA(b) {
          return this.__data__.set(b, l), this;
        }
        function gA(b) {
          return this.__data__.has(b);
        }
        bt.prototype.add = bt.prototype.push = LA, bt.prototype.has = gA;
        function D2(b) {
          var z = this.__data__ = new ce(b);
          this.size = z.size;
        }
        function yA() {
          this.__data__ = new ce(), this.size = 0;
        }
        function NA(b) {
          var z = this.__data__, n = z.delete(b);
          return this.size = z.size, n;
        }
        function BA(b) {
          return this.__data__.get(b);
        }
        function vA(b) {
          return this.__data__.has(b);
        }
        function TA(b, z) {
          var n = this.__data__;
          if (n instanceof ce) {
            var O = n.__data__;
            if (!NM || O.length < c - 1)
              return O.push([b, z]), this.size = ++n.size, this;
            n = this.__data__ = new ne(O);
          }
          return n.set(b, z), this.size = n.size, this;
        }
        D2.prototype.clear = yA, D2.prototype.delete = NA, D2.prototype.get = BA, D2.prototype.has = vA, D2.prototype.set = TA;
        function Ri(b, z) {
          var n = R0(b), O = !n && nt(b), a = !n && !O && xe(b), d = !n && !O && !a && Ht(b), q = n || O || a || d, h = q ? dz(b.length, Es) : [], N = h.length;
          for (var F in b)
            (z || K0.call(b, F)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
            (F == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            a && (F == "offset" || F == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            d && (F == "buffer" || F == "byteLength" || F == "byteOffset") || // Skip index properties.
            ae(F, N))) && h.push(F);
          return h;
        }
        function Li(b) {
          var z = b.length;
          return z ? b[wz(0, z - 1)] : e;
        }
        function _A(b, z) {
          return ep(j1(b), pt(z, 0, b.length));
        }
        function wA(b) {
          return ep(j1(b));
        }
        function mz(b, z, n) {
          (n !== e && !C2(b[z], n) || n === e && !(z in b)) && ie(b, z, n);
        }
        function _M(b, z, n) {
          var O = b[z];
          (!(K0.call(b, z) && C2(O, n)) || n === e && !(z in b)) && ie(b, z, n);
        }
        function xb(b, z) {
          for (var n = b.length; n--; )
            if (C2(b[n][0], z))
              return n;
          return -1;
        }
        function XA(b, z, n, O) {
          return Ie(b, function(a, d, q) {
            z(O, a, n(a), q);
          }), O;
        }
        function gi(b, z) {
          return b && Y2(z, C1(z), b);
        }
        function SA(b, z) {
          return b && Y2(z, t2(z), b);
        }
        function ie(b, z, n) {
          z == "__proto__" && Db ? Db(b, z, {
            configurable: !0,
            enumerable: !0,
            value: n,
            writable: !0
          }) : b[z] = n;
        }
        function Rz(b, z) {
          for (var n = -1, O = z.length, a = w(O), d = b == null; ++n < O; )
            a[n] = d ? e : bo(b, z[n]);
          return a;
        }
        function pt(b, z, n) {
          return b === b && (n !== e && (b = b <= n ? b : n), z !== e && (b = b >= z ? b : z)), b;
        }
        function m2(b, z, n, O, a, d) {
          var q, h = z & m, N = z & X, F = z & D;
          if (n && (q = a ? n(b, O, a, d) : n(b)), q !== e)
            return q;
          if (!W1(b))
            return b;
          var U = R0(b);
          if (U) {
            if (q = md(b), !h)
              return j1(b, q);
          } else {
            var J = x1(b), t0 = J == w0 || J == f;
            if (xe(b))
              return Vi(b, h);
            if (J == b0 || J == v1 || t0 && !a) {
              if (q = N || t0 ? {} : Ar(b), !h)
                return N ? Od(b, SA(q, b)) : rd(b, gi(q, b));
            } else {
              if (!z1[J])
                return a ? b : {};
              q = Rd(b, J, h);
            }
          }
          d || (d = new D2());
          var n0 = d.get(b);
          if (n0)
            return n0;
          d.set(b, q), Ur(b) ? b.forEach(function(u0) {
            q.add(m2(u0, z, n, u0, b, d));
          }) : xr(b) && b.forEach(function(u0, X0) {
            q.set(X0, m2(u0, z, n, X0, b, d));
          });
          var d0 = F ? N ? Uz : Fz : N ? t2 : C1, v0 = U ? e : d0(b);
          return f2(v0 || b, function(u0, X0) {
            v0 && (X0 = u0, u0 = b[X0]), _M(q, X0, m2(u0, z, n, X0, b, d));
          }), q;
        }
        function DA(b) {
          var z = C1(b);
          return function(n) {
            return yi(n, b, z);
          };
        }
        function yi(b, z, n) {
          var O = n.length;
          if (b == null)
            return !O;
          for (b = M1(b); O--; ) {
            var a = n[O], d = z[a], q = b[a];
            if (q === e && !(a in b) || !d(q))
              return !1;
          }
          return !0;
        }
        function Ni(b, z, n) {
          if (typeof b != "function")
            throw new W2(s);
          return kM(function() {
            b.apply(e, n);
          }, z);
        }
        function wM(b, z, n, O) {
          var a = -1, d = Lb, q = !0, h = b.length, N = [], F = z.length;
          if (!h)
            return N;
          n && (z = A1(z, i2(n))), O ? (d = iz, q = !1) : z.length >= c && (d = gM, q = !1, z = new bt(z));
          e:
            for (; ++a < h; ) {
              var U = b[a], J = n == null ? U : n(U);
              if (U = O || U !== 0 ? U : 0, q && J === J) {
                for (var t0 = F; t0--; )
                  if (z[t0] === J)
                    continue e;
                N.push(U);
              } else d(z, J, O) || N.push(U);
            }
          return N;
        }
        var Ie = er(H2), Bi = er(gz, !0);
        function CA(b, z) {
          var n = !0;
          return Ie(b, function(O, a, d) {
            return n = !!z(O, a, d), n;
          }), n;
        }
        function Fb(b, z, n) {
          for (var O = -1, a = b.length; ++O < a; ) {
            var d = b[O], q = z(d);
            if (q != null && (h === e ? q === q && !O2(q) : n(q, h)))
              var h = q, N = d;
          }
          return N;
        }
        function IA(b, z, n, O) {
          var a = b.length;
          for (n = y0(n), n < 0 && (n = -n > a ? 0 : a + n), O = O === e || O > a ? a : y0(O), O < 0 && (O += a), O = n > O ? 0 : Hr(O); n < O; )
            b[n++] = z;
          return b;
        }
        function vi(b, z) {
          var n = [];
          return Ie(b, function(O, a, d) {
            z(O, a, d) && n.push(O);
          }), n;
        }
        function P1(b, z, n, O, a) {
          var d = -1, q = b.length;
          for (n || (n = gd), a || (a = []); ++d < q; ) {
            var h = b[d];
            z > 0 && n(h) ? z > 1 ? P1(h, z - 1, n, O, a) : Se(a, h) : O || (a[a.length] = h);
          }
          return a;
        }
        var Lz = tr(), Ti = tr(!0);
        function H2(b, z) {
          return b && Lz(b, z, C1);
        }
        function gz(b, z) {
          return b && Ti(b, z, C1);
        }
        function Ub(b, z) {
          return Xe(z, function(n) {
            return se(b[n]);
          });
        }
        function zt(b, z) {
          z = Pe(z, b);
          for (var n = 0, O = z.length; b != null && n < O; )
            b = b[G2(z[n++])];
          return n && n == O ? b : e;
        }
        function _i(b, z, n) {
          var O = z(b);
          return R0(b) ? O : Se(O, n(b));
        }
        function G1(b) {
          return b == null ? b === e ? Be : V : tt && tt in M1(b) ? fd(b) : wd(b);
        }
        function yz(b, z) {
          return b > z;
        }
        function kA(b, z) {
          return b != null && K0.call(b, z);
        }
        function PA(b, z) {
          return b != null && z in M1(b);
        }
        function EA(b, z, n) {
          return b >= E1(z, n) && b < X1(z, n);
        }
        function Nz(b, z, n) {
          for (var O = n ? iz : Lb, a = b[0].length, d = b.length, q = d, h = w(d), N = 1 / 0, F = []; q--; ) {
            var U = b[q];
            q && z && (U = A1(U, i2(z))), N = E1(U.length, N), h[q] = !n && (z || a >= 120 && U.length >= 120) ? new bt(q && U) : e;
          }
          U = b[0];
          var J = -1, t0 = h[0];
          e:
            for (; ++J < a && F.length < N; ) {
              var n0 = U[J], d0 = z ? z(n0) : n0;
              if (n0 = n || n0 !== 0 ? n0 : 0, !(t0 ? gM(t0, d0) : O(F, d0, n))) {
                for (q = d; --q; ) {
                  var v0 = h[q];
                  if (!(v0 ? gM(v0, d0) : O(b[q], d0, n)))
                    continue e;
                }
                t0 && t0.push(d0), F.push(n0);
              }
            }
          return F;
        }
        function xA(b, z, n, O) {
          return H2(b, function(a, d, q) {
            z(O, n(a), d, q);
          }), O;
        }
        function XM(b, z, n) {
          z = Pe(z, b), b = lr(b, z);
          var O = b == null ? b : b[G2(L2(z))];
          return O == null ? e : n2(O, b, n);
        }
        function wi(b) {
          return R1(b) && G1(b) == v1;
        }
        function FA(b) {
          return R1(b) && G1(b) == ve;
        }
        function UA(b) {
          return R1(b) && G1(b) == p1;
        }
        function SM(b, z, n, O, a) {
          return b === z ? !0 : b == null || z == null || !R1(b) && !R1(z) ? b !== b && z !== z : JA(b, z, n, O, SM, a);
        }
        function JA(b, z, n, O, a, d) {
          var q = R0(b), h = R0(z), N = q ? i1 : x1(b), F = h ? i1 : x1(z);
          N = N == v1 ? b0 : N, F = F == v1 ? b0 : F;
          var U = N == b0, J = F == b0, t0 = N == F;
          if (t0 && xe(b)) {
            if (!xe(z))
              return !1;
            q = !0, U = !1;
          }
          if (t0 && !U)
            return d || (d = new D2()), q || Ht(b) ? Or(b, z, n, O, a, d) : qd(b, z, N, n, O, a, d);
          if (!(n & y)) {
            var n0 = U && K0.call(b, "__wrapped__"), d0 = J && K0.call(z, "__wrapped__");
            if (n0 || d0) {
              var v0 = n0 ? b.value() : b, u0 = d0 ? z.value() : z;
              return d || (d = new D2()), a(v0, u0, n, O, d);
            }
          }
          return t0 ? (d || (d = new D2()), ld(b, z, n, O, a, d)) : !1;
        }
        function HA(b) {
          return R1(b) && x1(b) == C;
        }
        function Bz(b, z, n, O) {
          var a = n.length, d = a, q = !O;
          if (b == null)
            return !d;
          for (b = M1(b); a--; ) {
            var h = n[a];
            if (q && h[2] ? h[1] !== b[h[0]] : !(h[0] in b))
              return !1;
          }
          for (; ++a < d; ) {
            h = n[a];
            var N = h[0], F = b[N], U = h[1];
            if (q && h[2]) {
              if (F === e && !(N in b))
                return !1;
            } else {
              var J = new D2();
              if (O)
                var t0 = O(F, U, N, b, z, J);
              if (!(t0 === e ? SM(U, F, y | S, O, J) : t0))
                return !1;
            }
          }
          return !0;
        }
        function Xi(b) {
          if (!W1(b) || Nd(b))
            return !1;
          var z = se(b) ? Hs : we;
          return z.test(ct(b));
        }
        function YA(b) {
          return R1(b) && G1(b) == h0;
        }
        function GA(b) {
          return R1(b) && x1(b) == f0;
        }
        function $A(b) {
          return R1(b) && op(b.length) && !!r1[G1(b)];
        }
        function Si(b) {
          return typeof b == "function" ? b : b == null ? M2 : typeof b == "object" ? R0(b) ? Ii(b[0], b[1]) : Ci(b) : MO(b);
        }
        function vz(b) {
          if (!IM(b))
            return Qs(b);
          var z = [];
          for (var n in M1(b))
            K0.call(b, n) && n != "constructor" && z.push(n);
          return z;
        }
        function VA(b) {
          if (!W1(b))
            return _d(b);
          var z = IM(b), n = [];
          for (var O in b)
            O == "constructor" && (z || !K0.call(b, O)) || n.push(O);
          return n;
        }
        function Tz(b, z) {
          return b < z;
        }
        function Di(b, z) {
          var n = -1, O = e2(b) ? w(b.length) : [];
          return Ie(b, function(a, d, q) {
            O[++n] = z(a, d, q);
          }), O;
        }
        function Ci(b) {
          var z = Hz(b);
          return z.length == 1 && z[0][2] ? ur(z[0][0], z[0][1]) : function(n) {
            return n === b || Bz(n, b, z);
          };
        }
        function Ii(b, z) {
          return Gz(b) && dr(z) ? ur(G2(b), z) : function(n) {
            var O = bo(n, b);
            return O === e && O === z ? po(n, b) : SM(z, O, y | S);
          };
        }
        function Jb(b, z, n, O, a) {
          b !== z && Lz(z, function(d, q) {
            if (a || (a = new D2()), W1(d))
              KA(b, z, q, n, Jb, O, a);
            else {
              var h = O ? O(Vz(b, q), d, q + "", b, z, a) : e;
              h === e && (h = d), mz(b, q, h);
            }
          }, t2);
        }
        function KA(b, z, n, O, a, d, q) {
          var h = Vz(b, n), N = Vz(z, n), F = q.get(N);
          if (F) {
            mz(b, n, F);
            return;
          }
          var U = d ? d(h, N, n + "", b, z, q) : e, J = U === e;
          if (J) {
            var t0 = R0(N), n0 = !t0 && xe(N), d0 = !t0 && !n0 && Ht(N);
            U = N, t0 || n0 || d0 ? R0(h) ? U = h : y1(h) ? U = j1(h) : n0 ? (J = !1, U = Vi(N, !0)) : d0 ? (J = !1, U = Ki(N, !0)) : U = [] : PM(N) || nt(N) ? (U = h, nt(h) ? U = Yr(h) : (!W1(h) || se(h)) && (U = Ar(N))) : J = !1;
          }
          J && (q.set(N, U), a(U, N, O, d, q), q.delete(N)), mz(b, n, U);
        }
        function ki(b, z) {
          var n = b.length;
          if (n)
            return z += z < 0 ? n : 0, ae(z, n) ? b[z] : e;
        }
        function Pi(b, z, n) {
          z.length ? z = A1(z, function(d) {
            return R0(d) ? function(q) {
              return zt(q, d.length === 1 ? d[0] : d);
            } : d;
          }) : z = [M2];
          var O = -1;
          z = A1(z, i2(A0()));
          var a = Di(b, function(d, q, h) {
            var N = A1(z, function(F) {
              return F(d);
            });
            return { criteria: N, index: ++O, value: d };
          });
          return Rs(a, function(d, q) {
            return id(d, q, n);
          });
        }
        function QA(b, z) {
          return Ei(b, z, function(n, O) {
            return po(b, O);
          });
        }
        function Ei(b, z, n) {
          for (var O = -1, a = z.length, d = {}; ++O < a; ) {
            var q = z[O], h = zt(b, q);
            n(h, q) && DM(d, Pe(q, b), h);
          }
          return d;
        }
        function ZA(b) {
          return function(z) {
            return zt(z, b);
          };
        }
        function _z(b, z, n, O) {
          var a = O ? ms : St, d = -1, q = z.length, h = b;
          for (b === z && (z = j1(z)), n && (h = A1(b, i2(n))); ++d < q; )
            for (var N = 0, F = z[d], U = n ? n(F) : F; (N = a(h, U, N, O)) > -1; )
              h !== b && Sb.call(h, N, 1), Sb.call(b, N, 1);
          return b;
        }
        function xi(b, z) {
          for (var n = b ? z.length : 0, O = n - 1; n--; ) {
            var a = z[n];
            if (n == O || a !== d) {
              var d = a;
              ae(a) ? Sb.call(b, a, 1) : Dz(b, a);
            }
          }
          return b;
        }
        function wz(b, z) {
          return b + Ib(hi() * (z - b + 1));
        }
        function jA(b, z, n, O) {
          for (var a = -1, d = X1(Cb((z - b) / (n || 1)), 0), q = w(d); d--; )
            q[O ? d : ++a] = b, b += n;
          return q;
        }
        function Xz(b, z) {
          var n = "";
          if (!b || z < 1 || z > $)
            return n;
          do
            z % 2 && (n += b), z = Ib(z / 2), z && (b += b);
          while (z);
          return n;
        }
        function T0(b, z) {
          return Kz(qr(b, z, M2), b + "");
        }
        function ed(b) {
          return Li(Yt(b));
        }
        function td(b, z) {
          var n = Yt(b);
          return ep(n, pt(z, 0, n.length));
        }
        function DM(b, z, n, O) {
          if (!W1(b))
            return b;
          z = Pe(z, b);
          for (var a = -1, d = z.length, q = d - 1, h = b; h != null && ++a < d; ) {
            var N = G2(z[a]), F = n;
            if (N === "__proto__" || N === "constructor" || N === "prototype")
              return b;
            if (a != q) {
              var U = h[N];
              F = O ? O(U, N, h) : e, F === e && (F = W1(U) ? U : ae(z[a + 1]) ? [] : {});
            }
            _M(h, N, F), h = h[N];
          }
          return b;
        }
        var Fi = kb ? function(b, z) {
          return kb.set(b, z), b;
        } : M2, Md = Db ? function(b, z) {
          return Db(b, "toString", {
            configurable: !0,
            enumerable: !1,
            value: oo(z),
            writable: !0
          });
        } : M2;
        function bd(b) {
          return ep(Yt(b));
        }
        function R2(b, z, n) {
          var O = -1, a = b.length;
          z < 0 && (z = -z > a ? 0 : a + z), n = n > a ? a : n, n < 0 && (n += a), a = z > n ? 0 : n - z >>> 0, z >>>= 0;
          for (var d = w(a); ++O < a; )
            d[O] = b[O + z];
          return d;
        }
        function pd(b, z) {
          var n;
          return Ie(b, function(O, a, d) {
            return n = z(O, a, d), !n;
          }), !!n;
        }
        function Hb(b, z, n) {
          var O = 0, a = b == null ? O : b.length;
          if (typeof z == "number" && z === z && a <= q2) {
            for (; O < a; ) {
              var d = O + a >>> 1, q = b[d];
              q !== null && !O2(q) && (n ? q <= z : q < z) ? O = d + 1 : a = d;
            }
            return a;
          }
          return Sz(b, z, M2, n);
        }
        function Sz(b, z, n, O) {
          var a = 0, d = b == null ? 0 : b.length;
          if (d === 0)
            return 0;
          z = n(z);
          for (var q = z !== z, h = z === null, N = O2(z), F = z === e; a < d; ) {
            var U = Ib((a + d) / 2), J = n(b[U]), t0 = J !== e, n0 = J === null, d0 = J === J, v0 = O2(J);
            if (q)
              var u0 = O || d0;
            else F ? u0 = d0 && (O || t0) : h ? u0 = d0 && t0 && (O || !n0) : N ? u0 = d0 && t0 && !n0 && (O || !v0) : n0 || v0 ? u0 = !1 : u0 = O ? J <= z : J < z;
            u0 ? a = U + 1 : d = U;
          }
          return E1(d, u2);
        }
        function Ui(b, z) {
          for (var n = -1, O = b.length, a = 0, d = []; ++n < O; ) {
            var q = b[n], h = z ? z(q) : q;
            if (!n || !C2(h, N)) {
              var N = h;
              d[a++] = q === 0 ? 0 : q;
            }
          }
          return d;
        }
        function Ji(b) {
          return typeof b == "number" ? b : O2(b) ? f1 : +b;
        }
        function r2(b) {
          if (typeof b == "string")
            return b;
          if (R0(b))
            return A1(b, r2) + "";
          if (O2(b))
            return mi ? mi.call(b) : "";
          var z = b + "";
          return z == "0" && 1 / b == -$0 ? "-0" : z;
        }
        function ke(b, z, n) {
          var O = -1, a = Lb, d = b.length, q = !0, h = [], N = h;
          if (n)
            q = !1, a = iz;
          else if (d >= c) {
            var F = z ? null : dd(b);
            if (F)
              return yb(F);
            q = !1, a = gM, N = new bt();
          } else
            N = z ? [] : h;
          e:
            for (; ++O < d; ) {
              var U = b[O], J = z ? z(U) : U;
              if (U = n || U !== 0 ? U : 0, q && J === J) {
                for (var t0 = N.length; t0--; )
                  if (N[t0] === J)
                    continue e;
                z && N.push(J), h.push(U);
              } else a(N, J, n) || (N !== h && N.push(J), h.push(U));
            }
          return h;
        }
        function Dz(b, z) {
          return z = Pe(z, b), b = lr(b, z), b == null || delete b[G2(L2(z))];
        }
        function Hi(b, z, n, O) {
          return DM(b, z, n(zt(b, z)), O);
        }
        function Yb(b, z, n, O) {
          for (var a = b.length, d = O ? a : -1; (O ? d-- : ++d < a) && z(b[d], d, b); )
            ;
          return n ? R2(b, O ? 0 : d, O ? d + 1 : a) : R2(b, O ? d + 1 : 0, O ? a : d);
        }
        function Yi(b, z) {
          var n = b;
          return n instanceof D0 && (n = n.value()), rz(z, function(O, a) {
            return a.func.apply(a.thisArg, Se([O], a.args));
          }, n);
        }
        function Cz(b, z, n) {
          var O = b.length;
          if (O < 2)
            return O ? ke(b[0]) : [];
          for (var a = -1, d = w(O); ++a < O; )
            for (var q = b[a], h = -1; ++h < O; )
              h != a && (d[a] = wM(d[a] || q, b[h], z, n));
          return ke(P1(d, 1), z, n);
        }
        function Gi(b, z, n) {
          for (var O = -1, a = b.length, d = z.length, q = {}; ++O < a; ) {
            var h = O < d ? z[O] : e;
            n(q, b[O], h);
          }
          return q;
        }
        function Iz(b) {
          return y1(b) ? b : [];
        }
        function kz(b) {
          return typeof b == "function" ? b : M2;
        }
        function Pe(b, z) {
          return R0(b) ? b : Gz(b, z) ? [b] : mr(G0(b));
        }
        var zd = T0;
        function Ee(b, z, n) {
          var O = b.length;
          return n = n === e ? O : n, !z && n >= O ? b : R2(b, z, n);
        }
        var $i = Ys || function(b) {
          return k1.clearTimeout(b);
        };
        function Vi(b, z) {
          if (z)
            return b.slice();
          var n = b.length, O = ui ? ui(n) : new b.constructor(n);
          return b.copy(O), O;
        }
        function Pz(b) {
          var z = new b.constructor(b.byteLength);
          return new wb(z).set(new wb(b)), z;
        }
        function od(b, z) {
          var n = z ? Pz(b.buffer) : b.buffer;
          return new b.constructor(n, b.byteOffset, b.byteLength);
        }
        function cd(b) {
          var z = new b.constructor(b.source, RM.exec(b));
          return z.lastIndex = b.lastIndex, z;
        }
        function nd(b) {
          return TM ? M1(TM.call(b)) : {};
        }
        function Ki(b, z) {
          var n = z ? Pz(b.buffer) : b.buffer;
          return new b.constructor(n, b.byteOffset, b.length);
        }
        function Qi(b, z) {
          if (b !== z) {
            var n = b !== e, O = b === null, a = b === b, d = O2(b), q = z !== e, h = z === null, N = z === z, F = O2(z);
            if (!h && !F && !d && b > z || d && q && N && !h && !F || O && q && N || !n && N || !a)
              return 1;
            if (!O && !d && !F && b < z || F && n && a && !O && !d || h && n && a || !q && a || !N)
              return -1;
          }
          return 0;
        }
        function id(b, z, n) {
          for (var O = -1, a = b.criteria, d = z.criteria, q = a.length, h = n.length; ++O < q; ) {
            var N = Qi(a[O], d[O]);
            if (N) {
              if (O >= h)
                return N;
              var F = n[O];
              return N * (F == "desc" ? -1 : 1);
            }
          }
          return b.index - z.index;
        }
        function Zi(b, z, n, O) {
          for (var a = -1, d = b.length, q = n.length, h = -1, N = z.length, F = X1(d - q, 0), U = w(N + F), J = !O; ++h < N; )
            U[h] = z[h];
          for (; ++a < q; )
            (J || a < d) && (U[n[a]] = b[a]);
          for (; F--; )
            U[h++] = b[a++];
          return U;
        }
        function ji(b, z, n, O) {
          for (var a = -1, d = b.length, q = -1, h = n.length, N = -1, F = z.length, U = X1(d - h, 0), J = w(U + F), t0 = !O; ++a < U; )
            J[a] = b[a];
          for (var n0 = a; ++N < F; )
            J[n0 + N] = z[N];
          for (; ++q < h; )
            (t0 || a < d) && (J[n0 + n[q]] = b[a++]);
          return J;
        }
        function j1(b, z) {
          var n = -1, O = b.length;
          for (z || (z = w(O)); ++n < O; )
            z[n] = b[n];
          return z;
        }
        function Y2(b, z, n, O) {
          var a = !n;
          n || (n = {});
          for (var d = -1, q = z.length; ++d < q; ) {
            var h = z[d], N = O ? O(n[h], b[h], h, n, b) : e;
            N === e && (N = b[h]), a ? ie(n, h, N) : _M(n, h, N);
          }
          return n;
        }
        function rd(b, z) {
          return Y2(b, Yz(b), z);
        }
        function Od(b, z) {
          return Y2(b, ar(b), z);
        }
        function Gb(b, z) {
          return function(n, O) {
            var a = R0(n) ? us : XA, d = z ? z() : {};
            return a(n, b, A0(O, 2), d);
          };
        }
        function Ft(b) {
          return T0(function(z, n) {
            var O = -1, a = n.length, d = a > 1 ? n[a - 1] : e, q = a > 2 ? n[2] : e;
            for (d = b.length > 3 && typeof d == "function" ? (a--, d) : e, q && $1(n[0], n[1], q) && (d = a < 3 ? e : d, a = 1), z = M1(z); ++O < a; ) {
              var h = n[O];
              h && b(z, h, O, d);
            }
            return z;
          });
        }
        function er(b, z) {
          return function(n, O) {
            if (n == null)
              return n;
            if (!e2(n))
              return b(n, O);
            for (var a = n.length, d = z ? a : -1, q = M1(n); (z ? d-- : ++d < a) && O(q[d], d, q) !== !1; )
              ;
            return n;
          };
        }
        function tr(b) {
          return function(z, n, O) {
            for (var a = -1, d = M1(z), q = O(z), h = q.length; h--; ) {
              var N = q[b ? h : ++a];
              if (n(d[N], N, d) === !1)
                break;
            }
            return z;
          };
        }
        function ad(b, z, n) {
          var O = z & B, a = CM(b);
          function d() {
            var q = this && this !== k1 && this instanceof d ? a : b;
            return q.apply(O ? n : this, arguments);
          }
          return d;
        }
        function Mr(b) {
          return function(z) {
            z = G0(z);
            var n = Dt(z) ? S2(z) : e, O = n ? n[0] : z.charAt(0), a = n ? Ee(n, 1).join("") : z.slice(1);
            return O[b]() + a;
          };
        }
        function Ut(b) {
          return function(z) {
            return rz(eO(jr(z).replace(Ms, "")), b, "");
          };
        }
        function CM(b) {
          return function() {
            var z = arguments;
            switch (z.length) {
              case 0:
                return new b();
              case 1:
                return new b(z[0]);
              case 2:
                return new b(z[0], z[1]);
              case 3:
                return new b(z[0], z[1], z[2]);
              case 4:
                return new b(z[0], z[1], z[2], z[3]);
              case 5:
                return new b(z[0], z[1], z[2], z[3], z[4]);
              case 6:
                return new b(z[0], z[1], z[2], z[3], z[4], z[5]);
              case 7:
                return new b(z[0], z[1], z[2], z[3], z[4], z[5], z[6]);
            }
            var n = xt(b.prototype), O = b.apply(n, z);
            return W1(O) ? O : n;
          };
        }
        function sd(b, z, n) {
          var O = CM(b);
          function a() {
            for (var d = arguments.length, q = w(d), h = d, N = Jt(a); h--; )
              q[h] = arguments[h];
            var F = d < 3 && q[0] !== N && q[d - 1] !== N ? [] : De(q, N);
            if (d -= F.length, d < n)
              return cr(
                b,
                z,
                $b,
                a.placeholder,
                e,
                q,
                F,
                e,
                e,
                n - d
              );
            var U = this && this !== k1 && this instanceof a ? O : b;
            return n2(U, this, q);
          }
          return a;
        }
        function br(b) {
          return function(z, n, O) {
            var a = M1(z);
            if (!e2(z)) {
              var d = A0(n, 3);
              z = C1(z), n = function(h) {
                return d(a[h], h, a);
              };
            }
            var q = b(z, n, O);
            return q > -1 ? a[d ? z[q] : q] : e;
          };
        }
        function pr(b) {
          return Oe(function(z) {
            var n = z.length, O = n, a = h2.prototype.thru;
            for (b && z.reverse(); O--; ) {
              var d = z[O];
              if (typeof d != "function")
                throw new W2(s);
              if (a && !q && Zb(d) == "wrapper")
                var q = new h2([], !0);
            }
            for (O = q ? O : n; ++O < n; ) {
              d = z[O];
              var h = Zb(d), N = h == "wrapper" ? Jz(d) : e;
              N && $z(N[0]) && N[1] == (v | e0 | G | E) && !N[4].length && N[9] == 1 ? q = q[Zb(N[0])].apply(q, N[3]) : q = d.length == 1 && $z(d) ? q[h]() : q.thru(d);
            }
            return function() {
              var F = arguments, U = F[0];
              if (q && F.length == 1 && R0(U))
                return q.plant(U).value();
              for (var J = 0, t0 = n ? z[J].apply(this, F) : U; ++J < n; )
                t0 = z[J].call(this, t0);
              return t0;
            };
          });
        }
        function $b(b, z, n, O, a, d, q, h, N, F) {
          var U = z & v, J = z & B, t0 = z & Z, n0 = z & (e0 | r0), d0 = z & K, v0 = t0 ? e : CM(b);
          function u0() {
            for (var X0 = arguments.length, k0 = w(X0), a2 = X0; a2--; )
              k0[a2] = arguments[a2];
            if (n0)
              var V1 = Jt(u0), s2 = gs(k0, V1);
            if (O && (k0 = Zi(k0, O, a, n0)), d && (k0 = ji(k0, d, q, n0)), X0 -= s2, n0 && X0 < F) {
              var N1 = De(k0, V1);
              return cr(
                b,
                z,
                $b,
                u0.placeholder,
                n,
                k0,
                N1,
                h,
                N,
                F - X0
              );
            }
            var I2 = J ? n : this, de = t0 ? I2[b] : b;
            return X0 = k0.length, h ? k0 = Xd(k0, h) : d0 && X0 > 1 && k0.reverse(), U && N < X0 && (k0.length = N), this && this !== k1 && this instanceof u0 && (de = v0 || CM(de)), de.apply(I2, k0);
          }
          return u0;
        }
        function zr(b, z) {
          return function(n, O) {
            return xA(n, b, z(O), {});
          };
        }
        function Vb(b, z) {
          return function(n, O) {
            var a;
            if (n === e && O === e)
              return z;
            if (n !== e && (a = n), O !== e) {
              if (a === e)
                return O;
              typeof n == "string" || typeof O == "string" ? (n = r2(n), O = r2(O)) : (n = Ji(n), O = Ji(O)), a = b(n, O);
            }
            return a;
          };
        }
        function Ez(b) {
          return Oe(function(z) {
            return z = A1(z, i2(A0())), T0(function(n) {
              var O = this;
              return b(z, function(a) {
                return n2(a, O, n);
              });
            });
          });
        }
        function Kb(b, z) {
          z = z === e ? " " : r2(z);
          var n = z.length;
          if (n < 2)
            return n ? Xz(z, b) : z;
          var O = Xz(z, Cb(b / Ct(z)));
          return Dt(z) ? Ee(S2(O), 0, b).join("") : O.slice(0, b);
        }
        function Ad(b, z, n, O) {
          var a = z & B, d = CM(b);
          function q() {
            for (var h = -1, N = arguments.length, F = -1, U = O.length, J = w(U + N), t0 = this && this !== k1 && this instanceof q ? d : b; ++F < U; )
              J[F] = O[F];
            for (; N--; )
              J[F++] = arguments[++h];
            return n2(t0, a ? n : this, J);
          }
          return q;
        }
        function or(b) {
          return function(z, n, O) {
            return O && typeof O != "number" && $1(z, n, O) && (n = O = e), z = Ae(z), n === e ? (n = z, z = 0) : n = Ae(n), O = O === e ? z < n ? 1 : -1 : Ae(O), jA(z, n, O, b);
          };
        }
        function Qb(b) {
          return function(z, n) {
            return typeof z == "string" && typeof n == "string" || (z = g2(z), n = g2(n)), b(z, n);
          };
        }
        function cr(b, z, n, O, a, d, q, h, N, F) {
          var U = z & e0, J = U ? q : e, t0 = U ? e : q, n0 = U ? d : e, d0 = U ? e : d;
          z |= U ? G : j, z &= ~(U ? j : G), z & H || (z &= -4);
          var v0 = [
            b,
            z,
            a,
            n0,
            J,
            d0,
            t0,
            h,
            N,
            F
          ], u0 = n.apply(e, v0);
          return $z(b) && fr(u0, v0), u0.placeholder = O, Wr(u0, b, z);
        }
        function xz(b) {
          var z = w1[b];
          return function(n, O) {
            if (n = g2(n), O = O == null ? 0 : E1(y0(O), 292), O && Wi(n)) {
              var a = (G0(n) + "e").split("e"), d = z(a[0] + "e" + (+a[1] + O));
              return a = (G0(d) + "e").split("e"), +(a[0] + "e" + (+a[1] - O));
            }
            return z(n);
          };
        }
        var dd = Pt && 1 / yb(new Pt([, -0]))[1] == $0 ? function(b) {
          return new Pt(b);
        } : io;
        function nr(b) {
          return function(z) {
            var n = x1(z);
            return n == C ? qz(z) : n == f0 ? ws(z) : Ls(z, b(z));
          };
        }
        function re(b, z, n, O, a, d, q, h) {
          var N = z & Z;
          if (!N && typeof b != "function")
            throw new W2(s);
          var F = O ? O.length : 0;
          if (F || (z &= -97, O = a = e), q = q === e ? q : X1(y0(q), 0), h = h === e ? h : y0(h), F -= a ? a.length : 0, z & j) {
            var U = O, J = a;
            O = a = e;
          }
          var t0 = N ? e : Jz(b), n0 = [
            b,
            z,
            n,
            O,
            a,
            U,
            J,
            d,
            q,
            h
          ];
          if (t0 && Td(n0, t0), b = n0[0], z = n0[1], n = n0[2], O = n0[3], a = n0[4], h = n0[9] = n0[9] === e ? N ? 0 : b.length : X1(n0[9] - F, 0), !h && z & (e0 | r0) && (z &= -25), !z || z == B)
            var d0 = ad(b, z, n);
          else z == e0 || z == r0 ? d0 = sd(b, z, h) : (z == G || z == (B | G)) && !a.length ? d0 = Ad(b, z, n, O) : d0 = $b.apply(e, n0);
          var v0 = t0 ? Fi : fr;
          return Wr(v0(d0, n0), b, z);
        }
        function ir(b, z, n, O) {
          return b === e || C2(b, kt[n]) && !K0.call(O, n) ? z : b;
        }
        function rr(b, z, n, O, a, d) {
          return W1(b) && W1(z) && (d.set(z, b), Jb(b, z, e, rr, d), d.delete(z)), b;
        }
        function ud(b) {
          return PM(b) ? e : b;
        }
        function Or(b, z, n, O, a, d) {
          var q = n & y, h = b.length, N = z.length;
          if (h != N && !(q && N > h))
            return !1;
          var F = d.get(b), U = d.get(z);
          if (F && U)
            return F == z && U == b;
          var J = -1, t0 = !0, n0 = n & S ? new bt() : e;
          for (d.set(b, z), d.set(z, b); ++J < h; ) {
            var d0 = b[J], v0 = z[J];
            if (O)
              var u0 = q ? O(v0, d0, J, z, b, d) : O(d0, v0, J, b, z, d);
            if (u0 !== e) {
              if (u0)
                continue;
              t0 = !1;
              break;
            }
            if (n0) {
              if (!Oz(z, function(X0, k0) {
                if (!gM(n0, k0) && (d0 === X0 || a(d0, X0, n, O, d)))
                  return n0.push(k0);
              })) {
                t0 = !1;
                break;
              }
            } else if (!(d0 === v0 || a(d0, v0, n, O, d))) {
              t0 = !1;
              break;
            }
          }
          return d.delete(b), d.delete(z), t0;
        }
        function qd(b, z, n, O, a, d, q) {
          switch (n) {
            case Te:
              if (b.byteLength != z.byteLength || b.byteOffset != z.byteOffset)
                return !1;
              b = b.buffer, z = z.buffer;
            case ve:
              return !(b.byteLength != z.byteLength || !d(new wb(b), new wb(z)));
            case b1:
            case p1:
            case k:
              return C2(+b, +z);
            case Z0:
              return b.name == z.name && b.message == z.message;
            case h0:
            case o2:
              return b == z + "";
            case C:
              var h = qz;
            case f0:
              var N = O & y;
              if (h || (h = yb), b.size != z.size && !N)
                return !1;
              var F = q.get(b);
              if (F)
                return F == z;
              O |= S, q.set(b, z);
              var U = Or(h(b), h(z), O, a, d, q);
              return q.delete(b), U;
            case w2:
              if (TM)
                return TM.call(b) == TM.call(z);
          }
          return !1;
        }
        function ld(b, z, n, O, a, d) {
          var q = n & y, h = Fz(b), N = h.length, F = Fz(z), U = F.length;
          if (N != U && !q)
            return !1;
          for (var J = N; J--; ) {
            var t0 = h[J];
            if (!(q ? t0 in z : K0.call(z, t0)))
              return !1;
          }
          var n0 = d.get(b), d0 = d.get(z);
          if (n0 && d0)
            return n0 == z && d0 == b;
          var v0 = !0;
          d.set(b, z), d.set(z, b);
          for (var u0 = q; ++J < N; ) {
            t0 = h[J];
            var X0 = b[t0], k0 = z[t0];
            if (O)
              var a2 = q ? O(k0, X0, t0, z, b, d) : O(X0, k0, t0, b, z, d);
            if (!(a2 === e ? X0 === k0 || a(X0, k0, n, O, d) : a2)) {
              v0 = !1;
              break;
            }
            u0 || (u0 = t0 == "constructor");
          }
          if (v0 && !u0) {
            var V1 = b.constructor, s2 = z.constructor;
            V1 != s2 && "constructor" in b && "constructor" in z && !(typeof V1 == "function" && V1 instanceof V1 && typeof s2 == "function" && s2 instanceof s2) && (v0 = !1);
          }
          return d.delete(b), d.delete(z), v0;
        }
        function Oe(b) {
          return Kz(qr(b, e, yr), b + "");
        }
        function Fz(b) {
          return _i(b, C1, Yz);
        }
        function Uz(b) {
          return _i(b, t2, ar);
        }
        var Jz = kb ? function(b) {
          return kb.get(b);
        } : io;
        function Zb(b) {
          for (var z = b.name + "", n = Et[z], O = K0.call(Et, z) ? n.length : 0; O--; ) {
            var a = n[O], d = a.func;
            if (d == null || d == b)
              return a.name;
          }
          return z;
        }
        function Jt(b) {
          var z = K0.call(A, "placeholder") ? A : b;
          return z.placeholder;
        }
        function A0() {
          var b = A.iteratee || co;
          return b = b === co ? Si : b, arguments.length ? b(arguments[0], arguments[1]) : b;
        }
        function jb(b, z) {
          var n = b.__data__;
          return yd(z) ? n[typeof z == "string" ? "string" : "hash"] : n.map;
        }
        function Hz(b) {
          for (var z = C1(b), n = z.length; n--; ) {
            var O = z[n], a = b[O];
            z[n] = [O, a, dr(a)];
          }
          return z;
        }
        function ot(b, z) {
          var n = vs(b, z);
          return Xi(n) ? n : e;
        }
        function fd(b) {
          var z = K0.call(b, tt), n = b[tt];
          try {
            b[tt] = e;
            var O = !0;
          } catch {
          }
          var a = Tb.call(b);
          return O && (z ? b[tt] = n : delete b[tt]), a;
        }
        var Yz = fz ? function(b) {
          return b == null ? [] : (b = M1(b), Xe(fz(b), function(z) {
            return li.call(b, z);
          }));
        } : ro, ar = fz ? function(b) {
          for (var z = []; b; )
            Se(z, Yz(b)), b = Xb(b);
          return z;
        } : ro, x1 = G1;
        (Wz && x1(new Wz(new ArrayBuffer(1))) != Te || NM && x1(new NM()) != C || hz && x1(hz.resolve()) != q0 || Pt && x1(new Pt()) != f0 || BM && x1(new BM()) != Ve) && (x1 = function(b) {
          var z = G1(b), n = z == b0 ? b.constructor : e, O = n ? ct(n) : "";
          if (O)
            switch (O) {
              case tA:
                return Te;
              case MA:
                return C;
              case bA:
                return q0;
              case pA:
                return f0;
              case zA:
                return Ve;
            }
          return z;
        });
        function Wd(b, z, n) {
          for (var O = -1, a = n.length; ++O < a; ) {
            var d = n[O], q = d.size;
            switch (d.type) {
              case "drop":
                b += q;
                break;
              case "dropRight":
                z -= q;
                break;
              case "take":
                z = E1(z, b + q);
                break;
              case "takeRight":
                b = X1(b, z - q);
                break;
            }
          }
          return { start: b, end: z };
        }
        function hd(b) {
          var z = b.match(WM);
          return z ? z[1].split(qb) : [];
        }
        function sr(b, z, n) {
          z = Pe(z, b);
          for (var O = -1, a = z.length, d = !1; ++O < a; ) {
            var q = G2(z[O]);
            if (!(d = b != null && n(b, q)))
              break;
            b = b[q];
          }
          return d || ++O != a ? d : (a = b == null ? 0 : b.length, !!a && op(a) && ae(q, a) && (R0(b) || nt(b)));
        }
        function md(b) {
          var z = b.length, n = new b.constructor(z);
          return z && typeof b[0] == "string" && K0.call(b, "index") && (n.index = b.index, n.input = b.input), n;
        }
        function Ar(b) {
          return typeof b.constructor == "function" && !IM(b) ? xt(Xb(b)) : {};
        }
        function Rd(b, z, n) {
          var O = b.constructor;
          switch (z) {
            case ve:
              return Pz(b);
            case b1:
            case p1:
              return new O(+b);
            case Te:
              return od(b, n);
            case pe:
            case Ke:
            case vt:
            case uM:
            case qM:
            case Qe:
            case _e:
            case T:
            case _:
              return Ki(b, n);
            case C:
              return new O();
            case k:
            case o2:
              return new O(b);
            case h0:
              return cd(b);
            case f0:
              return new O();
            case w2:
              return nd(b);
          }
        }
        function Ld(b, z) {
          var n = z.length;
          if (!n)
            return b;
          var O = n - 1;
          return z[O] = (n > 1 ? "& " : "") + z[O], z = z.join(n > 2 ? ", " : " "), b.replace(fM, `{
/* [wrapped with ` + z + `] */
`);
        }
        function gd(b) {
          return R0(b) || nt(b) || !!(fi && b && b[fi]);
        }
        function ae(b, z) {
          var n = typeof b;
          return z = z ?? $, !!z && (n == "number" || n != "symbol" && tz.test(b)) && b > -1 && b % 1 == 0 && b < z;
        }
        function $1(b, z, n) {
          if (!W1(n))
            return !1;
          var O = typeof z;
          return (O == "number" ? e2(n) && ae(z, n.length) : O == "string" && z in n) ? C2(n[z], b) : !1;
        }
        function Gz(b, z) {
          if (R0(b))
            return !1;
          var n = typeof b;
          return n == "number" || n == "symbol" || n == "boolean" || b == null || O2(b) ? !0 : db.test(b) || !c2.test(b) || z != null && b in M1(z);
        }
        function yd(b) {
          var z = typeof b;
          return z == "string" || z == "number" || z == "symbol" || z == "boolean" ? b !== "__proto__" : b === null;
        }
        function $z(b) {
          var z = Zb(b), n = A[z];
          if (typeof n != "function" || !(z in D0.prototype))
            return !1;
          if (b === n)
            return !0;
          var O = Jz(n);
          return !!O && b === O[0];
        }
        function Nd(b) {
          return !!di && di in b;
        }
        var Bd = Bb ? se : Oo;
        function IM(b) {
          var z = b && b.constructor, n = typeof z == "function" && z.prototype || kt;
          return b === n;
        }
        function dr(b) {
          return b === b && !W1(b);
        }
        function ur(b, z) {
          return function(n) {
            return n == null ? !1 : n[b] === z && (z !== e || b in M1(n));
          };
        }
        function vd(b) {
          var z = pp(b, function(O) {
            return n.size === W && n.clear(), O;
          }), n = z.cache;
          return z;
        }
        function Td(b, z) {
          var n = b[1], O = z[1], a = n | O, d = a < (B | Z | v), q = O == v && n == e0 || O == v && n == E && b[7].length <= z[8] || O == (v | E) && z[7].length <= z[8] && n == e0;
          if (!(d || q))
            return b;
          O & B && (b[2] = z[2], a |= n & B ? 0 : H);
          var h = z[3];
          if (h) {
            var N = b[3];
            b[3] = N ? Zi(N, h, z[4]) : h, b[4] = N ? De(b[3], L) : z[4];
          }
          return h = z[5], h && (N = b[5], b[5] = N ? ji(N, h, z[6]) : h, b[6] = N ? De(b[5], L) : z[6]), h = z[7], h && (b[7] = h), O & v && (b[8] = b[8] == null ? z[8] : E1(b[8], z[8])), b[9] == null && (b[9] = z[9]), b[0] = z[0], b[1] = a, b;
        }
        function _d(b) {
          var z = [];
          if (b != null)
            for (var n in M1(b))
              z.push(n);
          return z;
        }
        function wd(b) {
          return Tb.call(b);
        }
        function qr(b, z, n) {
          return z = X1(z === e ? b.length - 1 : z, 0), function() {
            for (var O = arguments, a = -1, d = X1(O.length - z, 0), q = w(d); ++a < d; )
              q[a] = O[z + a];
            a = -1;
            for (var h = w(z + 1); ++a < z; )
              h[a] = O[a];
            return h[z] = n(q), n2(b, this, h);
          };
        }
        function lr(b, z) {
          return z.length < 2 ? b : zt(b, R2(z, 0, -1));
        }
        function Xd(b, z) {
          for (var n = b.length, O = E1(z.length, n), a = j1(b); O--; ) {
            var d = z[O];
            b[O] = ae(d, n) ? a[d] : e;
          }
          return b;
        }
        function Vz(b, z) {
          if (!(z === "constructor" && typeof b[z] == "function") && z != "__proto__")
            return b[z];
        }
        var fr = hr(Fi), kM = $s || function(b, z) {
          return k1.setTimeout(b, z);
        }, Kz = hr(Md);
        function Wr(b, z, n) {
          var O = z + "";
          return Kz(b, Ld(O, Sd(hd(O), n)));
        }
        function hr(b) {
          var z = 0, n = 0;
          return function() {
            var O = Zs(), a = E0 - (O - n);
            if (n = O, a > 0) {
              if (++z >= s0)
                return arguments[0];
            } else
              z = 0;
            return b.apply(e, arguments);
          };
        }
        function ep(b, z) {
          var n = -1, O = b.length, a = O - 1;
          for (z = z === e ? O : z; ++n < z; ) {
            var d = wz(n, a), q = b[d];
            b[d] = b[n], b[n] = q;
          }
          return b.length = z, b;
        }
        var mr = vd(function(b) {
          var z = [];
          return b.charCodeAt(0) === 46 && z.push(""), b.replace(ub, function(n, O, a, d) {
            z.push(a ? d.replace(fb, "$1") : O || n);
          }), z;
        });
        function G2(b) {
          if (typeof b == "string" || O2(b))
            return b;
          var z = b + "";
          return z == "0" && 1 / b == -$0 ? "-0" : z;
        }
        function ct(b) {
          if (b != null) {
            try {
              return vb.call(b);
            } catch {
            }
            try {
              return b + "";
            } catch {
            }
          }
          return "";
        }
        function Sd(b, z) {
          return f2(Z1, function(n) {
            var O = "_." + n[0];
            z & n[1] && !Lb(b, O) && b.push(O);
          }), b.sort();
        }
        function Rr(b) {
          if (b instanceof D0)
            return b.clone();
          var z = new h2(b.__wrapped__, b.__chain__);
          return z.__actions__ = j1(b.__actions__), z.__index__ = b.__index__, z.__values__ = b.__values__, z;
        }
        function Dd(b, z, n) {
          (n ? $1(b, z, n) : z === e) ? z = 1 : z = X1(y0(z), 0);
          var O = b == null ? 0 : b.length;
          if (!O || z < 1)
            return [];
          for (var a = 0, d = 0, q = w(Cb(O / z)); a < O; )
            q[d++] = R2(b, a, a += z);
          return q;
        }
        function Cd(b) {
          for (var z = -1, n = b == null ? 0 : b.length, O = 0, a = []; ++z < n; ) {
            var d = b[z];
            d && (a[O++] = d);
          }
          return a;
        }
        function Id() {
          var b = arguments.length;
          if (!b)
            return [];
          for (var z = w(b - 1), n = arguments[0], O = b; O--; )
            z[O - 1] = arguments[O];
          return Se(R0(n) ? j1(n) : [n], P1(z, 1));
        }
        var kd = T0(function(b, z) {
          return y1(b) ? wM(b, P1(z, 1, y1, !0)) : [];
        }), Pd = T0(function(b, z) {
          var n = L2(z);
          return y1(n) && (n = e), y1(b) ? wM(b, P1(z, 1, y1, !0), A0(n, 2)) : [];
        }), Ed = T0(function(b, z) {
          var n = L2(z);
          return y1(n) && (n = e), y1(b) ? wM(b, P1(z, 1, y1, !0), e, n) : [];
        });
        function xd(b, z, n) {
          var O = b == null ? 0 : b.length;
          return O ? (z = n || z === e ? 1 : y0(z), R2(b, z < 0 ? 0 : z, O)) : [];
        }
        function Fd(b, z, n) {
          var O = b == null ? 0 : b.length;
          return O ? (z = n || z === e ? 1 : y0(z), z = O - z, R2(b, 0, z < 0 ? 0 : z)) : [];
        }
        function Ud(b, z) {
          return b && b.length ? Yb(b, A0(z, 3), !0, !0) : [];
        }
        function Jd(b, z) {
          return b && b.length ? Yb(b, A0(z, 3), !0) : [];
        }
        function Hd(b, z, n, O) {
          var a = b == null ? 0 : b.length;
          return a ? (n && typeof n != "number" && $1(b, z, n) && (n = 0, O = a), IA(b, z, n, O)) : [];
        }
        function Lr(b, z, n) {
          var O = b == null ? 0 : b.length;
          if (!O)
            return -1;
          var a = n == null ? 0 : y0(n);
          return a < 0 && (a = X1(O + a, 0)), gb(b, A0(z, 3), a);
        }
        function gr(b, z, n) {
          var O = b == null ? 0 : b.length;
          if (!O)
            return -1;
          var a = O - 1;
          return n !== e && (a = y0(n), a = n < 0 ? X1(O + a, 0) : E1(a, O - 1)), gb(b, A0(z, 3), a, !0);
        }
        function yr(b) {
          var z = b == null ? 0 : b.length;
          return z ? P1(b, 1) : [];
        }
        function Yd(b) {
          var z = b == null ? 0 : b.length;
          return z ? P1(b, $0) : [];
        }
        function Gd(b, z) {
          var n = b == null ? 0 : b.length;
          return n ? (z = z === e ? 1 : y0(z), P1(b, z)) : [];
        }
        function $d(b) {
          for (var z = -1, n = b == null ? 0 : b.length, O = {}; ++z < n; ) {
            var a = b[z];
            O[a[0]] = a[1];
          }
          return O;
        }
        function Nr(b) {
          return b && b.length ? b[0] : e;
        }
        function Vd(b, z, n) {
          var O = b == null ? 0 : b.length;
          if (!O)
            return -1;
          var a = n == null ? 0 : y0(n);
          return a < 0 && (a = X1(O + a, 0)), St(b, z, a);
        }
        function Kd(b) {
          var z = b == null ? 0 : b.length;
          return z ? R2(b, 0, -1) : [];
        }
        var Qd = T0(function(b) {
          var z = A1(b, Iz);
          return z.length && z[0] === b[0] ? Nz(z) : [];
        }), Zd = T0(function(b) {
          var z = L2(b), n = A1(b, Iz);
          return z === L2(n) ? z = e : n.pop(), n.length && n[0] === b[0] ? Nz(n, A0(z, 2)) : [];
        }), jd = T0(function(b) {
          var z = L2(b), n = A1(b, Iz);
          return z = typeof z == "function" ? z : e, z && n.pop(), n.length && n[0] === b[0] ? Nz(n, e, z) : [];
        });
        function eu(b, z) {
          return b == null ? "" : Ks.call(b, z);
        }
        function L2(b) {
          var z = b == null ? 0 : b.length;
          return z ? b[z - 1] : e;
        }
        function tu(b, z, n) {
          var O = b == null ? 0 : b.length;
          if (!O)
            return -1;
          var a = O;
          return n !== e && (a = y0(n), a = a < 0 ? X1(O + a, 0) : E1(a, O - 1)), z === z ? Ss(b, z, a) : gb(b, ci, a, !0);
        }
        function Mu(b, z) {
          return b && b.length ? ki(b, y0(z)) : e;
        }
        var bu = T0(Br);
        function Br(b, z) {
          return b && b.length && z && z.length ? _z(b, z) : b;
        }
        function pu(b, z, n) {
          return b && b.length && z && z.length ? _z(b, z, A0(n, 2)) : b;
        }
        function zu(b, z, n) {
          return b && b.length && z && z.length ? _z(b, z, e, n) : b;
        }
        var ou = Oe(function(b, z) {
          var n = b == null ? 0 : b.length, O = Rz(b, z);
          return xi(b, A1(z, function(a) {
            return ae(a, n) ? +a : a;
          }).sort(Qi)), O;
        });
        function cu(b, z) {
          var n = [];
          if (!(b && b.length))
            return n;
          var O = -1, a = [], d = b.length;
          for (z = A0(z, 3); ++O < d; ) {
            var q = b[O];
            z(q, O, b) && (n.push(q), a.push(O));
          }
          return xi(b, a), n;
        }
        function Qz(b) {
          return b == null ? b : eA.call(b);
        }
        function nu(b, z, n) {
          var O = b == null ? 0 : b.length;
          return O ? (n && typeof n != "number" && $1(b, z, n) ? (z = 0, n = O) : (z = z == null ? 0 : y0(z), n = n === e ? O : y0(n)), R2(b, z, n)) : [];
        }
        function iu(b, z) {
          return Hb(b, z);
        }
        function ru(b, z, n) {
          return Sz(b, z, A0(n, 2));
        }
        function Ou(b, z) {
          var n = b == null ? 0 : b.length;
          if (n) {
            var O = Hb(b, z);
            if (O < n && C2(b[O], z))
              return O;
          }
          return -1;
        }
        function au(b, z) {
          return Hb(b, z, !0);
        }
        function su(b, z, n) {
          return Sz(b, z, A0(n, 2), !0);
        }
        function Au(b, z) {
          var n = b == null ? 0 : b.length;
          if (n) {
            var O = Hb(b, z, !0) - 1;
            if (C2(b[O], z))
              return O;
          }
          return -1;
        }
        function du(b) {
          return b && b.length ? Ui(b) : [];
        }
        function uu(b, z) {
          return b && b.length ? Ui(b, A0(z, 2)) : [];
        }
        function qu(b) {
          var z = b == null ? 0 : b.length;
          return z ? R2(b, 1, z) : [];
        }
        function lu(b, z, n) {
          return b && b.length ? (z = n || z === e ? 1 : y0(z), R2(b, 0, z < 0 ? 0 : z)) : [];
        }
        function fu(b, z, n) {
          var O = b == null ? 0 : b.length;
          return O ? (z = n || z === e ? 1 : y0(z), z = O - z, R2(b, z < 0 ? 0 : z, O)) : [];
        }
        function Wu(b, z) {
          return b && b.length ? Yb(b, A0(z, 3), !1, !0) : [];
        }
        function hu(b, z) {
          return b && b.length ? Yb(b, A0(z, 3)) : [];
        }
        var mu = T0(function(b) {
          return ke(P1(b, 1, y1, !0));
        }), Ru = T0(function(b) {
          var z = L2(b);
          return y1(z) && (z = e), ke(P1(b, 1, y1, !0), A0(z, 2));
        }), Lu = T0(function(b) {
          var z = L2(b);
          return z = typeof z == "function" ? z : e, ke(P1(b, 1, y1, !0), e, z);
        });
        function gu(b) {
          return b && b.length ? ke(b) : [];
        }
        function yu(b, z) {
          return b && b.length ? ke(b, A0(z, 2)) : [];
        }
        function Nu(b, z) {
          return z = typeof z == "function" ? z : e, b && b.length ? ke(b, e, z) : [];
        }
        function Zz(b) {
          if (!(b && b.length))
            return [];
          var z = 0;
          return b = Xe(b, function(n) {
            if (y1(n))
              return z = X1(n.length, z), !0;
          }), dz(z, function(n) {
            return A1(b, az(n));
          });
        }
        function vr(b, z) {
          if (!(b && b.length))
            return [];
          var n = Zz(b);
          return z == null ? n : A1(n, function(O) {
            return n2(z, e, O);
          });
        }
        var Bu = T0(function(b, z) {
          return y1(b) ? wM(b, z) : [];
        }), vu = T0(function(b) {
          return Cz(Xe(b, y1));
        }), Tu = T0(function(b) {
          var z = L2(b);
          return y1(z) && (z = e), Cz(Xe(b, y1), A0(z, 2));
        }), _u = T0(function(b) {
          var z = L2(b);
          return z = typeof z == "function" ? z : e, Cz(Xe(b, y1), e, z);
        }), wu = T0(Zz);
        function Xu(b, z) {
          return Gi(b || [], z || [], _M);
        }
        function Su(b, z) {
          return Gi(b || [], z || [], DM);
        }
        var Du = T0(function(b) {
          var z = b.length, n = z > 1 ? b[z - 1] : e;
          return n = typeof n == "function" ? (b.pop(), n) : e, vr(b, n);
        });
        function Tr(b) {
          var z = A(b);
          return z.__chain__ = !0, z;
        }
        function Cu(b, z) {
          return z(b), b;
        }
        function tp(b, z) {
          return z(b);
        }
        var Iu = Oe(function(b) {
          var z = b.length, n = z ? b[0] : 0, O = this.__wrapped__, a = function(d) {
            return Rz(d, b);
          };
          return z > 1 || this.__actions__.length || !(O instanceof D0) || !ae(n) ? this.thru(a) : (O = O.slice(n, +n + (z ? 1 : 0)), O.__actions__.push({
            func: tp,
            args: [a],
            thisArg: e
          }), new h2(O, this.__chain__).thru(function(d) {
            return z && !d.length && d.push(e), d;
          }));
        });
        function ku() {
          return Tr(this);
        }
        function Pu() {
          return new h2(this.value(), this.__chain__);
        }
        function Eu() {
          this.__values__ === e && (this.__values__ = Jr(this.value()));
          var b = this.__index__ >= this.__values__.length, z = b ? e : this.__values__[this.__index__++];
          return { done: b, value: z };
        }
        function xu() {
          return this;
        }
        function Fu(b) {
          for (var z, n = this; n instanceof Eb; ) {
            var O = Rr(n);
            O.__index__ = 0, O.__values__ = e, z ? a.__wrapped__ = O : z = O;
            var a = O;
            n = n.__wrapped__;
          }
          return a.__wrapped__ = b, z;
        }
        function Uu() {
          var b = this.__wrapped__;
          if (b instanceof D0) {
            var z = b;
            return this.__actions__.length && (z = new D0(this)), z = z.reverse(), z.__actions__.push({
              func: tp,
              args: [Qz],
              thisArg: e
            }), new h2(z, this.__chain__);
          }
          return this.thru(Qz);
        }
        function Ju() {
          return Yi(this.__wrapped__, this.__actions__);
        }
        var Hu = Gb(function(b, z, n) {
          K0.call(b, n) ? ++b[n] : ie(b, n, 1);
        });
        function Yu(b, z, n) {
          var O = R0(b) ? zi : CA;
          return n && $1(b, z, n) && (z = e), O(b, A0(z, 3));
        }
        function Gu(b, z) {
          var n = R0(b) ? Xe : vi;
          return n(b, A0(z, 3));
        }
        var $u = br(Lr), Vu = br(gr);
        function Ku(b, z) {
          return P1(Mp(b, z), 1);
        }
        function Qu(b, z) {
          return P1(Mp(b, z), $0);
        }
        function Zu(b, z, n) {
          return n = n === e ? 1 : y0(n), P1(Mp(b, z), n);
        }
        function _r(b, z) {
          var n = R0(b) ? f2 : Ie;
          return n(b, A0(z, 3));
        }
        function wr(b, z) {
          var n = R0(b) ? qs : Bi;
          return n(b, A0(z, 3));
        }
        var ju = Gb(function(b, z, n) {
          K0.call(b, n) ? b[n].push(z) : ie(b, n, [z]);
        });
        function e4(b, z, n, O) {
          b = e2(b) ? b : Yt(b), n = n && !O ? y0(n) : 0;
          var a = b.length;
          return n < 0 && (n = X1(a + n, 0)), cp(b) ? n <= a && b.indexOf(z, n) > -1 : !!a && St(b, z, n) > -1;
        }
        var t4 = T0(function(b, z, n) {
          var O = -1, a = typeof z == "function", d = e2(b) ? w(b.length) : [];
          return Ie(b, function(q) {
            d[++O] = a ? n2(z, q, n) : XM(q, z, n);
          }), d;
        }), M4 = Gb(function(b, z, n) {
          ie(b, n, z);
        });
        function Mp(b, z) {
          var n = R0(b) ? A1 : Di;
          return n(b, A0(z, 3));
        }
        function b4(b, z, n, O) {
          return b == null ? [] : (R0(z) || (z = z == null ? [] : [z]), n = O ? e : n, R0(n) || (n = n == null ? [] : [n]), Pi(b, z, n));
        }
        var p4 = Gb(function(b, z, n) {
          b[n ? 0 : 1].push(z);
        }, function() {
          return [[], []];
        });
        function z4(b, z, n) {
          var O = R0(b) ? rz : ii, a = arguments.length < 3;
          return O(b, A0(z, 4), n, a, Ie);
        }
        function o4(b, z, n) {
          var O = R0(b) ? ls : ii, a = arguments.length < 3;
          return O(b, A0(z, 4), n, a, Bi);
        }
        function c4(b, z) {
          var n = R0(b) ? Xe : vi;
          return n(b, zp(A0(z, 3)));
        }
        function n4(b) {
          var z = R0(b) ? Li : ed;
          return z(b);
        }
        function i4(b, z, n) {
          (n ? $1(b, z, n) : z === e) ? z = 1 : z = y0(z);
          var O = R0(b) ? _A : td;
          return O(b, z);
        }
        function r4(b) {
          var z = R0(b) ? wA : bd;
          return z(b);
        }
        function O4(b) {
          if (b == null)
            return 0;
          if (e2(b))
            return cp(b) ? Ct(b) : b.length;
          var z = x1(b);
          return z == C || z == f0 ? b.size : vz(b).length;
        }
        function a4(b, z, n) {
          var O = R0(b) ? Oz : pd;
          return n && $1(b, z, n) && (z = e), O(b, A0(z, 3));
        }
        var s4 = T0(function(b, z) {
          if (b == null)
            return [];
          var n = z.length;
          return n > 1 && $1(b, z[0], z[1]) ? z = [] : n > 2 && $1(z[0], z[1], z[2]) && (z = [z[0]]), Pi(b, P1(z, 1), []);
        }), bp = Gs || function() {
          return k1.Date.now();
        };
        function A4(b, z) {
          if (typeof z != "function")
            throw new W2(s);
          return b = y0(b), function() {
            if (--b < 1)
              return z.apply(this, arguments);
          };
        }
        function Xr(b, z, n) {
          return z = n ? e : z, z = b && z == null ? b.length : z, re(b, v, e, e, e, e, z);
        }
        function Sr(b, z) {
          var n;
          if (typeof z != "function")
            throw new W2(s);
          return b = y0(b), function() {
            return --b > 0 && (n = z.apply(this, arguments)), b <= 1 && (z = e), n;
          };
        }
        var jz = T0(function(b, z, n) {
          var O = B;
          if (n.length) {
            var a = De(n, Jt(jz));
            O |= G;
          }
          return re(b, O, z, n, a);
        }), Dr = T0(function(b, z, n) {
          var O = B | Z;
          if (n.length) {
            var a = De(n, Jt(Dr));
            O |= G;
          }
          return re(z, O, b, n, a);
        });
        function Cr(b, z, n) {
          z = n ? e : z;
          var O = re(b, e0, e, e, e, e, e, z);
          return O.placeholder = Cr.placeholder, O;
        }
        function Ir(b, z, n) {
          z = n ? e : z;
          var O = re(b, r0, e, e, e, e, e, z);
          return O.placeholder = Ir.placeholder, O;
        }
        function kr(b, z, n) {
          var O, a, d, q, h, N, F = 0, U = !1, J = !1, t0 = !0;
          if (typeof b != "function")
            throw new W2(s);
          z = g2(z) || 0, W1(n) && (U = !!n.leading, J = "maxWait" in n, d = J ? X1(g2(n.maxWait) || 0, z) : d, t0 = "trailing" in n ? !!n.trailing : t0);
          function n0(N1) {
            var I2 = O, de = a;
            return O = a = e, F = N1, q = b.apply(de, I2), q;
          }
          function d0(N1) {
            return F = N1, h = kM(X0, z), U ? n0(N1) : q;
          }
          function v0(N1) {
            var I2 = N1 - N, de = N1 - F, bO = z - I2;
            return J ? E1(bO, d - de) : bO;
          }
          function u0(N1) {
            var I2 = N1 - N, de = N1 - F;
            return N === e || I2 >= z || I2 < 0 || J && de >= d;
          }
          function X0() {
            var N1 = bp();
            if (u0(N1))
              return k0(N1);
            h = kM(X0, v0(N1));
          }
          function k0(N1) {
            return h = e, t0 && O ? n0(N1) : (O = a = e, q);
          }
          function a2() {
            h !== e && $i(h), F = 0, O = N = a = h = e;
          }
          function V1() {
            return h === e ? q : k0(bp());
          }
          function s2() {
            var N1 = bp(), I2 = u0(N1);
            if (O = arguments, a = this, N = N1, I2) {
              if (h === e)
                return d0(N);
              if (J)
                return $i(h), h = kM(X0, z), n0(N);
            }
            return h === e && (h = kM(X0, z)), q;
          }
          return s2.cancel = a2, s2.flush = V1, s2;
        }
        var d4 = T0(function(b, z) {
          return Ni(b, 1, z);
        }), u4 = T0(function(b, z, n) {
          return Ni(b, g2(z) || 0, n);
        });
        function q4(b) {
          return re(b, K);
        }
        function pp(b, z) {
          if (typeof b != "function" || z != null && typeof z != "function")
            throw new W2(s);
          var n = function() {
            var O = arguments, a = z ? z.apply(this, O) : O[0], d = n.cache;
            if (d.has(a))
              return d.get(a);
            var q = b.apply(this, O);
            return n.cache = d.set(a, q) || d, q;
          };
          return n.cache = new (pp.Cache || ne)(), n;
        }
        pp.Cache = ne;
        function zp(b) {
          if (typeof b != "function")
            throw new W2(s);
          return function() {
            var z = arguments;
            switch (z.length) {
              case 0:
                return !b.call(this);
              case 1:
                return !b.call(this, z[0]);
              case 2:
                return !b.call(this, z[0], z[1]);
              case 3:
                return !b.call(this, z[0], z[1], z[2]);
            }
            return !b.apply(this, z);
          };
        }
        function l4(b) {
          return Sr(2, b);
        }
        var f4 = zd(function(b, z) {
          z = z.length == 1 && R0(z[0]) ? A1(z[0], i2(A0())) : A1(P1(z, 1), i2(A0()));
          var n = z.length;
          return T0(function(O) {
            for (var a = -1, d = E1(O.length, n); ++a < d; )
              O[a] = z[a].call(this, O[a]);
            return n2(b, this, O);
          });
        }), eo = T0(function(b, z) {
          var n = De(z, Jt(eo));
          return re(b, G, e, z, n);
        }), Pr = T0(function(b, z) {
          var n = De(z, Jt(Pr));
          return re(b, j, e, z, n);
        }), W4 = Oe(function(b, z) {
          return re(b, E, e, e, e, z);
        });
        function h4(b, z) {
          if (typeof b != "function")
            throw new W2(s);
          return z = z === e ? z : y0(z), T0(b, z);
        }
        function m4(b, z) {
          if (typeof b != "function")
            throw new W2(s);
          return z = z == null ? 0 : X1(y0(z), 0), T0(function(n) {
            var O = n[z], a = Ee(n, 0, z);
            return O && Se(a, O), n2(b, this, a);
          });
        }
        function R4(b, z, n) {
          var O = !0, a = !0;
          if (typeof b != "function")
            throw new W2(s);
          return W1(n) && (O = "leading" in n ? !!n.leading : O, a = "trailing" in n ? !!n.trailing : a), kr(b, z, {
            leading: O,
            maxWait: z,
            trailing: a
          });
        }
        function L4(b) {
          return Xr(b, 1);
        }
        function g4(b, z) {
          return eo(kz(z), b);
        }
        function y4() {
          if (!arguments.length)
            return [];
          var b = arguments[0];
          return R0(b) ? b : [b];
        }
        function N4(b) {
          return m2(b, D);
        }
        function B4(b, z) {
          return z = typeof z == "function" ? z : e, m2(b, D, z);
        }
        function v4(b) {
          return m2(b, m | D);
        }
        function T4(b, z) {
          return z = typeof z == "function" ? z : e, m2(b, m | D, z);
        }
        function _4(b, z) {
          return z == null || yi(b, z, C1(z));
        }
        function C2(b, z) {
          return b === z || b !== b && z !== z;
        }
        var w4 = Qb(yz), X4 = Qb(function(b, z) {
          return b >= z;
        }), nt = wi(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? wi : function(b) {
          return R1(b) && K0.call(b, "callee") && !li.call(b, "callee");
        }, R0 = w.isArray, S4 = jn ? i2(jn) : FA;
        function e2(b) {
          return b != null && op(b.length) && !se(b);
        }
        function y1(b) {
          return R1(b) && e2(b);
        }
        function D4(b) {
          return b === !0 || b === !1 || R1(b) && G1(b) == b1;
        }
        var xe = Vs || Oo, C4 = ei ? i2(ei) : UA;
        function I4(b) {
          return R1(b) && b.nodeType === 1 && !PM(b);
        }
        function k4(b) {
          if (b == null)
            return !0;
          if (e2(b) && (R0(b) || typeof b == "string" || typeof b.splice == "function" || xe(b) || Ht(b) || nt(b)))
            return !b.length;
          var z = x1(b);
          if (z == C || z == f0)
            return !b.size;
          if (IM(b))
            return !vz(b).length;
          for (var n in b)
            if (K0.call(b, n))
              return !1;
          return !0;
        }
        function P4(b, z) {
          return SM(b, z);
        }
        function E4(b, z, n) {
          n = typeof n == "function" ? n : e;
          var O = n ? n(b, z) : e;
          return O === e ? SM(b, z, e, n) : !!O;
        }
        function to(b) {
          if (!R1(b))
            return !1;
          var z = G1(b);
          return z == Z0 || z == _0 || typeof b.message == "string" && typeof b.name == "string" && !PM(b);
        }
        function x4(b) {
          return typeof b == "number" && Wi(b);
        }
        function se(b) {
          if (!W1(b))
            return !1;
          var z = G1(b);
          return z == w0 || z == f || z == S0 || z == V0;
        }
        function Er(b) {
          return typeof b == "number" && b == y0(b);
        }
        function op(b) {
          return typeof b == "number" && b > -1 && b % 1 == 0 && b <= $;
        }
        function W1(b) {
          var z = typeof b;
          return b != null && (z == "object" || z == "function");
        }
        function R1(b) {
          return b != null && typeof b == "object";
        }
        var xr = ti ? i2(ti) : HA;
        function F4(b, z) {
          return b === z || Bz(b, z, Hz(z));
        }
        function U4(b, z, n) {
          return n = typeof n == "function" ? n : e, Bz(b, z, Hz(z), n);
        }
        function J4(b) {
          return Fr(b) && b != +b;
        }
        function H4(b) {
          if (Bd(b))
            throw new m0(i);
          return Xi(b);
        }
        function Y4(b) {
          return b === null;
        }
        function G4(b) {
          return b == null;
        }
        function Fr(b) {
          return typeof b == "number" || R1(b) && G1(b) == k;
        }
        function PM(b) {
          if (!R1(b) || G1(b) != b0)
            return !1;
          var z = Xb(b);
          if (z === null)
            return !0;
          var n = K0.call(z, "constructor") && z.constructor;
          return typeof n == "function" && n instanceof n && vb.call(n) == Us;
        }
        var Mo = Mi ? i2(Mi) : YA;
        function $4(b) {
          return Er(b) && b >= -$ && b <= $;
        }
        var Ur = bi ? i2(bi) : GA;
        function cp(b) {
          return typeof b == "string" || !R0(b) && R1(b) && G1(b) == o2;
        }
        function O2(b) {
          return typeof b == "symbol" || R1(b) && G1(b) == w2;
        }
        var Ht = pi ? i2(pi) : $A;
        function V4(b) {
          return b === e;
        }
        function K4(b) {
          return R1(b) && x1(b) == Ve;
        }
        function Q4(b) {
          return R1(b) && G1(b) == jp;
        }
        var Z4 = Qb(Tz), j4 = Qb(function(b, z) {
          return b <= z;
        });
        function Jr(b) {
          if (!b)
            return [];
          if (e2(b))
            return cp(b) ? S2(b) : j1(b);
          if (yM && b[yM])
            return _s(b[yM]());
          var z = x1(b), n = z == C ? qz : z == f0 ? yb : Yt;
          return n(b);
        }
        function Ae(b) {
          if (!b)
            return b === 0 ? b : 0;
          if (b = g2(b), b === $0 || b === -$0) {
            var z = b < 0 ? -1 : 1;
            return z * x0;
          }
          return b === b ? b : 0;
        }
        function y0(b) {
          var z = Ae(b), n = z % 1;
          return z === z ? n ? z - n : z : 0;
        }
        function Hr(b) {
          return b ? pt(y0(b), 0, n1) : 0;
        }
        function g2(b) {
          if (typeof b == "number")
            return b;
          if (O2(b))
            return f1;
          if (W1(b)) {
            var z = typeof b.valueOf == "function" ? b.valueOf() : b;
            b = W1(z) ? z + "" : z;
          }
          if (typeof b != "string")
            return b === 0 ? b : +b;
          b = ri(b);
          var n = LM.test(b);
          return n || wt.test(b) ? As(b.slice(2), n ? 2 : 8) : ez.test(b) ? f1 : +b;
        }
        function Yr(b) {
          return Y2(b, t2(b));
        }
        function eq(b) {
          return b ? pt(y0(b), -$, $) : b === 0 ? b : 0;
        }
        function G0(b) {
          return b == null ? "" : r2(b);
        }
        var tq = Ft(function(b, z) {
          if (IM(z) || e2(z)) {
            Y2(z, C1(z), b);
            return;
          }
          for (var n in z)
            K0.call(z, n) && _M(b, n, z[n]);
        }), Gr = Ft(function(b, z) {
          Y2(z, t2(z), b);
        }), np = Ft(function(b, z, n, O) {
          Y2(z, t2(z), b, O);
        }), Mq = Ft(function(b, z, n, O) {
          Y2(z, C1(z), b, O);
        }), bq = Oe(Rz);
        function pq(b, z) {
          var n = xt(b);
          return z == null ? n : gi(n, z);
        }
        var zq = T0(function(b, z) {
          b = M1(b);
          var n = -1, O = z.length, a = O > 2 ? z[2] : e;
          for (a && $1(z[0], z[1], a) && (O = 1); ++n < O; )
            for (var d = z[n], q = t2(d), h = -1, N = q.length; ++h < N; ) {
              var F = q[h], U = b[F];
              (U === e || C2(U, kt[F]) && !K0.call(b, F)) && (b[F] = d[F]);
            }
          return b;
        }), oq = T0(function(b) {
          return b.push(e, rr), n2($r, e, b);
        });
        function cq(b, z) {
          return oi(b, A0(z, 3), H2);
        }
        function nq(b, z) {
          return oi(b, A0(z, 3), gz);
        }
        function iq(b, z) {
          return b == null ? b : Lz(b, A0(z, 3), t2);
        }
        function rq(b, z) {
          return b == null ? b : Ti(b, A0(z, 3), t2);
        }
        function Oq(b, z) {
          return b && H2(b, A0(z, 3));
        }
        function aq(b, z) {
          return b && gz(b, A0(z, 3));
        }
        function sq(b) {
          return b == null ? [] : Ub(b, C1(b));
        }
        function Aq(b) {
          return b == null ? [] : Ub(b, t2(b));
        }
        function bo(b, z, n) {
          var O = b == null ? e : zt(b, z);
          return O === e ? n : O;
        }
        function dq(b, z) {
          return b != null && sr(b, z, kA);
        }
        function po(b, z) {
          return b != null && sr(b, z, PA);
        }
        var uq = zr(function(b, z, n) {
          z != null && typeof z.toString != "function" && (z = Tb.call(z)), b[z] = n;
        }, oo(M2)), qq = zr(function(b, z, n) {
          z != null && typeof z.toString != "function" && (z = Tb.call(z)), K0.call(b, z) ? b[z].push(n) : b[z] = [n];
        }, A0), lq = T0(XM);
        function C1(b) {
          return e2(b) ? Ri(b) : vz(b);
        }
        function t2(b) {
          return e2(b) ? Ri(b, !0) : VA(b);
        }
        function fq(b, z) {
          var n = {};
          return z = A0(z, 3), H2(b, function(O, a, d) {
            ie(n, z(O, a, d), O);
          }), n;
        }
        function Wq(b, z) {
          var n = {};
          return z = A0(z, 3), H2(b, function(O, a, d) {
            ie(n, a, z(O, a, d));
          }), n;
        }
        var hq = Ft(function(b, z, n) {
          Jb(b, z, n);
        }), $r = Ft(function(b, z, n, O) {
          Jb(b, z, n, O);
        }), mq = Oe(function(b, z) {
          var n = {};
          if (b == null)
            return n;
          var O = !1;
          z = A1(z, function(d) {
            return d = Pe(d, b), O || (O = d.length > 1), d;
          }), Y2(b, Uz(b), n), O && (n = m2(n, m | X | D, ud));
          for (var a = z.length; a--; )
            Dz(n, z[a]);
          return n;
        });
        function Rq(b, z) {
          return Vr(b, zp(A0(z)));
        }
        var Lq = Oe(function(b, z) {
          return b == null ? {} : QA(b, z);
        });
        function Vr(b, z) {
          if (b == null)
            return {};
          var n = A1(Uz(b), function(O) {
            return [O];
          });
          return z = A0(z), Ei(b, n, function(O, a) {
            return z(O, a[0]);
          });
        }
        function gq(b, z, n) {
          z = Pe(z, b);
          var O = -1, a = z.length;
          for (a || (a = 1, b = e); ++O < a; ) {
            var d = b == null ? e : b[G2(z[O])];
            d === e && (O = a, d = n), b = se(d) ? d.call(b) : d;
          }
          return b;
        }
        function yq(b, z, n) {
          return b == null ? b : DM(b, z, n);
        }
        function Nq(b, z, n, O) {
          return O = typeof O == "function" ? O : e, b == null ? b : DM(b, z, n, O);
        }
        var Kr = nr(C1), Qr = nr(t2);
        function Bq(b, z, n) {
          var O = R0(b), a = O || xe(b) || Ht(b);
          if (z = A0(z, 4), n == null) {
            var d = b && b.constructor;
            a ? n = O ? new d() : [] : W1(b) ? n = se(d) ? xt(Xb(b)) : {} : n = {};
          }
          return (a ? f2 : H2)(b, function(q, h, N) {
            return z(n, q, h, N);
          }), n;
        }
        function vq(b, z) {
          return b == null ? !0 : Dz(b, z);
        }
        function Tq(b, z, n) {
          return b == null ? b : Hi(b, z, kz(n));
        }
        function _q(b, z, n, O) {
          return O = typeof O == "function" ? O : e, b == null ? b : Hi(b, z, kz(n), O);
        }
        function Yt(b) {
          return b == null ? [] : uz(b, C1(b));
        }
        function wq(b) {
          return b == null ? [] : uz(b, t2(b));
        }
        function Xq(b, z, n) {
          return n === e && (n = z, z = e), n !== e && (n = g2(n), n = n === n ? n : 0), z !== e && (z = g2(z), z = z === z ? z : 0), pt(g2(b), z, n);
        }
        function Sq(b, z, n) {
          return z = Ae(z), n === e ? (n = z, z = 0) : n = Ae(n), b = g2(b), EA(b, z, n);
        }
        function Dq(b, z, n) {
          if (n && typeof n != "boolean" && $1(b, z, n) && (z = n = e), n === e && (typeof z == "boolean" ? (n = z, z = e) : typeof b == "boolean" && (n = b, b = e)), b === e && z === e ? (b = 0, z = 1) : (b = Ae(b), z === e ? (z = b, b = 0) : z = Ae(z)), b > z) {
            var O = b;
            b = z, z = O;
          }
          if (n || b % 1 || z % 1) {
            var a = hi();
            return E1(b + a * (z - b + ss("1e-" + ((a + "").length - 1))), z);
          }
          return wz(b, z);
        }
        var Cq = Ut(function(b, z, n) {
          return z = z.toLowerCase(), b + (n ? Zr(z) : z);
        });
        function Zr(b) {
          return zo(G0(b).toLowerCase());
        }
        function jr(b) {
          return b = G0(b), b && b.replace(Wb, ys).replace(bs, "");
        }
        function Iq(b, z, n) {
          b = G0(b), z = r2(z);
          var O = b.length;
          n = n === e ? O : pt(y0(n), 0, O);
          var a = n;
          return n -= z.length, n >= 0 && b.slice(n, a) == z;
        }
        function kq(b) {
          return b = G0(b), b && Y1.test(b) ? b.replace(X2, Ns) : b;
        }
        function Pq(b) {
          return b = G0(b), b && Ze.test(b) ? b.replace(Tt, "\\$&") : b;
        }
        var Eq = Ut(function(b, z, n) {
          return b + (n ? "-" : "") + z.toLowerCase();
        }), xq = Ut(function(b, z, n) {
          return b + (n ? " " : "") + z.toLowerCase();
        }), Fq = Mr("toLowerCase");
        function Uq(b, z, n) {
          b = G0(b), z = y0(z);
          var O = z ? Ct(b) : 0;
          if (!z || O >= z)
            return b;
          var a = (z - O) / 2;
          return Kb(Ib(a), n) + b + Kb(Cb(a), n);
        }
        function Jq(b, z, n) {
          b = G0(b), z = y0(z);
          var O = z ? Ct(b) : 0;
          return z && O < z ? b + Kb(z - O, n) : b;
        }
        function Hq(b, z, n) {
          b = G0(b), z = y0(z);
          var O = z ? Ct(b) : 0;
          return z && O < z ? Kb(z - O, n) + b : b;
        }
        function Yq(b, z, n) {
          return n || z == null ? z = 0 : z && (z = +z), js(G0(b).replace(je, ""), z || 0);
        }
        function Gq(b, z, n) {
          return (n ? $1(b, z, n) : z === e) ? z = 1 : z = y0(z), Xz(G0(b), z);
        }
        function $q() {
          var b = arguments, z = G0(b[0]);
          return b.length < 3 ? z : z.replace(b[1], b[2]);
        }
        var Vq = Ut(function(b, z, n) {
          return b + (n ? "_" : "") + z.toLowerCase();
        });
        function Kq(b, z, n) {
          return n && typeof n != "number" && $1(b, z, n) && (z = n = e), n = n === e ? n1 : n >>> 0, n ? (b = G0(b), b && (typeof z == "string" || z != null && !Mo(z)) && (z = r2(z), !z && Dt(b)) ? Ee(S2(b), 0, n) : b.split(z, n)) : [];
        }
        var Qq = Ut(function(b, z, n) {
          return b + (n ? " " : "") + zo(z);
        });
        function Zq(b, z, n) {
          return b = G0(b), n = n == null ? 0 : pt(y0(n), 0, b.length), z = r2(z), b.slice(n, n + z.length) == z;
        }
        function jq(b, z, n) {
          var O = A.templateSettings;
          n && $1(b, z, n) && (z = e), b = G0(b), z = np({}, z, O, ir);
          var a = np({}, z.imports, O.imports, ir), d = C1(a), q = uz(a, d), h, N, F = 0, U = z.interpolate || hb, J = "__p += '", t0 = lz(
            (z.escape || hb).source + "|" + U.source + "|" + (U === oe ? mM : hb).source + "|" + (z.evaluate || hb).source + "|$",
            "g"
          ), n0 = "//# sourceURL=" + (K0.call(z, "sourceURL") ? (z.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ns + "]") + `
`;
          b.replace(t0, function(u0, X0, k0, a2, V1, s2) {
            return k0 || (k0 = a2), J += b.slice(F, s2).replace(Pa, Bs), X0 && (h = !0, J += `' +
__e(` + X0 + `) +
'`), V1 && (N = !0, J += `';
` + V1 + `;
__p += '`), k0 && (J += `' +
((__t = (` + k0 + `)) == null ? '' : __t) +
'`), F = s2 + u0.length, u0;
          }), J += `';
`;
          var d0 = K0.call(z, "variable") && z.variable;
          if (!d0)
            J = `with (obj) {
` + J + `
}
`;
          else if (hM.test(d0))
            throw new m0(u);
          J = (N ? J.replace(F0, "") : J).replace(j0, "$1").replace(t1, "$1;"), J = "function(" + (d0 || "obj") + `) {
` + (d0 ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (h ? ", __e = _.escape" : "") + (N ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + J + `return __p
}`;
          var v0 = tO(function() {
            return H0(d, n0 + "return " + J).apply(e, q);
          });
          if (v0.source = J, to(v0))
            throw v0;
          return v0;
        }
        function el(b) {
          return G0(b).toLowerCase();
        }
        function tl(b) {
          return G0(b).toUpperCase();
        }
        function Ml(b, z, n) {
          if (b = G0(b), b && (n || z === e))
            return ri(b);
          if (!b || !(z = r2(z)))
            return b;
          var O = S2(b), a = S2(z), d = Oi(O, a), q = ai(O, a) + 1;
          return Ee(O, d, q).join("");
        }
        function bl(b, z, n) {
          if (b = G0(b), b && (n || z === e))
            return b.slice(0, Ai(b) + 1);
          if (!b || !(z = r2(z)))
            return b;
          var O = S2(b), a = ai(O, S2(z)) + 1;
          return Ee(O, 0, a).join("");
        }
        function pl(b, z, n) {
          if (b = G0(b), b && (n || z === e))
            return b.replace(je, "");
          if (!b || !(z = r2(z)))
            return b;
          var O = S2(b), a = Oi(O, S2(z));
          return Ee(O, a).join("");
        }
        function zl(b, z) {
          var n = p0, O = O0;
          if (W1(z)) {
            var a = "separator" in z ? z.separator : a;
            n = "length" in z ? y0(z.length) : n, O = "omission" in z ? r2(z.omission) : O;
          }
          b = G0(b);
          var d = b.length;
          if (Dt(b)) {
            var q = S2(b);
            d = q.length;
          }
          if (n >= d)
            return b;
          var h = n - Ct(O);
          if (h < 1)
            return O;
          var N = q ? Ee(q, 0, h).join("") : b.slice(0, h);
          if (a === e)
            return N + O;
          if (q && (h += N.length - h), Mo(a)) {
            if (b.slice(h).search(a)) {
              var F, U = N;
              for (a.global || (a = lz(a.source, G0(RM.exec(a)) + "g")), a.lastIndex = 0; F = a.exec(U); )
                var J = F.index;
              N = N.slice(0, J === e ? h : J);
            }
          } else if (b.indexOf(r2(a), h) != h) {
            var t0 = N.lastIndexOf(a);
            t0 > -1 && (N = N.slice(0, t0));
          }
          return N + O;
        }
        function ol(b) {
          return b = G0(b), b && ze.test(b) ? b.replace(g0, Ds) : b;
        }
        var cl = Ut(function(b, z, n) {
          return b + (n ? " " : "") + z.toUpperCase();
        }), zo = Mr("toUpperCase");
        function eO(b, z, n) {
          return b = G0(b), z = n ? e : z, z === e ? Ts(b) ? ks(b) : hs(b) : b.match(z) || [];
        }
        var tO = T0(function(b, z) {
          try {
            return n2(b, e, z);
          } catch (n) {
            return to(n) ? n : new m0(n);
          }
        }), nl = Oe(function(b, z) {
          return f2(z, function(n) {
            n = G2(n), ie(b, n, jz(b[n], b));
          }), b;
        });
        function il(b) {
          var z = b == null ? 0 : b.length, n = A0();
          return b = z ? A1(b, function(O) {
            if (typeof O[1] != "function")
              throw new W2(s);
            return [n(O[0]), O[1]];
          }) : [], T0(function(O) {
            for (var a = -1; ++a < z; ) {
              var d = b[a];
              if (n2(d[0], this, O))
                return n2(d[1], this, O);
            }
          });
        }
        function rl(b) {
          return DA(m2(b, m));
        }
        function oo(b) {
          return function() {
            return b;
          };
        }
        function Ol(b, z) {
          return b == null || b !== b ? z : b;
        }
        var al = pr(), sl = pr(!0);
        function M2(b) {
          return b;
        }
        function co(b) {
          return Si(typeof b == "function" ? b : m2(b, m));
        }
        function Al(b) {
          return Ci(m2(b, m));
        }
        function dl(b, z) {
          return Ii(b, m2(z, m));
        }
        var ul = T0(function(b, z) {
          return function(n) {
            return XM(n, b, z);
          };
        }), ql = T0(function(b, z) {
          return function(n) {
            return XM(b, n, z);
          };
        });
        function no(b, z, n) {
          var O = C1(z), a = Ub(z, O);
          n == null && !(W1(z) && (a.length || !O.length)) && (n = z, z = b, b = this, a = Ub(z, C1(z)));
          var d = !(W1(n) && "chain" in n) || !!n.chain, q = se(b);
          return f2(a, function(h) {
            var N = z[h];
            b[h] = N, q && (b.prototype[h] = function() {
              var F = this.__chain__;
              if (d || F) {
                var U = b(this.__wrapped__), J = U.__actions__ = j1(this.__actions__);
                return J.push({ func: N, args: arguments, thisArg: b }), U.__chain__ = F, U;
              }
              return N.apply(b, Se([this.value()], arguments));
            });
          }), b;
        }
        function ll() {
          return k1._ === this && (k1._ = Js), this;
        }
        function io() {
        }
        function fl(b) {
          return b = y0(b), T0(function(z) {
            return ki(z, b);
          });
        }
        var Wl = Ez(A1), hl = Ez(zi), ml = Ez(Oz);
        function MO(b) {
          return Gz(b) ? az(G2(b)) : ZA(b);
        }
        function Rl(b) {
          return function(z) {
            return b == null ? e : zt(b, z);
          };
        }
        var Ll = or(), gl = or(!0);
        function ro() {
          return [];
        }
        function Oo() {
          return !1;
        }
        function yl() {
          return {};
        }
        function Nl() {
          return "";
        }
        function Bl() {
          return !0;
        }
        function vl(b, z) {
          if (b = y0(b), b < 1 || b > $)
            return [];
          var n = n1, O = E1(b, n1);
          z = A0(z), b -= n1;
          for (var a = dz(O, z); ++n < b; )
            z(n);
          return a;
        }
        function Tl(b) {
          return R0(b) ? A1(b, G2) : O2(b) ? [b] : j1(mr(G0(b)));
        }
        function _l(b) {
          var z = ++Fs;
          return G0(b) + z;
        }
        var wl = Vb(function(b, z) {
          return b + z;
        }, 0), Xl = xz("ceil"), Sl = Vb(function(b, z) {
          return b / z;
        }, 1), Dl = xz("floor");
        function Cl(b) {
          return b && b.length ? Fb(b, M2, yz) : e;
        }
        function Il(b, z) {
          return b && b.length ? Fb(b, A0(z, 2), yz) : e;
        }
        function kl(b) {
          return ni(b, M2);
        }
        function Pl(b, z) {
          return ni(b, A0(z, 2));
        }
        function El(b) {
          return b && b.length ? Fb(b, M2, Tz) : e;
        }
        function xl(b, z) {
          return b && b.length ? Fb(b, A0(z, 2), Tz) : e;
        }
        var Fl = Vb(function(b, z) {
          return b * z;
        }, 1), Ul = xz("round"), Jl = Vb(function(b, z) {
          return b - z;
        }, 0);
        function Hl(b) {
          return b && b.length ? Az(b, M2) : 0;
        }
        function Yl(b, z) {
          return b && b.length ? Az(b, A0(z, 2)) : 0;
        }
        return A.after = A4, A.ary = Xr, A.assign = tq, A.assignIn = Gr, A.assignInWith = np, A.assignWith = Mq, A.at = bq, A.before = Sr, A.bind = jz, A.bindAll = nl, A.bindKey = Dr, A.castArray = y4, A.chain = Tr, A.chunk = Dd, A.compact = Cd, A.concat = Id, A.cond = il, A.conforms = rl, A.constant = oo, A.countBy = Hu, A.create = pq, A.curry = Cr, A.curryRight = Ir, A.debounce = kr, A.defaults = zq, A.defaultsDeep = oq, A.defer = d4, A.delay = u4, A.difference = kd, A.differenceBy = Pd, A.differenceWith = Ed, A.drop = xd, A.dropRight = Fd, A.dropRightWhile = Ud, A.dropWhile = Jd, A.fill = Hd, A.filter = Gu, A.flatMap = Ku, A.flatMapDeep = Qu, A.flatMapDepth = Zu, A.flatten = yr, A.flattenDeep = Yd, A.flattenDepth = Gd, A.flip = q4, A.flow = al, A.flowRight = sl, A.fromPairs = $d, A.functions = sq, A.functionsIn = Aq, A.groupBy = ju, A.initial = Kd, A.intersection = Qd, A.intersectionBy = Zd, A.intersectionWith = jd, A.invert = uq, A.invertBy = qq, A.invokeMap = t4, A.iteratee = co, A.keyBy = M4, A.keys = C1, A.keysIn = t2, A.map = Mp, A.mapKeys = fq, A.mapValues = Wq, A.matches = Al, A.matchesProperty = dl, A.memoize = pp, A.merge = hq, A.mergeWith = $r, A.method = ul, A.methodOf = ql, A.mixin = no, A.negate = zp, A.nthArg = fl, A.omit = mq, A.omitBy = Rq, A.once = l4, A.orderBy = b4, A.over = Wl, A.overArgs = f4, A.overEvery = hl, A.overSome = ml, A.partial = eo, A.partialRight = Pr, A.partition = p4, A.pick = Lq, A.pickBy = Vr, A.property = MO, A.propertyOf = Rl, A.pull = bu, A.pullAll = Br, A.pullAllBy = pu, A.pullAllWith = zu, A.pullAt = ou, A.range = Ll, A.rangeRight = gl, A.rearg = W4, A.reject = c4, A.remove = cu, A.rest = h4, A.reverse = Qz, A.sampleSize = i4, A.set = yq, A.setWith = Nq, A.shuffle = r4, A.slice = nu, A.sortBy = s4, A.sortedUniq = du, A.sortedUniqBy = uu, A.split = Kq, A.spread = m4, A.tail = qu, A.take = lu, A.takeRight = fu, A.takeRightWhile = Wu, A.takeWhile = hu, A.tap = Cu, A.throttle = R4, A.thru = tp, A.toArray = Jr, A.toPairs = Kr, A.toPairsIn = Qr, A.toPath = Tl, A.toPlainObject = Yr, A.transform = Bq, A.unary = L4, A.union = mu, A.unionBy = Ru, A.unionWith = Lu, A.uniq = gu, A.uniqBy = yu, A.uniqWith = Nu, A.unset = vq, A.unzip = Zz, A.unzipWith = vr, A.update = Tq, A.updateWith = _q, A.values = Yt, A.valuesIn = wq, A.without = Bu, A.words = eO, A.wrap = g4, A.xor = vu, A.xorBy = Tu, A.xorWith = _u, A.zip = wu, A.zipObject = Xu, A.zipObjectDeep = Su, A.zipWith = Du, A.entries = Kr, A.entriesIn = Qr, A.extend = Gr, A.extendWith = np, no(A, A), A.add = wl, A.attempt = tO, A.camelCase = Cq, A.capitalize = Zr, A.ceil = Xl, A.clamp = Xq, A.clone = N4, A.cloneDeep = v4, A.cloneDeepWith = T4, A.cloneWith = B4, A.conformsTo = _4, A.deburr = jr, A.defaultTo = Ol, A.divide = Sl, A.endsWith = Iq, A.eq = C2, A.escape = kq, A.escapeRegExp = Pq, A.every = Yu, A.find = $u, A.findIndex = Lr, A.findKey = cq, A.findLast = Vu, A.findLastIndex = gr, A.findLastKey = nq, A.floor = Dl, A.forEach = _r, A.forEachRight = wr, A.forIn = iq, A.forInRight = rq, A.forOwn = Oq, A.forOwnRight = aq, A.get = bo, A.gt = w4, A.gte = X4, A.has = dq, A.hasIn = po, A.head = Nr, A.identity = M2, A.includes = e4, A.indexOf = Vd, A.inRange = Sq, A.invoke = lq, A.isArguments = nt, A.isArray = R0, A.isArrayBuffer = S4, A.isArrayLike = e2, A.isArrayLikeObject = y1, A.isBoolean = D4, A.isBuffer = xe, A.isDate = C4, A.isElement = I4, A.isEmpty = k4, A.isEqual = P4, A.isEqualWith = E4, A.isError = to, A.isFinite = x4, A.isFunction = se, A.isInteger = Er, A.isLength = op, A.isMap = xr, A.isMatch = F4, A.isMatchWith = U4, A.isNaN = J4, A.isNative = H4, A.isNil = G4, A.isNull = Y4, A.isNumber = Fr, A.isObject = W1, A.isObjectLike = R1, A.isPlainObject = PM, A.isRegExp = Mo, A.isSafeInteger = $4, A.isSet = Ur, A.isString = cp, A.isSymbol = O2, A.isTypedArray = Ht, A.isUndefined = V4, A.isWeakMap = K4, A.isWeakSet = Q4, A.join = eu, A.kebabCase = Eq, A.last = L2, A.lastIndexOf = tu, A.lowerCase = xq, A.lowerFirst = Fq, A.lt = Z4, A.lte = j4, A.max = Cl, A.maxBy = Il, A.mean = kl, A.meanBy = Pl, A.min = El, A.minBy = xl, A.stubArray = ro, A.stubFalse = Oo, A.stubObject = yl, A.stubString = Nl, A.stubTrue = Bl, A.multiply = Fl, A.nth = Mu, A.noConflict = ll, A.noop = io, A.now = bp, A.pad = Uq, A.padEnd = Jq, A.padStart = Hq, A.parseInt = Yq, A.random = Dq, A.reduce = z4, A.reduceRight = o4, A.repeat = Gq, A.replace = $q, A.result = gq, A.round = Ul, A.runInContext = g, A.sample = n4, A.size = O4, A.snakeCase = Vq, A.some = a4, A.sortedIndex = iu, A.sortedIndexBy = ru, A.sortedIndexOf = Ou, A.sortedLastIndex = au, A.sortedLastIndexBy = su, A.sortedLastIndexOf = Au, A.startCase = Qq, A.startsWith = Zq, A.subtract = Jl, A.sum = Hl, A.sumBy = Yl, A.template = jq, A.times = vl, A.toFinite = Ae, A.toInteger = y0, A.toLength = Hr, A.toLower = el, A.toNumber = g2, A.toSafeInteger = eq, A.toString = G0, A.toUpper = tl, A.trim = Ml, A.trimEnd = bl, A.trimStart = pl, A.truncate = zl, A.unescape = ol, A.uniqueId = _l, A.upperCase = cl, A.upperFirst = zo, A.each = _r, A.eachRight = wr, A.first = Nr, no(A, (function() {
          var b = {};
          return H2(A, function(z, n) {
            K0.call(A.prototype, n) || (b[n] = z);
          }), b;
        })(), { chain: !1 }), A.VERSION = p, f2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(b) {
          A[b].placeholder = A;
        }), f2(["drop", "take"], function(b, z) {
          D0.prototype[b] = function(n) {
            n = n === e ? 1 : X1(y0(n), 0);
            var O = this.__filtered__ && !z ? new D0(this) : this.clone();
            return O.__filtered__ ? O.__takeCount__ = E1(n, O.__takeCount__) : O.__views__.push({
              size: E1(n, n1),
              type: b + (O.__dir__ < 0 ? "Right" : "")
            }), O;
          }, D0.prototype[b + "Right"] = function(n) {
            return this.reverse()[b](n).reverse();
          };
        }), f2(["filter", "map", "takeWhile"], function(b, z) {
          var n = z + 1, O = n == l0 || n == W0;
          D0.prototype[b] = function(a) {
            var d = this.clone();
            return d.__iteratees__.push({
              iteratee: A0(a, 3),
              type: n
            }), d.__filtered__ = d.__filtered__ || O, d;
          };
        }), f2(["head", "last"], function(b, z) {
          var n = "take" + (z ? "Right" : "");
          D0.prototype[b] = function() {
            return this[n](1).value()[0];
          };
        }), f2(["initial", "tail"], function(b, z) {
          var n = "drop" + (z ? "" : "Right");
          D0.prototype[b] = function() {
            return this.__filtered__ ? new D0(this) : this[n](1);
          };
        }), D0.prototype.compact = function() {
          return this.filter(M2);
        }, D0.prototype.find = function(b) {
          return this.filter(b).head();
        }, D0.prototype.findLast = function(b) {
          return this.reverse().find(b);
        }, D0.prototype.invokeMap = T0(function(b, z) {
          return typeof b == "function" ? new D0(this) : this.map(function(n) {
            return XM(n, b, z);
          });
        }), D0.prototype.reject = function(b) {
          return this.filter(zp(A0(b)));
        }, D0.prototype.slice = function(b, z) {
          b = y0(b);
          var n = this;
          return n.__filtered__ && (b > 0 || z < 0) ? new D0(n) : (b < 0 ? n = n.takeRight(-b) : b && (n = n.drop(b)), z !== e && (z = y0(z), n = z < 0 ? n.dropRight(-z) : n.take(z - b)), n);
        }, D0.prototype.takeRightWhile = function(b) {
          return this.reverse().takeWhile(b).reverse();
        }, D0.prototype.toArray = function() {
          return this.take(n1);
        }, H2(D0.prototype, function(b, z) {
          var n = /^(?:filter|find|map|reject)|While$/.test(z), O = /^(?:head|last)$/.test(z), a = A[O ? "take" + (z == "last" ? "Right" : "") : z], d = O || /^find/.test(z);
          a && (A.prototype[z] = function() {
            var q = this.__wrapped__, h = O ? [1] : arguments, N = q instanceof D0, F = h[0], U = N || R0(q), J = function(X0) {
              var k0 = a.apply(A, Se([X0], h));
              return O && t0 ? k0[0] : k0;
            };
            U && n && typeof F == "function" && F.length != 1 && (N = U = !1);
            var t0 = this.__chain__, n0 = !!this.__actions__.length, d0 = d && !t0, v0 = N && !n0;
            if (!d && U) {
              q = v0 ? q : new D0(this);
              var u0 = b.apply(q, h);
              return u0.__actions__.push({ func: tp, args: [J], thisArg: e }), new h2(u0, t0);
            }
            return d0 && v0 ? b.apply(this, h) : (u0 = this.thru(J), d0 ? O ? u0.value()[0] : u0.value() : u0);
          });
        }), f2(["pop", "push", "shift", "sort", "splice", "unshift"], function(b) {
          var z = Nb[b], n = /^(?:push|sort|unshift)$/.test(b) ? "tap" : "thru", O = /^(?:pop|shift)$/.test(b);
          A.prototype[b] = function() {
            var a = arguments;
            if (O && !this.__chain__) {
              var d = this.value();
              return z.apply(R0(d) ? d : [], a);
            }
            return this[n](function(q) {
              return z.apply(R0(q) ? q : [], a);
            });
          };
        }), H2(D0.prototype, function(b, z) {
          var n = A[z];
          if (n) {
            var O = n.name + "";
            K0.call(Et, O) || (Et[O] = []), Et[O].push({ name: z, func: n });
          }
        }), Et[$b(e, Z).name] = [{
          name: "wrapper",
          func: e
        }], D0.prototype.clone = oA, D0.prototype.reverse = cA, D0.prototype.value = nA, A.prototype.at = Iu, A.prototype.chain = ku, A.prototype.commit = Pu, A.prototype.next = Eu, A.prototype.plant = Fu, A.prototype.reverse = Uu, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = Ju, A.prototype.first = A.prototype.head, yM && (A.prototype[yM] = xu), A;
      }), It = Ps();
      et ? ((et.exports = It)._ = It, cz._ = It) : k1._ = It;
    }).call(nh);
  })(FM, FM.exports)), FM.exports;
}
var I1 = ih();
function u1(M, t = { trimSpaces: !0 }) {
  let e = M;
  if (typeof e == "string" && t.trimSpaces == !0)
    e = e == null ? void 0 : e.trim();
  else if (typeof e == "number" || typeof e == "boolean" || I1.isDate(M))
    return e === void 0;
  return I1.isEmpty(e);
}
function v2(M) {
  if (M !== void 0)
    return { value: M };
}
function rh(M) {
  if (typeof M != "object") return {};
  const t = {};
  for (const e in M)
    t[e] = v2(M[e]);
  return t;
}
function Oh(M, t, e = !1) {
  if (M)
    return typeof M != "object" && e ? M : t && M.value ? t(M.value) : M.value;
}
function aa(M, t = !1) {
  let e = {};
  return Object.keys(M).forEach((p) => e[p] = Oh(M[p], void 0, t)), e;
}
Array.prototype.pushIfNotExists || (Array.prototype.pushIfNotExists = function(M, t = sa) {
  this.some((e) => t(e, M)) || this.push(M);
});
Array.prototype.remove || (Array.prototype.remove = function(M) {
  return this.filter((t) => t !== M);
});
Array.prototype.removeAt || (Array.prototype.removeAt = function(M) {
  const t = this.slice();
  return t.splice(M, 1), t;
});
Array.prototype.removeIf || (Array.prototype.removeIf = function(M) {
  return this.filter((t) => !M(t));
});
Array.prototype.reorder || (Array.prototype.reorder = function(M, t) {
  const e = this.slice(), p = e[M], c = e[t];
  return e.splice(M, 1), e.splice(t, 0, p), {
    oldItems: this,
    items: e,
    srcItem: p,
    dstItem: c
  };
});
Array.prototype.toggle || (Array.prototype.toggle = function(M, t) {
  const e = this.slice(), p = t || ((i) => i === M), c = e.findIndex(p);
  return c < 0 ? e.push(M) : e.splice(c, 1), e;
});
Array.prototype.toMap || (Array.prototype.toMap = function(M) {
  return new Map(this.map((t) => [M(t), t]));
});
Array.prototype.groupBy || (Array.prototype.groupBy = function(M) {
  const t = /* @__PURE__ */ new Map();
  return this.forEach((e) => {
    const p = M(e), c = t.get(p);
    c ? c.push(e) : t.set(p, [e]);
  }), t;
});
Array.prototype.isEmpty || (Array.prototype.isEmpty = function() {
  return this.length == 0;
});
function sa(M, t) {
  return M === t;
}
Array.prototype.isEquals || (Array.prototype.isEquals = function(M, t = sa) {
  return this === M ? !0 : !this || !M || this.length !== M.length ? !1 : this.every((e, p) => M.find((c, i) => t(e, c, p, i)) != null);
});
Array.prototype.orderBy || (Array.prototype.orderBy = function(M = (t) => t) {
  return this ? this.slice().sort((t, e) => M(t) < M(e) ? -1 : 1) : [];
});
Array.prototype.orderByDesc || (Array.prototype.orderByDesc = function(M = (t) => t) {
  return this ? this.slice().sort((t, e) => M(e) < M(t) ? -1 : 1) : [];
});
Array.prototype.count || (Array.prototype.count = function(M = (t) => !0) {
  return this.filter(M).length;
});
Array.prototype.insert || (Array.prototype.insert = function(M, t) {
  const e = this.slice();
  return e.splice(t, 0, M), e;
});
Array.prototype.binarySearch || (Array.prototype.binarySearch = function(M, t) {
  var e = 0, p = this.length - 1, c, i;
  for (t = t || function(s, u) {
    return s < u ? -1 : s > u ? 1 : 0;
  }; e <= p; )
    if (c = e + p >>> 1, i = t(this[c], M), i < 0)
      e = c + 1;
    else if (i > 0)
      p = c - 1;
    else
      return c;
  return ~e;
});
Array.prototype.binaryInsert || (Array.prototype.binaryInsert = function(M, t, e) {
  const p = this.slice();
  var c = p.binarySearch(M, e);
  if (c >= 0) {
    if (!t)
      return { index: c, items: p };
  } else
    c = ~c;
  return p.splice(c, 0, M), { index: c, items: p };
});
Array.prototype.distinct || (Array.prototype.distinct = function() {
  return this.filter((M, t, e) => e.indexOf(M) === t);
});
Array.prototype.distinctBy || (Array.prototype.distinctBy = function(M) {
  return this.filter((t, e) => this.findIndex((p) => M(t) === M(p)) === e);
});
Array.prototype.flat || (Array.prototype.flat = function(M = 1 / 0) {
  return this.reduce(function(t, e) {
    return t.concat(Array.isArray(e) && M > 1 ? e.flat(M - 1) : e);
  }, []);
});
Array.prototype.shuffle || (Array.prototype.shuffle = function() {
  let M = this.slice();
  for (let t = M.length - 1; t > 0; t--) {
    const e = Math.floor(Math.random() * (t + 1));
    [M[t], M[e]] = [M[e], M[t]];
  }
  return M;
});
class Yc extends M0 {
  constructor(e) {
    super();
    o(this, "adminId");
    o(this, "expiredDate");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Yc({
      ...e,
      expiredDate: e.expiredDate ? new Date(e.expiredDate) : void 0
    });
  }
  update(e) {
    super.update(e);
  }
  get isAdmin() {
    return !I1.isEmpty(this.adminId);
  }
}
var UM = { exports: {} }, ah = UM.exports, aO;
function sh() {
  return aO || (aO = 1, (function(M, t) {
    var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
      return typeof p;
    } : function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol ? "symbol" : typeof p;
    };
    (function(p, c) {
      e(t) === "object" ? M.exports = c() : p.Humanize = c();
    })(ah, function() {
      var p = [{
        name: "second",
        value: 1e3
      }, {
        name: "minute",
        value: 6e4
      }, {
        name: "hour",
        value: 36e5
      }, {
        name: "day",
        value: 864e5
      }, {
        name: "week",
        value: 6048e5
      }], c = {
        P: Math.pow(2, 50),
        T: Math.pow(2, 40),
        G: Math.pow(2, 30),
        M: Math.pow(2, 20)
      }, i = function(m) {
        return typeof m < "u" && m !== null;
      }, s = function(m) {
        return m !== m;
      }, u = function(m) {
        return isFinite(m) && !s(parseFloat(m));
      }, l = function(m) {
        var X = Object.prototype.toString.call(m);
        return X === "[object Array]";
      }, W = {
        // Converts a large integer to a friendly text representation.
        intword: function(m, X) {
          var D = arguments.length <= 2 || arguments[2] === void 0 ? 2 : arguments[2];
          return W.compactInteger(m, D);
        },
        // Converts an integer into its most compact representation
        compactInteger: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          X = Math.max(X, 0);
          var D = parseInt(m, 10), y = D < 0 ? "-" : "", S = Math.abs(D), B = String(S), Z = B.length, H = [13, 10, 7, 4], e0 = ["T", "B", "M", "k"];
          if (S < 1e3)
            return "" + y + B;
          if (Z > H[0] + 3)
            return D.toExponential(X).replace("e+", "x10^");
          for (var r0 = void 0, G = 0; G < H.length; G++) {
            var j = H[G];
            if (Z >= j) {
              r0 = j;
              break;
            }
          }
          var v = Z - r0 + 1, E = B.split(""), K = E.slice(0, v), p0 = E.slice(v, v + X + 1), O0 = K.join(""), s0 = p0.join("");
          s0.length < X && (s0 += "" + Array(X - s0.length + 1).join("0"));
          var E0 = void 0;
          if (X === 0)
            E0 = "" + y + O0 + e0[H.indexOf(r0)];
          else {
            var l0 = (+(O0 + "." + s0)).toFixed(X);
            E0 = "" + y + l0 + e0[H.indexOf(r0)];
          }
          return E0;
        },
        // Converts an integer to a string containing commas every three digits.
        intComma: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1];
          return W.formatNumber(m, X);
        },
        intcomma: function() {
          return W.intComma.apply(W, arguments);
        },
        // Formats the value like a 'human-readable' file size (i.e. '13 KB', '4.1 MB', '102 bytes', etc).
        fileSize: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 2 : arguments[1];
          for (var D in c)
            if (c.hasOwnProperty(D)) {
              var y = c[D];
              if (m >= y)
                return W.formatNumber(m / y, X, "") + " " + D + "B";
            }
          return m >= 1024 ? W.formatNumber(m / 1024, 0) + " KB" : W.formatNumber(m, 0) + W.pluralize(m, " byte");
        },
        filesize: function() {
          return W.fileSize.apply(W, arguments);
        },
        // Formats a number to a human-readable string.
        // Localize by overriding the precision, thousand and decimal arguments.
        formatNumber: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 0 : arguments[1], D = arguments.length <= 2 || arguments[2] === void 0 ? "," : arguments[2], y = arguments.length <= 3 || arguments[3] === void 0 ? "." : arguments[3], S = function(v, E, K) {
            return K ? v.substr(0, K) + E : "";
          }, B = function(v, E, K) {
            return v.substr(K).replace(/(\d{3})(?=\d)/g, "$1" + E);
          }, Z = function(v, E, K) {
            return K ? E + W.toFixed(Math.abs(v), K).split(".")[1] : "";
          }, H = W.normalizePrecision(X), e0 = m < 0 && "-" || "", r0 = String(parseInt(W.toFixed(Math.abs(m || 0), H), 10)), G = r0.length > 3 ? r0.length % 3 : 0;
          return e0 + S(r0, D, G) + B(r0, D, G) + Z(m, y, H);
        },
        // Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61')
        toFixed: function(m, X) {
          X = i(X) ? X : W.normalizePrecision(X, 0);
          var D = Math.pow(10, X);
          return (Math.round(m * D) / D).toFixed(X);
        },
        // Ensures precision value is a positive integer
        normalizePrecision: function(m, X) {
          return m = Math.round(Math.abs(m)), s(m) ? X : m;
        },
        // Converts an integer to its ordinal as a string.
        ordinal: function(m) {
          var X = parseInt(m, 10);
          if (X === 0)
            return m;
          var D = X % 100;
          if ([11, 12, 13].indexOf(D) >= 0)
            return X + "th";
          var y = X % 10, S = void 0;
          switch (y) {
            case 1:
              S = "st";
              break;
            case 2:
              S = "nd";
              break;
            case 3:
              S = "rd";
              break;
            default:
              S = "th";
          }
          return "" + X + S;
        },
        // Interprets numbers as occurences. Also accepts an optional array/map of overrides.
        times: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
          if (u(m) && m >= 0) {
            var D = parseFloat(m), y = ["never", "once", "twice"];
            if (i(X[D]))
              return String(X[D]);
            var S = i(y[D]) && y[D].toString();
            return S || D.toString() + " times";
          }
          return null;
        },
        // Returns the plural version of a given word if the value is not 1. The default suffix is 's'.
        pluralize: function(m, X, D) {
          return i(m) && i(X) ? (D = i(D) ? D : X + "s", parseInt(m, 10) === 1 ? X : D) : null;
        },
        // Truncates a string if it is longer than the specified number of characters (inclusive).
        // Truncated strings will end with a translatable ellipsis sequence ("…").
        truncate: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1], D = arguments.length <= 2 || arguments[2] === void 0 ? "..." : arguments[2];
          return m.length > X ? m.substring(0, X - D.length) + D : m;
        },
        // Truncates a string after a certain number of words.
        truncateWords: function(m, X) {
          for (var D = m.split(" "), y = "", S = 0; S < X; )
            i(D[S]) && (y += D[S] + " "), S++;
          return D.length > X ? y + "..." : null;
        },
        truncatewords: function() {
          return W.truncateWords.apply(W, arguments);
        },
        // Truncates a number to an upper bound.
        boundedNumber: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? 100 : arguments[1], D = arguments.length <= 2 || arguments[2] === void 0 ? "+" : arguments[2], y = void 0;
          return u(m) && u(X) && m > X && (y = X + D), (y || m).toString();
        },
        truncatenumber: function() {
          return W.boundedNumber.apply(W, arguments);
        },
        // Converts a list of items to a human readable string with an optional limit.
        oxford: function(m, X, D) {
          var y = m.length, S = void 0;
          if (y < 2)
            return String(m);
          if (y === 2)
            return m.join(" and ");
          if (i(X) && y > X) {
            var B = y - X;
            S = X, D = i(D) ? D : ", and " + B + " " + W.pluralize(B, "other");
          } else
            S = -1, D = ", and " + m[y - 1];
          return m.slice(0, S).join(", ") + D;
        },
        // Converts an object to a definition-like string
        dictionary: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? " is " : arguments[1], D = arguments.length <= 2 || arguments[2] === void 0 ? ", " : arguments[2], y = "";
          if (i(m) && (typeof m > "u" ? "undefined" : e(m)) === "object" && !l(m)) {
            var S = [];
            for (var B in m)
              if (m.hasOwnProperty(B)) {
                var Z = m[B];
                S.push("" + B + X + Z);
              }
            return S.join(D);
          }
          return y;
        },
        // Describes how many times an item appears in a list
        frequency: function(m, X) {
          if (!l(m))
            return null;
          var D = m.length, y = W.times(D);
          return D === 0 ? y + " " + X : X + " " + y;
        },
        pace: function(m, X) {
          var D = arguments.length <= 2 || arguments[2] === void 0 ? "time" : arguments[2];
          if (m === 0 || X === 0)
            return "No " + W.pluralize(0, D);
          for (var y = "Approximately", S = void 0, B = void 0, Z = m / X, H = 0; H < p.length; ++H) {
            var e0 = p[H];
            if (B = Z * e0.value, B > 1) {
              S = e0.name;
              break;
            }
          }
          S || (y = "Less than", B = 1, S = p[p.length - 1].name);
          var r0 = Math.round(B);
          return D = W.pluralize(r0, D), y + " " + r0 + " " + D + " per " + S;
        },
        // Converts newlines to <br/> tags
        nl2br: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? "<br/>" : arguments[1];
          return m.replace(/\n/g, X);
        },
        // Converts <br/> tags to newlines
        br2nl: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? `\r
` : arguments[1];
          return m.replace(/\<br\s*\/?\>/g, X);
        },
        // Capitalizes first letter in a string
        capitalize: function(m) {
          var X = arguments.length <= 1 || arguments[1] === void 0 ? !1 : arguments[1];
          return "" + m.charAt(0).toUpperCase() + (X ? m.slice(1).toLowerCase() : m.slice(1));
        },
        // Capitalizes the first letter of each word in a string
        capitalizeAll: function(m) {
          return m.replace(/(?:^|\s)\S/g, function(X) {
            return X.toUpperCase();
          });
        },
        // Titlecase words in a string.
        titleCase: function(m) {
          var X = /\b(a|an|and|at|but|by|de|en|for|if|in|of|on|or|the|to|via|vs?\.?)\b/i, D = /\S+[A-Z]+\S*/, y = /\s+/, S = /-/, B = void 0;
          return B = function(H) {
            for (var e0 = arguments.length <= 1 || arguments[1] === void 0 ? !1 : arguments[1], r0 = arguments.length <= 2 || arguments[2] === void 0 ? !0 : arguments[2], G = [], j = H.split(e0 ? S : y), v = 0; v < j.length; ++v) {
              var E = j[v];
              if (E.indexOf("-") !== -1) {
                G.push(B(E, !0, v === 0 || v === j.length - 1));
                continue;
              }
              if (r0 && (v === 0 || v === j.length - 1)) {
                G.push(D.test(E) ? E : W.capitalize(E));
                continue;
              }
              D.test(E) ? G.push(E) : X.test(E) ? G.push(E.toLowerCase()) : G.push(W.capitalize(E));
            }
            return G.join(e0 ? "-" : " ");
          }, B(m);
        },
        titlecase: function() {
          return W.titleCase.apply(W, arguments);
        }
      };
      return W;
    });
  })(UM, UM.exports)), UM.exports;
}
var Ah = sh();
const dh = /* @__PURE__ */ Hc(Ah);
class Gc extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "text");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Gc({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0
    });
  }
}
class Pp extends M0 {
  constructor(e) {
    super();
    o(this, "status", "default");
    o(this, "progress", 0);
    o(this, "scheduledDate");
    o(this, "settings");
    o(this, "error");
    e && this.update(e);
  }
  get isScheduled() {
    return this.status == "default" || this.status == "pending";
  }
  get isActive() {
    return this.status == "inProgress";
  }
  get isCompleted() {
    return this.status == "completed" || this.status == "aborted" || this.status == "error";
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      school: void 0,
      scheduledDate: (e = this.scheduledDate) == null ? void 0 : e.toISOString(),
      settingsJson: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  static fromJson(e) {
    return new Pp({
      ...e,
      scheduledDate: e.scheduledDate ? R(e.scheduledDate) : void 0,
      settings: e.settingsJson ? JSON.parse(e.settingsJson) : void 0
    });
  }
}
var uh = /* @__PURE__ */ ((M) => (M.Default = "default", M.Pending = "pending", M.InProgress = "inProgress", M.Completed = "completed", M.Aborted = "aborted", M.Error = "error", M))(uh || {});
class $c extends M0 {
  constructor(e) {
    super();
    o(this, "isActive");
    o(this, "agreementRequired");
    o(this, "agreementText");
    o(this, "agreementUrl");
    o(this, "partnerAssigningCookieDurationDays");
    o(this, "partnerAssigningDurationType");
    o(this, "partnerAssigningDurationDays");
    o(this, "transferBonusPartner");
    o(this, "transferBonusPartnerAmount");
    o(this, "transferBonusReferral");
    o(this, "transferBonusReferralAmount");
    o(this, "transferFeeMethod");
    o(this, "transferFeeAllowed");
    o(this, "transferFeeAllowedToBonus");
    o(this, "transferFeeMinAmount");
    o(this, "transferFeeHoldingPeriodDays");
    o(this, "partnershipVisible");
    o(this, "partnershipPaidOrdersVisible");
    o(this, "partnershipAllOrdersVisible");
    o(this, "partnershipOrdersContactVisible");
    o(this, "paymentGatewayFeeEnabled");
    o(this, "levelCount");
    c0(this, {
      isActive: r,
      agreementRequired: r,
      agreementText: r,
      agreementUrl: r,
      partnerAssigningCookieDurationDays: r,
      partnerAssigningDurationType: r,
      partnerAssigningDurationDays: r,
      transferBonusPartner: r,
      transferBonusPartnerAmount: r,
      transferBonusReferral: r,
      transferBonusReferralAmount: r,
      transferFeeMethod: r,
      transferFeeAllowed: r,
      transferFeeAllowedToBonus: r,
      transferFeeMinAmount: r,
      transferFeeHoldingPeriodDays: r,
      partnershipVisible: r,
      partnershipPaidOrdersVisible: r,
      partnershipAllOrdersVisible: r,
      partnershipOrdersContactVisible: r,
      paymentGatewayFeeEnabled: r,
      levelCount: r,
      isSingleLevel: Y
    }), e && this.update(e);
  }
  get isSingleLevel() {
    return this.levelCount === 1;
  }
  static fromJson(e) {
    return new $c({
      ...e
    });
  }
}
class Vc extends M0 {
  constructor(e) {
    super();
    o(this, "enabled", !1);
    o(this, "createdDate");
    o(this, "updatedDate");
    // #region Settings
    /**
     * Whether a student is asked to join in a popup; off = the student joins on the first visit, without the popup
     * @default true
     */
    o(this, "popupEnabled", !0);
    /**
     * Welcome popup text supports markdown and links
     * @default "Community affords you to make posts, view, comment and communicate with participants"
     */
    o(this, "popupText", "");
    /**
     * Welcome popup join button text
     * @default "Join"
     */
    o(this, "popupJoinText", "");
    /**
     * Posts sort type
     * @default "createdDate"
     */
    o(this, "sortType", "createdDate");
    /**
     * Whether or not to show popular posts widget
     * @default true
     */
    o(this, "popularPostsWidgetEnabled", !0);
    o(this, "popularPostsWidgetSortType", "likesCount");
    /**
     * Whether or not to show calendar widget
     * @default true
     */
    o(this, "calendarWidgetEnabled", !0);
    /**
     * Whether or not to show leaderboard widget
     * @default true
     */
    o(this, "leaderboardWidgetEnabled", !0);
    c0(this, {
      enabled: r,
      createdDate: r,
      updatedDate: r,
      popupEnabled: r,
      popupText: r,
      popupJoinText: r,
      sortType: r,
      popularPostsWidgetEnabled: r,
      popularPostsWidgetSortType: r,
      calendarWidgetEnabled: r,
      leaderboardWidgetEnabled: r,
      update: I
    }), e && this.update(e);
  }
  // #endregion
  toJson() {
    return {
      ...this
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    return this.popupText != e.popupText || this.popupJoinText != e.popupJoinText || this.sortType !== e.sortType || this.popularPostsWidgetSortType !== e.popularPostsWidgetSortType || this.popularPostsWidgetEnabled !== e.popularPostsWidgetEnabled || this.calendarWidgetEnabled !== e.calendarWidgetEnabled || this.leaderboardWidgetEnabled !== e.leaderboardWidgetEnabled;
  }
  static fromJson(e) {
    return new Vc({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      popupText: e.popupText ?? "",
      popupJoinText: e.popupJoinText ?? ""
    });
  }
}
class g1 extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "cloudKey");
    o(this, "size");
    o(this, "mimetype");
    o(this, "type");
    o(this, "extension");
    o(this, "createdDate");
    o(this, "nativeFile");
    o(this, "previewImage");
    o(this, "previewAudio");
    /**
    * external file source
    */
    o(this, "url");
    e && this.update(e);
  }
  get isExternalFile() {
    return !I1.isEmpty(this.url);
  }
  get isImage() {
    return [".bmp", ".dib", ".rle", ".jpg", ".jpeg", ".jpe", ".jfif", ".gif", ".tif", ".tiff", ".png", ".svg", ".pjpeg", ".webp", ".ico"].includes(this.extension);
  }
  get isAudio() {
    return [".mp3", ".ogg", ".webm", ".m4a"].includes(this.extension);
  }
  get filename() {
    return this.name + this.extension;
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(e) {
    return new g1({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0
    });
  }
  static fromFile(e, p) {
    const c = e.name.lastIndexOf("."), i = new g1({
      nativeFile: e,
      size: e.size,
      mimetype: e.type,
      name: e.name.substring(0, c),
      extension: e.name.substring(c),
      createdDate: R(),
      ...p
    });
    return i.isImage && i.nativeFile && (i.previewImage = URL.createObjectURL(i.nativeFile)), i.isAudio && i.nativeFile && i.nativeFile.type.includes("audio") && (i.previewAudio = URL.createObjectURL(i.nativeFile)), i;
  }
}
const qh = [
  "courses",
  "course",
  "libraries",
  "library",
  "step",
  "steps",
  "community",
  "achievements",
  "points",
  "access",
  "feed",
  "newPost",
  "topPosts"
], sO = ["popular", "events", "leaderboard"], lh = "Inter", d1 = (M) => M != null && typeof M == "object" && !Array.isArray(M) ? M : {}, Y0 = (M, t, e) => t.includes(M) ? M : e, o1 = (M, t) => typeof M == "boolean" ? M : t, F1 = (M) => typeof M == "string" && M.trim() !== "" ? M.trim() : null, $2 = (M) => {
  const t = F1(M);
  return t && /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(t) ? t : null;
}, rt = (M, t, e, p) => typeof M == "number" && Number.isFinite(M) ? Math.min(p, Math.max(e, M)) : t, AO = (M) => {
  const t = F1(M);
  return t && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(t) ? t : null;
}, k2 = (M, t) => {
  if (typeof M != "string") return null;
  const e = M.replace(/[\u0000-\u001f\u007f]+/g, " ").replace(/\s+/g, " ").trim();
  return e ? e.slice(0, t).trim() : null;
}, Aa = /^[^\s@<>()"']+@[^\s@<>()"']+\.[^\s@<>()"']+$/, Ep = (M) => {
  let t = F1(M);
  if (t && /^tel:/i.test(t) && (t = t.replace(/\s+/g, "")), !t || t.length > 2e3 || /\s/.test(t)) return null;
  if (/^https?:\/\//i.test(t))
    try {
      const e = new URL(t);
      return e.protocol === "http:" || e.protocol === "https:" ? e.href : null;
    } catch {
      return null;
    }
  return /^mailto:/i.test(t) ? Aa.test(fh(t.slice(7).split("?")[0] ?? "")) ? t : null : /^tel:/i.test(t) && /^tel:\+?[0-9()\-.]{3,32}$/i.test(t) ? t : null;
}, fh = (M) => {
  try {
    return decodeURIComponent(M);
  } catch {
    return M;
  }
}, Kc = (M, t) => Array.isArray(M) ? M.slice(0, t) : [], da = (M, t) => Kc(M, t * 3).map((e) => {
  const p = d1(e), c = k2(p.label, 60), i = Ep(p.url);
  return c && i ? { label: c, url: i } : null;
}).filter((e) => !!e).slice(0, t), Wh = ["learning", "community", "achievements", "access", "partnership"], hh = ["link", "globe", "telegram", "youtube", "book", "chat", "star", "gift"], mh = ["courses", "libraries", "events"], Rh = ["telegram", "vk", "youtube", "instagram", "whatsapp", "website", "email"];
function Lh(M) {
  if (!Array.isArray(M)) return null;
  const t = /* @__PURE__ */ new Set(), e = [];
  for (const p of M.slice(0, 24)) {
    if (e.length >= 12) break;
    const c = d1(p), i = o1(c.hidden, !1);
    if (c.key === "custom") {
      const s = k2(c.label, 40), u = Ep(c.url);
      if (!s || !u) continue;
      e.push({ key: "custom", hidden: i, label: s, url: u, icon: Y0(c.icon, hh, "link") });
    } else Wh.includes(c.key) && !t.has(c.key) && (t.add(c.key), e.push({ key: c.key, hidden: i, label: k2(c.label, 40) }));
  }
  return e.length ? e : null;
}
function gh(M) {
  const t = Array.isArray(M) ? M.filter((e) => sO.includes(e)) : [];
  return Array.from(/* @__PURE__ */ new Set([...t, ...sO]));
}
function yh(M) {
  if (!Array.isArray(M)) return null;
  const t = Array.from(new Set(M.filter((e) => mh.includes(e))));
  if (!t.length) return null;
  for (const e of ["courses", "libraries"]) t.includes(e) || t.push(e);
  return t;
}
function Nh(M) {
  const t = d1(M), e = {};
  for (const p of qh) {
    const c = k2(t[p], 40);
    c && (e[p] = c);
  }
  return e;
}
function Bh(M) {
  return Kc(M, 16).map((t) => {
    const e = d1(t);
    if (!Rh.includes(e.type)) return null;
    const p = F1(e.url), c = Ep(e.type === "email" && p && Aa.test(p) ? `mailto:${p}` : p);
    return c ? { type: e.type, url: c } : null;
  }).filter((t) => !!t).slice(0, 8);
}
function vh(M) {
  return Kc(M, 4).map((t) => {
    const e = d1(t), p = k2(e.title, 60) ?? "", c = da(e.links, 8);
    return p || c.length ? { title: p, links: c } : null;
  }).filter((t) => !!t);
}
function Th(M) {
  let t = M;
  if (typeof M == "string")
    try {
      t = M.trim() ? JSON.parse(M) : {};
    } catch {
      t = {};
    }
  const e = d1(t), p = d1(e.theme), c = d1(e.typography), i = d1(e.shape), s = d1(e.header), u = d1(e.background), l = d1(e.auth), W = d1(l.background), L = d1(e.home), m = d1(e.coursePage), X = d1(e.lesson), D = d1(X.background), y = d1(L.announcement), S = k2(y.text, 300), B = d1(e.brand), Z = d1(e.nav), H = d1(e.cards), e0 = d1(e.accessibility), r0 = d1(e.footer), G = d1(e.community), j = F1(c.font) ?? lh;
  return {
    theme: {
      // light unless the school picked otherwise (2026-10-26); 'system' follows the device
      default: Y0(p.default, ["system", "light", "dark"], "light"),
      allowSwitch: o1(p.allowSwitch, !0)
    },
    typography: {
      font: j,
      headingFont: F1(c.headingFont) ?? j,
      scale: Y0(c.scale, ["compact", "default", "large"], "default")
    },
    shape: { radius: Y0(i.radius, ["sharp", "default", "rounded"], "default") },
    header: {
      style: Y0(s.style, ["surface", "accent", "custom"], "surface"),
      color: $2(s.color),
      nav: Y0(s.nav, ["top", "side"], "top")
    },
    background: {
      ambient: o1(u.ambient, !0),
      type: Y0(u.type, ["default", "color", "gradient", "image"], "default"),
      color: $2(u.color),
      gradientFrom: $2(u.gradientFrom),
      gradientTo: $2(u.gradientTo),
      gradientAngle: rt(u.gradientAngle, 135, 0, 360),
      imageFileId: F1(u.imageFileId),
      imageCloudKey: F1(u.imageCloudKey),
      overlay: rt(u.overlay, 0, 0, 90)
    },
    auth: {
      layout: Y0(l.layout, ["center", "left", "right"], "center"),
      background: {
        type: Y0(W.type, ["animated", "color", "gradient", "image"], "animated"),
        color: $2(W.color),
        gradientFrom: $2(W.gradientFrom),
        gradientTo: $2(W.gradientTo),
        gradientAngle: rt(W.gradientAngle, 135, 0, 360),
        imageFileId: F1(W.imageFileId),
        imageCloudKey: F1(W.imageCloudKey),
        overlay: rt(W.overlay, 0, 0, 80)
      },
      title: F1(l.title),
      subtitle: F1(l.subtitle),
      surfaceOpacity: rt(l.surfaceOpacity, 100, 40, 100),
      sideImageFileId: F1(l.sideImageFileId),
      sideImageCloudKey: F1(l.sideImageCloudKey),
      links: da(l.links, 4),
      submitLabel: k2(l.submitLabel, 30),
      showSchoolName: o1(l.showSchoolName, !0)
    },
    home: {
      welcome: o1(L.welcome, !0),
      stats: o1(L.stats, !0),
      cardColumns: Y0(L.cardColumns, ["auto", 2, 3, 4], "auto"),
      cardStyle: Y0(L.cardStyle, ["cover", "compact"], "cover"),
      greeting: k2(L.greeting, 80),
      greetingHint: k2(L.greetingHint, 140),
      announcement: o1(y.enabled, !1) && S ? {
        text: S,
        linkLabel: k2(y.linkLabel, 40),
        url: Ep(y.url),
        tone: Y0(y.tone, ["info", "accent", "success", "warning"], "info"),
        dismissible: o1(y.dismissible, !1)
      } : null,
      blocks: yh(L.blocks)
    },
    coursePage: {
      showDescription: o1(m.showDescription, !0),
      showCover: o1(m.showCover, !0),
      hero: Y0(m.hero, ["split", "banner", "compact"], "split"),
      structureView: Y0(m.structureView, ["tree", "cards"], "tree"),
      cardColumns: Y0(m.cardColumns, ["auto", 2, 3, 4], "auto"),
      modules: Y0(m.modules, ["current", "expanded", "collapsed"], "current"),
      showProgress: o1(m.showProgress, !0),
      showStepNumbers: o1(m.showStepNumbers, !0),
      showStepParts: o1(m.showStepParts, !1),
      showRating: o1(m.showRating, !0),
      showDuration: o1(m.showDuration, !1)
    },
    lesson: {
      layout: Y0(X.layout, ["tabs", "feed"], "tabs"),
      sidebar: Y0(X.sidebar, ["open", "collapsed"], "open"),
      // wide by default (owner, 2026-10-27): old v1 lessons were laid out for a wide column; `normal` only when stored
      width: Y0(X.width, ["normal", "wide"], "wide"),
      autoNext: o1(X.autoNext, !1),
      contentScale: Y0(X.contentScale, ["small", "default", "large"], "default"),
      commentsOpen: o1(X.commentsOpen, !1),
      background: {
        type: Y0(D.type, ["inherit", "default", "color", "gradient", "image"], "inherit"),
        color: $2(D.color),
        gradientFrom: $2(D.gradientFrom),
        gradientTo: $2(D.gradientTo),
        gradientAngle: rt(D.gradientAngle, 135, 0, 360),
        imageFileId: F1(D.imageFileId),
        imageCloudKey: F1(D.imageCloudKey),
        overlay: rt(D.overlay, 0, 0, 90)
      }
    },
    brand: {
      darkPrimaryColor: AO(B.darkPrimaryColor),
      buttonColor: AO(B.buttonColor),
      buttonStyle: Y0(B.buttonStyle, ["filled", "outline", "pill"], "filled")
    },
    nav: {
      items: Lh(Z.items),
      landing: Y0(Z.landing, ["home", "lastCourse", "community"], "home")
    },
    cards: {
      showProgress: o1(H.showProgress, !0),
      showDescription: o1(H.showDescription, !0),
      showBadges: o1(H.showBadges, !0),
      coverRatio: Y0(H.coverRatio, ["16:9", "4:3", "1:1"], "16:9")
    },
    texts: Nh(e.texts),
    accessibility: {
      highContrast: o1(e0.highContrast, !1),
      reduceMotion: o1(e0.reduceMotion, !1)
    },
    footer: {
      mode: Y0(r0.mode, ["html", "structured"], "html"),
      columns: vh(r0.columns),
      socials: Bh(r0.socials),
      legal: k2(r0.legal, 300)
    },
    community: {
      spaces: Y0(G.spaces, ["left", "top"], "left"),
      widgets: Y0(G.widgets, ["right", "left", "hidden"], "right"),
      widgetOrder: gh(G.widgetOrder),
      feedWidth: Y0(G.feedWidth, ["narrow", "default", "wide"], "default"),
      postStyle: Y0(G.postStyle, ["card", "compact"], "card"),
      previewLines: Y0(G.previewLines, [2, 4, 8], 4),
      showMedia: o1(G.showMedia, !0),
      showViews: o1(G.showViews, !0),
      showBadges: o1(G.showBadges, !0),
      composer: Y0(G.composer, ["button", "inline"], "button"),
      sortSwitch: o1(G.sortSwitch, !0)
    }
  };
}
class jM extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "number");
    o(this, "domain");
    o(this, "customDomain");
    o(this, "disableOpenRegistration");
    o(this, "isForumAvailable");
    o(this, "settings");
    o(this, "profileSettings");
    o(this, "timezone");
    // owner: Admin;
    o(this, "logo");
    o(this, "favicon");
    /** Logo for the dark theme; the regular `logo` is shown when absent. */
    o(this, "darkLogo");
    /** The school's accent colour (`#rrggbb`), null = the platform default. */
    o(this, "primaryColor");
    /** Extended portal look (theme, fonts, header, sign-in page, home, lesson…) as JSON; null = all defaults. */
    o(this, "designJson");
    o(this, "_designSource");
    o(this, "_design");
    o(this, "showUnavailableStartedCourses");
    o(this, "isExternal");
    /**
     * @deprecated use owner instead
     */
    o(this, "ownerId");
    o(this, "jsHeadCode");
    o(this, "jsBodyCode");
    o(this, "supportChatEnabled");
    o(this, "supportConversationTitle");
    o(this, "recordInternalCalls");
    o(this, "recordCRMCalls");
    o(this, "lang");
    o(this, "createdDate");
    // mainSiteDomain: SiteDomain | null;
    o(this, "phoneBalance");
    o(this, "isLocked");
    o(this, "currency");
    // billing: SchoolBilling;
    // metadata: SchoolMetadata;
    // country: Country;
    // appIntegrations: ApplicationType[];
    // chatChannelIntegrations: ChatChannelIntegration[];
    o(this, "allowCustomProductGatewaySettings");
    o(this, "allowCustomProductPaymentMethodsSettings");
    // organization: Organization;
    o(this, "partnership");
    o(this, "community");
    o(this, "gamification");
    o(this, "migration", null);
    e && this.update(e);
  }
  /** `designJson` parsed with every default filled in (cached per JSON string). */
  get design() {
    return (!this._design || this._designSource !== this.designJson) && (this._designSource = this.designJson, this._design = Th(this.designJson)), this._design;
  }
  get hasMigrationLock() {
    var e, p;
    return ((e = this.migration) == null ? void 0 : e.isActive) || ((p = this.migration) == null ? void 0 : p.isCompleted);
  }
  // get canUseBillingAddress() {
  //     return this.billing.currency == Currency.USD;
  // }
  // get hasTgAppIntegration() {
  //     return this.appIntegrations.includes(ApplicationType.Telegram);
  // }
  // get hasChatChannelIntegrations() {
  //     return this.chatChannelIntegrations.length > 0;
  // }
  update(e) {
    super.update(e);
  }
  // clone(): School {
  //     return new School({
  //         ...this,
  //         settings: this.settings?.copy(),
  //         profileSettings: this.profileSettings.copy(),
  //         timezone: this.timezone.clone(),
  //         owner: this.owner?.clone(),
  //         logo: this.logo?.clone(),
  //         favicon: this.favicon?.clone(),
  //         createdDate: this.createdDate ? new Date(this.createdDate) : undefined,
  //         mainSiteDomain: this.mainSiteDomain?.clone(),
  //         billing: this.billing?.clone(),
  //         metadata: this.metadata?.clone(),
  //         chatChannelIntegrations: this.chatChannelIntegrations.map((c) => c.clone()),
  //         partnership: this.partnership?.clone(),
  //         organization: this.organization?.clone()
  //     });
  // }
  static fromJson(e) {
    return new jM({
      ...e,
      timezone: e.timezone ? dt.fromJson(e.timezone) : dt.utc(),
      // settings: json.settings ? SchoolSettings.fromJson(json.settings) : new SchoolSettings(),
      // profileSettings: SchoolProfileSettings.fromJson(json.studentProfileSettings),
      logo: e.logo ? g1.fromJson(e.logo) : null,
      favicon: e.favicon ? g1.fromJson(e.favicon) : null,
      darkLogo: e.darkLogo ? g1.fromJson(e.darkLogo) : null,
      primaryColor: e.primaryColor ?? null,
      designJson: e.designJson ?? null,
      // createdDate: json.createdDate ? new Date(json.createdDate) : undefined,
      // mainSiteDomain: json.mainSiteDomain ? SiteDomain.fromJson(json.mainSiteDomain) : null,
      // billing: json.billing ? SchoolBilling.fromJson(json.billing) : undefined,
      // metadata: json.metadata ? SchoolMetadata.fromJson(json.metadata) : undefined,
      // country: json.country,
      // owner: json.owner ? Admin.fromJson(json.owner) : undefined,
      // appIntegrations: json.appIntegrations ?? [],
      // chatChannelIntegrations: json.chatChannelIntegrations
      //     ? json.chatChannelIntegrations.map(ChatChannelIntegration.fromJson)
      //     : [],
      allowCustomProductGatewaySettings: e.allowCustomProductGatewaySettings ?? !1,
      allowCustomProductPaymentMethodsSettings: e.allowCustomProductPaymentMethodsSettings ?? !1,
      partnership: e.partnership ? $c.fromJson(e.partnership) : null,
      community: e.community ? Vc.fromJson(e.community) : null,
      gamification: e.gamification ? Yp.fromJson(e.gamification) : null,
      // organization: json.organization ? Organization.fromJson(json.organization) : undefined,
      migration: e.migration ? Pp.fromJson(e.migration) : void 0
    });
  }
}
var _h = /* @__PURE__ */ ((M) => (M.Simple = "simple", M.Api = "api", M))(_h || {}), wh = /* @__PURE__ */ ((M) => (M.NotPartner = "notPartner", M.Silver = "silver", M.Gold = "gold", M.Platinum = "platinum", M))(wh || {});
class ut extends M0 {
  constructor(e) {
    super();
    o(this, "firstName");
    o(this, "lastName");
    o(this, "middleName");
    o(this, "phone");
    o(this, "email");
    o(this, "avatar");
    o(this, "gender");
    o(this, "birthday");
    o(this, "lang");
    o(this, "post");
    o(this, "isEmailConfirmed");
    o(this, "emailConfirmationSentDate");
    o(this, "isPhoneConfirmed");
    o(this, "needChangePassword");
    /**
     * current selected school
     */
    o(this, "school");
    /**
     * schools you own
     */
    o(this, "schools");
    o(this, "partner");
    /**
     * Source type
     *  - api key
     *  - simple admin
     */
    o(this, "type");
    o(this, "partnerStatus");
    o(this, "createdDate");
    c0(this, {
      firstName: r,
      lastName: r,
      middleName: r,
      phone: r,
      email: r,
      avatar: r,
      gender: r,
      birthday: r,
      lang: r,
      post: r,
      isEmailConfirmed: r,
      emailConfirmationSentDate: r,
      isPhoneConfirmed: r,
      needChangePassword: r,
      school: r,
      schools: r,
      partner: r,
      type: r,
      partnerStatus: r,
      createdDate: r,
      isFirstNameEmpty: Y,
      isLastNameEmpty: Y,
      hasName: Y,
      fullName: Y,
      fullNameNoEmail: Y,
      update: I
    }), e && this.update(e);
  }
  get isFirstNameEmpty() {
    return u1(this.firstName);
  }
  get isLastNameEmpty() {
    return u1(this.lastName);
  }
  get hasName() {
    return !this.isFirstNameEmpty || !this.isLastNameEmpty;
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  get fullNameNoEmail() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? "" : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  clone() {
    var e, p, c;
    return new ut({
      ...this,
      school: (e = this.school) == null ? void 0 : e.clone(),
      schools: this.schools.map((i) => i.clone()),
      partner: (p = this.partner) == null ? void 0 : p.clone(),
      avatar: (c = this.avatar) == null ? void 0 : c.clone(),
      birthday: this.birthday ? new Date(this.birthday) : void 0,
      createdDate: this.createdDate ? R(this.createdDate) : void 0,
      emailConfirmationSentDate: this.emailConfirmationSentDate ? new Date(this.emailConfirmationSentDate) : null
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new ut({
      ...e,
      school: e.school ? jM.fromJson(e.school) : null,
      schools: e.schools ? e.schools.map(jM.fromJson) : [],
      partner: e.partner ? ut.fromJson(e.partner) : null,
      avatar: e.avatar ? D1.fromJson(e.avatar) : void 0,
      birthday: e.birthday ? new Date(e.birthday) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      emailConfirmationSentDate: e.emailConfirmationSentDate ? new Date(e.emailConfirmationSentDate) : null
    });
  }
}
class be extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "primaryImage");
    o(this, "dontAskFeedback");
    o(this, "totalItemCount");
    o(this, "freeAccess");
    o(this, "studentCanBuyAccess");
    o(this, "paymentUrl");
    o(this, "appearanceSettingsJson");
    e && this.update(e);
  }
  get appearanceSettings() {
    return I1.isEmpty(this.appearanceSettingsJson) ? null : JSON.parse(this.appearanceSettingsJson);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var p;
    return new be({
      ...e,
      primaryImage: (p = e.primaryImage) != null && p.file ? g1.fromJson(e.primaryImage.file) : null
    });
  }
}
class OM extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "course");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new OM({
      ...e,
      course: e.course ? be.fromJson(e.course) : void 0
    });
  }
}
class Xh extends I0 {
  constructor(e) {
    super();
    o(this, "courseId");
    o(this, "courseIds");
    o(this, "productPackageId");
    o(this, "isPopular");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var dp = /* @__PURE__ */ ((M) => (M.RegardlessOfPreviousSteps = "regardlessOfPreviousSteps", M.PreviousStepCompleted = "previousStepCompleted", M.AllPreviousStepsCompleted = "allPreviousStepsCompleted", M))(dp || {}), Ue = /* @__PURE__ */ ((M) => (M.PreviousStep = "previousStep", M.CourseStart = "courseStart", M.AccessStart = "accessStart", M.PreviousSectionStarted = "previousSectionStarted", M.PreviousSectionCompleted = "previousSectionCompleted", M))(Ue || {}), Je = /* @__PURE__ */ ((M) => (M.PreviousStep = "previousStep", M.FlowStart = "flowStart", M.CourseStart = "courseStart", M.PreviousSectionStarted = "previousSectionStarted", M.PreviousSectionCompleted = "previousSectionCompleted", M))(Je || {}), L1 = /* @__PURE__ */ ((M) => (M.Step = "step", M.Section = "section", M))(L1 || {}), Sh = /* @__PURE__ */ ((M) => (M.Legacy = "legacy", M.Custom = "custom", M))(Sh || {});
class me extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "position");
    o(this, "isDraft");
    o(this, "isOptional");
    o(this, "type");
    o(this, "comment");
    // restrictions and availability
    o(this, "allowComments");
    o(this, "showComments");
    o(this, "disableCommentModeration");
    o(this, "ratingEnabled");
    o(this, "ratingRequired");
    o(this, "ratingCommentRequired");
    o(this, "availableOnAllPlans");
    o(this, "showRegardlessPlan");
    o(this, "availability");
    o(this, "regularTimeDelayActive");
    o(this, "regularTimeDelay");
    o(this, "regularTimeDelayCondition");
    o(this, "regularTimeDelayMeasureType");
    o(this, "regularWaitUntilTimeDaysOfWeekActive");
    o(this, "regularWaitUntilDaysOfWeek");
    o(this, "regularWaitUntilTimeActive");
    o(this, "regularWaitUntilTime", null);
    o(this, "flowTimeDelayActive");
    o(this, "flowTimeDelay");
    o(this, "flowTimeDelayCondition");
    o(this, "flowTimeDelayMeasureType");
    o(this, "flowWaitUntilTimeDaysOfWeekActive");
    o(this, "flowWaitUntilDaysOfWeek");
    o(this, "flowWaitUntilTimeActive");
    o(this, "flowWaitUntilTime");
    o(this, "dateDelayActive");
    o(this, "dateDelay", null);
    o(this, "preventCopingAndSelectingText");
    o(this, "blockCourseUntilTasksApproved");
    o(this, "theoryVisible");
    o(this, "tasksVisible");
    o(this, "testsVisible");
    o(this, "score");
    o(this, "plans", []);
    o(this, "files", []);
    o(this, "parent");
    o(this, "parentItemId", null);
    o(this, "children", []);
    o(this, "course");
    o(this, "createdDate");
    o(this, "updatedDate");
    //#region Design
    o(this, "designSettings");
    o(this, "designSettingsPublished");
    o(this, "designHTMLPublished");
    o(this, "designStylePublished");
    o(this, "designConcurrencyStamp");
    c0(this, {
      title: r,
      position: r,
      isDraft: r,
      isOptional: r,
      type: r,
      comment: r,
      allowComments: r,
      showComments: r,
      disableCommentModeration: r,
      ratingEnabled: r,
      ratingRequired: r,
      ratingCommentRequired: r,
      availableOnAllPlans: r,
      showRegardlessPlan: r,
      availability: r,
      regularTimeDelayActive: r,
      regularTimeDelay: r,
      regularTimeDelayCondition: r,
      regularTimeDelayMeasureType: r,
      regularWaitUntilTimeDaysOfWeekActive: r,
      regularWaitUntilDaysOfWeek: r,
      regularWaitUntilTimeActive: r,
      regularWaitUntilTime: r,
      flowTimeDelayActive: r,
      flowTimeDelay: r,
      flowTimeDelayCondition: r,
      flowTimeDelayMeasureType: r,
      flowWaitUntilTimeDaysOfWeekActive: r,
      flowWaitUntilDaysOfWeek: r,
      flowWaitUntilTimeActive: r,
      flowWaitUntilTime: r,
      dateDelayActive: r,
      dateDelay: r,
      preventCopingAndSelectingText: r,
      blockCourseUntilTasksApproved: r,
      theoryVisible: r,
      tasksVisible: r,
      testsVisible: r,
      score: r,
      plans: r,
      files: r,
      parent: r,
      parentItemId: r,
      children: r,
      course: r,
      createdDate: r,
      updatedDate: r,
      designSettings: r,
      designSettingsPublished: r,
      designHTMLPublished: r,
      designStylePublished: r,
      designConcurrencyStamp: r,
      update: I
    }), e && this.update(e);
  }
  //#endregion
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new me({
      ...e,
      regularTimeDelay: e.regularTimeDelay ? e.regularTimeDelay : 1,
      regularTimeDelayCondition: e.regularTimeDelayCondition ? e.regularTimeDelayCondition : "previousStep",
      regularTimeDelayMeasureType: e.regularTimeDelayMeasureType ? e.regularTimeDelayMeasureType : "days",
      flowTimeDelay: e.flowTimeDelay ? e.flowTimeDelay : 1,
      flowTimeDelayCondition: e.flowTimeDelayCondition ? e.flowTimeDelayCondition : "previousStep",
      flowTimeDelayMeasureType: e.flowTimeDelayMeasureType ? e.flowTimeDelayMeasureType : "days",
      // TODO simplify model?
      plans: e.plans ? e.plans.map((p) => OM.fromJson(p.coursePlan)) : void 0,
      parent: e.parentItem ? me.fromJson(e.parentItem) : void 0,
      children: e.children ? e.children.map(me.fromJson) : void 0,
      course: e.course ? be.fromJson(e.course) : void 0,
      // TODO simplify model?
      files: e.fileLinks ? e.fileLinks.map((p) => g1.fromJson(p.file)) : [],
      dateDelay: e.dateDelay ? R(e.dateDelay) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      regularWaitUntilTime: e.regularWaitUntilTime ? R(e.regularWaitUntilTime) : void 0,
      flowWaitUntilTime: e.flowWaitUntilTime ? R(e.flowWaitUntilTime) : void 0
    });
  }
}
class aM extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "lastActivityDate");
    o(this, "beginDate");
    o(this, "endDate");
    o(this, "state");
    o(this, "progress");
    o(this, "contact");
    o(this, "course");
    o(this, "currentCourseItem");
    o(this, "feedback");
    o(this, "score");
    /**
     * sections excluded
     */
    o(this, "totalItemCount");
    /**
     * @deprecated use currentCourseItem instead
     */
    o(this, "initialCourseItemId");
    o(this, "cohortBeginDate");
    o(this, "accessBeginDate");
    o(this, "accessEndDate");
    o(this, "isSubscription");
    c0(this, {
      beginDate: r,
      endDate: r,
      state: r,
      progress: r,
      contact: r,
      course: r,
      currentCourseItem: r,
      feedback: r,
      score: r,
      cohortBeginDate: r,
      accessBeginDate: r,
      accessEndDate: r,
      isSubscription: r,
      hasFeedback: Y,
      isInCohort: Y
    }), e && this.update(e);
  }
  get hasFeedback() {
    return !I1.isEmpty(this.feedback);
  }
  get isInCohort() {
    return this.cohortBeginDate != null;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var p;
    return new aM({
      ...e,
      lastActivityDate: e.lastActivityDate ? R(e.lastActivityDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      course: e.course ? be.fromJson(e.course) : void 0,
      // TODO remove from model, use currentCourseItem instead
      initialCourseItemId: (p = e.currentCourseItem) == null ? void 0 : p.id,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      beginDate: e.beginDate ? R(e.beginDate) : void 0,
      endDate: e.endDate ? R(e.endDate) : void 0,
      // TODO rename flowBeginDate to cohortBeginDate?
      cohortBeginDate: e.flowBeginDate ? R(e.flowBeginDate) : void 0,
      accessBeginDate: e.accessBeginDate ? R(e.accessBeginDate) : void 0,
      accessEndDate: e.accessEndDate ? R(e.accessEndDate) : void 0,
      isSubscription: e.isSubscription ?? !1,
      currentCourseItem: e.currentCourseItem ? me.fromJson(e.currentCourseItem) : void 0
    });
  }
}
class Ne extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "title");
    o(this, "shortDescription");
    o(this, "freeAccess");
    o(this, "primaryImageCloudKey");
    o(this, "primaryImage");
    o(this, "studentAccessDate");
    o(this, "flowBeginDate");
    o(this, "studentHasAccess");
    o(this, "categories");
    c0(this, {
      name: r,
      title: r,
      shortDescription: r,
      freeAccess: r,
      primaryImageCloudKey: r,
      studentAccessDate: r,
      flowBeginDate: r,
      studentHasAccess: r,
      categories: r
    }), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var p;
    return new Ne({
      ...e,
      primaryImage: (p = e.primaryImage) != null && p.file ? g1.fromJson(e.primaryImage.file) : null,
      studentAccessDate: e.studentAccessDate ? new Date(e.studentAccessDate) : void 0,
      flowBeginDate: e.flowBeginDate ? new Date(e.flowBeginDate) : void 0
    });
  }
}
class I8 extends I0 {
  constructor(t) {
    super(), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
var JM = /* @__PURE__ */ ((M) => (M.Section = "section", M.Article = "step", M))(JM || {});
class Z2 extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "comment");
    o(this, "position");
    o(this, "avgRating");
    o(this, "designHTMLPublished");
    o(this, "designStylePublished");
    /** Which renderer draws the article: `legacy` = the design fields above, `custom` = `headHtml` + `bodyHtml` (site page editor). */
    o(this, "layoutType");
    o(this, "bodyHtml");
    o(this, "headHtml");
    o(this, "type");
    o(this, "parent");
    o(this, "parentItemId");
    o(this, "isDraft");
    o(this, "allowComments");
    o(this, "showComments");
    o(this, "ratingEnabled");
    o(this, "disableCommentModeration");
    o(this, "ratingCommentRequired");
    o(this, "preventCopingAndSelectingText");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "flowTimeDelayActive");
    o(this, "flowTimeDelay");
    o(this, "flowTimeDelayCondition");
    o(this, "flowTimeDelayMeasureType");
    o(this, "library");
    o(this, "parentItem");
    o(this, "children", []);
    o(this, "section");
    o(this, "previousItem");
    o(this, "nextItem");
    o(this, "studentHasAccess");
    o(this, "flowBeginDate");
    o(this, "progress");
    o(this, "_tab");
    c0(this, {
      title: r,
      comment: r,
      position: r,
      avgRating: r,
      designHTMLPublished: r,
      designStylePublished: r,
      layoutType: r,
      bodyHtml: r,
      headHtml: r,
      type: r,
      parent: r,
      parentItemId: r,
      isDraft: r,
      allowComments: r,
      showComments: r,
      ratingEnabled: r,
      disableCommentModeration: r,
      ratingCommentRequired: r,
      preventCopingAndSelectingText: r,
      createdDate: r,
      updatedDate: r,
      flowTimeDelayActive: r,
      flowTimeDelay: r,
      flowTimeDelayCondition: r,
      flowTimeDelayMeasureType: r,
      library: r,
      parentItem: r,
      children: r,
      section: r,
      previousItem: r,
      nextItem: r,
      studentHasAccess: r,
      flowBeginDate: r,
      progress: r,
      ratingVisible: Y,
      _tab: r,
      tab: Y,
      completed: Y,
      fullPosition: Y,
      lastChild: Y,
      firstChild: Y,
      parentAvailability: Y,
      canSelect: Y,
      availability: Y,
      availabilityRelativeToTimeDelay: Y,
      flowTimeDelayValue: Y,
      update: I
    }), e && this.update(e);
  }
  get ratingVisible() {
    return this.allowComments || this.ratingEnabled;
  }
  get tab() {
    return this._tab;
  }
  set tab(e) {
    switch (e) {
      case "article": {
        this._tab = "article";
        return;
      }
      case "rating": {
        if (this.allowComments || this.ratingEnabled) {
          this._tab = "rating";
          return;
        }
        break;
      }
    }
  }
  get completed() {
    return !u1(this.progress);
  }
  get fullPosition() {
    let e = "", p = this.section;
    for (; p != null; )
      e += `${p.position}.`, p = p.section;
    return e += this.position, e;
  }
  get lastChild() {
    return this.getLastNestedStep();
  }
  getLastNestedStep() {
    if (this.type == "step" || this.children.length == 0)
      return null;
    for (const e of this.children.slice().reverse()) {
      if (e.type == "step")
        return e;
      const p = e.getLastNestedStep();
      if (p != null)
        return p;
    }
    return null;
  }
  get firstChild() {
    return this.getFirstNestedStep();
  }
  getFirstNestedStep() {
    if (this.type == "step" || this.children.length == 0)
      return null;
    const e = this.children.filter(
      (p) => p.type == "step"
      /* Article */
    );
    if (e.length > 0)
      return e[0];
    for (const p of this.children) {
      const c = p.getFirstNestedStep();
      if (c != null)
        return c;
    }
    return null;
  }
  get parentAvailability() {
    return this.section != null ? this.section.availability : { result: !0 };
  }
  get canSelect() {
    return this.availability.result;
  }
  get availability() {
    const e = this.parentAvailability;
    return e.result ? this.availabilityRelativeToTimeDelay.result ? this.studentHasAccess ? { result: !0 } : { result: !1 } : this.availabilityRelativeToTimeDelay : { ...e, isSection: !0 };
  }
  get availabilityRelativeToTimeDelay() {
    if (this.flowTimeDelayActive)
      switch (this.flowTimeDelayCondition) {
        case "flowStart": {
          if (this.flowBeginDate == null)
            break;
          const e = R(), p = R(this.flowBeginDate).add(this.flowTimeDelayValue.milliseconds, "milliseconds");
          if (e <= p)
            return { result: !1, willBeAvailableOn: p };
          break;
        }
      }
    return { result: !0 };
  }
  get flowTimeDelayValue() {
    return I1.isNil(this.flowTimeDelay) ? c1.zero : c1.fromTimeMeasure(this.flowTimeDelay, this.flowTimeDelayMeasureType ?? "days");
  }
  clone() {
    return new Z2({
      ...this,
      parent: this.parent ? this.parent.clone() : void 0,
      library: this.library ? this.library.clone() : void 0
    });
  }
  static fromJson(e) {
    return new Z2({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      library: e.library ? Ne.fromJson(e.library) : void 0,
      parent: e.parentItem ? Z2.fromJson(e.parentItem) : void 0,
      studentHasAccess: e.studentHasAccess,
      parentItem: e.parentItem ? Z2.fromJson(e.parentItem) : null,
      progress: e.progress ? Qc.fromJson(e.progress) : void 0
    });
  }
  update(e) {
    super.update(e);
  }
}
class Qc extends M0 {
  constructor(e) {
    super();
    o(this, "beginDate");
    o(this, "rating");
    c0(this, {
      beginDate: r,
      rating: r,
      update: I
    }), e && this.update(e);
  }
  static fromJson(e) {
    return new Qc({
      ...e,
      beginDate: e.createdDate ? R(e.createdDate) : void 0,
      rating: e.rating ? xp.fromJson(e.rating) : null
    });
  }
  update(e) {
    super.update(e);
  }
}
class Dh extends I0 {
  constructor(e) {
    super();
    o(this, "courseItemId");
    o(this, "courseId");
    o(this, "libraryItemId");
    o(this, "libraryId");
    o(this, "progressId");
    o(this, "parentId");
    o(this, "studentId");
    o(this, "state");
    o(this, "states");
    o(this, "root");
    o(this, "parentSoftDeleted");
    o(this, "ratingId");
    o(this, "hasRating");
    o(this, "studentIds");
    o(this, "courseItemIds");
    o(this, "libraryItemIds");
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "sectionType");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var Ch = /* @__PURE__ */ ((M) => (M.Moderation = "moderation", M.Published = "published", M.NotPublished = "notPublished", M))(Ch || {});
class B2 extends M0 {
  constructor(e) {
    super();
    o(this, "text");
    o(this, "state");
    o(this, "contact");
    o(this, "admin");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "parentId");
    o(this, "replyId");
    o(this, "children");
    o(this, "childrenCount");
    o(this, "rating");
    o(this, "files");
    o(this, "reply");
    o(this, "courseItem");
    o(this, "libraryItem");
    o(this, "sectionType");
    c0(this, {
      text: r,
      state: r,
      contact: r,
      admin: r,
      createdDate: r,
      updatedDate: r,
      parentId: r,
      replyId: r,
      children: r,
      childrenCount: r,
      rating: r,
      files: r,
      reply: r,
      courseItem: r,
      libraryItem: r,
      sectionType: r,
      author: Y,
      isEmpty: Y,
      isRoot: Y,
      hasMore: Y,
      update: I
    }), e && this.update(e);
  }
  // TODO: review if base user is needed
  get author() {
    return this.admin ?? this.contact;
  }
  get isEmpty() {
    return !this.text && this.files.length == 0;
  }
  get isRoot() {
    return this.parentId == null;
  }
  get hasMore() {
    return this.childrenCount > this.children.length;
  }
  static fromJson(e) {
    return new B2({
      ...e,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      admin: e.admin ? ut.fromJson(e.admin) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      children: e.children ? e.children.map(B2.fromJson) : void 0,
      rating: e.progress ? e.progress.rating : void 0,
      files: e.files ? e.files.map(D1.fromJson) : [],
      reply: e.reply ? B2.fromJson(e.reply) : void 0,
      courseItem: e.courseItem ? me.fromJson(e.courseItem) : void 0,
      libraryItem: e.libraryItem ? Z2.fromJson(e.libraryItem) : void 0
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
}
class xp extends M0 {
  constructor(e) {
    super();
    o(this, "comment");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "comments");
    o(this, "commentsCount");
    o(this, "rating");
    o(this, "files", []);
    o(this, "courseItem");
    o(this, "libraryItem");
    o(this, "sectionType");
    c0(this, {
      comment: r,
      createdDate: r,
      updatedDate: r,
      comments: r,
      commentsCount: r,
      rating: r,
      files: r,
      courseItem: r,
      libraryItem: r,
      sectionType: r,
      isCommentEmpty: Y,
      update: I
    }), e && this.update(e);
  }
  get isCommentEmpty() {
    return I1.isEmpty(this.comment) && this.files.length == 0;
  }
  update(e) {
    super.update(e);
  }
  // clone() {
  //     return new SchoolContentItemProgressRating({
  //         ...this,
  //         files: this.files.slice(),
  //     });
  // }
  static fromJson(e) {
    return new xp({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      comments: e.comments ? e.comments.map(B2.fromJson) : void 0,
      files: e.files ? e.files.map(D1.fromJson) : [],
      courseItem: e.courseItem ? me.fromJson(e.courseItem) : void 0,
      libraryItem: e.libraryItem ? Ne.fromJson(e.libraryItem) : void 0
    });
  }
}
class ua extends M0 {
  constructor() {
    super();
    o(this, "beginDate");
    o(this, "completeDate");
    o(this, "numberUncheckedTasks", 0);
    o(this, "numberCorrectTasks", 0);
    o(this, "numberIncorrectTasks", 0);
    c0(this, {
      beginDate: r,
      completeDate: r,
      numberUncheckedTasks: r,
      numberCorrectTasks: r,
      numberIncorrectTasks: r
    });
  }
}
class Ih extends ua {
  constructor(t) {
    super(), c0(this, {
      update: I
    }), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
class Fp extends ua {
  constructor(e) {
    super();
    o(this, "precompleteDate");
    o(this, "theoryStatus");
    o(this, "testStatus");
    o(this, "taskStatus");
    o(this, "status");
    o(this, "rating");
    c0(this, {
      precompleteDate: r,
      theoryStatus: r,
      testStatus: r,
      taskStatus: r,
      status: r,
      rating: r,
      theoryCompleted: Y,
      testsCompleted: Y,
      tasksCompleted: Y,
      update: I
    }), e && this.update(e);
  }
  // Same as the server (StudentCourseItemProgress.TheoryCompleted etc.): null = nothing to complete.
  // The server leaves theoryStatus null for HTML-mode lessons, and a step completed that way must not block "Next".
  get theoryCompleted() {
    return this.theoryStatus == null || this.theoryStatus == !0;
  }
  get testsCompleted() {
    return this.testStatus == null || this.testStatus == !0;
  }
  get tasksCompleted() {
    return this.taskStatus == null || this.taskStatus == "completed";
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Fp({
      ...e,
      beginDate: new Date(e.beginDate),
      completeDate: e.completeDate ? new Date(e.completeDate) : null,
      precompleteDate: e.precompleteDate ? new Date(e.precompleteDate) : null,
      rating: e.rating ? xp.fromJson(e.rating) : null
    });
  }
}
class p2 {
  constructor(t) {
    o(this, "courseItemId");
    o(this, "contactCourse");
    o(this, "courseItemProgress");
    t && Object.assign(this, t);
  }
  static fromJson(t) {
    return new p2({
      courseItemId: t.courseItemId,
      contactCourse: t.studentCourse ? aM.fromJson(t.studentCourse) : void 0,
      courseItemProgress: t.courseItemProgress ? Fp.fromJson(t.courseItemProgress) : void 0
    });
  }
}
var qo = { exports: {} }, up = { exports: {} };
const kh = /* @__PURE__ */ Oa(Z6);
var Ph = up.exports, dO;
function Eh() {
  return dO || (dO = 1, (function(M) {
    //! moment-timezone.js
    //! version : 0.5.48
    //! Copyright (c) JS Foundation and other contributors
    //! license : MIT
    //! github.com/moment/moment-timezone
    (function(t, e) {
      M.exports ? M.exports = e(kh) : e(t.moment);
    })(Ph, function(t) {
      t.version === void 0 && t.default && (t = t.default);
      var e = "0.5.48", p = {}, c = {}, i = {}, s = {}, u = {}, l;
      (!t || typeof t.version != "string") && i1("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
      var W = t.version.split("."), L = +W[0], m = +W[1];
      (L < 2 || L === 2 && m < 6) && i1("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + t.version + ". See momentjs.com");
      function X(f) {
        return f > 96 ? f - 87 : f > 64 ? f - 29 : f - 48;
      }
      function D(f) {
        var C = 0, k = f.split("."), V = k[0], b0 = k[1] || "", q0 = 1, V0, h0 = 0, f0 = 1;
        for (f.charCodeAt(0) === 45 && (C = 1, f0 = -1), C; C < V.length; C++)
          V0 = X(V.charCodeAt(C)), h0 = 60 * h0 + V0;
        for (C = 0; C < b0.length; C++)
          q0 = q0 / 60, V0 = X(b0.charCodeAt(C)), h0 += V0 * q0;
        return h0 * f0;
      }
      function y(f) {
        for (var C = 0; C < f.length; C++)
          f[C] = D(f[C]);
      }
      function S(f, C) {
        for (var k = 0; k < C; k++)
          f[k] = Math.round((f[k - 1] || 0) + f[k] * 6e4);
        f[C - 1] = 1 / 0;
      }
      function B(f, C) {
        var k = [], V;
        for (V = 0; V < C.length; V++)
          k[V] = f[C[V]];
        return k;
      }
      function Z(f) {
        var C = f.split("|"), k = C[2].split(" "), V = C[3].split(""), b0 = C[4].split(" ");
        return y(k), y(V), y(b0), S(b0, V.length), {
          name: C[0],
          abbrs: B(C[1].split(" "), V),
          offsets: B(k, V),
          untils: b0,
          population: C[5] | 0
        };
      }
      function H(f) {
        f && this._set(Z(f));
      }
      function e0(f, C) {
        var k = C.length;
        if (f < C[0])
          return 0;
        if (k > 1 && C[k - 1] === 1 / 0 && f >= C[k - 2])
          return k - 1;
        if (f >= C[k - 1])
          return -1;
        for (var V, b0 = 0, q0 = k - 1; q0 - b0 > 1; )
          V = Math.floor((b0 + q0) / 2), C[V] <= f ? b0 = V : q0 = V;
        return q0;
      }
      H.prototype = {
        _set: function(f) {
          this.name = f.name, this.abbrs = f.abbrs, this.untils = f.untils, this.offsets = f.offsets, this.population = f.population;
        },
        _index: function(f) {
          var C = +f, k = this.untils, V;
          if (V = e0(C, k), V >= 0)
            return V;
        },
        countries: function() {
          var f = this.name;
          return Object.keys(i).filter(function(C) {
            return i[C].zones.indexOf(f) !== -1;
          });
        },
        parse: function(f) {
          var C = +f, k = this.offsets, V = this.untils, b0 = V.length - 1, q0, V0, h0, f0;
          for (f0 = 0; f0 < b0; f0++)
            if (q0 = k[f0], V0 = k[f0 + 1], h0 = k[f0 && f0 - 1], q0 < V0 && S0.moveAmbiguousForward ? q0 = V0 : q0 > h0 && S0.moveInvalidForward && (q0 = h0), C < V[f0] - q0 * 6e4)
              return k[f0];
          return k[b0];
        },
        abbr: function(f) {
          return this.abbrs[this._index(f)];
        },
        offset: function(f) {
          return i1("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(f)];
        },
        utcOffset: function(f) {
          return this.offsets[this._index(f)];
        }
      };
      function r0(f, C) {
        this.name = f, this.zones = C;
      }
      function G(f) {
        var C = f.toTimeString(), k = C.match(/\([a-z ]+\)/i);
        k && k[0] ? (k = k[0].match(/[A-Z]/g), k = k ? k.join("") : void 0) : (k = C.match(/[A-Z]{3,5}/g), k = k ? k[0] : void 0), k === "GMT" && (k = void 0), this.at = +f, this.abbr = k, this.offset = f.getTimezoneOffset();
      }
      function j(f) {
        this.zone = f, this.offsetScore = 0, this.abbrScore = 0;
      }
      j.prototype.scoreOffsetAt = function(f) {
        this.offsetScore += Math.abs(this.zone.utcOffset(f.at) - f.offset), this.zone.abbr(f.at).replace(/[^A-Z]/g, "") !== f.abbr && this.abbrScore++;
      };
      function v(f, C) {
        for (var k, V; V = ((C.at - f.at) / 12e4 | 0) * 6e4; )
          k = new G(new Date(f.at + V)), k.offset === f.offset ? f = k : C = k;
        return f;
      }
      function E() {
        var f = (/* @__PURE__ */ new Date()).getFullYear() - 2, C = new G(new Date(f, 0, 1)), k = C.offset, V = [C], b0, q0, V0, h0;
        for (h0 = 1; h0 < 48; h0++)
          V0 = new Date(f, h0, 1).getTimezoneOffset(), V0 !== k && (q0 = new G(new Date(f, h0, 1)), b0 = v(C, q0), V.push(b0), V.push(new G(new Date(b0.at + 6e4))), C = q0, k = V0);
        for (h0 = 0; h0 < 4; h0++)
          V.push(new G(new Date(f + h0, 0, 1))), V.push(new G(new Date(f + h0, 6, 1)));
        return V;
      }
      function K(f, C) {
        return f.offsetScore !== C.offsetScore ? f.offsetScore - C.offsetScore : f.abbrScore !== C.abbrScore ? f.abbrScore - C.abbrScore : f.zone.population !== C.zone.population ? C.zone.population - f.zone.population : C.zone.name.localeCompare(f.zone.name);
      }
      function p0(f, C) {
        var k, V;
        for (y(C), k = 0; k < C.length; k++)
          V = C[k], u[V] = u[V] || {}, u[V][f] = !0;
      }
      function O0(f) {
        var C = f.length, k = {}, V = [], b0 = {}, q0, V0, h0, f0;
        for (q0 = 0; q0 < C; q0++)
          if (h0 = f[q0].offset, !b0.hasOwnProperty(h0)) {
            f0 = u[h0] || {};
            for (V0 in f0)
              f0.hasOwnProperty(V0) && (k[V0] = !0);
            b0[h0] = !0;
          }
        for (q0 in k)
          k.hasOwnProperty(q0) && V.push(s[q0]);
        return V;
      }
      function s0() {
        try {
          var f = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (f && f.length > 3) {
            var C = s[l0(f)];
            if (C)
              return C;
            i1("Moment Timezone found " + f + " from the Intl api, but did not have that data loaded.");
          }
        } catch {
        }
        var k = E(), V = k.length, b0 = O0(k), q0 = [], V0, h0, f0;
        for (h0 = 0; h0 < b0.length; h0++) {
          for (V0 = new j(W0(b0[h0])), f0 = 0; f0 < V; f0++)
            V0.scoreOffsetAt(k[f0]);
          q0.push(V0);
        }
        return q0.sort(K), q0.length > 0 ? q0[0].zone.name : void 0;
      }
      function E0(f) {
        return (!l || f) && (l = s0()), l;
      }
      function l0(f) {
        return (f || "").toLowerCase().replace(/\//g, "_");
      }
      function Q0(f) {
        var C, k, V, b0;
        for (typeof f == "string" && (f = [f]), C = 0; C < f.length; C++)
          V = f[C].split("|"), k = V[0], b0 = l0(k), p[b0] = f[C], s[b0] = k, p0(b0, V[2].split(" "));
      }
      function W0(f, C) {
        f = l0(f);
        var k = p[f], V;
        return k instanceof H ? k : typeof k == "string" ? (k = new H(k), p[f] = k, k) : c[f] && C !== W0 && (V = W0(c[f], W0)) ? (k = p[f] = new H(), k._set(V), k.name = s[f], k) : null;
      }
      function $0() {
        var f, C = [];
        for (f in s)
          s.hasOwnProperty(f) && (p[f] || p[c[f]]) && s[f] && C.push(s[f]);
        return C.sort();
      }
      function $() {
        return Object.keys(i);
      }
      function x0(f) {
        var C, k, V, b0;
        for (typeof f == "string" && (f = [f]), C = 0; C < f.length; C++)
          k = f[C].split("|"), V = l0(k[0]), b0 = l0(k[1]), c[V] = b0, s[V] = k[0], c[b0] = V, s[b0] = k[1];
      }
      function f1(f) {
        var C, k, V, b0;
        if (!(!f || !f.length))
          for (C = 0; C < f.length; C++)
            b0 = f[C].split("|"), k = b0[0].toUpperCase(), V = b0[1].split(" "), i[k] = new r0(
              k,
              V
            );
      }
      function n1(f) {
        return f = f.toUpperCase(), i[f] || null;
      }
      function u2(f, C) {
        if (f = n1(f), !f) return null;
        var k = f.zones.sort();
        return C ? k.map(function(V) {
          var b0 = W0(V);
          return {
            name: V,
            offset: b0.utcOffset(/* @__PURE__ */ new Date())
          };
        }) : k;
      }
      function q2(f) {
        Q0(f.zones), x0(f.links), f1(f.countries), S0.dataVersion = f.version;
      }
      function Z1(f) {
        return Z1.didShowError || (Z1.didShowError = !0, i1("moment.tz.zoneExists('" + f + "') has been deprecated in favor of !moment.tz.zone('" + f + "')")), !!W0(f);
      }
      function v1(f) {
        var C = f._f === "X" || f._f === "x";
        return !!(f._a && f._tzm === void 0 && !C);
      }
      function i1(f) {
        typeof console < "u" && typeof console.error == "function" && console.error(f);
      }
      function S0(f) {
        var C = Array.prototype.slice.call(arguments, 0, -1), k = arguments[arguments.length - 1], V = t.utc.apply(null, C), b0;
        return !t.isMoment(f) && v1(V) && (b0 = W0(k)) && V.add(b0.parse(V), "minutes"), V.tz(k), V;
      }
      S0.version = e, S0.dataVersion = "", S0._zones = p, S0._links = c, S0._names = s, S0._countries = i, S0.add = Q0, S0.link = x0, S0.load = q2, S0.zone = W0, S0.zoneExists = Z1, S0.guess = E0, S0.names = $0, S0.Zone = H, S0.unpack = Z, S0.unpackBase60 = D, S0.needsOffset = v1, S0.moveInvalidForward = !0, S0.moveAmbiguousForward = !1, S0.countries = $, S0.zonesForCountry = u2;
      var b1 = t.fn;
      t.tz = S0, t.defaultZone = null, t.updateOffset = function(f, C) {
        var k = t.defaultZone, V;
        if (f._z === void 0 && (k && v1(f) && !f._isUTC && f.isValid() && (f._d = t.utc(f._a)._d, f.utc().add(k.parse(f), "minutes")), f._z = k), f._z)
          if (V = f._z.utcOffset(f), Math.abs(V) < 16 && (V = V / 60), f.utcOffset !== void 0) {
            var b0 = f._z;
            f.utcOffset(-V, C), f._z = b0;
          } else
            f.zone(V, C);
      }, b1.tz = function(f, C) {
        if (f) {
          if (typeof f != "string")
            throw new Error("Time zone name must be a string, got " + f + " [" + typeof f + "]");
          return this._z = W0(f), this._z ? t.updateOffset(this, C) : i1("Moment Timezone has no data for " + f + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
        }
        if (this._z)
          return this._z.name;
      };
      function p1(f) {
        return function() {
          return this._z ? this._z.abbr(this) : f.call(this);
        };
      }
      function _0(f) {
        return function() {
          return this._z = null, f.apply(this, arguments);
        };
      }
      function Z0(f) {
        return function() {
          return arguments.length > 0 && (this._z = null), f.apply(this, arguments);
        };
      }
      b1.zoneName = p1(b1.zoneName), b1.zoneAbbr = p1(b1.zoneAbbr), b1.utc = _0(b1.utc), b1.local = _0(b1.local), b1.utcOffset = Z0(b1.utcOffset), t.tz.setDefault = function(f) {
        return (L < 2 || L === 2 && m < 9) && i1("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + t.version + "."), t.defaultZone = f ? W0(f) : null, t;
      };
      var w0 = t.momentProperties;
      return Object.prototype.toString.call(w0) === "[object Array]" ? (w0.push("_z"), w0.push("_a")) : w0 && (w0._z = null), t;
    });
  })(up)), up.exports;
}
const xh = "2025b", Fh = /* @__PURE__ */ JSON.parse('["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3"]'), Uh = ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Iceland", "Africa/Cairo|Egypt", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Maputo|Africa/Blantyre", "Africa/Maputo|Africa/Bujumbura", "Africa/Maputo|Africa/Gaborone", "Africa/Maputo|Africa/Harare", "Africa/Maputo|Africa/Kigali", "Africa/Maputo|Africa/Lubumbashi", "Africa/Maputo|Africa/Lusaka", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|US/Alaska", "America/Argentina/Buenos_Aires|America/Buenos_Aires", "America/Argentina/Catamarca|America/Argentina/ComodRivadavia", "America/Argentina/Catamarca|America/Catamarca", "America/Argentina/Cordoba|America/Cordoba", "America/Argentina/Cordoba|America/Rosario", "America/Argentina/Jujuy|America/Jujuy", "America/Argentina/Mendoza|America/Mendoza", "America/Chicago|CST6CDT", "America/Chicago|US/Central", "America/Denver|America/Shiprock", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Detroit|US/Michigan", "America/Edmonton|America/Yellowknife", "America/Edmonton|Canada/Mountain", "America/Fort_Wayne|America/Indiana/Indianapolis", "America/Fort_Wayne|America/Indianapolis", "America/Fort_Wayne|US/East-Indiana", "America/Godthab|America/Nuuk", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/Indiana/Knox|America/Knox_IN", "America/Indiana/Knox|US/Indiana-Starke", "America/Iqaluit|America/Pangnirtung", "America/Jamaica|Jamaica", "America/Kentucky/Louisville|America/Louisville", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Manaus|Brazil/West", "America/Mazatlan|Mexico/BajaSur", "America/Mexico_City|Mexico/General", "America/New_York|EST5EDT", "America/New_York|US/Eastern", "America/Noronha|Brazil/DeNoronha", "America/Panama|America/Atikokan", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|EST", "America/Phoenix|America/Creston", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Puerto_Rico|America/Anguilla", "America/Puerto_Rico|America/Antigua", "America/Puerto_Rico|America/Aruba", "America/Puerto_Rico|America/Blanc-Sablon", "America/Puerto_Rico|America/Curacao", "America/Puerto_Rico|America/Dominica", "America/Puerto_Rico|America/Grenada", "America/Puerto_Rico|America/Guadeloupe", "America/Puerto_Rico|America/Kralendijk", "America/Puerto_Rico|America/Lower_Princes", "America/Puerto_Rico|America/Marigot", "America/Puerto_Rico|America/Montserrat", "America/Puerto_Rico|America/Port_of_Spain", "America/Puerto_Rico|America/St_Barthelemy", "America/Puerto_Rico|America/St_Kitts", "America/Puerto_Rico|America/St_Lucia", "America/Puerto_Rico|America/St_Thomas", "America/Puerto_Rico|America/St_Vincent", "America/Puerto_Rico|America/Tortola", "America/Puerto_Rico|America/Virgin", "America/Regina|Canada/Saskatchewan", "America/Rio_Branco|America/Porto_Acre", "America/Rio_Branco|Brazil/Acre", "America/Santiago|Chile/Continental", "America/Sao_Paulo|Brazil/East", "America/St_Johns|Canada/Newfoundland", "America/Tijuana|America/Ensenada", "America/Tijuana|America/Santa_Isabel", "America/Tijuana|Mexico/BajaNorte", "America/Toronto|America/Montreal", "America/Toronto|America/Nassau", "America/Toronto|America/Nipigon", "America/Toronto|America/Thunder_Bay", "America/Toronto|Canada/Eastern", "America/Vancouver|Canada/Pacific", "America/Whitehorse|Canada/Yukon", "America/Winnipeg|America/Rainy_River", "America/Winnipeg|Canada/Central", "Asia/Ashgabat|Asia/Ashkhabad", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Indian/Christmas", "Asia/Brunei|Asia/Kuching", "Asia/Dhaka|Asia/Dacca", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Reunion", "Asia/Ho_Chi_Minh|Asia/Saigon", "Asia/Hong_Kong|Hongkong", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Singapore", "Asia/Macau|Asia/Macao", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Nicosia|Europe/Nicosia", "Asia/Qatar|Asia/Bahrain", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Riyadh|Antarctica/Syowa", "Asia/Riyadh|Asia/Aden", "Asia/Riyadh|Asia/Kuwait", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|PRC", "Asia/Taipei|ROC", "Asia/Tehran|Iran", "Asia/Thimphu|Asia/Thimbu", "Asia/Tokyo|Japan", "Asia/Ulaanbaatar|Asia/Choibalsan", "Asia/Ulaanbaatar|Asia/Ulan_Bator", "Asia/Urumqi|Asia/Kashgar", "Atlantic/Faroe|Atlantic/Faeroe", "Australia/Adelaide|Australia/South", "Australia/Brisbane|Australia/Queensland", "Australia/Broken_Hill|Australia/Yancowinna", "Australia/Darwin|Australia/North", "Australia/Hobart|Australia/Currie", "Australia/Hobart|Australia/Tasmania", "Australia/Lord_Howe|Australia/LHI", "Australia/Melbourne|Australia/Victoria", "Australia/Perth|Australia/West", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/NSW", "Etc/GMT-0|Etc/GMT", "Etc/GMT-0|Etc/GMT+0", "Etc/GMT-0|Etc/GMT0", "Etc/GMT-0|Etc/Greenwich", "Etc/GMT-0|GMT", "Etc/GMT-0|GMT+0", "Etc/GMT-0|GMT-0", "Etc/GMT-0|GMT0", "Etc/GMT-0|Greenwich", "Etc/UTC|Etc/UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UCT", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|EET", "Europe/Belgrade|Europe/Ljubljana", "Europe/Belgrade|Europe/Podgorica", "Europe/Belgrade|Europe/Sarajevo", "Europe/Belgrade|Europe/Skopje", "Europe/Belgrade|Europe/Zagreb", "Europe/Berlin|Arctic/Longyearbyen", "Europe/Berlin|Atlantic/Jan_Mayen", "Europe/Berlin|Europe/Copenhagen", "Europe/Berlin|Europe/Oslo", "Europe/Berlin|Europe/Stockholm", "Europe/Brussels|CET", "Europe/Brussels|Europe/Amsterdam", "Europe/Brussels|Europe/Luxembourg", "Europe/Brussels|MET", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Helsinki|Europe/Mariehamn", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Turkey", "Europe/Kiev|Europe/Kyiv", "Europe/Kiev|Europe/Uzhgorod", "Europe/Kiev|Europe/Zaporozhye", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|W-SU", "Europe/Paris|Europe/Monaco", "Europe/Prague|Europe/Bratislava", "Europe/Rome|Europe/San_Marino", "Europe/Rome|Europe/Vatican", "Europe/Warsaw|Poland", "Europe/Zurich|Europe/Busingen", "Europe/Zurich|Europe/Vaduz", "Indian/Maldives|Indian/Kerguelen", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Enderbury|Pacific/Kanton", "Pacific/Guadalcanal|Pacific/Pohnpei", "Pacific/Guadalcanal|Pacific/Ponape", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kwajalein|Kwajalein", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Port_Moresby|Antarctica/DumontDUrville", "Pacific/Port_Moresby|Pacific/Chuuk", "Pacific/Port_Moresby|Pacific/Truk", "Pacific/Port_Moresby|Pacific/Yap", "Pacific/Tarawa|Pacific/Funafuti", "Pacific/Tarawa|Pacific/Majuro", "Pacific/Tarawa|Pacific/Wake", "Pacific/Tarawa|Pacific/Wallis"], Jh = ["AD|Europe/Andorra", "AE|Asia/Dubai", "AF|Asia/Kabul", "AG|America/Puerto_Rico America/Antigua", "AI|America/Puerto_Rico America/Anguilla", "AL|Europe/Tirane", "AM|Asia/Yerevan", "AO|Africa/Lagos Africa/Luanda", "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa", "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia", "AS|Pacific/Pago_Pago", "AT|Europe/Vienna", "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo", "AW|America/Puerto_Rico America/Aruba", "AX|Europe/Helsinki Europe/Mariehamn", "AZ|Asia/Baku", "BA|Europe/Belgrade Europe/Sarajevo", "BB|America/Barbados", "BD|Asia/Dhaka", "BE|Europe/Brussels", "BF|Africa/Abidjan Africa/Ouagadougou", "BG|Europe/Sofia", "BH|Asia/Qatar Asia/Bahrain", "BI|Africa/Maputo Africa/Bujumbura", "BJ|Africa/Lagos Africa/Porto-Novo", "BL|America/Puerto_Rico America/St_Barthelemy", "BM|Atlantic/Bermuda", "BN|Asia/Kuching Asia/Brunei", "BO|America/La_Paz", "BQ|America/Puerto_Rico America/Kralendijk", "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco", "BS|America/Toronto America/Nassau", "BT|Asia/Thimphu", "BW|Africa/Maputo Africa/Gaborone", "BY|Europe/Minsk", "BZ|America/Belize", "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston", "CC|Asia/Yangon Indian/Cocos", "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi", "CF|Africa/Lagos Africa/Bangui", "CG|Africa/Lagos Africa/Brazzaville", "CH|Europe/Zurich", "CI|Africa/Abidjan", "CK|Pacific/Rarotonga", "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter", "CM|Africa/Lagos Africa/Douala", "CN|Asia/Shanghai Asia/Urumqi", "CO|America/Bogota", "CR|America/Costa_Rica", "CU|America/Havana", "CV|Atlantic/Cape_Verde", "CW|America/Puerto_Rico America/Curacao", "CX|Asia/Bangkok Indian/Christmas", "CY|Asia/Nicosia Asia/Famagusta", "CZ|Europe/Prague", "DE|Europe/Zurich Europe/Berlin Europe/Busingen", "DJ|Africa/Nairobi Africa/Djibouti", "DK|Europe/Berlin Europe/Copenhagen", "DM|America/Puerto_Rico America/Dominica", "DO|America/Santo_Domingo", "DZ|Africa/Algiers", "EC|America/Guayaquil Pacific/Galapagos", "EE|Europe/Tallinn", "EG|Africa/Cairo", "EH|Africa/El_Aaiun", "ER|Africa/Nairobi Africa/Asmara", "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary", "ET|Africa/Nairobi Africa/Addis_Ababa", "FI|Europe/Helsinki", "FJ|Pacific/Fiji", "FK|Atlantic/Stanley", "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei", "FO|Atlantic/Faroe", "FR|Europe/Paris", "GA|Africa/Lagos Africa/Libreville", "GB|Europe/London", "GD|America/Puerto_Rico America/Grenada", "GE|Asia/Tbilisi", "GF|America/Cayenne", "GG|Europe/London Europe/Guernsey", "GH|Africa/Abidjan Africa/Accra", "GI|Europe/Gibraltar", "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule", "GM|Africa/Abidjan Africa/Banjul", "GN|Africa/Abidjan Africa/Conakry", "GP|America/Puerto_Rico America/Guadeloupe", "GQ|Africa/Lagos Africa/Malabo", "GR|Europe/Athens", "GS|Atlantic/South_Georgia", "GT|America/Guatemala", "GU|Pacific/Guam", "GW|Africa/Bissau", "GY|America/Guyana", "HK|Asia/Hong_Kong", "HN|America/Tegucigalpa", "HR|Europe/Belgrade Europe/Zagreb", "HT|America/Port-au-Prince", "HU|Europe/Budapest", "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura", "IE|Europe/Dublin", "IL|Asia/Jerusalem", "IM|Europe/London Europe/Isle_of_Man", "IN|Asia/Kolkata", "IO|Indian/Chagos", "IQ|Asia/Baghdad", "IR|Asia/Tehran", "IS|Africa/Abidjan Atlantic/Reykjavik", "IT|Europe/Rome", "JE|Europe/London Europe/Jersey", "JM|America/Jamaica", "JO|Asia/Amman", "JP|Asia/Tokyo", "KE|Africa/Nairobi", "KG|Asia/Bishkek", "KH|Asia/Bangkok Asia/Phnom_Penh", "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati", "KM|Africa/Nairobi Indian/Comoro", "KN|America/Puerto_Rico America/St_Kitts", "KP|Asia/Pyongyang", "KR|Asia/Seoul", "KW|Asia/Riyadh Asia/Kuwait", "KY|America/Panama America/Cayman", "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral", "LA|Asia/Bangkok Asia/Vientiane", "LB|Asia/Beirut", "LC|America/Puerto_Rico America/St_Lucia", "LI|Europe/Zurich Europe/Vaduz", "LK|Asia/Colombo", "LR|Africa/Monrovia", "LS|Africa/Johannesburg Africa/Maseru", "LT|Europe/Vilnius", "LU|Europe/Brussels Europe/Luxembourg", "LV|Europe/Riga", "LY|Africa/Tripoli", "MA|Africa/Casablanca", "MC|Europe/Paris Europe/Monaco", "MD|Europe/Chisinau", "ME|Europe/Belgrade Europe/Podgorica", "MF|America/Puerto_Rico America/Marigot", "MG|Africa/Nairobi Indian/Antananarivo", "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro", "MK|Europe/Belgrade Europe/Skopje", "ML|Africa/Abidjan Africa/Bamako", "MM|Asia/Yangon", "MN|Asia/Ulaanbaatar Asia/Hovd", "MO|Asia/Macau", "MP|Pacific/Guam Pacific/Saipan", "MQ|America/Martinique", "MR|Africa/Abidjan Africa/Nouakchott", "MS|America/Puerto_Rico America/Montserrat", "MT|Europe/Malta", "MU|Indian/Mauritius", "MV|Indian/Maldives", "MW|Africa/Maputo Africa/Blantyre", "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana", "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur", "MZ|Africa/Maputo", "NA|Africa/Windhoek", "NC|Pacific/Noumea", "NE|Africa/Lagos Africa/Niamey", "NF|Pacific/Norfolk", "NG|Africa/Lagos", "NI|America/Managua", "NL|Europe/Brussels Europe/Amsterdam", "NO|Europe/Berlin Europe/Oslo", "NP|Asia/Kathmandu", "NR|Pacific/Nauru", "NU|Pacific/Niue", "NZ|Pacific/Auckland Pacific/Chatham", "OM|Asia/Dubai Asia/Muscat", "PA|America/Panama", "PE|America/Lima", "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier", "PG|Pacific/Port_Moresby Pacific/Bougainville", "PH|Asia/Manila", "PK|Asia/Karachi", "PL|Europe/Warsaw", "PM|America/Miquelon", "PN|Pacific/Pitcairn", "PR|America/Puerto_Rico", "PS|Asia/Gaza Asia/Hebron", "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores", "PW|Pacific/Palau", "PY|America/Asuncion", "QA|Asia/Qatar", "RE|Asia/Dubai Indian/Reunion", "RO|Europe/Bucharest", "RS|Europe/Belgrade", "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr", "RW|Africa/Maputo Africa/Kigali", "SA|Asia/Riyadh", "SB|Pacific/Guadalcanal", "SC|Asia/Dubai Indian/Mahe", "SD|Africa/Khartoum", "SE|Europe/Berlin Europe/Stockholm", "SG|Asia/Singapore", "SH|Africa/Abidjan Atlantic/St_Helena", "SI|Europe/Belgrade Europe/Ljubljana", "SJ|Europe/Berlin Arctic/Longyearbyen", "SK|Europe/Prague Europe/Bratislava", "SL|Africa/Abidjan Africa/Freetown", "SM|Europe/Rome Europe/San_Marino", "SN|Africa/Abidjan Africa/Dakar", "SO|Africa/Nairobi Africa/Mogadishu", "SR|America/Paramaribo", "SS|Africa/Juba", "ST|Africa/Sao_Tome", "SV|America/El_Salvador", "SX|America/Puerto_Rico America/Lower_Princes", "SY|Asia/Damascus", "SZ|Africa/Johannesburg Africa/Mbabane", "TC|America/Grand_Turk", "TD|Africa/Ndjamena", "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen", "TG|Africa/Abidjan Africa/Lome", "TH|Asia/Bangkok", "TJ|Asia/Dushanbe", "TK|Pacific/Fakaofo", "TL|Asia/Dili", "TM|Asia/Ashgabat", "TN|Africa/Tunis", "TO|Pacific/Tongatapu", "TR|Europe/Istanbul", "TT|America/Puerto_Rico America/Port_of_Spain", "TV|Pacific/Tarawa Pacific/Funafuti", "TW|Asia/Taipei", "TZ|Africa/Nairobi Africa/Dar_es_Salaam", "UA|Europe/Simferopol Europe/Kyiv", "UG|Africa/Nairobi Africa/Kampala", "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake", "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu", "UY|America/Montevideo", "UZ|Asia/Samarkand Asia/Tashkent", "VA|Europe/Rome Europe/Vatican", "VC|America/Puerto_Rico America/St_Vincent", "VE|America/Caracas", "VG|America/Puerto_Rico America/Tortola", "VI|America/Puerto_Rico America/St_Thomas", "VN|Asia/Bangkok Asia/Ho_Chi_Minh", "VU|Pacific/Efate", "WF|Pacific/Tarawa Pacific/Wallis", "WS|Pacific/Apia", "YE|Asia/Riyadh Asia/Aden", "YT|Africa/Nairobi Indian/Mayotte", "ZA|Africa/Johannesburg", "ZM|Africa/Maputo Africa/Lusaka", "ZW|Africa/Maputo Africa/Harare"], Hh = {
  version: xh,
  zones: Fh,
  links: Uh,
  countries: Jh
};
var uO;
function Yh() {
  if (uO) return qo.exports;
  uO = 1;
  var M = qo.exports = Eh();
  return M.tz.load(Hh), qo.exports;
}
var Gh = Yh();
const h1 = /* @__PURE__ */ Hc(Gh);
class Zc extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "description");
    o(this, "position");
    o(this, "minPercentageCompletion");
    o(this, "minScoreCompletion");
    o(this, "questions");
    o(this, "files");
    o(this, "countingMethod");
    o(this, "shuffle");
    o(this, "isCompleted");
    o(this, "parent");
    c0(this, {
      title: r,
      description: r,
      position: r,
      minPercentageCompletion: r,
      minScoreCompletion: r,
      questions: r,
      files: r,
      countingMethod: r,
      shuffle: r,
      isCompleted: r,
      parent: r,
      update: I
    }), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e, p) {
    return new Zc({
      ...e,
      files: e.files ? e.files.map(g1.fromJson) : void 0,
      parent: p
    });
  }
}
class jc extends H1 {
  constructor(e) {
    super();
    o(this, "options");
    c0(this, {
      options: r
    }), e && this.update(e);
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new jc({
      options: [],
      ...e
    });
  }
}
class $h {
  static build(t, e) {
    const p = e ? JSON.parse(e) : null;
    switch (t) {
      case fc.MonoSelect:
      case fc.MultiSelect:
        return jc.fromJson(p);
      default:
        return p;
    }
  }
}
var fc = /* @__PURE__ */ ((M) => (M.TextField = "textField", M.TextArea = "textArea", M.Checkbox = "checkbox", M.MultiSelect = "multiSelect", M.MonoSelect = "monoSelect", M))(fc || {});
class Up extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "placeholder");
    o(this, "description");
    o(this, "required");
    o(this, "position");
    o(this, "type");
    o(this, "task");
    o(this, "settings");
    c0(this, {
      title: r,
      placeholder: r,
      description: r,
      required: r,
      position: r,
      type: r,
      task: r,
      settings: r,
      update: I
    }), e && this.update(e);
  }
  get listSettings() {
    return this.settings;
  }
  get isListType() {
    return this.type == "monoSelect" || this.type == "multiSelect";
  }
  toJson() {
    var e;
    return {
      id: this.id,
      title: this.title,
      placeholder: this.placeholder,
      description: this.description,
      required: this.required,
      position: this.position,
      type: this.type,
      taskId: (e = this.task) == null ? void 0 : e.id,
      additionalData: this.settings ? JSON.stringify(this.settings) : void 0
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new Up({
      id: e.id,
      title: e.title,
      placeholder: e.placeholder,
      description: e.description,
      required: e.required,
      position: e.position,
      type: e.type,
      task: e.task ? Hp.fromJson(e.task) : void 0,
      settings: $h.build(e.type, e.additionalData)
    });
  }
}
class Rp extends M0 {
  constructor(e) {
    super();
    o(this, "stringValue");
    o(this, "booleanValue");
    o(this, "listValue");
    o(this, "listLabelValue");
    o(this, "multiListValue");
    o(this, "multiListLabelValue");
    o(this, "field");
    c0(this, {
      stringValue: r,
      booleanValue: r,
      listValue: r,
      listLabelValue: r,
      multiListValue: r,
      multiListLabelValue: r,
      field: r,
      update: I
    }), e && this.update(e);
  }
  get value() {
    if (this.booleanValue !== void 0) return this.booleanValue;
    if (this.stringValue !== void 0) return this.stringValue;
    if (this.listValue !== void 0) return this.listValue;
    if (this.multiListValue !== void 0) return this.multiListValue;
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  isEquals(e) {
    return this.field.id != e.field.id ? !1 : this.booleanValue !== void 0 ? this.booleanValue === e.booleanValue : this.listValue !== void 0 ? this.listValue === e.listValue : this.multiListValue !== void 0 ? this.multiListValue === e.multiListValue : this.stringValue === e.stringValue;
  }
  copy() {
    var e, p;
    return new Rp({
      id: this.id,
      field: this.field,
      stringValue: this.stringValue,
      booleanValue: this.booleanValue,
      listValue: this.listValue,
      listLabelValue: this.listLabelValue,
      multiListValue: (e = this.multiListValue) == null ? void 0 : e.slice(),
      multiListLabelValue: (p = this.multiListLabelValue) == null ? void 0 : p.slice()
    });
  }
  get valueJson() {
    return typeof this.value == "object" ? JSON.stringify(this.value) : this.value;
  }
  toJson() {
    return {
      id: this.field.id,
      value: this.valueJson
    };
  }
  static fromJson(e) {
    return new Rp({
      id: e.id,
      stringValue: e.stringValue ?? void 0,
      booleanValue: e.booleanValue ?? void 0,
      listValue: e.listValue ?? void 0,
      listLabelValue: e.listLabelValue ?? void 0,
      multiListValue: e.multiListValue ? JSON.parse(e.multiListValue) : void 0,
      multiListLabelValue: e.multiListLabelValue ? JSON.parse(e.multiListLabelValue) : void 0,
      field: e.field ? Up.fromJson(e.field) : void 0
    });
  }
}
class k8 extends I0 {
  constructor(e) {
    super();
    o(this, "contactId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class eb extends M0 {
  constructor(e) {
    super();
    o(this, "image");
    o(this, "title");
    o(this, "type");
    c0(this, {
      image: r,
      title: r,
      type: r,
      update: I
    }), e && this.update(e);
  }
  clone() {
    return new eb({
      ...this,
      image: this.image ? new D1(this.image) : null
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new eb({
      ...e,
      image: e.image ? D1.fromJson(e.image) : null
    });
  }
}
class Lp extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    /**
     * Null when this object stands for an AI agent (the author of a curator comment on a task answer):
     * since the 2026-08 agents migration the server sends `application: null` + `agentType` there.
     */
    o(this, "application", null);
    /** `'curator'` for the AI curator's comments; null for a real installed app. */
    o(this, "agentType", null);
    c0(this, {
      title: r,
      application: r,
      agentType: r,
      update: I
    }), e && this.update(e);
  }
  clone() {
    return new Lp({
      ...this,
      application: this.application ? new eb(this.application) : null
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new Lp({
      ...e,
      application: e.application ? eb.fromJson(e.application) : null,
      agentType: e.agentType ?? null
    });
  }
}
class sb extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "comment");
    o(this, "contact", null);
    o(this, "admin", null);
    o(this, "schoolApp", null);
    o(this, "files", []);
    c0(this, {
      createdDate: r,
      updatedDate: r,
      comment: r,
      contact: r,
      admin: r,
      schoolApp: r,
      files: r,
      update: I
    }), e && this.update(e);
  }
  get author() {
    var e, p;
    if (this.schoolApp) {
      const c = this.schoolApp.title ?? ((e = this.schoolApp.application) == null ? void 0 : e.title) ?? null;
      return {
        id: this.schoolApp.id,
        firstName: c,
        fullName: c,
        avatar: ((p = this.schoolApp.application) == null ? void 0 : p.image) ?? null
      };
    }
    return this.contact ?? this.admin;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new sb({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      admin: e.admin ? ut.fromJson(e.admin) : void 0,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      files: e.files ? e.files.map(g1.fromJson) : [],
      schoolApp: e.schoolApp ? Lp.fromJson(e.schoolApp) : void 0
    });
  }
}
class Vh extends I0 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "answerId");
    o(this, "adminId");
    o(this, "studentId");
    o(this, "createdDateLessThan");
    c0(this, {
      id: r,
      answerId: r,
      adminId: r,
      studentId: r,
      createdDateLessThan: r
    }), e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var Wc = /* @__PURE__ */ ((M) => (M.Default = "default", M.Pending = "pending", M.Incorrect = "incorrect", M.Correct = "correct", M.Incomplete = "incomplete", M.Editing = "editing", M))(Wc || {});
class Jp extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "text");
    o(this, "contact");
    o(this, "status");
    o(this, "comments");
    o(this, "commentCount");
    o(this, "files");
    o(this, "fields");
    c0(this, {
      createdDate: r,
      updatedDate: r,
      text: r,
      contact: r,
      status: r,
      comments: r,
      commentCount: r,
      files: r,
      fields: r,
      setFieldValue: I,
      update: I
    }), e && this.update(e);
  }
  getFieldValue(e) {
    return this.fields.find((c) => c.field.id == e) ?? null;
  }
  setFieldValue(e) {
    const p = this.getFieldValue(e.field.id);
    p ? p.update(e, !0) : this.fields.push(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Jp({
      ...e,
      text: I1.isEmpty(e.text) ? void 0 : e.text,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      comments: e.comments ? e.comments.map(sb.fromJson) : void 0,
      files: e.files ? e.files.map(g1.fromJson) : void 0,
      fields: e.studentAnswerFields ? e.studentAnswerFields.map(Rp.fromJson) : void 0
    });
  }
}
class Hp extends M0 {
  constructor(e) {
    super();
    o(this, "question");
    o(this, "description");
    o(this, "correctAnswer");
    o(this, "position");
    o(this, "files");
    o(this, "disableVerification");
    o(this, "fields");
    o(this, "answer");
    o(this, "parent");
    c0(this, {
      question: r,
      description: r,
      correctAnswer: r,
      position: r,
      files: r,
      disableVerification: r,
      fields: r,
      hasDescription: Y,
      hasQuestion: Y,
      answer: r,
      parent: r,
      status: Y,
      isCompleted: Y,
      update: I
    }), e && this.update(e);
  }
  get hasDescription() {
    return !I1.isEmpty(this.description);
  }
  get hasQuestion() {
    return !I1.isEmpty(this.question);
  }
  get status() {
    var e;
    return ((e = this.answer) == null ? void 0 : e.status) || Wc.Default;
  }
  get isCompleted() {
    return this.status === Wc.Correct;
  }
  static fromJson(e, p) {
    return new Hp({
      ...e,
      files: e.files ? e.files.map(g1.fromJson) : void 0,
      answer: e.answer ? Jp.fromJson(e.answer) : void 0,
      fields: e.fields ? e.fields.map(Up.fromJson) : void 0,
      parent: p
    });
  }
  update(e) {
    super.update(e);
  }
}
const at = class at extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "position");
    o(this, "isDraft");
    o(this, "isOptional");
    /** The section's / step's picture in the course program (`fileProvider.getUrlByKey`); null — none. */
    o(this, "imageCloudKey");
    o(this, "type");
    o(this, "comment");
    // restrictions and availability
    o(this, "allowComments");
    o(this, "showComments");
    o(this, "disableCommentModeration");
    o(this, "ratingEnabled");
    o(this, "ratingRequired");
    o(this, "ratingCommentRequired");
    /** Average rating of the step over all students (1..5); null when nobody rated it or the server does not send it. */
    o(this, "ratingAverage", null);
    /** How many students rated the step; 0 when the server does not send it. */
    o(this, "ratingCount", 0);
    o(this, "availability");
    o(this, "disableTimeLimits");
    o(this, "regularTimeDelayActive");
    o(this, "regularTimeDelay");
    o(this, "regularTimeDelayCondition");
    o(this, "regularTimeDelayMeasureType");
    o(this, "regularWaitUntilTimeActive");
    o(this, "regularWaitUntilTime");
    o(this, "regularWaitUntilTimeDaysOfWeekActive");
    o(this, "regularWaitUntilDaysOfWeek");
    o(this, "flowTimeDelayActive");
    o(this, "flowTimeDelay");
    o(this, "flowTimeDelayCondition");
    o(this, "flowTimeDelayMeasureType");
    o(this, "flowWaitUntilTimeActive");
    o(this, "flowWaitUntilTime");
    o(this, "flowWaitUntilTimeDaysOfWeekActive");
    o(this, "flowWaitUntilDaysOfWeek");
    o(this, "dateDelayActive");
    o(this, "dateDelay");
    o(this, "preventCopingAndSelectingText");
    o(this, "designHTMLPublished");
    o(this, "designStylePublished");
    /** Theory render mode. `legacy` (default) = the fields above; `custom` = `customTheoryHtml`. */
    o(this, "layoutType");
    /** Theory markup when `layoutType === Custom`. Null when the step hides its theory. */
    o(this, "customTheoryHtml");
    /** Palette/fonts head of a theory made in the site page editor; null for older HTML and when theory is hidden. */
    o(this, "headHtml");
    o(this, "blockCourseUntilTasksApproved");
    o(this, "theoryVisible");
    o(this, "tasksVisible");
    o(this, "testsVisible");
    o(this, "score");
    o(this, "files");
    o(this, "progress");
    o(this, "tests", []);
    o(this, "tasks", []);
    o(this, "requiredPlans");
    o(this, "currentTest", null);
    o(this, "parent");
    o(this, "parentItemId");
    o(this, "children", []);
    o(this, "previousItem");
    o(this, "nextItem");
    o(this, "studentCourse");
    o(this, "course");
    o(this, "fetching");
    /** 
     * position regarding all steps
    */
    o(this, "globalPosition");
    /**
     * level of the item in the tree
     */
    o(this, "level");
    o(this, "schoolTimezone");
    o(this, "_tab");
    c0(this, {
      title: r,
      position: r,
      isDraft: r,
      isOptional: r,
      imageCloudKey: r,
      type: r,
      comment: r,
      allowComments: r,
      showComments: r,
      disableCommentModeration: r,
      ratingEnabled: r,
      ratingRequired: r,
      ratingCommentRequired: r,
      ratingAverage: r,
      ratingCount: r,
      availability: r,
      disableTimeLimits: r,
      regularTimeDelayActive: r,
      regularTimeDelay: r,
      regularTimeDelayCondition: r,
      regularTimeDelayMeasureType: r,
      regularWaitUntilTimeActive: r,
      regularWaitUntilTime: r,
      regularWaitUntilTimeDaysOfWeekActive: r,
      regularWaitUntilDaysOfWeek: r,
      flowTimeDelayActive: r,
      flowTimeDelay: r,
      flowTimeDelayCondition: r,
      flowTimeDelayMeasureType: r,
      flowWaitUntilTimeActive: r,
      flowWaitUntilTime: r,
      flowWaitUntilTimeDaysOfWeekActive: r,
      flowWaitUntilDaysOfWeek: r,
      dateDelayActive: r,
      dateDelay: r,
      preventCopingAndSelectingText: r,
      designHTMLPublished: r,
      designStylePublished: r,
      layoutType: r,
      customTheoryHtml: r,
      headHtml: r,
      blockCourseUntilTasksApproved: r,
      theoryVisible: r,
      tasksVisible: r,
      testsVisible: r,
      ratingVisible: Y,
      score: r,
      files: r,
      progress: r,
      tests: r,
      tasks: r,
      requiredPlans: r,
      currentTest: r,
      parent: r,
      parentItemId: r,
      children: r,
      previousItem: r,
      nextItem: r,
      studentCourse: r,
      course: r,
      fetching: r,
      previousSection: Y,
      firstAvailableTab: Y,
      itemCount: Y,
      itemCompletedCount: Y,
      stepCount: Y,
      taskCount: Y,
      taskCompletedCount: Y,
      sectionProgress: Y,
      ratingCompleted: Y,
      completed: Y,
      beginDate: Y,
      completeDate: Y,
      precompleted: Y,
      fullPosition: Y,
      _tab: r,
      tab: Y,
      defaultTab: Y,
      canSelect: Y,
      previousRequiredItem: Y,
      previousAccessibleItem: Y,
      nextAccessibleItem: Y,
      hasAccessibleItems: Y,
      accessibleChildren: Y,
      courseItemAvailability: Y,
      parentAvailability: Y,
      availabilityRelativeToTimeDelay: Y,
      availabilityRelativeToOther: Y,
      hasPlanAccess: Y,
      hasAccessGrantedByAdmin: Y,
      canSkip: Y,
      update: I,
      regularTimeDelayValue: Y,
      flowTimeDelayValue: Y
    }), this._tab = this.defaultTab, e && this.update(e);
  }
  get ratingVisible() {
    return this.allowComments || this.ratingEnabled;
  }
  /**
   * returns the nearest previous section on the same level is exists
   */
  get previousSection() {
    var p, c, i;
    let e = ((p = this.previousItem) == null ? void 0 : p.parent) ?? null;
    for (; e != null; ) {
      if (((c = e.parent) == null ? void 0 : c.id) === ((i = this.parent) == null ? void 0 : i.id))
        return e;
      e = e.parent ?? null;
    }
    return null;
  }
  get firstAvailableTab() {
    return this.theoryVisible ? "theory" : this.testsVisible ? "tests" : this.tasksVisible ? "tasks" : this.ratingVisible ? "rating" : "theory";
  }
  get itemCount() {
    if (this.type == L1.Step) return 0;
    let e = this.children.length;
    for (const p of this.children)
      e += p.itemCount;
    return e;
  }
  get itemCompletedCount() {
    if (this.type == L1.Step) return 0;
    let e = this.children.filter((p) => p.completed).length;
    for (const p of this.children)
      e += p.itemCompletedCount;
    return e;
  }
  get stepCount() {
    if (this.type == L1.Step) return 0;
    let e = this.children.count((p) => p.type == L1.Step);
    for (const p of this.children)
      e += p.stepCount;
    return e;
  }
  get taskCount() {
    return this.type == L1.Step ? this.tasks.length : this.children.reduce((e, p) => e + p.taskCount, 0);
  }
  get taskCompletedCount() {
    var e;
    return this.type == L1.Step ? ((e = this.progress) == null ? void 0 : e.numberCorrectTasks) ?? 0 : this.children.reduce((p, c) => p + c.taskCompletedCount, 0);
  }
  get sectionProgress() {
    const e = new Ih();
    let p = !0;
    for (const c of this.accessibleChildren) {
      const i = c.type == L1.Section ? c.sectionProgress : c.progress;
      if (!i) {
        p = !1, e.completeDate = null;
        continue;
      }
      e.numberCorrectTasks += i.numberCorrectTasks, e.numberIncorrectTasks += i.numberIncorrectTasks, e.numberUncheckedTasks += i.numberUncheckedTasks, p && (i.completeDate ? (!e.completeDate || e.completeDate < i.completeDate) && (e.completeDate = i.completeDate) : (p = !1, e.completeDate = null)), i.beginDate && (!e.beginDate || e.beginDate > i.beginDate) && (e.beginDate = i.beginDate);
    }
    return e;
  }
  get ratingCompleted() {
    var e, p;
    return !this.ratingEnabled || !this.ratingRequired ? !0 : ((e = this.progress) == null ? void 0 : e.rating) == null ? !1 : this.ratingCommentRequired ? ((p = this.progress.rating.comment) == null ? void 0 : p.length) > 0 : !0;
  }
  get completed() {
    var e, p;
    return this.type == L1.Step ? ((e = this.progress) == null ? void 0 : e.completeDate) != null : ((p = this.sectionProgress) == null ? void 0 : p.completeDate) != null;
  }
  get beginDate() {
    var e, p;
    return this.type == L1.Step ? (e = this.progress) == null ? void 0 : e.beginDate : (p = this.sectionProgress) == null ? void 0 : p.beginDate;
  }
  get completeDate() {
    var e, p;
    return this.type == L1.Step ? (e = this.progress) == null ? void 0 : e.completeDate : (p = this.sectionProgress) == null ? void 0 : p.completeDate;
  }
  // a completed step is precompleted too, even when an import wrote only completeDate
  get precompleted() {
    var e, p;
    return ((e = this.progress) == null ? void 0 : e.precompleteDate) != null || ((p = this.progress) == null ? void 0 : p.completeDate) != null;
  }
  get fullPosition() {
    let e = "", p = this.parent;
    for (; p != null; )
      e += `${p.position}.`, p = p.parent;
    return e += this.position, e;
  }
  get tab() {
    return this._tab;
  }
  set tab(e) {
    switch (e) {
      case "theory": {
        if (this.theoryVisible) {
          this._tab = "theory";
          return;
        }
        break;
      }
      case "tests": {
        if (this.testsVisible) {
          this._tab = "tests";
          return;
        }
        break;
      }
      case "tasks": {
        if (this.tasksVisible) {
          this._tab = "tasks";
          return;
        }
        break;
      }
      case "rating": {
        if (this.allowComments || this.ratingEnabled) {
          this._tab = "rating";
          return;
        }
        break;
      }
    }
  }
  get defaultTab() {
    return this.progress == null || this.theoryVisible && !this.progress.theoryCompleted ? "theory" : this.testsVisible && !this.progress.testsCompleted ? "tests" : this.tasksVisible && !this.progress.tasksCompleted ? "tasks" : "theory";
  }
  get canSelect() {
    return this.courseItemAvailability.result;
  }
  get previousRequiredItem() {
    return this.previousAccessibleItem == null ? null : this.previousAccessibleItem.canSkip ? this.previousAccessibleItem.previousRequiredItem : this.previousAccessibleItem;
  }
  get previousAccessibleItem() {
    return this.previousItem == null ? null : this.previousItem.hasPlanAccess ? this.previousItem : this.previousItem.previousAccessibleItem;
  }
  /**
   * returns the next item regarding to plan access (skip unavalaible items)
   */
  get nextAccessibleItem() {
    return this.nextItem == null ? null : this.nextItem.hasPlanAccess ? this.nextItem : this.nextItem.nextAccessibleItem;
  }
  get hasAccessibleItems() {
    if (this.type != L1.Section || this.children.length == 0)
      return !1;
    for (const e of this.children)
      if (e.hasPlanAccess && (e.type == L1.Step || e.hasAccessibleItems))
        return !0;
    return !1;
  }
  /**
   * returns all children (sections and steps) that have plan access
   */
  get accessibleChildren() {
    return this.children.filter((e) => e.hasPlanAccess);
  }
  hasAncestor(e) {
    let p = this.parent;
    for (; p; ) {
      if (p == e) return !0;
      p = p.parent;
    }
    return !1;
  }
  get courseItemAvailability() {
    if (this.progress != null && this.progress.status == "opened")
      return { result: !0 };
    if (!this.hasPlanAccess)
      return { result: !1, requiredPlans: this.requiredPlans };
    if (!this.availabilityRelativeToTimeDelay.result)
      return this.availabilityRelativeToTimeDelay;
    const e = this.parentAvailability;
    return e.result ? this.availabilityRelativeToOther.result ? { result: !0 } : this.availabilityRelativeToOther : { ...e, isSection: !0 };
  }
  get parentAvailability() {
    return this.parent != null ? this.parent.courseItemAvailability : { result: !0 };
  }
  get availabilityRelativeToTimeDelay() {
    if (this.disableTimeLimits) return { result: !0 };
    if (!this.studentCourse) return { result: !0 };
    if (this.flowTimeDelayActive && this.studentCourse.isInCohort)
      switch (this.flowTimeDelayCondition) {
        case Je.CourseStart: {
          const c = h1(), i = this.calculateDelay(
            h1(this.studentCourse.beginDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Je.FlowStart: {
          if (this.studentCourse.cohortBeginDate == null)
            break;
          const c = h1(), i = this.calculateDelay(
            h1(this.studentCourse.cohortBeginDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Je.PreviousStep: {
          if (!this.previousAccessibleItem)
            break;
          if (!this.previousAccessibleItem.precompleted)
            return { result: !1, needToCompletePrevStep: !0 };
          const c = h1(), i = this.calculateDelay(
            h1(this.previousAccessibleItem.progress.precompleteDate),
            this.flowTimeDelayValue,
            this.flowWaitUntilTimeActive,
            this.flowWaitUntilTime,
            this.flowWaitUntilTimeDaysOfWeekActive,
            this.flowWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Je.PreviousSectionStarted:
        case Je.PreviousSectionCompleted: {
          const c = this.previousSection;
          if (c && c.hasAccessibleItems) {
            const i = this.flowTimeDelayCondition == Je.PreviousSectionStarted ? c.beginDate : c.completeDate;
            if (i) {
              const s = h1(), u = this.calculateDelay(
                h1(i),
                this.flowTimeDelayValue,
                this.flowWaitUntilTimeActive,
                this.flowWaitUntilTime,
                this.flowWaitUntilTimeDaysOfWeekActive,
                this.flowWaitUntilDaysOfWeek
              );
              if (s <= u)
                return { result: !1, willBeAvailableOn: u };
            } else
              return {
                result: !1,
                willBeAvailableIf: {
                  in: this.flowTimeDelayValue,
                  item: c,
                  condition: this.flowTimeDelayCondition == Je.PreviousSectionStarted ? "afterStart" : "afterComplete"
                }
              };
          }
          break;
        }
      }
    if (this.regularTimeDelayActive)
      switch (this.regularTimeDelayCondition) {
        case Ue.AccessStart: {
          const c = h1(), i = this.calculateDelay(
            h1(this.studentCourse.accessBeginDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Ue.CourseStart: {
          const c = h1(), i = this.calculateDelay(
            h1(this.studentCourse.beginDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Ue.PreviousStep: {
          if (!this.previousAccessibleItem)
            break;
          if (!this.previousAccessibleItem.precompleted)
            return { result: !1, needToCompletePrevStep: !0 };
          const c = h1(), i = this.calculateDelay(
            h1(this.previousAccessibleItem.progress.precompleteDate),
            this.regularTimeDelayValue,
            this.regularWaitUntilTimeActive,
            this.regularWaitUntilTime,
            this.regularWaitUntilTimeDaysOfWeekActive,
            this.regularWaitUntilDaysOfWeek
          );
          if (c <= i)
            return { result: !1, willBeAvailableOn: i };
          break;
        }
        case Ue.PreviousSectionStarted:
        case Ue.PreviousSectionCompleted: {
          const c = this.previousSection;
          if (c && c.hasAccessibleItems) {
            const i = this.regularTimeDelayCondition == Ue.PreviousSectionStarted ? c.beginDate : c.completeDate;
            if (i) {
              const s = h1(), u = this.calculateDelay(
                h1(i),
                this.regularTimeDelayValue,
                this.regularWaitUntilTimeActive,
                this.regularWaitUntilTime,
                this.regularWaitUntilTimeDaysOfWeekActive,
                this.regularWaitUntilDaysOfWeek
              );
              if (s <= u)
                return { result: !1, willBeAvailableOn: u };
            } else
              return {
                result: !1,
                willBeAvailableIf: {
                  in: this.regularTimeDelayValue,
                  item: c,
                  condition: this.regularTimeDelayCondition == Ue.PreviousSectionStarted ? "afterStart" : "afterComplete"
                }
              };
          }
          break;
        }
      }
    return this.dateDelayActive && this.dateDelay != null && !h1().isAfter(this.dateDelay) ? { result: !1, willBeAvailableOn: this.dateDelay } : { result: !0 };
  }
  get availabilityRelativeToOther() {
    var e;
    switch (this.availability) {
      case dp.RegardlessOfPreviousSteps: {
        let p = this.previousRequiredItem;
        for (; p; ) {
          if (p.blockCourseUntilTasksApproved == !0) {
            if (p.completed == !1) {
              if (((e = p.nextAccessibleItem) == null ? void 0 : e.progress) != null) break;
              return { result: !1, blockingCourseItem: p };
            }
            break;
          }
          p = p.previousRequiredItem;
        }
        break;
      }
      case dp.AllPreviousStepsCompleted: {
        let p = this.previousRequiredItem;
        for (; p; ) {
          if (p.blockCourseUntilTasksApproved == !0 && p.completed == !1)
            return { result: !1, blockingCourseItem: p };
          if (p.blockCourseUntilTasksApproved == !1 && p.precompleted == !1)
            return { result: !1, blockingCourseItem: p };
          p = p.previousRequiredItem;
        }
        break;
      }
      case dp.PreviousStepCompleted: {
        if (!this.previousRequiredItem)
          break;
        if (this.previousRequiredItem.blockCourseUntilTasksApproved == !0 && this.previousRequiredItem.completed == !1)
          return { result: !1, blockingCourseItem: this.previousRequiredItem };
        if (this.previousRequiredItem.blockCourseUntilTasksApproved == !1 && this.previousRequiredItem.precompleted == !1)
          return { result: !1, blockingCourseItem: this.previousRequiredItem };
        break;
      }
    }
    return { result: !0 };
  }
  get hasPlanAccess() {
    var e;
    return this.hasAccessGrantedByAdmin || ((e = this.requiredPlans) == null ? void 0 : e.length) == 0;
  }
  get hasAccessGrantedByAdmin() {
    var e;
    return this.type == L1.Step ? ((e = this.progress) == null ? void 0 : e.status) == "opened" : this.children.some((p) => p.hasAccessGrantedByAdmin);
  }
  get canSkip() {
    return this.isOptional == !0 || !this.hasPlanAccess;
  }
  update(e) {
    super.update(e);
  }
  get regularTimeDelayValue() {
    return I1.isNil(this.regularTimeDelay) ? c1.zero : c1.fromTimeMeasure(this.regularTimeDelay, this.regularTimeDelayMeasureType ?? "days");
  }
  get flowTimeDelayValue() {
    return I1.isNil(this.flowTimeDelay) ? c1.zero : c1.fromTimeMeasure(this.flowTimeDelay, this.flowTimeDelayMeasureType ?? "days");
  }
  calculateDelay(e, p, c, i, s, u) {
    let l = h1(e).utc().tz(this.schoolTimezone.id);
    if (l.add(p, "milliseconds"), c) {
      const L = h1(i).utc().tz(this.schoolTimezone.id), m = L.hours(), X = L.minutes();
      let D = l.clone().hours(m).minutes(X).startOf("minute");
      D.isBefore(l) && D.add(1, "day"), l = D;
    }
    if (s && u && u.length > 0) {
      const L = u.map((m) => at.DayOfWeekMap[m]);
      for (; !L.includes(l.day()); )
        l.add(1, "day");
    }
    const W = h1.tz.guess();
    return l.tz(W);
  }
  static fromJson(e) {
    const p = new at({
      ...e,
      ratingAverage: typeof e.ratingAverage == "number" ? e.ratingAverage : null,
      ratingCount: typeof e.ratingCount == "number" ? e.ratingCount : 0,
      plans: e.plans ? e.plans.map((c) => OM.fromJson(c.coursePlan)) : void 0,
      parent: e.parentItem ? at.fromJson(e.parentItem) : void 0,
      children: e.children ? e.children.map((c) => at.fromJson(c)) : void 0,
      course: e.course ? be.fromJson(e.course) : void 0,
      files: e.files ? e.files.map((c) => D1.fromJson(c)) : [],
      progress: e.progress ? Fp.fromJson(e.progress) : void 0,
      tests: [],
      tasks: [],
      dateDelay: e.dateDelay ? h1(e.dateDelay) : void 0,
      regularWaitUntilTime: e.regularWaitUntilTime ? h1(e.regularWaitUntilTime) : void 0,
      flowWaitUntilTime: e.flowWaitUntilTime ? h1(e.flowWaitUntilTime) : void 0
    });
    return e.tasks && (p.tasks = e.tasks.map((c) => Hp.fromJson(c, p))), e.tests && (p.tests = e.tests.map((c) => Zc.fromJson(c, p))), p;
  }
};
o(at, "DayOfWeekMap", {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
});
let Le = at;
class qa extends I0 {
  constructor(e) {
    super();
    o(this, "studentCourseId");
    /**
     * Item we'd like to select
     * In addition to root branch, request the item section branch
     */
    o(this, "courseItemId");
    /**
     * Request only the section items
     */
    o(this, "sectionId");
    this.sortName = "position", this.sortType = "Asc", e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class en extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "shortDescription");
    o(this, "freeAccess");
    o(this, "isCompleteAnyCourseRequirement");
    o(this, "primaryImageCloudKey");
    o(this, "studentCourse");
    o(this, "studentAccessDate");
    o(this, "studentHasAccess");
    o(this, "categories");
    o(this, "requirements");
    o(this, "certId");
    o(this, "paymentUrl");
    o(this, "studentCanBuyAccess");
    c0(this, {
      title: r,
      shortDescription: r,
      freeAccess: r,
      isCompleteAnyCourseRequirement: r,
      primaryImageCloudKey: r,
      studentCourse: r,
      studentAccessDate: r,
      studentHasAccess: r,
      categories: r,
      requirements: r,
      certId: r,
      paymentUrl: r,
      studentCanBuyAccess: r,
      hasRequirements: Y,
      hasCourseItem: Y,
      update: I
    }), e && this.update(e);
  }
  get hasRequirements() {
    return this.requirements && this.requirements.length > 0;
  }
  get hasCourseItem() {
    return this.studentCourse && this.studentCourse.currentCourseItem;
  }
  static fromJson(e) {
    var p, c;
    return new en({
      ...e,
      studentAccessDate: e.studentAccessDate ? new Date(e.studentAccessDate) : void 0,
      studentCourse: e.studentCourse ? aM.fromJson(e.studentCourse) : void 0,
      certId: e.cert ? (c = (p = e.cert) == null ? void 0 : p.image) == null ? void 0 : c.id : void 0
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
}
class YM extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "description");
    o(this, "coverCloudKey");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "position");
    o(this, "parentId");
    o(this, "parent");
    o(this, "course");
    o(this, "library");
    o(this, "type");
    o(this, "sectionType");
    o(this, "children");
    e && this.update(e);
  }
  get progress() {
    var p, c;
    if (this.sectionType == "library") return 0;
    if (this.type == "item")
      return ((c = (p = this.course) == null ? void 0 : p.studentCourse) == null ? void 0 : c.progress) ?? 0;
    let e = 0;
    return this.children.forEach((i) => e += i.progress), e > 0 && (e = Math.floor(e / this.children.length)), e;
  }
  get itemCount() {
    if (this.type == "item") return 1;
    let e = 0;
    for (const p of this.children)
      e += p.itemCount;
    return e;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    const p = new YM({
      id: e.id,
      title: e.title,
      description: e.description,
      type: e.type,
      sectionType: e.sectionType,
      position: e.position,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      coverCloudKey: e.coverCloudKey,
      parentId: e.parentId,
      parent: e.parent ? YM.fromJson(e.parent) : e.parent === null ? null : void 0,
      course: e.course ? en.fromJson(e.course) : void 0,
      library: e.library ? Ne.fromJson(e.library) : void 0,
      children: e.children ? e.children.map(YM.fromJson) : []
    });
    return p.children.forEach((c) => c.update({ parent: p })), p;
  }
}
class Kh extends I0 {
  constructor(e) {
    super(e);
    o(this, "courseType");
    o(this, "onlyAvailable");
    o(this, "sectionType");
    e && this.update(e);
  }
}
class hc extends M0 {
  constructor(e) {
    super();
    o(this, "email");
    o(this, "emailNeedConfirm");
    o(this, "blockAccessIfEmailUnconfirmed");
    o(this, "blockEmailChange");
    o(this, "phone");
    o(this, "phoneRequired");
    o(this, "phoneNeedConfirm");
    o(this, "blockAccessIfPhoneUnconfirmed");
    o(this, "firstName");
    o(this, "firstNameRequired");
    o(this, "lastName");
    o(this, "lastNameRequired");
    o(this, "middleName");
    o(this, "middleNameRequired");
    o(this, "birthday");
    o(this, "birthdayRequired");
    o(this, "gender");
    o(this, "genderRequired");
    e && this.update(e);
  }
  clone() {
    return new hc({
      ...this
    });
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new hc({
      ...e
    });
  }
}
class mc extends M0 {
  constructor(e) {
    super();
    o(this, "registrationAgreementText");
    o(this, "isRegistrationAgreementEnabled");
    o(this, "isCookieNotificationEnabled");
    o(this, "cookieNotificationText");
    o(this, "footerHtml");
    o(this, "isPageFooterEnabled");
    o(this, "isLearnPageFooterEnabled");
    e && this.update(e);
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  copy() {
    return new mc({
      id: this.id,
      registrationAgreementText: this.registrationAgreementText,
      isRegistrationAgreementEnabled: this.isRegistrationAgreementEnabled,
      footerHtml: this.footerHtml,
      isPageFooterEnabled: this.isPageFooterEnabled,
      isLearnPageFooterEnabled: this.isLearnPageFooterEnabled,
      cookieNotificationText: this.cookieNotificationText,
      isCookieNotificationEnabled: this.isCookieNotificationEnabled
    });
  }
  static fromJson(e) {
    return new mc({
      ...e,
      footerHtml: e.footerText
    });
  }
}
var Qh = /* @__PURE__ */ ((M) => (M.Created = "created", M.CheckoutData = "checkoutData", M.Payment = "payment", M.PartiallyPaid = "partiallyPaid", M.Paid = "paid", M.PreparingShipment = "preparingShipment", M.Shipped = "shipped", M.Fulfilled = "fulfilled", M.Canceled = "canceled", M.Refund = "refund", M))(Qh || {});
class sM extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "paidDate");
    o(this, "currency");
    o(this, "isDigitalDelivery");
    o(this, "fullyPaid");
    o(this, "shippingPrice");
    o(this, "number");
    o(this, "totalAmount");
    o(this, "paidAmount");
    o(this, "savingsAmount");
    o(this, "paidBonusAmount");
    o(this, "feeAmount");
    o(this, "contact");
    o(this, "completed");
    o(this, "status");
    o(this, "contents");
    e && this.update(e);
  }
  get isPartiallyPaid() {
    return this.paidAmount > 0 && this.paidAmount < this.totalAmount;
  }
  toJson() {
    return {
      ...this
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new sM({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      contact: e.contact ? l1.fromJson(e.contact) : null,
      contents: e.contents ? e.contents.map(tn.fromJson) : [],
      paidDate: e.paidDate ? R(e.paidDate) : null
    });
  }
}
class Zh extends I0 {
  constructor(e) {
    super();
    o(this, "createdFromDate");
    o(this, "createdToDate");
    o(this, "paidFromDate");
    o(this, "paidToDate");
    o(this, "status");
    o(this, "number");
    o(this, "currency");
    o(this, "isDigitalDelivery");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var jh = /* @__PURE__ */ ((M) => (M.Digital = "digital", M.Physical = "physical", M.Service = "service", M.Material = "material", M.Subscription = "subscription", M.Cohort = "cohort", M))(jh || {});
class AM extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "price");
    o(this, "type");
    o(this, "subsPrice");
    o(this, "subsDuration");
    o(this, "subsDurationType");
    o(this, "image");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new AM({
      ...e,
      image: e.image ? g1.fromJson(e.image) : void 0
    });
  }
}
class tn extends M0 {
  constructor(e) {
    super();
    o(this, "quantity");
    o(this, "product");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new tn({
      ...e,
      product: e.product ? AM.fromJson(e.product) : void 0
    });
  }
}
class Mn extends M0 {
  constructor(e) {
    super();
    o(this, "beginDate");
    o(this, "endDate");
    e && this.update(e);
  }
  get periodInDays() {
    return this.beginDate != null && this.endDate != null ? this.endDate.diff(this.beginDate, "days") : 0;
  }
  get isActive() {
    return this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Mn({
      ...e,
      beginDate: e.beginDate ? R(e.beginDate) : void 0,
      endDate: e.endDate ? R(e.endDate) : null
    });
  }
}
class tb extends M0 {
  constructor(e) {
    super();
    o(this, "beginDate");
    o(this, "endDate");
    o(this, "creditEndDate");
    o(this, "type");
    o(this, "state");
    o(this, "product");
    o(this, "currentSuspension");
    o(this, "course");
    o(this, "coursePlan");
    o(this, "library");
    e && this.update(e);
  }
  get isActive() {
    return this.endDate == null ? this.beginDate.isSameOrBefore(R()) : this.beginDate.isSameOrBefore() && this.endDate.isAfter();
  }
  get isSuspended() {
    return this.currentSuspension != null;
  }
  get isBeginInFuture() {
    return this.beginDate.isAfter(R());
  }
  //#region Subscription
  get isSubscriptionActive() {
    return this.beginDate.isSameOrBefore() && (this.creditEndDate && this.creditEndDate.isAfter() || !this.creditEndDate && this.endDate && this.endDate.isAfter() || this.endDate == null);
  }
  get isSubscriptionEnding() {
    return this.isSubscriptionActive && this.endDate && this.creditEndDate && this.endDate.isSameOrBefore() && this.creditEndDate.isAfter();
  }
  get isSubscriptionEnded() {
    return !this.isSubscriptionActive && this.endDate && this.creditEndDate && this.creditEndDate.isSameOrBefore();
  }
  get canPauseSubscription() {
    return this.state == "active";
  }
  get canContinueSubscription() {
    return this.state == "paused" && !this.isSubscriptionEnded;
  }
  //#endregion
  get periodInDays() {
    return this.beginDate != null && this.endDate != null ? this.endDate.diff(this.beginDate, "days") : 0;
  }
  get daysAndHoursLeft() {
    return this.calculateDaysLeft(this.endDate, !1);
  }
  get creditDaysAndHoursLeft() {
    return this.calculateDaysLeft(this.creditEndDate, !0);
  }
  calculateDaysLeft(e, p) {
    if (e == null)
      return { days: p ? 0 : 1 / 0, hours: 0, lessThanOneDay: !1, lessThanOneHour: !1, daysAgo: 0 };
    let c = e.diff(R.now(), "hours", !0), i = Math.trunc(c / 24), s = Math.floor(c % 24);
    if (c < 0)
      return { days: 0, hours: 0, daysAgo: Math.abs(i), lessThanOneDay: !1, lessThanOneHour: !1 };
    const u = i < 1, l = i === 0 && c < 1;
    return { days: i, hours: s, lessThanOneDay: u, lessThanOneHour: l, daysAgo: 0 };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    var c, i;
    const p = new tb({
      ...e,
      beginDate: e.beginDate ? R(e.beginDate) : void 0,
      endDate: e.endDate ? R(e.endDate) : null,
      creditEndDate: e.creditEndDate ? R(e.creditEndDate) : null,
      product: e.product ? new AM(e.product) : void 0,
      currentSuspension: e.currentSuspension ? Mn.fromJson(e.currentSuspension) : null,
      coursePlan: e.coursePlan ? OM.fromJson(e.coursePlan) : void 0,
      library: (c = e.libraryAccess) != null && c.library ? Ne.fromJson(e.libraryAccess.library) : void 0,
      course: e.course ? be.fromJson(e.course) : void 0
    });
    return p.coursePlan && p.update({ course: (i = p.coursePlan) == null ? void 0 : i.course }), p;
  }
}
class bn extends I0 {
  constructor(e) {
    super();
    o(this, "studentId");
    o(this, "isActive");
    o(this, "isExpired");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Yp extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "enabled");
    o(this, "shopEnabled");
    o(this, "leaderboardEnabled");
    o(this, "leaderboardTakeCount");
    o(this, "leaderboardDuration");
    o(this, "leaderboardDurationType");
    o(this, "pointsName");
    o(this, "pointsShortName");
    o(this, "pointsExpireDuration");
    o(this, "pointsExpireDurationType");
    o(this, "pointsIconType");
    o(this, "pointsIconCloudKey");
    o(this, "pointsCustomIcon");
    o(this, "achievementStyle");
    c0(this, {
      createdDate: r,
      updatedDate: r,
      enabled: r,
      shopEnabled: r,
      leaderboardEnabled: r,
      leaderboardTakeCount: r,
      leaderboardDuration: r,
      leaderboardDurationType: r,
      pointsName: r,
      pointsShortName: r,
      pointsExpireDuration: r,
      pointsExpireDurationType: r,
      pointsIconType: r,
      pointsIconCloudKey: r,
      pointsCustomIcon: r,
      achievementStyle: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      pointsCustomIconId: this.pointsCustomIcon === null ? null : (e = this.pointsCustomIcon) == null ? void 0 : e.id,
      // skip some fields just in case,
      pointsCustomIcon: void 0,
      scenario: void 0
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    var p, c;
    return this.achievementStyle !== e.achievementStyle || this.pointsName !== e.pointsName || this.pointsShortName !== e.pointsShortName || this.pointsExpireDuration !== e.pointsExpireDuration || this.pointsExpireDurationType !== e.pointsExpireDurationType || this.pointsIconType !== e.pointsIconType || this.pointsIconCloudKey !== e.pointsIconCloudKey || ((p = this.pointsCustomIcon) == null ? void 0 : p.id) !== ((c = e.pointsCustomIcon) == null ? void 0 : c.id) || this.leaderboardEnabled !== e.leaderboardEnabled || this.leaderboardTakeCount !== e.leaderboardTakeCount || this.leaderboardDuration !== e.leaderboardDuration || this.leaderboardDurationType !== e.leaderboardDurationType;
  }
  static fromJson(e) {
    return new Yp({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      pointsCustomIcon: e.pointsCustomIcon ? g1.fromJson(e.pointsCustomIcon) : void 0
    });
  }
}
class qt extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "enabled");
    o(this, "points");
    o(this, "title");
    o(this, "description");
    o(this, "type");
    o(this, "subtype");
    o(this, "style");
    o(this, "imageType");
    o(this, "imageCloudKey");
    o(this, "customImage");
    o(this, "systemAchievement");
    o(this, "gamificationId");
    o(this, "achievedDate");
    o(this, "count");
    c0(this, {
      createdDate: r,
      updatedDate: r,
      enabled: r,
      points: r,
      title: r,
      description: r,
      type: r,
      subtype: r,
      style: r,
      imageType: r,
      imageCloudKey: r,
      customImage: r,
      systemAchievement: r,
      isOverrided: Y,
      isSystem: Y,
      update: I
    }), e && this.update(e);
  }
  get isOverrided() {
    return this.systemAchievement !== null;
  }
  get isSystem() {
    return this.type == "system";
  }
  get executionMethod() {
    switch (this.subtype) {
      case "firstStep":
      case "firstTask":
      case "firstTest":
        return "once-material";
      case "activeStudent":
        return "many";
      default:
        return "once";
    }
  }
  toJson() {
    var e, p;
    return {
      ...this,
      customImageId: this.customImage === null ? null : (e = this.customImage) == null ? void 0 : e.id,
      systemAchievementId: this.systemAchievement === null ? null : (p = this.systemAchievement) == null ? void 0 : p.id,
      // skip some fields just in case,
      customImage: void 0,
      systemAchievement: void 0
    };
  }
  clone(e) {
    var p, c;
    return new qt({
      ...this,
      customImage: (p = this.customImage) == null ? void 0 : p.clone(),
      systemAchievement: (c = this.systemAchievement) == null ? void 0 : c.clone(),
      ...e
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    return Object.keys(e).some((p) => e[p] !== this[p]);
  }
  static fromJson(e) {
    return new qt({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      customImage: e.customImage ? g1.fromJson(e.customImage) : null,
      systemAchievement: e.systemAchievement ? qt.fromJson(e.systemAchievement) : null,
      achievedDate: e.achievedDate ? R(e.achievedDate) : void 0
    });
  }
}
class em extends I0 {
  constructor(e) {
    super();
    o(this, "style");
    o(this, "gamificationId");
    o(this, "showAll");
    o(this, "enabled");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Mb extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "description");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "enabled");
    o(this, "points");
    o(this, "useAvailableCount");
    o(this, "availableCount");
    o(this, "contentType");
    o(this, "bonusAmount");
    o(this, "image");
    o(this, "product");
    o(this, "gamification");
    o(this, "purchasedDate");
    c0(this, {
      title: r,
      description: r,
      createdDate: r,
      updatedDate: r,
      enabled: r,
      points: r,
      useAvailableCount: r,
      availableCount: r,
      contentType: r,
      bonusAmount: r,
      image: r,
      product: r,
      setContentType: I,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e, p, c;
    return {
      ...this,
      imageId: this.image === null ? null : (e = this.image) == null ? void 0 : e.id,
      productId: this.product === null ? null : (p = this.product) == null ? void 0 : p.id,
      gamificationId: this.gamification === null ? null : (c = this.gamification) == null ? void 0 : c.id,
      // skip some fields just in case,
      image: void 0,
      product: void 0,
      scenario: void 0,
      gamification: void 0
    };
  }
  clone() {
    var e, p, c;
    return new Mb({
      ...this,
      image: (e = this.image) == null ? void 0 : e.clone(),
      product: (p = this.product) == null ? void 0 : p.clone(),
      gamification: (c = this.gamification) == null ? void 0 : c.clone()
    });
  }
  setContentType(e) {
    this.contentType = e;
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    var p, c, i, s;
    return this.title !== e.title || this.description !== e.description || this.points !== e.points || this.useAvailableCount !== e.useAvailableCount || this.availableCount !== e.availableCount || this.contentType !== e.contentType || this.bonusAmount !== e.bonusAmount || ((p = this.image) == null ? void 0 : p.id) !== ((c = e.image) == null ? void 0 : c.id) || ((i = this.product) == null ? void 0 : i.id) !== ((s = e.product) == null ? void 0 : s.id) || this.enabled !== e.enabled;
  }
  static fromJson(e) {
    return new Mb({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      image: e.image ? g1.fromJson(e.image) : null,
      product: e.product ? AM.fromJson(e.product) : null,
      gamification: e.gamification ? Yp.fromJson(e.gamification) : void 0,
      purchaseDate: e.purchaseDate ? R(e.purchaseDate) : void 0
    });
  }
}
class P8 extends I0 {
  constructor(e) {
    super();
    o(this, "gamificationId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var tm = /* @__PURE__ */ ((M) => (M.Day = "day", M.Month = "month", M.Year = "year", M))(tm || {}), Mm = /* @__PURE__ */ ((M) => (M.Endless = "endless", M.Duration = "duration", M.Date = "date", M))(Mm || {});
class GM extends M0 {
  constructor(e) {
    super();
    o(this, "points");
    o(this, "type");
    o(this, "comment");
    o(this, "burnedTransaction");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "expiredDate");
    o(this, "contact");
    o(this, "achievement");
    o(this, "product");
    o(this, "duration");
    o(this, "durationType");
    o(this, "validUntilDate");
    c0(this, {
      points: r,
      type: r,
      comment: r,
      burnedTransaction: r,
      createdDate: r,
      updatedDate: r,
      expiredDate: r,
      contact: r,
      achievement: r,
      product: r,
      duration: r,
      durationType: r,
      validUntilDate: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e, p, c, i;
    return {
      ...this,
      contactId: this.contact === null ? null : (e = this.contact) == null ? void 0 : e.id,
      studentAchievementId: this.achievement === null ? null : (p = this.achievement) == null ? void 0 : p.id,
      productId: this.product === null ? null : (c = this.product) == null ? void 0 : c.id,
      burnedTransactionId: this.burnedTransaction === null ? null : (i = this.burnedTransaction) == null ? void 0 : i.id,
      // skip some fields just in case,
      contact: void 0,
      adminCreator: void 0,
      achievement: void 0,
      product: void 0,
      scenarioNode: void 0,
      burnedTransaction: void 0
    };
  }
  clone() {
    var e, p, c, i;
    return new GM({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone(),
      achievement: (p = this.achievement) == null ? void 0 : p.clone(),
      product: (c = this.product) == null ? void 0 : c.clone(),
      burnedTransaction: (i = this.burnedTransaction) == null ? void 0 : i.clone()
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    return Object.keys(e).some((p) => e[p] !== this[p]);
  }
  static fromJson(e) {
    return new GM({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      expiredDate: e.expiredDate ? R(e.expiredDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : null,
      achievement: e.studentAchievement ? pn.fromJson(e.studentAchievement) : null,
      product: e.product ? Mb.fromJson(e.product) : null,
      course: e.course ? be.fromJson(e.course) : null,
      courseItem: e.courseItem ? me.fromJson(e.courseItem) : null,
      burnedTransaction: e.burnedTransaction ? GM.fromJson(e.burnedTransaction) : null
    });
  }
}
class E8 extends I0 {
  constructor(e) {
    super();
    o(this, "gamificationId");
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "studentId");
    o(this, "studentIds");
    o(this, "type");
    o(this, "pointsFrom");
    o(this, "pointsTo");
    o(this, "productId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class pn extends M0 {
  constructor(e) {
    super();
    o(this, "course");
    o(this, "courseItem");
    o(this, "library");
    o(this, "libraryItem");
    o(this, "achievement");
    o(this, "points");
    c0(this, {
      course: r,
      courseItem: r,
      library: r,
      libraryItem: r,
      achievement: r,
      points: r
    }), e && this.update(e);
  }
  static fromJson(e) {
    return new pn({
      ...e,
      achievement: e.achievement ? qt.fromJson(e.achievement) : void 0,
      course: e.course ? be.fromJson(e.course) : null,
      courseItem: e.courseItem ? me.fromJson(e.courseItem) : null,
      library: e.library ? Ne.fromJson(e.library) : null,
      libraryItem: e.libraryItem ? Z2.fromJson(e.libraryItem) : null
    });
  }
}
class zn extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "subtype");
    o(this, "imageCloudKey");
    o(this, "count");
    e && this.update(e);
  }
  static fromJson(e) {
    return new zn({
      ...e
    });
  }
}
class gp extends M0 {
  constructor(e) {
    super();
    o(this, "place");
    o(this, "score");
    o(this, "createdDate");
    o(this, "contact");
    o(this, "achievements");
    c0(this, {
      place: r,
      score: r,
      createdDate: r,
      contact: r,
      achievements: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    return {
      ...this
    };
  }
  clone() {
    var e;
    return new gp({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone()
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new gp({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : null,
      achievements: e.achievements ? e.achievements.map(zn.fromJson) : null
    });
  }
}
class la extends I0 {
  constructor(e) {
    super();
    o(this, "gamificationId");
    o(this, "registrationDateFrom");
    o(this, "registrationDateTo");
    o(this, "studentIds");
    o(this, "scoreFrom");
    o(this, "scoreTo");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class yp extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "details");
    o(this, "url");
    o(this, "address");
    o(this, "beginDate");
    o(this, "endDate");
    o(this, "isMember");
    o(this, "duration");
    o(this, "timezone");
    e && this.update(e);
  }
  get isOutdated() {
    return this.endDate ? this.endDate.isBefore(R()) : !1;
  }
  get isActive() {
    return R().isBetween(this.beginDate, this.endDate, null, "[]");
  }
  get allDay() {
    return this.duration === "day";
  }
  toJson() {
    var e, p;
    return {
      ...this,
      beginDate: (e = this.beginDate) == null ? void 0 : e.toISOString(),
      endDate: (p = this.endDate) == null ? void 0 : p.toISOString()
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new yp({
      ...e,
      beginDate: e.beginDate ? R(e.beginDate) : void 0,
      endDate: e.endDate ? R(e.endDate) : void 0,
      timezone: e.timezone ? dt.fromJson(e.timezone) : void 0
    });
  }
}
class bm extends I0 {
  constructor(e) {
    super();
    o(this, "beginDateFrom");
    o(this, "beginDateTo");
    o(this, "isOutdated");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var K1 = /* @__PURE__ */ ((M) => (M.AccountLoginSuccess = "accountLoginSuccess", M.AccountLoginPrevented = "accountLoginPrevented", M.EmailConfirmed = "adminEmailConfirmed", M.CourseTaskAnswer = "courseTaskAnswer", M.Order = "order", M.OrderPayment = "orderPayment", M.AdminTaskStatus = "adminTaskStatus", M.AdminTaskCreated = "adminTaskCreated", M.AdminTaskReminder = "adminTaskReminder", M.CustomNotification = "customNotification", M.CourseTaskComment = "courseTaskComment", M.CourseItemComment = "courseItemComment", M.LibraryItemComment = "libraryItemComment", M.PipelineDealCreated = "pipelineDealCreated", M.PipelineDealCompleted = "pipelineDealCompleted", M.CourseTaskAnswerStatus = "courseTaskAnswerStatus", M.PasswordChanged = "passwordChanged", M.NewChatMessage = "receivedNewChatMessage", M.NewEmailMessage = "receivedNewEmailMessage", M.AdminPartnershipTransactionRequest = "adminPartnershipTransactionRequest", M.StudentPartnershipTransaction = "studentPartnershipTransaction", M.StudentPartnershipRegistration = "studentPartnershipRegistration", M.StudentBonusTransaction = "studentBonusTransaction", M.CommunityPostComment = "communityPostComment", M.CommunityCommentReply = "communityCommentReply", M))(K1 || {});
class Gp extends M0 {
  constructor(e) {
    super();
    o(this, "type");
    o(this, "payload");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "seenDate");
    o(this, "adminTaskId");
    o(this, "courseItemId");
    o(this, "libraryItemId");
    o(this, "taskAnswerId");
    o(this, "courseItemTaskId");
    o(this, "schoolContentItemCommentId");
    o(this, "orderId");
    o(this, "orderPaymentId");
    o(this, "scenarioId");
    o(this, "chatConversationId");
    o(this, "courseId");
    o(this, "libraryId");
    o(this, "contactId");
    o(this, "adminId");
    o(this, "schoolContentItemProgressRatingId");
    //#region Partnership
    o(this, "partnershipTransactionId");
    o(this, "partnershipTransactionRequestId");
    o(this, "studentBonusTransactionId");
    //#endregion
    //#region Community
    o(this, "communityPostId");
    o(this, "communityPostCommentId");
    e && this.update(e);
  }
  get isSeen() {
    return this.seenDate != null;
  }
  //#endregion
  static fromJson(e) {
    return new Gp({
      ...e,
      payload: e.payloadJson ? JSON.parse(e.payloadJson) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      seenDate: e.seenDate ? R(e.seenDate) : null
    });
  }
  update(e) {
    super.update(e);
  }
}
class pm extends I0 {
  constructor(e) {
    super();
    o(this, "adminId");
    o(this, "studentId");
    o(this, "read");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class mt extends M0 {
  constructor(e) {
    super();
    o(this, "type");
    e && this.update(e);
  }
  toJson() {
    return {
      ...this
    };
  }
  static fromJson(e) {
    return new mt({
      ...e
    });
  }
  update(e) {
    super.update(e);
  }
}
class fa extends M0 {
  constructor(e) {
    super();
    o(this, "reason");
    o(this, "beginDate");
    o(this, "endDate");
    o(this, "contact");
    e && this.update(e);
  }
  static fromJson(e) {
    return new fa({
      ...e,
      beginDate: e.beginDate ? new Date(e.beginDate) : void 0,
      endDate: e.endDate ? new Date(e.endDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : null
    });
  }
  update(e) {
    super.update(e);
  }
}
class x8 extends I0 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "isActive");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class lt extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "description");
    o(this, "canStudentCreateTopics");
    o(this, "isPublished");
    o(this, "isLimitedAccess");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "lastActivityDate");
    o(this, "parentThread");
    o(this, "moderators");
    o(this, "topicCount");
    o(this, "commentCount");
    o(this, "designSettings");
    o(this, "designSettingsPublished");
    o(this, "designHTMLPublished");
    o(this, "designStylePublished");
    o(this, "designConcurrencyStamp");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e;
    return {
      ...this,
      parentThread: (e = this.parentThread) == null ? void 0 : e.toJson(),
      moderators: this.moderators.map((p) => p.toJson())
    };
  }
  static fromJson(e) {
    return new lt({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? new Date(e.lastActivityDate) : void 0,
      parentThread: e.parentThread ? lt.fromJson(e.parentThread) : null,
      moderators: e.moderators ? e.moderators.map((p) => l1.fromJson(p.student)) : []
    });
  }
}
class F8 extends I0 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "parentThreadId");
    o(this, "onlyRoots");
    o(this, "flowId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Rt extends M0 {
  constructor(e) {
    super();
    o(this, "text");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "reply");
    o(this, "contact");
    o(this, "files");
    o(this, "sequenceNumber");
    o(this, "likeCount", 0);
    o(this, "dislikeCount", 0);
    o(this, "currentUserReaction");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Rt({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      reply: e.replyToComment ? Rt.fromJson(e.replyToComment) : null,
      files: e.files ? e.files.map(g1.fromJson) : [],
      contact: e.student ? l1.fromJson(e.student) : null,
      currentUserReaction: e.currentUserReaction ? mt.fromJson(e.currentUserReaction) : null
    });
  }
}
class Wa extends I0 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "topicId");
    o(this, "studentId");
    o(this, "replyToCommentId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Ab extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "text");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "lastActivityDate");
    o(this, "lastComment");
    o(this, "commentCount");
    o(this, "contact");
    o(this, "files");
    o(this, "likeCount");
    o(this, "dislikeCount");
    o(this, "currentUserReaction");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Ab({
      ...e,
      createdDate: e.createdDate ? new Date(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? new Date(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? new Date(e.lastActivityDate) : void 0,
      lastComment: e.lastComment ? Rt.fromJson(e.lastComment) : null,
      contact: e.student ? l1.fromJson(e.student) : null,
      files: e.files ? e.files.map(g1.fromJson) : [],
      currentUserReaction: e.currentUserReaction ? mt.fromJson(e.currentUserReaction) : null
    });
  }
}
class U8 extends I0 {
  constructor(e) {
    super();
    o(this, "id");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class bb extends M0 {
  constructor(e) {
    super();
    o(this, "amount");
    o(this, "fee");
    o(this, "useBonus");
    o(this, "comment");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "partner");
    o(this, "type");
    o(this, "order");
    o(this, "validAfterDate");
    o(this, "level");
    o(this, "levelPartner");
    c0(this, {
      amount: r,
      fee: r,
      useBonus: r,
      comment: r,
      createdDate: r,
      updatedDate: r,
      partner: r,
      type: r,
      order: r,
      validAfterDate: r,
      canWithdraw: Y,
      update: I
    }), e && this.update(e);
  }
  // @computed get contact() {
  //     return this.order?.contact;
  // }
  get canWithdraw() {
    return this.validAfterDate && this.validAfterDate.isBefore(R());
  }
  update(e) {
    super.update(e);
  }
  toJson() {
    var e, p, c;
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      fee: this.fee,
      comment: this.comment,
      partnerId: (e = this.partner) == null ? void 0 : e.id,
      orderId: (p = this.order) == null ? void 0 : p.id,
      useBonus: this.useBonus,
      level: this.level,
      levelPartnerId: (c = this.levelPartner) == null ? void 0 : c.id
    };
  }
  static fromJson(e) {
    return new bb({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      partner: e.partner ? l1.fromJson(e.partner) : void 0,
      order: e.order ? sM.fromJson(e.order) : void 0,
      validAfterDate: e.validAfterDate ? R(e.validAfterDate) : void 0,
      levelPartner: e.levelPartner ? l1.fromJson(e.levelPartner) : void 0
    });
  }
  static default() {
    return new bb({
      fee: 0,
      type: "deposit"
    });
  }
}
class zm extends I0 {
  constructor(e) {
    super();
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "partnerIds");
    o(this, "amountFrom");
    o(this, "amountTo");
    o(this, "feeFrom");
    o(this, "feeTo");
    /**
     * has admin => manual transaction
     */
    o(this, "hasAdminId");
    o(this, "type");
    o(this, "orderId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var om = /* @__PURE__ */ ((M) => (M.Day = "day", M.Month = "month", M))(om || {}), cm = /* @__PURE__ */ ((M) => (M.Endless = "endless", M.Duration = "duration", M.Date = "date", M))(cm || {});
class tM extends M0 {
  constructor(e) {
    super();
    o(this, "amount");
    o(this, "comment");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "contact");
    o(this, "order");
    o(this, "type");
    o(this, "transaction");
    o(this, "burnedTransaction");
    o(this, "duration");
    o(this, "durationType");
    o(this, "validUntilDate");
    c0(this, {
      amount: r,
      comment: r,
      createdDate: r,
      updatedDate: r,
      contact: r,
      order: r,
      type: r,
      transaction: r,
      burnedTransaction: r,
      duration: r,
      durationType: r,
      validUntilDate: r,
      update: I
    }), e && this.update(e);
  }
  clone() {
    return new tM({
      ...this
    });
  }
  toJson() {
    var e, p;
    return {
      id: this.id,
      amount: this.amount,
      type: this.type,
      comment: this.comment,
      studentId: (e = this.contact) == null ? void 0 : e.id,
      orderId: (p = this.order) == null ? void 0 : p.id,
      duration: this.duration,
      durationType: this.durationType,
      validUntilDate: this.validUntilDate
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new tM({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      validUntilDate: e.validUntilDate ? R(e.validUntilDate) : null,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      order: e.order ? sM.fromJson(e.order) : void 0,
      transaction: e.transaction ? bb.fromJson(e.transaction) : void 0,
      burnedTransaction: e.burnedTransaction ? tM.fromJson(e.burnedTransaction) : void 0
    });
  }
  static default() {
    return new tM({
      amount: 0,
      type: "deposit"
    });
  }
}
class nm extends I0 {
  constructor(e) {
    super();
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "studentIds");
    o(this, "amountFrom");
    o(this, "amountTo");
    /**
     * has admin => manual transaction
     */
    o(this, "hasAdminId");
    o(this, "adminId");
    o(this, "type");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class on extends M0 {
  constructor(e) {
    super();
    o(this, "notificationType");
    o(this, "useSite");
    o(this, "useEmail");
    o(this, "useTg");
    o(this, "useWebPush");
    o(this, "contact");
    o(this, "subscriptionId");
    c0(this, {
      notificationType: r,
      useSite: r,
      useEmail: r,
      useTg: r,
      useWebPush: r,
      contact: r,
      subscriptionId: r,
      hasSubscription: Y,
      update: I
    }), e && this.update(e);
  }
  get hasSubscription() {
    return this.subscriptionId != null;
  }
  get canUseAsGlobalSub() {
    switch (this.notificationType) {
      case K1.AdminTaskStatus:
      case K1.AdminTaskCreated:
      case K1.CourseTaskAnswer:
      case K1.CourseTaskComment:
      case K1.Order:
      case K1.OrderPayment:
      case K1.CommunityPostComment:
      case K1.CommunityCommentReply:
        return !0;
      default:
        return !1;
    }
  }
  /**
   * indicates whether this type of subscription can be used for a personal subscription to a contact
   */
  get canUseAsPersonalSub() {
    switch (this.notificationType) {
      case K1.CourseTaskAnswer:
      case K1.CourseTaskComment:
      case K1.OrderPayment:
      case K1.Order:
      case K1.CommunityPostComment:
      case K1.CommunityCommentReply:
        return !0;
      default:
        return !1;
    }
  }
  static fromJson(e) {
    return new on({
      id: e.id,
      notificationType: e.notificationType,
      useSite: e.useSite,
      useEmail: e.useEmail,
      useTg: e.useTg,
      useWebPush: e.useWebPush,
      subscriptionId: e.subscriptionId,
      contact: e.student ? l1.fromJson(e.student) : void 0
    });
  }
  update(e, p = !1) {
    super.update(e, p);
  }
}
class J8 extends I0 {
  constructor(t) {
    super(), t && this.update(t);
  }
  update(t) {
    super.update(t);
  }
}
class cn extends M0 {
  constructor(e) {
    super();
    o(this, "contact");
    o(this, "useEmail");
    o(this, "email");
    o(this, "customEmail");
    o(this, "useTg");
    o(this, "tgId");
    o(this, "channels");
    o(this, "tgLink");
    o(this, "useWebPush");
    c0(this, {
      contact: r,
      useEmail: r,
      email: r,
      customEmail: r,
      useTg: r,
      tgId: r,
      channels: r,
      useWebPush: r,
      update: I
    }), e && this.update(e);
  }
  static fromJson(e) {
    return new cn({
      id: e.id,
      contact: e.student ? l1.fromJson(e.student) : void 0,
      useEmail: e.useEmail,
      email: e.email,
      customEmail: e.customEmail,
      useTg: e.useTg,
      tgId: e.tgId,
      tgLink: e.tgLink,
      useWebPush: e.useWebPush,
      channels: e.channels ? e.channels.map(on.fromJson) : []
    });
  }
  update(e) {
    super.update(e);
  }
}
class nn extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    /**
     * @deprecated use urls instead (TODO fix)
     */
    o(this, "url");
    o(this, "urls");
    o(this, "description");
    o(this, "isActive");
    o(this, "createdDate");
    o(this, "updatedDate");
    /**
     * @deprecated use levels instead (TODO fix)
     */
    o(this, "fee");
    o(this, "feeType");
    o(this, "productType");
    o(this, "partnerType");
    o(this, "purchaseType");
    o(this, "products");
    o(this, "partners");
    o(this, "levels");
    c0(this, {
      title: r,
      url: r,
      urls: r,
      description: r,
      isActive: r,
      createdDate: r,
      updatedDate: r,
      fee: r,
      feeType: r,
      productType: r,
      partnerType: r,
      purchaseType: r,
      products: r,
      partners: r,
      levels: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    return {
      id: this.id,
      title: this.title,
      url: this.url,
      urls: this.urls,
      description: this.description,
      isActive: this.isActive,
      feeType: this.feeType,
      productType: this.productType,
      partnerType: this.partnerType,
      purchaseType: this.purchaseType,
      productIds: this.products.map((e) => e.id),
      partnerIds: this.partners.map((e) => e.id),
      levels: this.levels
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new nn({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      urls: e.urlsJson ? JSON.parse(e.urlsJson) : void 0,
      products: e.productLinks ? e.productLinks.map((p) => AM.fromJson(p.product)) : void 0,
      partners: e.partnerLinks ? e.partnerLinks.map((p) => l1.fromJson(p.partner)) : void 0
    });
  }
}
class im extends I0 {
  constructor(e) {
    super();
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "feeFrom");
    o(this, "feeTo");
    o(this, "productIds");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class $p extends M0 {
  constructor(e) {
    super();
    o(this, "isActive");
    o(this, "navigationCount");
    o(this, "registrationCount");
    o(this, "amount");
    o(this, "fee");
    o(this, "availableFee");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "acceptedDate");
    o(this, "contact");
    o(this, "code");
    c0(this, {
      isActive: r,
      navigationCount: r,
      registrationCount: r,
      amount: r,
      fee: r,
      availableFee: r,
      createdDate: r,
      updatedDate: r,
      acceptedDate: r,
      contact: r,
      code: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      id: this.id,
      acceptedDate: this.acceptedDate,
      studentId: (e = this.contact) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new $p({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : null,
      acceptedDate: e.acceptedDate ? R(e.acceptedDate) : null
    });
  }
}
class rm extends I0 {
  constructor(e) {
    super();
    o(this, "createdFromDate");
    o(this, "createdToDate");
    o(this, "statisticFromDate");
    o(this, "statisticToDate");
    o(this, "acceptedFromDate");
    o(this, "acceptedToDate");
    o(this, "code");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class rn extends M0 {
  constructor(e) {
    super();
    o(this, "amount");
    o(this, "partnerComment");
    o(this, "adminComment");
    o(this, "status");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "partner");
    c0(this, {
      amount: r,
      partnerComment: r,
      adminComment: r,
      status: r,
      createdDate: r,
      updatedDate: r,
      partner: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e;
    return {
      id: this.id,
      amount: this.amount,
      partnerComment: this.partnerComment,
      adminComment: this.adminComment,
      status: this.status,
      partnerId: (e = this.partner) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new rn({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      partner: e.partner ? l1.fromJson(e.partner) : void 0
    });
  }
}
class Om extends I0 {
  constructor(e) {
    super();
    o(this, "createdDateFrom");
    o(this, "createdDateTo");
    o(this, "partnerIds");
    o(this, "amountFrom");
    o(this, "amountTo");
    o(this, "feeFrom");
    o(this, "feeTo");
    /**
     * has admin => manual transaction
     */
    o(this, "hasAdminId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class zM extends M0 {
  constructor(e) {
    super();
    o(this, "title", "");
    o(this, "titleEmoji", "");
    o(this, "position");
    o(this, "type", "space");
    o(this, "parentId");
    o(this, "segment");
    o(this, "url");
    o(this, "parent");
    // Payment settings (only for spaces)
    o(this, "showIfNoAccess", !1);
    o(this, "showPaymentLink", !1);
    o(this, "paymentUrl", "");
    /**
     * Access type for viewing posts (primary restriction)
     * Only applicable when type === 'space'
     */
    o(this, "viewAccessType", "public");
    o(this, "viewAccessFilterJson");
    /**
     * Access type for liking posts
     * Only applicable when type === 'space'
     */
    o(this, "likesAccessType", "public");
    o(this, "likesAccessFilterJson");
    /**
     * Access type for commenting on posts
     * Only applicable when type === 'space'
     */
    o(this, "commentsAccessType", "public");
    o(this, "commentsAccessFilterJson");
    /**
     * Access type for publishing posts
     * Only applicable when type === 'space'
     */
    o(this, "publishAccessType", "public");
    o(this, "publishAccessFilterJson");
    /**
     * Restrictions for the current member
     */
    o(this, "restrictions", {
      commentsRestrictionEnabled: !1,
      likesRestrictionEnabled: !1,
      publishRestrictionEnabled: !1,
      viewRestrictionEnabled: !1
    });
    c0(this, {
      title: r,
      titleEmoji: r,
      position: r,
      type: r,
      parentId: r,
      segment: r,
      url: r,
      parent: r,
      showIfNoAccess: r,
      showPaymentLink: r,
      paymentUrl: r,
      viewAccessType: r,
      viewAccessFilterJson: r,
      likesAccessType: r,
      likesAccessFilterJson: r,
      commentsAccessType: r,
      commentsAccessFilterJson: r,
      publishAccessType: r,
      publishAccessFilterJson: r,
      isSection: Y,
      isSpace: Y,
      update: I
    }), e && this.update(e);
  }
  get isSection() {
    return this.type === "section";
  }
  get isSpace() {
    return this.type === "space";
  }
  toJson() {
    var e;
    return {
      ...this,
      viewAccessFilterJson: this.viewAccessFilterJson,
      likesAccessFilterJson: this.likesAccessFilterJson,
      commentsAccessFilterJson: this.commentsAccessFilterJson,
      publishAccessFilterJson: this.publishAccessFilterJson,
      parentId: (e = this.parent) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    return this.title !== e.title || this.titleEmoji !== e.titleEmoji || this.type !== e.type || this.position !== e.position || this.parentId !== e.parentId || this.segment !== e.segment || this.url !== e.url || this.showIfNoAccess !== e.showIfNoAccess || this.showPaymentLink !== e.showPaymentLink || this.paymentUrl !== e.paymentUrl;
  }
  clone() {
    return new zM({
      ...this
    });
  }
  static fromJson(e) {
    return new zM({
      ...e,
      viewAccessFilterJson: e.viewAccessExtendedFilterJson,
      likesAccessFilterJson: e.likesAccessExtendedFilterJson,
      commentsAccessFilterJson: e.commentsAccessExtendedFilterJson,
      publishAccessFilterJson: e.publishAccessExtendedFilterJson,
      parent: e.parent ? zM.fromJson(e.parent) : void 0,
      restrictions: e.currentMember ? e.currentMember : {
        commentsRestrictionEnabled: !1,
        likesRestrictionEnabled: !1,
        publishRestrictionEnabled: !1,
        viewRestrictionEnabled: !1
      }
    });
  }
}
class am extends I0 {
  constructor(e) {
    super();
    o(this, "communityId");
    o(this, "type");
    o(this, "parentId");
    o(this, "segment");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class ha {
  generate(t = 10) {
    return [...Array(t)].map((e) => (~~(Math.random() * 36)).toString(36)).join("");
  }
  static generate(t = 10) {
    return [...Array(t)].map((e) => (~~(Math.random() * 36)).toString(36)).join("");
  }
}
class pb extends M0 {
  constructor(e) {
    super();
    o(this, "name", "");
    o(this, "file");
    o(this, "position");
    /**
     * Url for external links youtube, vimeo, etc
     */
    o(this, "url");
    c0(this, {
      name: r,
      file: r,
      position: r,
      url: r,
      isExternalVideo: Y,
      isMedia: Y,
      externalVideoFile: Y,
      update: I
    }), e && this.update(e);
  }
  get isExternalVideo() {
    return !u1(this.url);
  }
  get isMedia() {
    return this.isExternalVideo || this.file != null && (this.file.isVideo || this.file.isImage);
  }
  get externalVideoFile() {
    return this.isExternalVideo ? new D1({
      key: ha.generate(5),
      name: this.name,
      url: this.url,
      type: ma.Video,
      extension: ".mp4"
    }) : void 0;
  }
  toJson() {
    var e;
    return {
      id: this.id,
      name: this.name,
      position: this.position,
      url: this.url,
      fileId: (e = this.file) == null ? void 0 : e.id
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var p, c;
    return this.name !== e.name || this.position !== e.position || ((p = this.file) == null ? void 0 : p.id) !== ((c = e.file) == null ? void 0 : c.id) || this.url !== e.url;
  }
  clone() {
    var e;
    return new pb({
      ...this,
      file: (e = this.file) == null ? void 0 : e.clone()
    });
  }
  static fromJson(e) {
    return new pb({
      ...e,
      file: e.file ? D1.fromJson(e.file) : void 0
    });
  }
}
class On extends M0 {
  constructor(e) {
    super();
    o(this, "name", "");
    o(this, "description", "");
    o(this, "emoji", "");
    o(this, "image", null);
    c0(this, {
      name: r,
      description: r,
      emoji: r,
      image: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e, p;
    return {
      ...this,
      imageId: (e = this.image) == null ? void 0 : e.id,
      imageJson: (p = this.image) == null ? void 0 : p.toJson(),
      image: void 0
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var p, c;
    return this.name !== e.name || this.description !== e.description || this.emoji !== e.emoji || ((p = this.image) == null ? void 0 : p.id) !== ((c = e.image) == null ? void 0 : c.id);
  }
  static fromJson(e) {
    return new On({
      ...e,
      image: e.image ? D1.fromJson(e.image) : void 0
    });
  }
}
class H8 extends I0 {
  constructor(e) {
    super();
    o(this, "communityId");
    o(this, "memberId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class an extends M0 {
  constructor(e) {
    super();
    o(this, "badge");
    o(this, "member");
    c0(this, {
      badge: r,
      member: r,
      update: I
    }), e && this.update(e);
  }
  toJson(e) {
    var p, c;
    return {
      badgeId: (p = this.badge) == null ? void 0 : p.id,
      memberId: e ?? ((c = this.member) == null ? void 0 : c.id)
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new an({
      ...e,
      badge: e.badge ? On.fromJson(e.badge) : void 0,
      member: e.member ? ee.fromJson(e.member) : void 0
    });
  }
}
class ee extends M0 {
  constructor(e) {
    super();
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "lastActivityDate");
    o(this, "contact");
    o(this, "admin");
    o(this, "role");
    o(this, "viewRestrictionEnabled", !1);
    o(this, "likesRestrictionEnabled", !1);
    o(this, "commentsRestrictionEnabled", !1);
    o(this, "publishRestrictionEnabled", !1);
    o(this, "badges", []);
    c0(this, {
      createdDate: r,
      updatedDate: r,
      lastActivityDate: r,
      contact: r,
      admin: r,
      role: r,
      viewRestrictionEnabled: r,
      likesRestrictionEnabled: r,
      commentsRestrictionEnabled: r,
      publishRestrictionEnabled: r,
      badges: r,
      userId: Y,
      fullName: Y,
      update: I
    }), e && this.update(e);
  }
  get userId() {
    var e, p;
    return ((e = this.contact) == null ? void 0 : e.id) || ((p = this.admin) == null ? void 0 : p.id);
  }
  get fullName() {
    return this.contact ? this.contact.fullName : this.admin ? this.admin.fullName : "";
  }
  toJson() {
    var e, p;
    return {
      ...this,
      contactId: (e = this.contact) == null ? void 0 : e.id,
      contact: void 0,
      adminId: (p = this.admin) == null ? void 0 : p.id,
      admin: void 0,
      badges: this.badges.map((c) => c.toJson(this.id))
      // hack to pass member id to badge
    };
  }
  update(e) {
    super.update(e);
  }
  hasChanges(e) {
    var p, c;
    return ((p = this.contact) == null ? void 0 : p.id) !== ((c = e.contact) == null ? void 0 : c.id);
  }
  clone() {
    var e, p;
    return new ee({
      ...this,
      contact: (e = this.contact) == null ? void 0 : e.clone(),
      admin: (p = this.admin) == null ? void 0 : p.clone()
    });
  }
  static fromJson(e) {
    return new ee({
      ...e,
      contact: e.contact ? l1.fromJson(e.contact) : void 0,
      admin: e.admin ? ut.fromJson(e.admin) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      lastActivityDate: e.lastActivityDate ? R(e.lastActivityDate) : void 0,
      badges: e.badges ? e.badges.map(an.fromJson) : []
    });
  }
}
class sm extends I0 {
  constructor(e) {
    super();
    o(this, "communityId");
    o(this, "contactId");
    o(this, "role");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Lt extends M0 {
  constructor(e) {
    super();
    o(this, "title", "");
    o(this, "body", "");
    o(this, "spaceId");
    o(this, "space");
    o(this, "number");
    /**
     * Attachments sorted by position
     */
    o(this, "attachments", []);
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "status", "default");
    o(this, "author");
    o(this, "isLikedByCurrentUser", !1);
    o(this, "pinDate", null);
    o(this, "pinPosition", null);
    o(this, "reports", []);
    o(this, "likesCount", 0);
    o(this, "commentsCount", 0);
    o(this, "viewsCount", 0);
    o(this, "reportsCount", 0);
    c0(this, {
      title: r,
      body: r,
      spaceId: r,
      space: r,
      number: r,
      attachments: r,
      coverAttachment: Y,
      mediaAttachments: Y,
      fileAttachments: Y,
      createdDate: r,
      updatedDate: r,
      status: r,
      author: r,
      isLikedByCurrentUser: r,
      pinDate: r,
      pinPosition: r,
      reports: r,
      likesCount: r,
      commentsCount: r,
      viewsCount: r,
      reportsCount: r,
      update: I
    }), e && this.update(e);
  }
  /**
   * First image or video attachment
   */
  get coverAttachment() {
    return this.mediaAttachments.length === 0 ? null : this.mediaAttachments[0];
  }
  get mediaAttachments() {
    return this.attachments.filter((e) => e.isMedia);
  }
  get fileAttachments() {
    return this.attachments.filter((e) => !e.isMedia);
  }
  toJson() {
    var e;
    return {
      ...this,
      attachments: this.attachments.map((p) => p.toJson()),
      spaceId: (e = this.space) == null ? void 0 : e.id,
      space: void 0,
      status: this.status
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    return this.title !== e.title || this.body !== e.body || this.spaceId !== e.spaceId || !this.attachments.isEquals(e.attachments, (p, c) => !p.hasChanges(c));
  }
  clone() {
    var e, p;
    return new Lt({
      ...this,
      attachments: this.attachments.map((c) => c.clone()),
      author: (e = this.author) == null ? void 0 : e.clone(),
      space: (p = this.space) == null ? void 0 : p.clone()
    });
  }
  static fromJson(e) {
    var p;
    return new Lt({
      ...e,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      attachments: ((p = e.attachments) == null ? void 0 : p.map(pb.fromJson)) || [],
      author: e.author ? ee.fromJson(e.author) : void 0,
      space: e.space ? zM.fromJson(e.space) : void 0,
      pinDate: e.pinDate ? R(e.pinDate) : null
    });
  }
}
class Am extends I0 {
  constructor(e) {
    super();
    o(this, "communityId");
    o(this, "spaceId");
    o(this, "spaceIds");
    o(this, "statuses");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class ft extends M0 {
  constructor(e) {
    super();
    o(this, "text", "");
    o(this, "status", "default");
    o(this, "postId");
    o(this, "post");
    o(this, "author");
    o(this, "files", []);
    o(this, "likesCount", 0);
    o(this, "replyId");
    o(this, "reply");
    o(this, "parent");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "isLikedByCurrentUser", !1);
    o(this, "childrenCollapsed", !0);
    o(this, "childrenCount", 0);
    o(this, "children", []);
    o(this, "reports", []);
    o(this, "reportsCount", 0);
    c0(this, {
      text: r,
      status: r,
      postId: r,
      post: r,
      author: r,
      files: r,
      likesCount: r,
      replyId: r,
      reply: r,
      parent: r,
      createdDate: r,
      updatedDate: r,
      isLikedByCurrentUser: r,
      childrenCollapsed: r,
      childrenCount: r,
      children: r,
      reports: r,
      reportsCount: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e, p, c, i;
    return {
      id: this.id,
      text: this.text,
      status: this.status,
      postId: (e = this.post) == null ? void 0 : e.id,
      authorId: (p = this.author) == null ? void 0 : p.id,
      fileIds: this.files.map((s) => s.id),
      replyId: (c = this.reply) == null ? void 0 : c.id,
      parentId: (i = this.parent) == null ? void 0 : i.id,
      reportsCount: this.reportsCount
    };
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  hasChanges(e) {
    var p, c, i, s, u, l, W, L, m, X;
    return this.text !== e.text || ((p = this.post) == null ? void 0 : p.id) !== ((c = e.post) == null ? void 0 : c.id) || ((i = this.author) == null ? void 0 : i.id) !== ((s = e.author) == null ? void 0 : s.id) || ((u = this.reply) == null ? void 0 : u.id) !== ((l = e.reply) == null ? void 0 : l.id) || !this.files.isEquals(e.files, (D, y) => D.id === y.id) || ((W = this.reply) == null ? void 0 : W.id) !== ((L = e.reply) == null ? void 0 : L.id) || ((m = this.parent) == null ? void 0 : m.id) !== ((X = e.parent) == null ? void 0 : X.id);
  }
  static fromJson(e) {
    return new ft({
      ...e,
      post: e.post ? Lt.fromJson(e.post) : void 0,
      author: e.author ? ee.fromJson(e.author) : void 0,
      files: e.files ? e.files.map(D1.fromJson) : [],
      reply: e.reply ? ft.fromJson(e.reply) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      parent: e.parent ? ft.fromJson(e.parent) : void 0
    });
  }
}
class qO extends I0 {
  constructor(e) {
    super();
    o(this, "postId");
    o(this, "communityId");
    o(this, "authorId");
    o(this, "replyId");
    o(this, "parentId");
    o(this, "hasParentId");
    o(this, "statuses");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class sn extends M0 {
  constructor(e) {
    super();
    o(this, "text", "");
    o(this, "type", "custom");
    o(this, "postId");
    o(this, "post");
    o(this, "commentId");
    o(this, "comment");
    o(this, "memberId");
    o(this, "member");
    o(this, "createdDate");
    o(this, "updatedDate");
    c0(this, {
      text: r,
      type: r,
      postId: r,
      post: r,
      commentId: r,
      comment: r,
      memberId: r,
      member: r,
      createdDate: r,
      updatedDate: r,
      update: I
    }), e && this.update(e);
  }
  toJson() {
    var e, p, c;
    return {
      ...this,
      postId: (e = this.post) == null ? void 0 : e.id,
      commentId: (p = this.comment) == null ? void 0 : p.id,
      memberId: (c = this.member) == null ? void 0 : c.id
    };
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new sn({
      ...e,
      post: e.post ? Lt.fromJson(e.post) : void 0,
      comment: e.comment ? ft.fromJson(e.comment) : void 0,
      member: e.member ? ee.fromJson(e.member) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0
    });
  }
}
class dm extends I0 {
  constructor(e) {
    super();
    o(this, "postId");
    o(this, "commentId");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
var K2 = /* @__PURE__ */ ((M) => (M[M.Kilobytes = 1024] = "Kilobytes", M[M.Megabytes = 1048576] = "Megabytes", M[M.Gigabytes = 1073741824] = "Gigabytes", M))(K2 || {}), Qt = /* @__PURE__ */ ((M) => (M[M.Bytes = 0] = "Bytes", M[M.Kilobytes = 1] = "Kilobytes", M[M.Megabytes = 2] = "Megabytes", M[M.Gigabytes = 3] = "Gigabytes", M))(Qt || {});
class um {
  static toBytes(t, e = 0) {
    switch (e) {
      case 3:
        return t * K2.Gigabytes;
      case 2:
        return t * K2.Megabytes;
      case 1:
        return t * K2.Kilobytes;
      case 0:
        return t;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
  static fromBytes(t, e) {
    switch (e) {
      case 3:
        return t / K2.Gigabytes;
      case 2:
        return t / K2.Megabytes;
      case 1:
        return t / K2.Kilobytes;
      case 0:
        return t;
      default:
        throw new Error("Invalid FileSizeUnit");
    }
  }
}
class V2 {
  constructor(t, e = Qt.Bytes) {
    o(this, "bytes");
    o(this, "kilobytes");
    o(this, "megabytes");
    o(this, "gigabytes");
    const p = um.toBytes(t, e);
    this.bytes = p, this.kilobytes = p / K2.Kilobytes, this.megabytes = p / K2.Megabytes, this.gigabytes = p / K2.Gigabytes;
  }
  add(t) {
    return V2.fromBytes(this.bytes + t.bytes);
  }
  substract(t) {
    return V2.fromBytes(this.bytes - t.bytes);
  }
  get total() {
    return this;
  }
  get isZero() {
    return this.bytes == 0;
  }
  static from(t, e) {
    return new V2(t, e);
  }
  static fromBytes(t) {
    return new V2(t, Qt.Bytes);
  }
  static fromKilobytes(t) {
    return new V2(t, Qt.Kilobytes);
  }
  static fromMegabytes(t) {
    return new V2(t, Qt.Megabytes);
  }
  static fromGigabytes(t) {
    return new V2(t, Qt.Gigabytes);
  }
  static get zero() {
    return new V2(0);
  }
}
var ma = /* @__PURE__ */ ((M) => (M.Other = "other", M.Image = "image", M.Video = "video", M.Audio = "audio", M.Doc = "doc", M.Pdf = "pdf", M.Zip = "zip", M.Ppt = "ppt", M.Xls = "xls", M.Json = "json", M.Csv = "csv", M))(ma || {}), qm = /* @__PURE__ */ ((M) => (M.Amazon = "amazon", M))(qm || {});
class D1 extends M0 {
  constructor(e) {
    super();
    o(this, "name");
    o(this, "description");
    o(this, "cloudKey");
    o(this, "size");
    o(this, "mimetype");
    o(this, "type");
    o(this, "source");
    o(this, "additionalData");
    o(this, "extension");
    o(this, "createdDate");
    o(this, "videoThumbnailUrl");
    o(this, "originalName");
    o(this, "isPublic");
    o(this, "isVoice");
    o(this, "key");
    o(this, "nativeFile");
    o(this, "previewImage");
    o(this, "previewAudio");
    /**
     * external file source
     */
    o(this, "url");
    c0(this, {
      name: r,
      description: r,
      cloudKey: r,
      isPublic: r,
      isVoice: r,
      audioMeta: Y,
      key: r,
      nativeFile: r,
      previewImage: r,
      previewAudio: r,
      isUploaded: Y,
      url: r,
      update: I
    }), e && this.update(e);
  }
  get audioMeta() {
    return this.additionalData;
  }
  set audioMeta(e) {
    this.additionalData = e;
  }
  /**
   * remove 'size' and rename
   */
  get fileSize() {
    return V2.fromBytes(this.size);
  }
  get fileSizeString() {
    return dh.fileSize(this.size);
  }
  get isUploaded() {
    return !u1(this.cloudKey);
  }
  get isExternalFile() {
    return !u1(this.url);
  }
  get isVideo() {
    return [".mp4", ".mov", ".avi", ".wmv", ".flv", ".mkv"].includes(this.extension);
  }
  get isImage() {
    return [".bmp", ".dib", ".rle", ".jpg", ".jpeg", ".jpe", ".jfif", ".gif", ".tif", ".tiff", ".png", ".svg", ".pjpeg", ".webp", ".ico"].includes(this.extension);
  }
  get isAudio() {
    return [".mp3", ".ogg", ".webm", ".m4a"].includes(this.extension);
  }
  get filename() {
    return this.name + this.extension;
  }
  replaceFile(e) {
    this.update({
      ...D1.fromFile(e),
      id: this.id,
      name: this.name,
      description: this.description,
      createdDate: this.createdDate,
      isPublic: this.isPublic
    }, !0);
  }
  update(e, p = !1) {
    super.update(e, p);
  }
  toJson() {
    return {
      ...this,
      additionalData: JSON.stringify(this.additionalData),
      nativeFile: void 0
    };
  }
  clone() {
    return new D1({
      ...this
    });
  }
  static fromJson(e) {
    return new D1({
      ...e,
      key: e.id,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      convertData: e.convertDataJson ? JSON.parse(e.convertDataJson) : void 0,
      additionalData: e.additionalData ? JSON.parse(e.additionalData) : void 0
    });
  }
  static fromFile(e, p) {
    const c = e.name.lastIndexOf("."), i = new D1({
      key: ha.generate(10),
      source: "amazon",
      nativeFile: e,
      size: e.size,
      mimetype: e.type,
      name: e.name.substring(0, c),
      extension: e.name.substring(c),
      createdDate: R(),
      ...p
    });
    return i.isImage && i.nativeFile && (i.previewImage = URL.createObjectURL(i.nativeFile)), i.isAudio && i.nativeFile && i.nativeFile.type.includes("audio") && (i.previewAudio = URL.createObjectURL(i.nativeFile)), i;
  }
}
class l1 extends M0 {
  constructor(e) {
    super();
    o(this, "avatar");
    o(this, "email");
    o(this, "firstName");
    o(this, "middleName");
    o(this, "lastName");
    o(this, "gender");
    o(this, "phone");
    o(this, "isSchoolEmailConfirmed");
    o(this, "birthday");
    o(this, "bonusBalance");
    o(this, "session");
    o(this, "emailConfirmationSentDate");
    o(this, "needChangePassword");
    o(this, "communityMember");
    e && this.update(e);
  }
  get isFirstNameEmpty() {
    return u1(this.firstName);
  }
  get isLastNameEmpty() {
    return u1(this.lastName);
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  get fullNameNoEmail() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? "" : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  toJson() {
    var e, p;
    return {
      ...this,
      birthday: (e = this.birthday) == null ? void 0 : e.toISOString(),
      avatarId: (p = this.avatar) == null ? void 0 : p.id,
      avatar: void 0
    };
  }
  static fromJson(e) {
    return new l1({
      ...e,
      avatar: e.avatar ? D1.fromJson(e.avatar) : void 0,
      bonusBalance: e.bonusBalance ?? 0,
      session: e.session ? Yc.fromJson(e.session) : void 0,
      birthday: e.birthday ? R(e.birthday) : void 0,
      emailConfirmationSentDate: e.emailConfirmationSentDate ? new Date(e.emailConfirmationSentDate) : null,
      communityMember: e.communityMember ? ee.fromJson(e.communityMember) : null
    });
  }
}
class lm {
  constructor(t) {
    o(this, "login", (t) => this.api.post("/authorization/login", t));
    o(this, "logout", (t) => this.api.put("/authorization/logout", { token: t }));
    o(this, "refreshToken", (t) => this.api.put("/authorization/refresh", { token: t }));
    o(this, "register", (t) => this.api.post("/authorization/register", t));
    // registerContact = (body: RegisterContactRequestBody) => this.api.post('/authorization/register-contact', body);
    o(this, "resetPassword", (t) => this.api.put("/authorization/reset-password", t));
    o(this, "confirmEmail", (t) => this.api.put("/authorization/confirm-email", t));
    o(this, "checkInvite", (t) => this.api.get(`/authorization/check-invite/${t}`));
    o(this, "confirmInvite", (t) => this.api.put("/authorization/confirm-invite", t));
    o(this, "sendInvite", (t) => this.api.post("/authorization/send-invite", { email: t }));
    o(this, "forgotPassword", (t) => this.api.put("/authorization/forgot-password", { email: t }));
    o(this, "loginToken", (t) => this.api.post("/authorization/login-token", { token: t }));
    o(this, "loginAs", (t) => this.api.post("/authorization/login-as", t));
    o(this, "prolongSession", (t) => this.api.put("/authorization/prolong-session", { token: t }));
    o(this, "fetchContact", (t) => this.api.get(`/authorization/contact/${t}`));
    o(this, "fetchMe", () => this.api.get("/authorization/me", void 0, l1.fromJson));
    o(this, "fetchEmailNotificationsSubscriptionStatus", (t) => this.api.execute({ method: "GET", url: "/authorization/email-notifications-subscription-status", body: t }, (e) => ({ subscribed: e.subscribed })));
    o(this, "fetchStudentEmailStatus", ({ studentId: t, messageId: e }) => this.api.get(`/student/email-broadcast-subscription-status/${t}/${e}`));
    o(this, "unsubscribeStudentEmailStatus", (t) => this.api.put("/student/unsubscribe-email-broadcast", t));
    o(this, "unsubscribeEmailNotifications", (t) => this.api.put("/authorization/unsubscribe-email-notifications", t));
    o(this, "getQr", () => this.api.get("/authorization/qr"));
    o(this, "loginQr", (t) => this.api.execute({ method: "GET", url: "/authorization/qr/login", body: { token: t, responseType: "json" } }));
    this.api = t;
  }
}
class fm {
  constructor(t) {
    o(this, "fetch", () => this.api.get("/announcement", "", (t) => t.map(Gc.fromJson)));
    o(this, "close", (t) => this.api.post("/announcement/close", { id: t }));
    this.api = t;
  }
}
class Wm {
  constructor(t) {
    o(this, "fetch", (t) => this.api.execute({
      method: "GET",
      url: "/school-content-item",
      body: t,
      fields: t.fields
    }, (e) => ({
      items: e.items.map(YM.fromJson),
      filter: new Kh(e.filter)
    })));
    this.api = t;
  }
}
class hm {
  constructor(t) {
    o(this, "fetch", (t) => this.api.execute({ method: "GET", url: "/school-setting" }, jM.fromJson));
    this.api = t;
  }
}
const mm = `{
            id,
            beginDate,
            endDate,
            state,
            flowBeginDate,
            accessBeginDate,
            accessEndDate,
            isSubscription,
            course{
                id,
                name,
                dontAskFeedback,
                appearanceSettingsJson
            },
            currentCourseItem{
                id
            },        
            feedback,
            progress,
            student{
                id
            }
        }`, Ra = `{
        id,
        parentItemId,
        title,
        type,
        position,
        availability,
        disableTimeLimits,
        regularTimeDelayActive,
        regularTimeDelay,
        regularTimeDelayCondition,
        regularTimeDelayMeasureType,
        regularWaitUntilTimeActive,
        regularWaitUntilTime,
        regularWaitUntilTimeDaysOfWeekActive,
        regularWaitUntilDaysOfWeek,
        flowTimeDelayActive,
        flowTimeDelay,
        flowTimeDelayCondition,
        flowTimeDelayMeasureType,
        flowWaitUntilTimeActive,
        flowWaitUntilTime,
        flowWaitUntilTimeDaysOfWeekActive,
        flowWaitUntilDaysOfWeek,
        dateDelayActive,
        dateDelay,
        preventCopingAndSelectingText,
        blockCourseUntilTasksApproved,
        isOptional,
        imageCloudKey,
        allowComments,
        showComments,
        ratingEnabled,
        ratingRequired,
        ratingCommentRequired,
        theoryVisible,
        testsVisible,
        tasksVisible,
        requiredPlans,
        progress{
            id,
            beginDate,
            completeDate,
            precompleteDate,
            status,
            theoryStatus,
            testStatus,
            taskStatus,
            numberUncheckedTasks,
            numberCorrectTasks,
            numberIncorrectTasks,
        },
        tasks{
            id,
        },
        ratingAverage,
        ratingCount
    }`, Rm = Ra.replace(/,\s*ratingAverage,\s*ratingCount/, "").replace(/\s*imageCloudKey,/, ""), Lm = `{
    id,
    title,
    type,
    designHTMLPublished,
    designStylePublished,
    layoutType,
    bodyHtml,
    headHtml,
    preventCopingAndSelectingText,
    ratingEnabled,
    progress{
        id,
        beginDate,
        rating {
            id,
            comment,
            rating,
            createdDate,
            updatedDate,
            files(filter:"{take:0}") {
                id,
                name,
                cloudKey,
                extension,
                size,
                type
            }
        }
    }
}`, gm = `{
    id,
    title,
    type,
    flowTimeDelayActive,
    flowTimeDelay,
    flowTimeDelayCondition,
    flowTimeDelayMeasureType,
    preventCopingAndSelectingText,
    allowComments,
    showComments,
    ratingEnabled,
    ratingCommentRequired,
    studentHasAccess,
    position,
    parentItem {
        id,
    }
    progress {
        id
    }
}`;
class ym extends I0 {
  constructor(e) {
    super();
    o(this, "libraryId");
    /**
     * Item we'd like to select
     * In addition to root branch, request the item section branch
     */
    o(this, "libraryItemId");
    /**
     * Request only the section items
     */
    o(this, "sectionId");
    this.sortName = "position", this.sortType = "Asc", e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class Nm {
  constructor(t) {
    o(this, "contentItemComment", {
      create: (t) => this.api.post("/school-content-item-comment", t, (e) => ({ id: e })),
      save: (t) => this.api.put("/school-content-item-comment", t),
      fetch: (t, e) => this.api.execute({ method: "GET", url: `/school-content-item-comment/${t}`, body: e }, (p) => ({
        filter: new Dh(p.filter),
        items: p.items.map(B2.fromJson),
        /** the student is not allowed to write comments — the comment form must be hidden */
        commentsBanned: p.commentsBanned === !0
      })),
      remove: (t) => this.api.delete(`/school-content-item-comment/${t}`)
    });
    o(this, "contentItemRating", {
      create: (t) => this.api.post("/school-content-item-rating", t, (e) => ({
        id: e.ratingId,
        progress: p2.fromJson(e.progress)
      })),
      save: (t) => {
        var e;
        return this.api.put("/school-content-item-rating", {
          ...t,
          fileIds: ((e = t.files) == null ? void 0 : e.map((p) => p.id)) ?? []
        });
      }
    });
    o(this, "studentCourse", {
      fetchItem: (t) => this.api.get(`/student-course/${t}`, mm, (e) => ({
        studentCourse: aM.fromJson(e.studentCourse),
        hasItemAccess: e.hasItemAccess
      })),
      startCourse: (t) => this.api.post("/student-course", { courseId: t }, (e) => ({
        studentCourseId: e.studentCourseId,
        currentCourseItemId: e.currentCourseItemId
      })),
      completeTheory: (t) => this.api.put("/student-course-item/complete-theory", { studentCourseItemProgressId: t }, (e) => ({
        progress: p2.fromJson(e)
      })),
      completeTest: (t, e, p) => this.api.post("/student-course-item/complete-test", { studentCourseItemProgressId: t, courseItemTestId: e, isRight: p }, (c) => p2.fromJson(c)),
      sendFeedback: (t, e) => this.api.post("/student-course/send-feedback", { studentCourseId: t, text: e }),
      item: {
        fetch: async (t) => {
          const e = (c) => this.api.execute({ method: "GET", url: "/student-course-item", body: t, fields: c }, (i) => i.items.map(Le.fromJson)), p = await e(Ra);
          return p.success ? p : e(Rm);
        },
        fetchItem: (t, e) => this.api.get(`/student-course-item/${t}/${e}`, "", Le.fromJson),
        resetTaskAnswerStatus: (t) => this.api.put("/student-course-item/task-answer/reset-status", { answerId: t }, (e) => ({
          progress: p2.fromJson(e)
        })),
        saveTaskAnswer: (t) => this.api.put("/student-course-item/task-answer", t, (e) => ({
          status: e.answerStatus,
          progress: p2.fromJson(e.progress)
        })),
        createTaskAnswer: (t) => this.api.post("/student-course-item/task-answer", t, (e) => ({
          id: e.answerId,
          status: e.answerStatus,
          progress: p2.fromJson(e.progress)
        })),
        fetchTaskAnswerComments: (t) => this.api.execute({ method: "GET", url: "/student-course-item/task-answer/comment", body: t }, (e) => ({
          filter: new Vh(e.filter),
          items: e.items.map(sb.fromJson)
        })),
        createTaskAnswerComment: (t) => this.api.post("/student-course-item/task-answer/comment", t, (e) => ({
          id: e
        })),
        saveTaskAnswerComment: (t) => this.api.put("/student-course-item/task-answer/comment", t),
        deleteTaskAnswerComment: (t) => this.api.delete(`/student-course-item/task-answer/comment/${t}`)
      }
    });
    o(this, "studentLibrary", {
      fetchLibrary: (t) => this.api.get(`/school-library/${t}`, "{ id, title, flowBeginDate }", (e) => ({
        library: Ne.fromJson(e)
      })),
      fetchLibraryItem: (t, e) => this.api.get(`/school-library-item/${t}/${e}`, Lm, (p) => ({
        item: Z2.fromJson(p)
      })),
      fetchLibraryItems: (t) => this.api.execute({ method: "GET", url: "/school-library-item", fields: gm, body: new ym({ libraryId: t, useBaseFilter: !1 }) }, (e) => ({
        items: e.items.map(Z2.fromJson)
      }))
    });
    o(this, "service", {
      trackForm: (t) => this.api.post("/t/f", t),
      contactInFilter: (t, e) => this.api.execute({
        method: "GET",
        url: "/service/contact-in-filter",
        body: {
          f: t,
          c: e
        }
      }, (p) => ({ isInFilter: p.isInFilter })),
      runCustomEvent: (t) => this.api.post("/service/run-custom-event", t)
    });
    this.api = t;
  }
}
class Q1 {
  constructor(t, e) {
    this.baseApi = t, this.settings = e;
  }
  create(t, e) {
    return this.baseApi.post(
      this.settings.endpoint,
      this.settings.serialize ? this.settings.serialize(t) : t.toJson(),
      e
    );
  }
  fetch(t, e) {
    return this.baseApi.getList(
      this.settings.endpoint,
      t ?? this.settings.defaultFields,
      e,
      (p) => ({
        filter: new I0(p.filter),
        items: p.items.map((c) => this.settings.parse(c))
      })
    );
  }
  fetchItem(t, e) {
    return this.baseApi.get(
      `${this.settings.endpoint}/${t}`,
      e ?? this.settings.defaultFields,
      this.settings.parse
    );
  }
  save(t) {
    return this.baseApi.put(
      this.settings.endpoint,
      this.settings.serialize ? this.settings.serialize(t) : { ...rh(t), id: t.id }
    );
  }
  delete(t, e) {
    return this.baseApi.delete(`${this.settings.endpoint}/${t}`, e);
  }
}
class Bm {
  constructor(t) {
    o(this, "member");
    o(this, "transaction");
    o(this, "transactionRequest");
    o(this, "offer");
    o(this, "order");
    o(this, "utmTagApi");
    o(this, "fetchTotals", (t) => this.api.post("/partnership/totals", { filter: t }, (e) => ({ items: e.items })));
    o(this, "fetchMaxAmount", () => this.api.get("/partnership/max-amount"));
    this.api = t, this.member = new Tm(this.api), this.transaction = new vm(this.api), this.transactionRequest = new Xm(this.api), this.offer = new _m(this.api), this.order = new wm(this.api), this.utmTagApi = new Sm(this.api);
  }
}
class Y8 extends I0 {
  constructor(e) {
    super();
    o(this, "dateFrom", null);
    o(this, "dateTo", null);
    o(this, "utmSources", []);
    o(this, "utmMediums", []);
    o(this, "utmCampaigns", []);
    o(this, "utmTerms", []);
    o(this, "utmContents", []);
    e && this.update(e);
  }
  get hasChanges() {
    return this.dateFrom !== null || this.dateTo !== null || this.utmSources.length > 0 || this.utmMediums.length > 0 || this.utmCampaigns.length > 0 || this.utmTerms.length > 0 || this.utmContents.length > 0;
  }
}
class vm extends Q1 {
  constructor(e) {
    super(e, {
      endpoint: "/partnership/transaction",
      parse: (p) => bb.fromJson(p),
      defaultFields: `{
                id,
                createdDate,
                amount,
                fee,
                comment,
                partner{
                    id,
                    firstName,
                    lastName,
                    email
                },
                student{
                    id,
                    firstName,
                    lastName,
                    email
                },
                type,
                order{
                    id,
                    number
                },
                validAfterDate,
                level,
                levelPartner{
                    id,
                    firstName,
                    lastName,
                    email
                }
            }`
    });
    o(this, "fetchTotals", (e) => this.api.post(this.settings.endpoint + "/totals", { filter: e }, (p) => ({ items: p.items })));
    this.api = e;
  }
}
let Tm = class extends Q1 {
  constructor(e) {
    super(e, {
      endpoint: "/partnership/member",
      parse: (p) => $p.fromJson(p),
      defaultFields: `{
                id,
                acceptedDate
            }`
    });
    o(this, "accept", () => this.api.put(this.settings.endpoint, { accepted: !0 }));
    this.api = e;
  }
};
class _m extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/offer",
      parse: (e) => nn.fromJson(e),
      defaultFields: `{
                id,
                title,
                url,
                urlsJson,
                description,
                fee,
                feeType,
                productType,
                levels,
                productLinks{
                    product{
                        id,
                        name
                    }
                }
            }`
    }), this.api = t;
  }
}
class wm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/order",
      parse: (e) => sM.fromJson(e)
    }), this.api = t;
  }
}
class Xm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/transaction/request",
      parse: (e) => rn.fromJson(e),
      defaultFields: `{
                id,
                amount,
                partnerComment,
                adminComment,
                status,
                createdDate
            }`
    }), this.api = t;
  }
}
class Sm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/partnership/utm",
      parse: (e) => e
    });
  }
}
class Dm {
  constructor(t) {
    o(this, "spaceItem");
    o(this, "post");
    o(this, "postComment");
    o(this, "member");
    o(this, "report");
    /**
     * Join community - creates member if not exists => reset tokens => update current user
     */
    o(this, "join", () => this.api.post("/community/join", {}, (t) => ee.fromJson(t)));
    this.api = t, this.spaceItem = new Cm(this.api), this.post = new Im(this.api), this.postComment = new km(this.api), this.member = new Pm(this.api), this.report = new Em(this.api);
  }
  /**
   * Get current member or null if not joined
   */
  // getCurrentMember = () => this.api.get<CommunityMember | null>('/community/member/current', '', json => json ? CommunityMember.fromJson(json) : null);
}
class Cm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/community/space",
      parse: (e) => zM.fromJson(e),
      defaultFields: `{
                id,
                title,
                titleEmoji,
                position,
                type,
                parentId,
                segment,
                viewAccessType,
                likesAccessType,
                commentsAccessType,
                publishAccessType,
                viewAccessExtendedFilterJson,
                likesAccessExtendedFilterJson,
                commentsAccessExtendedFilterJson,
                publishAccessExtendedFilterJson,
                children {
                    id
                },
                parent {
                    id,
                    position
                }
            }`
    }), this.api = t;
  }
}
class Im extends Q1 {
  constructor(e) {
    super(e, {
      endpoint: "/community/post",
      parse: (p) => Lt.fromJson(p),
      defaultFields: `{
                id,
                title,
                body,
                spaceId,
                number,
                createdDate,
                updatedDate,
                likesCount,
                commentsCount,
                viewsCount,
                status,
                isLikedByCurrentUser,
                space {
                    id,
                    title,
                    titleEmoji,
                    type
                },
                author {
                    id,
                    contact{
                        id,
                        firstName,
                        lastName,
                        email,
                        avatar {
                            id,
                            cloudKey,
                            size
                        }
                    },
                    badges {
                        badge {
                            id,
                            name,
                            description,
                            emoji,
                            image {
                                id,
                                cloudKey,
                                size
                            }
                        }
                    }
                },
                attachments(filter:"{sortName:'Position', sortType:'Asc', useBaseFilter: false}") {
                    id,
                    name,
                    position,
                    url,
                    file {
                        id,
                        cloudKey,
                        size,
                        type,
                        name,
                        extension
                    }
                },
                reports {
                    _count
                }
            }`
    });
    o(this, "like", (e) => this.api.post("/community/reaction", {
      postId: e,
      type: "like"
    }));
    o(this, "unlike", (e) => this.api.post("/community/reaction", {
      postId: e,
      type: "unlike"
    }));
    o(this, "fetchByNumber", (e) => this.api.get(`${this.settings.endpoint}/${e}`, this.settings.defaultFields, this.settings.parse));
    this.api = e;
  }
}
class km extends Q1 {
  constructor(e) {
    super(e, {
      endpoint: "/community/post/comment",
      parse: (p) => ft.fromJson(p)
    });
    o(this, "like", (e) => this.api.post("/community/reaction", {
      commentId: e,
      type: "like"
    }));
    o(this, "unlike", (e) => this.api.post("/community/reaction", {
      commentId: e,
      type: "unlike"
    }));
    this.api = e;
  }
}
class Pm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/community/member",
      parse: (p) => ee.fromJson(p),
      defaultFields: `{
                id,
                createdDate,
                updatedDate,
                lastActivityDate,
                role,
                viewRestrictionEnabled,
                likesRestrictionEnabled,
                commentsRestrictionEnabled,
                publishRestrictionEnabled,
                contact {
                    id,
                    firstName,
                    lastName,
                    email,
                    phone,
                    avatar {
                        id,
                        cloudKey,
                        size
                    }
                },
                badges {
                    badge {
                        
            id,
            name,
            description,
            emoji,
            image {
                id,
                cloudKey,
                size
            }
        
                    },
                    member {
                        id
                    }
                }
            }`
    }), this.api = t;
  }
}
class Em extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/community/report",
      parse: (e) => sn.fromJson(e),
      defaultFields: `{
                id,
                createdDate,
                updatedDate,
                text,
                type,
                post {
                    id,
                    title
                },
                comment {
                    id,
                    text
                },
                member {
                    id,
                    contact {
                        id,
                        firstName,
                        lastName,
                        email,
                        avatar {
                            id,
                            cloudKey,
                            size
                        }
                    }
                }
            }`
    }), this.api = t;
  }
}
const xm = `{
    canModerate,
    thread{
        id,
        title,
        description,
        designHTMLPublished,
        designStylePublished,
        canStudentCreateTopics,
        createdDate,
        updatedDate,
        lastActivityDate,
        topicCount,
        commentCount
    },
    threads{
        id,
        title,
        description,
        createdDate,
        updatedDate,
        lastActivityDate,
        topicCount,
        commentCount
    },
    topics{
        id,
        title,
        text,
        createdDate,
        updatedDate,
        lastActivityDate,
        commentCount,
        lastComment{
            id,
            createdDate,
            student{
                id,
                firstName,
                lastName
            }
        },
        student{
            id,
            firstName,
            lastName,
            email
        }
    },
    breadcrumbs(filter:"{useSort:false}"){
        id, 
        title
    },
    banStatus{
        type,
        untilDate
    }
}`, Fm = `{
    canModerate,
    topic{
        id,
        title,
        text,
        createdDate,
        updatedDate,
        lastActivityDate,
        commentCount,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        },
        files{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        },
        likeCount,
        dislikeCount,
        currentUserReaction{
            id,
            type
        }
    },
    breadcrumbs(filter:"{useSort:false}"){
        id, 
        title
    },
    banStatus{
        type,
        untilDate
    }
}`, Um = `{
    id,
    text,
    createdDate,
    updatedDate,
    sequenceNumber,
    replyToComment{
        id,
        text,
        createdDate,
        sequenceNumber,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        }
    }
    student{
        id,
        firstName,
        lastName,
        email,
        avatar {
            id,
            cloudKey
        }
    },
    files{
        id,
        name,
        cloudKey,
        extension,
        size,
        type
    },
    likeCount,
    dislikeCount,
    currentUserReaction{
        id,
        type
    }
}`, Jm = `
        id,
        text,
        createdDate,
        sequenceNumber,
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        }
    `, Hm = `{
        id,
        text,
        createdDate,
        updatedDate,
        sequenceNumber,
        replyToComment{
           ${Jm}
        }
        student{
            id,
            firstName,
            lastName,
            email,
            avatar {
                id,
                cloudKey
            }
        },
        files{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        },
        likeCount,
        dislikeCount,
        currentUserReaction{
            id,
            type
        }
    }`;
class Ym {
  constructor(t) {
    o(this, "thread");
    o(this, "topic");
    o(this, "comment");
    o(this, "reaction");
    o(this, "blockStudent", async (t, e, p, c, i, s, u) => this.api.post("/forum/block-student", {
      threadId: t,
      studentId: e,
      beginDate: p,
      endDate: c,
      reason: i,
      topicId: s,
      commentId: u
    }));
    this.api = t, this.thread = new Gm(t), this.topic = new $m(t), this.comment = new Vm(t), this.reaction = new Km(t);
  }
}
class Gm {
  constructor(t) {
    o(this, "fetchThread", async (t) => {
      const e = t ? `/forum/thread/${t}` : "/forum/thread";
      return this.api.execute({ method: "GET", url: e, fields: xm }, (p) => ({
        canModerate: p.canModerate,
        thread: p.thread ? lt.fromJson(p.thread) : null,
        threads: p.threads.map(lt.fromJson),
        topics: p.topics.map(Ab.fromJson),
        breadcrumbs: p.breadcrumbs.map(lt.fromJson),
        banStatus: p.banStatus ? {
          ...p.banStatus,
          untilDate: p.banStatus.untilDate ? new Date(p.banStatus.untilDate) : null
        } : null
      }));
    });
    this.api = t;
  }
}
class $m {
  constructor(t) {
    o(this, "fetchTopic", async (t) => this.api.execute({ method: "GET", url: `/forum/topic/${t}`, fields: Fm }, (e) => ({
      canModerate: e.canModerate,
      topic: Ab.fromJson(e.topic),
      breadcrumbs: e.breadcrumbs.map(lt.fromJson),
      banStatus: e.banStatus ? {
        ...e.banStatus,
        untilDate: e.banStatus.untilDate ? new Date(e.banStatus.untilDate) : null
      } : null
    })));
    o(this, "createTopic", async (t, e, p, c) => this.api.post("/forum/topic", { threadId: t, title: e, text: p, files: c }));
    o(this, "updateTopic", async (t, e, p) => this.api.put("/forum/topic", { id: t, text: e, files: p }));
    o(this, "deleteTopic", async (t) => this.api.delete(`/forum/topic/${t}`));
    this.api = t;
  }
}
class Vm {
  constructor(t) {
    o(this, "fetchTopicComments", async (t) => this.api.getList("/forum/topic/comment", Um, t, (e) => ({
      filter: new Wa(e.filter),
      items: e.items.map(Rt.fromJson)
    })));
    o(this, "createTopicComment", async (t, e, p, c) => this.api.post("/forum/topic/comment", { topicId: t, text: e, replyId: p, files: c, fields: Hm }, (i) => ({
      comment: Rt.fromJson(i.comment),
      itemsTotal: i.itemsTotal
    })));
    o(this, "updateTopicComment", async (t, e, p, c) => this.api.put("/forum/topic/comment", { id: t, text: e, files: p, replyId: c }));
    o(this, "deleteTopicComment", async (t) => this.api.delete(`/forum/topic/comment/${t}`));
    o(this, "fetchTopicCommentPosition", async (t, e) => {
      const p = `/forum/topic/${t}/comment-position/${e}`;
      return this.api.execute({ method: "GET", url: p }, (c) => c.body);
    });
    this.api = t;
  }
}
class Km {
  constructor(t) {
    o(this, "create", async (t, e, p) => this.api.post("/forum/reaction", { topicId: t, commentId: e, type: p }, (c) => mt.fromJson(c)));
    o(this, "update", async (t, e) => this.api.put("/forum/reaction", { id: e, type: t }, (p) => mt.fromJson(p)));
    o(this, "delete", async (t) => this.api.delete(`/forum/reaction/${t}`));
    this.api = t;
  }
}
class Qm extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/student/bonus-transaction",
      parse: (e) => tM.fromJson(e),
      defaultFields: `{
                id,
                amount,
                comment,
                createdDate,
                order{
                    id,
                    number
                },
                type,
                transaction{
                    id
                },
                validUntilDate
            }`
    });
  }
}
const Zm = `{
    id,
    number,
    createdDate,
    image {
        id,
        name,
        cloudKey,
        extension,
        size,
        type
    },
    course {
        id,
        name
    },
    cert {
        id,
        name
    }
}`;
class jm {
  constructor(t) {
    /** The student's certificates, newest first. */
    o(this, "fetch", (t = {}) => this.api.execute({
      url: "/student/cert",
      method: "GET",
      body: new I0({ take: 200, sortName: "createdDate", sortType: "Desc", ...t }),
      fields: Zm
    }, (e) => (e.items ?? []).map((p) => ({
      id: p.id,
      number: p.number,
      createdDate: p.createdDate ? new Date(p.createdDate) : null,
      image: p.image ? D1.fromJson(p.image) : null,
      course: p.course ? { id: p.course.id, name: p.course.name } : null,
      cert: p.cert ? { id: p.cert.id, name: p.cert.name } : null
    }))));
    this.api = t;
  }
}
const eR = `{
            id,
            beginDate,
            endDate,
            type,
            coursePlan {
                id,
                name,
                softDeleted,
                course {
                    id,
                    name,
                    softDeleted
                }
            },
            course {
                id,
                name,
                softDeleted,
                primaryImage{
                    id,
                    file{
                        id,
                        name,
                        cloudKey,
                        extension,
                        size,
                        type
                    }
                }
            },
            libraryAccess{
                library{
                    id,
                    name,
                    softDeleted,
                    primaryImage{
                        id,
                        file{
                            id,
                            name,
                            cloudKey,
                            extension,
                            size,
                            type
                        }
                    }
                }
            }
        }`;
class tR {
  constructor(t) {
    o(this, "fetch", (t, e = eR) => this.api.execute({ url: "/student/license", method: "GET", body: t, fields: e }, (p) => ({ items: p.items.map(tb.fromJson), filter: p.filter })));
    this.api = t;
  }
}
const MR = `{
                id,
                createdDate,
                paidDate,
                currency,
                isDigitalDelivery,
                fullyPaid,
                shippingPrice,
                totalAmount,
                paidAmount,
                savingsAmount,
                status,
                completed,
                number,
                contents{
                    id,
                    quantity,
                    product{
                        id,
                        name,
                        type,
                        price,
                        softDeleted
                    }
                }
            }`;
class bR extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/student/order",
      parse: (e) => sM.fromJson(e),
      defaultFields: MR
    }), this.api = t;
  }
}
const lO = `{
    id,
    beginDate,
    endDate,
    creditEndDate,
    type,
    state,
    product{
        id,
        name,
        subsPrice,
        subsDuration,
        subsDurationType,
        image{
            id,
            name,
            cloudKey,
            extension,
            size,
            type
        }
    },
    currentSuspension{
        id,
        beginDate,
        endDate
    }
}`;
class pR {
  constructor(t) {
    o(this, "fetch", (t, e = lO) => this.api.get("/student/subscription", e, (p) => ({
      items: p.items.map(tb.fromJson),
      filter: new bn(p.filter)
    })));
    o(this, "fetchItem", (t, e = lO) => this.api.get(`/student/subscription/${t}`, e, (p) => tb.fromJson(p)));
    o(this, "save", (t) => this.api.put("/student/subscription", { id: t.id, state: { value: t.state } }));
    this.api = t;
  }
}
class zR {
  constructor(t) {
    o(this, "order");
    o(this, "sub");
    o(this, "license");
    o(this, "bonusTransaction");
    o(this, "cert");
    o(this, "save", (t) => {
      var e;
      return this.api.put("/student", {
        avatarId: t.avatarId,
        email: t.email,
        firstName: t.firstName,
        middleName: t.middleName,
        lastName: t.lastName,
        phone: t.phone,
        gender: t.gender,
        birthday: (e = t.birthday) == null ? void 0 : e.toISOString(),
        password: t.password
      });
    });
    o(this, "resendEmailConfirmation", () => this.api.post("/student/resend-email-confirmation", null));
    o(this, "selectLang", (t) => this.api.put("/student/select-lang", { lang: t }));
    o(this, "updatePassword", (t) => this.api.put("/student/update-password", { password: t }));
    this.api = t, this.order = new bR(this.api), this.sub = new pR(this.api), this.license = new tR(this.api), this.bonusTransaction = new Qm(this.api), this.cert = new jm(this.api);
  }
}
class oR {
  constructor(t) {
    o(this, "product");
    o(this, "transaction");
    o(this, "fetchTotals", () => this.api.get("/gamification/totals"));
    o(this, "fetchBalance", () => this.api.get("/gamification/balance"));
    o(this, "fetchAchievements", (t) => this.api.getList(
      "/gamification/achievement",
      void 0,
      t,
      (e) => ({
        items: e.items.map(qt.fromJson),
        filter: new em(e.filter)
      })
    ));
    o(this, "fetchLeaders", (t) => this.api.getList(
      "/gamification/leaders",
      void 0,
      t,
      (e) => ({
        items: e.items.map(gp.fromJson),
        filter: new la(e.filter)
      })
    ));
    this.api = t, this.product = new cR(this.api), this.transaction = new nR(this.api);
  }
}
class cR extends Q1 {
  constructor(e) {
    super(e, {
      endpoint: "/gamification/product",
      parse: (p) => Mb.fromJson(p),
      defaultFields: ""
    });
    o(this, "pay", (e) => this.api.post(this.settings.endpoint, { productId: e }));
    this.api = e;
  }
}
class nR extends Q1 {
  constructor(t) {
    super(t, {
      endpoint: "/gamification/transaction",
      parse: (e) => GM.fromJson(e),
      defaultFields: ""
    }), this.api = t;
  }
}
class iR {
  constructor(t) {
    /**
     * Get single event by ID
     */
    o(this, "getItem", (t) => this.api.get(
      `/event-calendar/${t}`,
      "",
      (e) => yp.fromJson(e)
    ));
    /**
     * Get list of events with filter
     */
    o(this, "getItems", (t) => this.api.getList(
      "/event-calendar",
      void 0,
      t,
      (e) => ({
        items: e.items.map(yp.fromJson),
        filter: new bm(e.filter)
      })
    ));
    /**
     * Register for an event
     */
    o(this, "register", (t) => this.api.post("/event-calendar/register", { id: t }));
    this.api = t;
  }
}
const rR = `{
    id,
    beginDate,
    endDate,
    state,
    flowBeginDate,
    accessBeginDate,
    course{
        id,
        name,
        dontAskFeedback,
        appearanceSettingsJson
    },
    currentCourseItem{
        id
    },        
    student{
        id,
        firstName,
        lastName
    },
    progress
}`;
class OR {
  constructor(t) {
    o(this, "fetchStudentCourse", async (t) => this.api.get(`/student-course-preview/${t}`, rR, (e) => ({
      studentCourse: aM.fromJson(e)
    })));
    o(this, "fetchStudentCourseItem", async (t, e) => this.api.get(`/student-course-preview/${t}/items/${e}`, "", (p) => ({
      studentCourseItem: Le.fromJson(p)
    })));
    o(this, "fetchStudentCourseItems", async (t) => this.api.get(`/student-course-preview/${t}/items`, "", (e) => ({
      items: e.items.map(Le.fromJson)
    })));
    o(this, "completeStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/complete", { studentCourseId: t, courseItemId: e }, (p) => ({
      progresses: p.map(p2.fromJson)
    })));
    o(this, "resetStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/uncomplete", { studentCourseId: t, courseItemId: e }, (p) => ({
      progresses: p.map(p2.fromJson)
    })));
    o(this, "unblockStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/open", { studentCourseId: t, courseItemId: e }, (p) => ({
      progresses: p.map(p2.fromJson)
    })));
    o(this, "blockStudentCourseItem", async (t, e) => this.api.post("/student-course-preview/item/close", { studentCourseId: t, courseItemId: e }, (p) => ({
      progresses: p.map(p2.fromJson)
    })));
    this.api = t;
  }
}
class aR {
  constructor(t) {
    o(this, "fetchCourse", async (t) => this.api.get(`/course-preview/${t}`, "{ id, name }", (e) => ({
      course: be.fromJson(e)
    })));
    o(this, "fetchCourseItem", async (t, e) => this.api.get(`/course-preview/${t}/items/${e}`, "", (p) => ({
      courseItem: Le.fromJson(p)
    })));
    o(this, "fetchCourseItems", async (t, e) => this.api.execute({ method: "GET", url: `/course-preview/${t}/items`, body: { planId: e } }, (p) => ({
      items: p.items.map(Le.fromJson)
    })));
    o(this, "fetchCoursePlans", async (t) => this.api.get(
      `/course-preview/${t}/plans`,
      `{
        id,
        name,
        disableTimeLimits,
        softDeleted
    }`,
      (e) => ({
        filter: new Xh(e.filter),
        items: e.items.map(OM.fromJson)
      })
    ));
    this.api = t;
  }
}
const sR = `{
    id,
    type,
    payloadJson,
    createdDate,
    seenDate,
    adminId,
    studentId,
    adminTaskId,
    courseItemId,
    libraryItemId,
    orderId,
    orderPaymentId,
    scenarioId,
    chatConversationId,
    courseId,
    libraryId,
    courseItemTaskId,
    schoolContentItemCommentId,
    communityPostId,
    communityCommentId,
}`, AR = `{
    useEmail,
    email,
    customEmail,
    useTg,
    tgId,
    tgLink,
    channels {
        id,
        useSite,
        useEmail,
        useTg,
        notificationType,
        subscriptionId
    }
}`;
class dR {
  constructor(t) {
    o(this, "settings");
    o(this, "channel");
    o(this, "fetch", async (t) => this.api.getList("/notification", sR, t, (e) => ({
      items: e.items.map(Gp.fromJson),
      filter: new pm(e.filter)
    })));
    o(this, "save", async (t) => this.api.put("/notification", { id: t.id, seenDate: v2(t.seenDate) }));
    o(this, "delete", async (t) => this.api.delete(`/notification/${t}`));
    o(this, "fetchCount", async (t) => this.api.execute({ method: "GET", url: "/notification/count", body: t }, (e) => ({
      count: e
    })));
    o(this, "markAllAsRead", async () => this.api.post("/notification/markAllAsRead", {}));
    this.api = t, this.settings = new uR(this.api), this.channel = new qR(this.api);
  }
}
class uR {
  constructor(t) {
    o(this, "fetch", async () => this.api.get("/notification/settings", AR, (t) => ({
      settings: cn.fromJson(t)
    })));
    o(this, "save", async (t) => this.api.put("/notification/settings", {
      useEmail: v2(t.useEmail),
      customEmail: v2(t.customEmail ?? void 0),
      useTg: v2(t.useTg)
    }));
    this.api = t;
  }
}
class qR {
  constructor(t) {
    o(this, "create", async (t) => this.api.post("/notification/channel", {
      notificationType: t.notificationType,
      useSite: t.useSite,
      useEmail: t.useEmail,
      useTg: t.useTg
    }, (e) => ({
      id: e
    })));
    o(this, "save", async (t, e) => this.api.put("/notification/channel", {
      id: t,
      useEmail: v2(e.useEmail),
      useSite: v2(e.useSite),
      useTg: v2(e.useTg)
    }));
    this.api = t;
  }
}
class lR {
  constructor(t) {
    o(this, "fetch", async (t, e) => this.api.execute(
      { method: "GET", url: "/localization", body: { lang: t, timestamp: e } },
      (p) => ({
        words: p.words ? p.words : {},
        timestamp: p.timestamp,
        needSync: p.needSync,
        excludedLangs: p.excludedLangs ?? []
      })
    ));
    this.api = t;
  }
}
class fR {
  constructor(t) {
    o(this, "download", (t, e = !1) => this.api.get(`/file/${t}?isPreview=${e}`));
    o(this, "abort", (t) => this.api.execute({ url: "/file/abort", method: "PUT", headers: { "X-Content-Id": t } }));
    o(this, "begin", (t, e, p) => {
      const c = {};
      return c["X-Content-Type"] = t.type ? t.type : "application/octet-stream", t.size && (c["X-Content-Length"] = t.size), e && (c["X-Chunk-Size"] = e), t.name && (c["X-Content-Name"] = encodeURI(t.name)), p.fileId && (c["X-Content-File-Id"] = p.fileId), p.source && (c["X-Source"] = p.source), p.schoolId && (c["X-School-Id"] = p.schoolId), p.courseItemId && (c["X-Course-Item-Id"] = p.courseItemId), p.courseItemTaskId && (c["X-Course-Item-Task-Id"] = p.courseItemTaskId), p.courseItemTestId && (c["X-Course-Item-Test-Id"] = p.courseItemTestId), p.courseItemTestQuestionId && (c["X-Course-Item-Test-Question-Id"] = p.courseItemTestQuestionId), p.courseItemTestAnswerId && (c["X-Course-Item-Test-Answer-Id"] = p.courseItemTestAnswerId), p.courseItemTaskAnswerId && (c["X-Course-Item-Task-Answer-Id"] = p.courseItemTaskAnswerId), p.courseItemTaskAnswerCommentId && (c["X-Course-Item-Task-Answer-Comment-Id"] = p.courseItemTaskAnswerCommentId), p.isPublic && (c["X-Is-Public"] = p.isPublic), p.siteId && (c["X-Site-Id"] = p.siteId), p.meta && (c["X-Meta"] = JSON.stringify(p.meta)), p.voice && (c["X-Voice"] = p.voice), this.api.execute({
        url: "/file/begin",
        method: "POST",
        headers: c
      });
    });
    o(this, "complete", (t, e) => this.api.execute({ url: "/file/complete", method: "POST", body: { id: t, eTags: e } }, (p) => D1.fromJson(p)));
    o(this, "save", (t) => this.api.execute({
      url: "/file",
      method: "PUT",
      body: {
        id: t.id,
        name: v2(t.name),
        description: v2(t.description),
        isPublic: v2(t.isPublic),
        metadataJson: v2(t.additionalData ? JSON.stringify(t.additionalData) : void 0)
      }
    }));
    o(this, "remove", (t) => this.api.execute({ url: `/file/${t}`, method: "DELETE" }));
    /**
     * Prepares a file for future use, calc metadata, convert to another type if needed, etc.
     */
    o(this, "prepare", (t) => this.api.execute({ method: "PUT", url: `/file/prepare/${t}` }));
    this.api = t;
  }
}
class WR {
  constructor(t) {
    //#region Methods
    o(this, "auth", new lm(this));
    o(this, "file", new fR(this));
    o(this, "loc", new lR(this));
    o(this, "announcement", new fm(this));
    o(this, "content", new Wm(this));
    o(this, "school", new hm(this));
    o(this, "education", new Nm(this));
    o(this, "partnership", new Bm(this));
    o(this, "community", new Dm(this));
    o(this, "forum", new Ym(this));
    o(this, "account", new zR(this));
    o(this, "gamification", new oR(this));
    o(this, "eventCalendar", new iR(this));
    o(this, "coursePreview", new aR(this));
    o(this, "studentCoursePreview", new OR(this));
    o(this, "notification", new dR(this));
    this.client = t;
  }
  //#endregion
  //#region Core
  async execute(t, e) {
    const p = { ...t, v: t.v ?? 1, authorized: t.authorized ?? !0, cancellationToken: new AbortController() }, c = await this.client.execute(p, this);
    return c.body && e && (c.body = e(c.body)), c;
  }
  async put(t, e, p) {
    return this.execute({ method: "PUT", url: t, body: e }, p);
  }
  async get(t, e = "", p) {
    return this.execute({ method: "GET", url: t, fields: e }, p);
  }
  async getList(t, e = "", p, c) {
    const i = {
      method: "GET",
      url: t,
      fields: e,
      body: p ?? {},
      cancellationToken: new AbortController()
    }, s = await this.execute(i);
    return s.body && c && (s.body = c(s.body)), s;
  }
  async post(t, e, p) {
    return this.execute({ method: "POST", url: t, body: e }, p);
  }
  async delete(t, e) {
    return this.execute({ method: "DELETE", url: t }, e);
  }
  //#endregion
}
class hR {
  constructor(t) {
    this.sdk = t;
  }
  get isAuthenticated() {
    return this.sdk.tokenStorage.hasTokens;
  }
  async login(t, e = !1) {
    if (u1(t.email) || u1(t.password))
      throw new Error("Email and password are required");
    const p = await this.sdk.api.auth.login(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async register(t, e = !1) {
    if (u1(t.email) || u1(t.password))
      throw new Error("Email and password are required");
    const p = await this.sdk.api.auth.register(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async logout(t = !1) {
    var c;
    const e = (c = this.sdk.tokenStorage.tokens) == null ? void 0 : c.refreshToken;
    if (!e) throw new Error("No refresh token");
    const p = await this.sdk.api.auth.logout(e);
    return p.success && (await this.sdk.tokenStorage.setTokens(null, t), this.sdk.dispatcher.emit("auth.logout", void 0)), p;
  }
  async refreshToken(t, e = !1) {
    if (!t) throw new Error("Refresh token is required");
    const p = await this.sdk.api.auth.refreshToken(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  // TODO: check if needed
  // async registerContact(body: RegisterContactRequestBody) {
  //     const result = await this.sdk.api.auth.registerContact(body);
  //     return result;
  // }
  // A new password closes the student's sessions and answers with a fresh pair (same as confirmEmail): store it,
  // so the link from the email signs them in — a student moved from another platform lands in the course right away.
  async resetPassword(t, e = !0) {
    if (!t.token || u1(t.password) || u1(t.confirmPassword))
      throw new Error("Token, password and confirmPassword are required");
    const p = await this.sdk.api.auth.resetPassword(t);
    return p.success && p.body && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  // Confirming closes the student's sessions and answers with a fresh pair (same as confirmInvite):
  // without storing it the student is logged out right after confirming.
  async confirmEmail(t, e = !0) {
    if (!t.token || !t.userId)
      throw new Error("Token and userId are required");
    const p = await this.sdk.api.auth.confirmEmail(t);
    return p.success && p.body && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async checkInvite(t) {
    if (!t) throw new Error("Invite token is required");
    return await this.sdk.api.auth.checkInvite(t);
  }
  // The server closes the student's sessions and answers with a fresh pair — without storing it
  // the invite page navigates an anonymous visitor to "/" and the school throws them back to login.
  // Waits for the user by default: the only caller navigates right after.
  async confirmInvite(t, e = !0) {
    var c;
    if (!t.token || !t.password || !t.confirmPassword)
      throw new Error("Token, password and confirmPassword are required");
    const p = await this.sdk.api.auth.confirmInvite(t);
    return p.success && ((c = p.body) != null && c.jwtCredential) && await this.sdk.tokenStorage.setTokens(p.body.jwtCredential, e), p;
  }
  async sendInvite(t) {
    if (u1(t)) throw new Error("Email is required");
    return await this.sdk.api.auth.sendInvite(t);
  }
  async forgotPassword(t) {
    if (u1(t)) throw new Error("Email is required");
    return await this.sdk.api.auth.forgotPassword(t);
  }
  async loginToken(t, e = !1) {
    if (u1(t)) throw new Error("Token is required");
    const p = await this.sdk.api.auth.loginToken(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async loginAs(t, e = !1) {
    const p = await this.sdk.api.auth.loginAs(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async prolongSession(t, e = !1) {
    if (!t) throw new Error("Refresh token is required");
    const p = await this.sdk.api.auth.prolongSession(t);
    return p.success && await this.sdk.tokenStorage.setTokens(p.body, e), p;
  }
  async fetchContact(t) {
    if (u1(t)) throw new Error("Contact id is required");
    return await this.sdk.api.auth.fetchContact(t);
  }
  async fetchMe() {
    return await this.sdk.api.auth.fetchMe();
  }
  async fetchEmailNotificationsSubscriptionStatus(t) {
    if (u1(t.studentId)) throw new Error("Student id is required");
    return await this.sdk.api.auth.fetchEmailNotificationsSubscriptionStatus(t);
  }
  async fetchStudentEmailStatus(t) {
    if (u1(t.studentId) || u1(t.messageId))
      throw new Error("studentId and messageId is required");
    return await this.sdk.api.auth.fetchStudentEmailStatus(t);
  }
  async unsubscribeStudentEmailStatus(t) {
    if (u1(t.messageId))
      throw new Error("messageId is required");
    return await this.sdk.api.auth.unsubscribeStudentEmailStatus(t);
  }
  async unsubscribeEmailNotifications(t) {
    if (u1(t.studentId)) throw new Error("Student id is required");
    return await this.sdk.api.auth.unsubscribeEmailNotifications(t);
  }
}
class mR extends Ob {
  constructor(t) {
    super(), this.sdk = t;
  }
  async fetchItems(t) {
    return this.sdk.api.content.fetch(t || this.filter);
  }
}
class fO {
  constructor(t, e) {
    o(this, "store");
    this.sdk = t, this.store = new mR(t), e && this.store.updateFilter(e);
  }
  async init() {
    this.store.inited || await this.store.fetch();
  }
}
class RR extends Ob {
  constructor(t) {
    super(), this.sdk = t, this.sdk = t;
  }
  async fetchItems(t) {
    return await this.sdk.api.account.license.fetch(t ?? this.filter);
  }
  createFilter(t) {
    return new bn({ ...this.filter, ...t });
  }
  async startCourse(t) {
    return await this.sdk.api.education.studentCourse.startCourse(t);
  }
}
class LR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.account.bonusTransaction;
  }
  createFilter(t) {
    return new nm({ ...this.filter, ...t });
  }
}
class gR extends Ob {
  constructor(t) {
    super(), this.sdk = t;
  }
  async fetchItems(t) {
    return await this.sdk.api.account.sub.fetch(t ?? this.filter);
  }
  async fetchItem(t, e) {
    return await this.sdk.api.account.sub.fetchItem(t, e);
  }
  createFilter(t) {
    return new bn({ ...this.filter, ...t });
  }
  async save(t, e) {
    const p = await this.sdk.api.account.sub.save({ id: t.id, ...e });
    return p.success && t.update(e), p;
  }
}
class yR extends z2 {
  constructor(t) {
    super(), this.sdk = t, this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.account.order;
  }
}
class NR {
  constructor(t) {
    o(this, "user", null);
    o(this, "license");
    o(this, "order");
    o(this, "bonus");
    o(this, "subscription");
    this.sdk = t, this.sdk.dispatcher.on("auth.token.changed", this.onTokenChanged.bind(this)), this.license = new RR(this.sdk), this.bonus = new LR(this.sdk), this.subscription = new gR(this.sdk), this.order = new yR(this.sdk);
  }
  get isAuthorized() {
    return this.user != null;
  }
  setUser(t) {
    this.user = t, this.sdk.dispatcher.emit("auth.user.changed", this.user);
  }
  async onTokenChanged(t) {
    t ? await this.fetchUser() : this.setUser(null);
  }
  async fetchUser() {
    var e;
    const t = await this.sdk.api.auth.fetchMe();
    return t.success ? this.setUser(t.body) : (this.setUser(null), this.sdk.dispatcher.emit("error", { message: ((e = t.errors[0]) == null ? void 0 : e.message) ?? "Token invalid or expired" })), t;
  }
  // async saveUser(user: SaveStudentModel) {
  //     const result = await this.sdk.api.account.save(user);
  //     if (result.success) {
  //         this.user?.update(user);
  //         this.setUser(this.user);
  //     }
  //     return result;
  // }
}
class La extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.member;
  }
  createFilter(t) {
    return new rm({ ...this.filter, ...t });
  }
  async acceptAgreement(t) {
    const e = await this.sdk.api.partnership.member.accept();
    return e.success && t.update({ acceptedDate: R() }), e;
  }
}
class BR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.offer;
  }
  createFilter(t) {
    return new im({ ...this.filter, ...t });
  }
}
class vR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.order;
  }
  createFilter(t) {
    return new Zh({ ...this.filter, ...t });
  }
}
class TR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.partnership.transactionRequest;
  }
  createFilter(t) {
    return new Om({ ...this.filter, ...t });
  }
}
var ga = /* @__PURE__ */ ((M) => (M[M.InvalidModel = 0] = "InvalidModel", M[M.UserNotFound = 1] = "UserNotFound", M[M.InternalError = 2] = "InternalError", M[M.MustSpecifyFieldsToSelect = 3] = "MustSpecifyFieldsToSelect", M[M.IsRequired = 4] = "IsRequired", M[M.TokenExpired = 5] = "TokenExpired", M[M.AccessDenied = 6] = "AccessDenied", M[M.FileNotFound = 7] = "FileNotFound", M[M.NeedFillField = 8] = "NeedFillField", M[M.EditingProhibited = 9] = "EditingProhibited", M[M.LoginFailed = 10] = "LoginFailed", M[M.RequestLogLevelFailed = 11] = "RequestLogLevelFailed", M[M.UnknownTimezone = 12] = "UnknownTimezone", M[M.NumberAttemptsExceeded = 13] = "NumberAttemptsExceeded", M[M.EmailAlreadyConfirmed = 14] = "EmailAlreadyConfirmed", M[M.AlreadyExists = 15] = "AlreadyExists", M[M.EmailAlreadyExists = 16] = "EmailAlreadyExists", M[M.InvalidDatePeriod = 17] = "InvalidDatePeriod", M[M.FailedSendEmail = 18] = "FailedSendEmail", M[M.InvalidEmail = 19] = "InvalidEmail", M[M.EmailNotConfirmed = 20] = "EmailNotConfirmed", M[M.EmailNotFound = 21] = "EmailNotFound", M[M.AlreadyHasDifferentWebhook = 27] = "AlreadyHasDifferentWebhook", M[M.AlreadyHasBeenChanged = 31] = "AlreadyHasBeenChanged", M[M.InvalidParameter = 1e3] = "InvalidParameter", M[M.WrongPassword = 1001] = "WrongPassword", M[M.PasswordMustBeBetween6And30Characters = 1002] = "PasswordMustBeBetween6And30Characters", M[M.PasswordAndConfirmationPasswordDoNotMatch = 1003] = "PasswordAndConfirmationPasswordDoNotMatch", M[M.InvalidRefreshToken = 1005] = "InvalidRefreshToken", M[M.UserAlreadyExist = 1006] = "UserAlreadyExist", M[M.InvalidAccessToken = 1007] = "InvalidAccessToken", M[M.InvalidResetToken = 1008] = "InvalidResetToken", M[M.SchoolNotFound = 1009] = "SchoolNotFound", M[M.CannotDeleteOwnerFromSchool = 1010] = "CannotDeleteOwnerFromSchool", M[M.SchoolPhoneInsufficientFunds = 1011] = "SchoolPhoneInsufficientFunds", M[M.LockedSchoolAccessDenied = 1012] = "LockedSchoolAccessDenied", M[M.LockedUserAccessDenied = 1013] = "LockedUserAccessDenied", M[M.ConfirmCodeSendExceedLimit = 1014] = "ConfirmCodeSendExceedLimit", M[M.InvalidConfirmCode = 1015] = "InvalidConfirmCode", M[M.NewPasswordMustBeDifferent = 1016] = "NewPasswordMustBeDifferent", M[M.ResetPasswordRequired = 1017] = "ResetPasswordRequired", M[M.LocWordAlreadyExist = 2001] = "LocWordAlreadyExist", M[M.LocWordNotFound = 2002] = "LocWordNotFound", M[M.LocTranslationNotFound = 2003] = "LocTranslationNotFound", M[M.LocNeedFillFields = 2004] = "LocNeedFillFields", M[M.LocLanguageNotFound = 2005] = "LocLanguageNotFound", M[M.LocWordNeedText = 2006] = "LocWordNeedText", M[M.LocWordNeedTranslations = 2007] = "LocWordNeedTranslations", M[M.LocTranslationNeedText = 2008] = "LocTranslationNeedText", M[M.LocNeedFields = 2009] = "LocNeedFields", M[M.EmailTemplateNotFound = 3001] = "EmailTemplateNotFound", M[M.PhoneAlreadyExist = 4001] = "PhoneAlreadyExist", M[M.InvalidPhone = 4002] = "InvalidPhone", M[M.SchoolAlreadyExist = 5001] = "SchoolAlreadyExist", M[M.SchoolAdminNotFound = 5002] = "SchoolAdminNotFound", M[M.SchoolProfileSettingsNotFound = 5003] = "SchoolProfileSettingsNotFound", M[M.SchoolStatisticsNotFound = 5101] = "SchoolStatisticsNotFound", M[M.SchoolBillingNotFound = 5201] = "SchoolBillingNotFound", M[M.SchoolDomainAlreadyExist = 5251] = "SchoolDomainAlreadyExist", M[M.CourseNotFound = 6001] = "CourseNotFound", M[M.CoursePlanNotFound = 6002] = "CoursePlanNotFound", M[M.CourseCategoryNotFound = 6003] = "CourseCategoryNotFound", M[M.CourseAlreadyContainsPackage = 6005] = "CourseAlreadyContainsPackage", M[M.CourseNotFoundPackageLink = 6006] = "CourseNotFoundPackageLink", M[M.CourseCategoryRequireName = 6007] = "CourseCategoryRequireName", M[M.CourseAlreadyContainCategory = 6008] = "CourseAlreadyContainCategory", M[M.CourseNotContainCategory = 6009] = "CourseNotContainCategory", M[M.CourseItemNotFound = 6010] = "CourseItemNotFound", M[M.CourseFileBelongsToAnotherCourse = 6011] = "CourseFileBelongsToAnotherCourse", M[M.CourseItemNotValidPosition = 6013] = "CourseItemNotValidPosition", M[M.CourseItemAlreadyContainsPlan = 6014] = "CourseItemAlreadyContainsPlan", M[M.CourseItemNotFoundPlanLink = 6015] = "CourseItemNotFoundPlanLink", M[M.CourseItemCommentNotFound = 6016] = "CourseItemCommentNotFound", M[M.CourseItemTaskNotFound = 6016] = "CourseItemTaskNotFound", M[M.CourseItemTestQuestionNotFound = 6017] = "CourseItemTestQuestionNotFound", M[M.CourseItemTestAnswerNotFound = 6018] = "CourseItemTestAnswerNotFound", M[M.CourseItemTestNotFound = 6019] = "CourseItemTestNotFound", M[M.CourseStudentNotFound = 6020] = "CourseStudentNotFound", M[M.CourseItemTestQuestionMustHaveCorrectAnswer = 6021] = "CourseItemTestQuestionMustHaveCorrectAnswer", M[M.CourseItemTaskFieldNotFound = 6027] = "CourseItemTaskFieldNotFound", M[M.FileInitiateError = 7001] = "FileInitiateError", M[M.FileUploadError = 7002] = "FileUploadError", M[M.FileCompleteError = 7003] = "FileCompleteError", M[M.DirectoryWithSameNameAlreadyExist = 7004] = "DirectoryWithSameNameAlreadyExist", M[M.DirectoryCannotBeRecursive = 7005] = "DirectoryCannotBeRecursive", M[M.DirectoryNotFound = 7006] = "DirectoryNotFound", M[M.FileManagerItemNotFound = 7007] = "FileManagerItemNotFound", M[M.YouCannotDeleteDirectoryBecauseIsNotEmpty = 7008] = "YouCannotDeleteDirectoryBecauseIsNotEmpty", M[M.FileWithSameNameAlreadyExist = 7009] = "FileWithSameNameAlreadyExist", M[M.FileUpdateCannedACLError = 7010] = "FileUpdateCannedACLError", M[M.FileReplaceExtensionError = 7011] = "FileReplaceExtensionError", M[M.FileUpdateError = 7012] = "FileUpdateError", M[M.StudentNotFound = 8001] = "StudentNotFound", M[M.StudentCourseNotFound = 8002] = "StudentCourseNotFound", M[M.StudentCourseItemProgressNotFound = 8003] = "StudentCourseItemProgressNotFound", M[M.StudentCourseItemTaskAnswerNotFound = 8004] = "StudentCourseItemTaskAnswerNotFound", M[M.StudentCourseStepAccessDenied = 8005] = "StudentCourseStepAccessDenied", M[M.StudentCourseCannotBeCompleted = 8006] = "StudentCourseCannotBeCompleted", M[M.StudentCourseItemTaskAnswerCommentNotFound = 8007] = "StudentCourseItemTaskAnswerCommentNotFound", M[M.StudentCourseItemCommentTimeLimit = 8009] = "StudentCourseItemCommentTimeLimit", M[M.StudentCourseStartError = 8010] = "StudentCourseStartError", M[M.StudentNotHaveEmail = 8011] = "StudentNotHaveEmail", M[M.StudentAlreadyMerging = 8012] = "StudentAlreadyMerging", M[M.StudentLibraryItemsNotFound = 8013] = "StudentLibraryItemsNotFound", M[M.StudentCourseHasRequirements = 8040] = "StudentCourseHasRequirements", M[M.StudentCourseItemsNotFound = 8500] = "StudentCourseItemsNotFound", M[M.InvalidInviteToken = 9001] = "InvalidInviteToken", M[M.TagNotFound = 10001] = "TagNotFound", M[M.TagAlreadyExists = 10002] = "TagAlreadyExists", M[M.StudentTagLinkNotFound = 11001] = "StudentTagLinkNotFound", M[M.LeadNotFound = 12001] = "LeadNotFound", M[M.StudentLicenseNotFound = 12003] = "StudentLicenseNotFound", M[M.LeadAttributeNotFound = 12100] = "LeadAttributeNotFound", M[M.LeadAttributeNameAlreadyExists = 12101] = "LeadAttributeNameAlreadyExists", M[M.LeadAttributeKeyNameAlreadyExists = 12102] = "LeadAttributeKeyNameAlreadyExists", M[M.LeadAttributeKeyNameBusyBySystem = 12103] = "LeadAttributeKeyNameBusyBySystem", M[M.FlowNotFound = 13001] = "FlowNotFound", M[M.FlowDateNotFound = 13002] = "FlowDateNotFound", M[M.AdminNotFound = 14001] = "AdminNotFound", M[M.AdminResponsibleNotFound = 14002] = "AdminResponsibleNotFound", M[M.AdminResponsibleFromUserExists = 14011] = "AdminResponsibleFromUserExists", M[M.AdminCRMSettingsNotFound = 14050] = "AdminCRMSettingsNotFound", M[M.AdminPartnerTariffNotFound = 14100] = "AdminPartnerTariffNotFound", M[M.AdminPartnerTariffAlreadyExists = 14101] = "AdminPartnerTariffAlreadyExists", M[M.AdminPartnerTransactionNotFound = 14200] = "AdminPartnerTransactionNotFound", M[M.AdminPartnerTransactionInsufficientFunds = 14201] = "AdminPartnerTransactionInsufficientFunds", M[M.CRMImportInvalidFile = 15001] = "CRMImportInvalidFile", M[M.CRMImportInvalidText = 15002] = "CRMImportInvalidText", M[M.CRMImportNoRowsFound = 15003] = "CRMImportNoRowsFound", M[M.CRMImportError = 15004] = "CRMImportError", M[M.CRMImportInvalidRow = 15005] = "CRMImportInvalidRow", M[M.CRMImportFieldInvalidPattern = 15006] = "CRMImportFieldInvalidPattern", M[M.CRMImportEmailRequired = 15007] = "CRMImportEmailRequired", M[M.CRMImportInvalidFieldCast = 15008] = "CRMImportInvalidFieldCast", M[M.CRMImportRequiredFields = 15012] = "CRMImportRequiredFields", M[M.ForumThreadNotFound = 17001] = "ForumThreadNotFound", M[M.ForumThreadCannotDeleteWhileHasNestedThreads = 17002] = "ForumThreadCannotDeleteWhileHasNestedThreads", M[M.ForumAccessDenied = 17003] = "ForumAccessDenied", M[M.ForumThreadModeratorNotFound = 17100] = "ForumThreadModeratorNotFound", M[M.ForumTopicNotFound = 17200] = "ForumTopicNotFound", M[M.ForumTopicCommentNotFound = 17201] = "ForumTopicCommentNotFound", M[M.ForumReactionNotFound = 17300] = "ForumReactionNotFound", M[M.ForumSubscriptionNotFound = 17400] = "ForumSubscriptionNotFound", M[M.ForumUnableCreateTopic = 17451] = "ForumUnableCreateTopic", M[M.ForumUnableEditTopic = 17452] = "ForumUnableEditTopic", M[M.ForumUnableEditTopicComment = 17453] = "ForumUnableEditTopicComment", M[M.ForumUnableCreateTopicTooOften = 17454] = "ForumUnableCreateTopicTooOften", M[M.ForumBanNotFound = 17800] = "ForumBanNotFound", M[M.ForumBanAccessDenied = 17801] = "ForumBanAccessDenied", M[M.ChatConversationNotFound = 18001] = "ChatConversationNotFound", M[M.ChatCurrentContactNotFound = 18002] = "ChatCurrentContactNotFound", M[M.ChatContactNotFound = 18003] = "ChatContactNotFound", M[M.ChatDepartmentNotFound = 18004] = "ChatDepartmentNotFound", M[M.ChatConversationMemberNotFound = 18005] = "ChatConversationMemberNotFound", M[M.ChatMessageNotFound = 18006] = "ChatMessageNotFound", M[M.ChatMessageCouldntBeEmpty = 18007] = "ChatMessageCouldntBeEmpty", M[M.ChatConversationWrongType = 18008] = "ChatConversationWrongType", M[M.ChatConversationWrongContactCount = 18009] = "ChatConversationWrongContactCount", M[M.EmailProfileNotFound = 19001] = "EmailProfileNotFound", M[M.EmailProfileFailedDeletePrimary = 19002] = "EmailProfileFailedDeletePrimary", M[M.EmailProfileFailedDeleteActive = 19003] = "EmailProfileFailedDeleteActive", M[M.EmailProfileTestFailed = 19004] = "EmailProfileTestFailed", M[M.ExtendedFilterNotFound = 20001] = "ExtendedFilterNotFound", M[M.EmailDomainNotFound = 21001] = "EmailDomainNotFound", M[M.EmailDomainFailedDelete = 21002] = "EmailDomainFailedDelete", M[M.EmailDomainFailedAdd = 21003] = "EmailDomainFailedAdd", M[M.EmailDomainFailedVerify = 21004] = "EmailDomainFailedVerify", M[M.EmailDomainNeedVerify = 21005] = "EmailDomainNeedVerify", M[M.EmailDomainWaitRegistration = 21007] = "EmailDomainWaitRegistration", M[M.EmailMessageNotFound = 25001] = "EmailMessageNotFound", M[M.EmailMessageBlockedEmails = 25002] = "EmailMessageBlockedEmails", M[M.EmailMessageNotEnoughDataToSend = 25003] = "EmailMessageNotEnoughDataToSend", M[M.EmailMessageAttachmentsSizeExceeded = 25004] = "EmailMessageAttachmentsSizeExceeded", M[M.EmailMessageExceedLimit = 25006] = "EmailMessageExceedLimit", M[M.CallAccountAlreadyInUse = 27015] = "CallAccountAlreadyInUse", M[M.CallAccountCantSetWebhookUrl = 27016] = "CallAccountCantSetWebhookUrl", M[M.LibraryNotFound = 29001] = "LibraryNotFound", M[M.LibraryItemNotFound = 29501] = "LibraryItemNotFound", M[M.LibraryItemAccessDenied = 29502] = "LibraryItemAccessDenied", M[M.ProductPackageNotFound = 30001] = "ProductPackageNotFound", M[M.SiteNotFound = 31001] = "SiteNotFound", M[M.SiteAlreadyExists = 31002] = "SiteAlreadyExists", M[M.SitePageNotFound = 31003] = "SitePageNotFound", M[M.SitePageAlreadyExists = 31004] = "SitePageAlreadyExists", M[M.SiteDomainNotFound = 31005] = "SiteDomainNotFound", M[M.SiteDomainAlreadyExists = 31006] = "SiteDomainAlreadyExists", M[M.SiteMenuItemAlreadyExists = 31007] = "SiteMenuItemAlreadyExists", M[M.SiteMenuItemNotFound = 31008] = "SiteMenuItemNotFound", M[M.ProductNotFound = 33001] = "ProductNotFound", M[M.ProductImageLinkNotFound = 33002] = "ProductImageLinkNotFound", M[M.ProductContentAlreadyExists = 33100] = "ProductContentAlreadyExists", M[M.WebinarNotFound = 38001] = "WebinarNotFound", M[M.WebinarShortNameAlreadyExist = 38003] = "WebinarShortNameAlreadyExist", M[M.WebinarScheduleInvalid = 38004] = "WebinarScheduleInvalid", M[M.WebinarImportEventInvalidFileFormat = 38451] = "WebinarImportEventInvalidFileFormat", M[M.WebinarImportEventInvalidEventFormat = 38452] = "WebinarImportEventInvalidEventFormat", M[M.ChatChannelNotFound = 41001] = "ChatChannelNotFound", M[M.ChatChannelResponseTimeLimitExceeded = 41002] = "ChatChannelResponseTimeLimitExceeded", M[M.BulkActionRegisterWebinarMaxSizeExceeded = 44001] = "BulkActionRegisterWebinarMaxSizeExceeded", M[M.DocumentNotFound = 45001] = "DocumentNotFound", M[M.DocumentContentNotFound = 45100] = "DocumentContentNotFound", M[M.DocumentUrlAlreadyExists = 45200] = "DocumentUrlAlreadyExists", M[M.DocumentTitleAlreadyExists = 45300] = "DocumentTitleAlreadyExists", M[M.BillingPlanNotFound = 49001] = "BillingPlanNotFound", M[M.BillingPlanNameAlreadyExists = 49002] = "BillingPlanNameAlreadyExists", M[M.BillingPaymentMethodNotFound = 49100] = "BillingPaymentMethodNotFound", M[M.BillingPaymentNotFound = 49200] = "BillingPaymentNotFound", M[M.BillingPaymentFailed = 49201] = "BillingPaymentFailed", M[M.BillingInvoiceNotFound = 49301] = "BillingInvoiceNotFound", M[M.BillingCurrencyExchangeRateChanged = 49401] = "BillingCurrencyExchangeRateChanged", M[M.RequisiteNotFound = 52001] = "RequisiteNotFound", M[M.RequisiteAlreadyExists = 52002] = "RequisiteAlreadyExists", M[M.PipelineNotFound = 53001] = "PipelineNotFound", M[M.PipelineStageNotFound = 53050] = "PipelineStageNotFound", M[M.PipelineStageItemNotFound = 53100] = "PipelineStageItemNotFound", M[M.PipelineTagNotFound = 53150] = "PipelineTagNotFound", M[M.PipelineFieldNotFound = 53200] = "PipelineFieldNotFound", M[M.PipelineFieldValueUpdatedFailed = 53201] = "PipelineFieldValueUpdatedFailed", M[M.PipelineFieldKeyAlreadyExists = 53202] = "PipelineFieldKeyAlreadyExists", M[M.PipelineFieldRequired = 53203] = "PipelineFieldRequired", M[M.PipelineItemNotFound = 53301] = "PipelineItemNotFound", M[M.ApplicationNotFound = 54001] = "ApplicationNotFound", M[M.ApplicationCantHasMultipleInstance = 54002] = "ApplicationCantHasMultipleInstance", M[M.ApplicationSchoolLinkNotFound = 54101] = "ApplicationSchoolLinkNotFound", M[M.ApplicationSchoolLinkCantBeRestored = 54102] = "ApplicationSchoolLinkCantBeRestored", M[M.TelegramGroupNotFound = 54201] = "TelegramGroupNotFound", M[M.TelegramGroupCantRegistered = 54202] = "TelegramGroupCantRegistered", M[M.TelegramGroupUserNotFound = 54301] = "TelegramGroupUserNotFound", M[M.TelegramGroupCannotDeleteOwnerFromGroup = 54302] = "TelegramGroupCannotDeleteOwnerFromGroup", M[M.TelegramGroupCannotUpdateOwner = 54303] = "TelegramGroupCannotUpdateOwner", M[M.TelegramGroupCannotDeleteAdminFromGroup = 54304] = "TelegramGroupCannotDeleteAdminFromGroup", M[M.MetaConversionCantRegistered = 54350] = "MetaConversionCantRegistered", M[M.TelegramGroupApproveChatJoinRequest = 54401] = "TelegramGroupApproveChatJoinRequest", M[M.TelegramGroupDeclineChatJoinRequest = 54402] = "TelegramGroupDeclineChatJoinRequest", M[M.YandexMetrikaGoalNotFound = 54501] = "YandexMetrikaGoalNotFound", M[M.YandexMetrikaAuthError = 54502] = "YandexMetrikaAuthError", M[M.YandexMetrikaExportError = 54503] = "YandexMetrikaExportError", M[M.YandexMetrikaImportError = 54504] = "YandexMetrikaImportError", M[M.GlossaryNotFound = 55001] = "GlossaryNotFound", M[M.GlossaryAlreadyExists = 55002] = "GlossaryAlreadyExists", M[M.GlossaryWordsCountExceeded = 55003] = "GlossaryWordsCountExceeded", M[M.GlobalVariableNotFound = 56001] = "GlobalVariableNotFound", M[M.WebhookNumberAttemptsExceeded = 57001] = "WebhookNumberAttemptsExceeded", M[M.PartnershipNotFound = 58001] = "PartnershipNotFound", M[M.PartnershipAlreadyExists = 58002] = "PartnershipAlreadyExists", M[M.PartnershipInsufficientFunds = 58003] = "PartnershipInsufficientFunds", M[M.PartnershipTransferMinFeeAmountRestrictions = 58004] = "PartnershipTransferMinFeeAmountRestrictions", M[M.PartnershipMemberNotFound = 58050] = "PartnershipMemberNotFound", M[M.PartnershipTransactionNotFound = 58100] = "PartnershipTransactionNotFound", M[M.PartnershipOfferNotFound = 58200] = "PartnershipOfferNotFound", M[M.PartnershipOfferWithSameProductAlreadyExists = 58201] = "PartnershipOfferWithSameProductAlreadyExists", M[M.PartnershipTransactionRequestNotFound = 58251] = "PartnershipTransactionRequestNotFound", M[M.SharedSettingsExportNotFound = 59001] = "SharedSettingsExportNotFound", M[M.SharedSettingsReexportProhibited = 59002] = "SharedSettingsReexportProhibited", M[M.SharedSettingsImportNotFound = 59100] = "SharedSettingsImportNotFound", M))(ga || {});
class _R {
  constructor(t) {
    o(this, "currentMember");
    o(this, "inited", !1);
    o(this, "partnership");
    o(this, "memberStore");
    o(this, "accepting", !1);
    o(this, "fetchingTotals", !1);
    o(this, "fetching", !1);
    this.sdk = t, c0(this, {
      currentMember: r,
      inited: r,
      init: I,
      accepting: r,
      acceptAgreement: I,
      fetchingTotals: r,
      fetching: r
    }), this.memberStore = new La(t);
  }
  async init() {
    var p;
    if (this.inited) return;
    this.partnership = this.sdk.school.partnership;
    const t = await this.memberStore.fetchItem("");
    if (!t.success && !((p = t.errors) != null && p.some((c) => c.code === ga.PartnershipMemberNotFound)))
      return !1;
    const e = t.body ?? new $p();
    if (!e.id) {
      const c = await this.memberStore.create(e);
      if (!c.success) return c.success;
    }
    return i0(() => {
      this.currentMember = e, this.inited = !0;
    }), !0;
  }
  async acceptAgreement() {
    this.accepting = !0;
    try {
      return await this.memberStore.acceptAgreement(this.currentMember);
    } finally {
      i0(() => this.accepting = !1);
    }
  }
  async fetchTotals(t) {
    this.fetchingTotals = !0;
    try {
      return await this.sdk.api.partnership.fetchTotals(t);
    } finally {
      i0(() => this.fetchingTotals = !1);
    }
  }
  async fetchMaxAvailableAmount() {
    this.fetching = !0;
    try {
      return await this.sdk.api.partnership.fetchMaxAmount();
    } finally {
      i0(() => this.fetching = !1);
    }
  }
}
class wR extends z2 {
  constructor(e) {
    super();
    o(this, "fetchingTotals", !1);
    this.sdk = e, c0(this, {
      fetchingTotals: r
    });
  }
  get crudApi() {
    return this.sdk.api.partnership.transaction;
  }
  async fetchTotals(e) {
    this.fetchingTotals = !0;
    try {
      return await this.crudApi.fetchTotals(e);
    } finally {
      i0(() => this.fetchingTotals = !1);
    }
  }
  createFilter(e) {
    return new zm({ ...this.filter, ...e });
  }
}
class XR {
  constructor(t) {
    o(this, "store");
    o(this, "memberStore");
    o(this, "transactionStore");
    o(this, "requestStore");
    o(this, "orderStore");
    o(this, "offerStore");
    this.sdk = t, this.store = new _R(this.sdk), this.memberStore = new La(this.sdk), this.transactionStore = new wR(this.sdk), this.requestStore = new TR(this.sdk), this.orderStore = new vR(this.sdk), this.offerStore = new BR(this.sdk);
  }
  async init() {
    this.store.inited || await this.store.init();
  }
}
class SR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.member;
  }
  createFilter(t) {
    return new sm({ ...this.filter, ...t });
  }
}
class DR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.spaceItem;
  }
  createFilter(t) {
    return new am({ ...this.filter, ...t });
  }
}
class CR extends z2 {
  constructor(t) {
    super("infinity"), this.sdk = t, c0(this, {
      like: I,
      unlike: I,
      addPost: I,
      updatePost: I,
      removePost: I
    });
  }
  get crudApi() {
    return this.sdk.api.community.post;
  }
  createFilter(t) {
    return new Am({ ...this.filter, ...t });
  }
  async like(t) {
    t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 });
    const e = await this.crudApi.like(t.id);
    return e.success || t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 }), e;
  }
  async unlike(t) {
    t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 });
    const e = await this.crudApi.unlike(t.id);
    return e.success || t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 }), e;
  }
  addPost(t) {
    this.insertItems(t);
  }
  updatePost(t) {
    const e = this.items.find((p) => p.id === t.id);
    e && e.update({
      updatedDate: t.updatedDate,
      title: t.title,
      body: t.body,
      pinPosition: t.pinPosition,
      status: t.status,
      likesCount: t.likesCount,
      commentsCount: t.commentsCount,
      viewsCount: t.viewsCount,
      pinDate: t.pinDate,
      attachments: t.attachments
    });
  }
  removePost(t) {
    this.removeItems(t);
  }
  async fetchItemByNumber(t) {
    return await this.crudApi.fetchByNumber(t);
  }
}
class IR extends z2 {
  constructor(t) {
    super("infinity"), this.sdk = t, c0(this, {
      fetchReplies: I,
      like: I,
      unlike: I,
      addComment: I,
      updateComment: I,
      removeComment: I
    });
  }
  get crudApi() {
    return this.sdk.api.community.postComment;
  }
  createFilter(t) {
    return new qO({ ...this.filter, ...t });
  }
  async fetchReplies(t) {
    const e = await this.fetchItems(new qO({
      parentId: t.id,
      skip: t.children.length,
      sortName: "CreatedDate",
      sortType: "Asc",
      take: 100
    }));
    return e.success && t.update({
      children: [...t.children, ...e.body.items],
      childrenCount: e.body.filter.itemsTotal,
      childrenCollapsed: !0
    }), e;
  }
  async like(t) {
    t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 });
    const e = await this.crudApi.like(t.id);
    return e.success || t.update({ likesCount: t.likesCount - 1, isLikedByCurrentUser: !1 }), e;
  }
  async unlike(t) {
    t.update({ likesCount: Math.max(t.likesCount - 1, 0), isLikedByCurrentUser: !1 });
    const e = await this.crudApi.unlike(t.id);
    return e.success || t.update({ likesCount: t.likesCount + 1, isLikedByCurrentUser: !0 }), e;
  }
  addComment(t) {
    if (t.parent) {
      const e = this.items.find((p) => p.id === t.parent.id);
      e && e.update({
        childrenCount: e.childrenCount + 1,
        children: e.childrenCollapsed ? e.children : [...e.children, t]
      });
    } else
      this.insertItems(t);
  }
  updateComment(t) {
    if (t.parent) {
      const e = this.items.find((p) => p.id === t.parent.id);
      if (e) {
        const p = e.children.find((c) => c.id === t.id);
        p && p.update(p);
      }
    } else {
      const e = this.items.find((p) => p.id === t.id);
      e && e.update({
        text: t.text,
        status: t.status,
        likesCount: t.likesCount,
        files: t.files,
        updatedDate: t.updatedDate
      });
    }
  }
  removeComment(t) {
    if (t.parent) {
      const e = this.items.find((p) => p.id === t.parent.id);
      if (e) {
        const p = e.children.find((c) => c.id === t.id);
        p && e.update({ children: e.children.filter((c) => c.id !== p.id), childrenCount: e.childrenCount - 1 });
      }
    } else
      this.removeItems(t);
  }
}
class kR extends z2 {
  constructor(t) {
    super(), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.community.report;
  }
  createFilter(t) {
    return new dm({ ...this.filter, ...t });
  }
}
class PR {
  constructor(t) {
    o(this, "memberStore");
    o(this, "spaceItemStore");
    o(this, "postStore");
    o(this, "postCommentStore");
    o(this, "reportStore");
    o(this, "currentMember", null);
    o(this, "inited", !1);
    o(this, "joining", !1);
    this.sdk = t, c0(this, {
      currentMember: r,
      inited: r,
      isJoined: Y,
      isModerator: Y,
      init: I,
      joining: r,
      join: I,
      reset: I
    }), this.memberStore = new SR(this.sdk), this.spaceItemStore = new DR(this.sdk), this.postStore = new CR(this.sdk), this.postCommentStore = new IR(this.sdk), this.reportStore = new kR(this.sdk);
  }
  get community() {
    return this.sdk.school.community;
  }
  get isJoined() {
    return this.currentMember !== null;
  }
  get isModerator() {
    var t;
    return ((t = this.currentMember) == null ? void 0 : t.role) === "moderator";
  }
  async init() {
    var t;
    return this.inited || (this.currentMember = ((t = this.sdk.account.user) == null ? void 0 : t.communityMember) || null, this.inited = !0), !0;
  }
  async join() {
    this.joining = !0;
    try {
      const t = await this.sdk.api.community.join();
      return t.success && i0(() => {
        var e;
        this.currentMember = ((e = this.sdk.account.user) == null ? void 0 : e.communityMember) || null;
      }), t;
    } finally {
      i0(() => this.joining = !1);
    }
  }
  reset() {
    this.currentMember = null, this.inited = !1;
  }
}
class Wt extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(t, e) {
    const p = new.target.prototype;
    super(`${t}: Status code '${e}'`), this.statusCode = e, this.__proto__ = p;
  }
}
class An extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "A timeout occurred.") {
    const e = new.target.prototype;
    super(t), this.__proto__ = e;
  }
}
class E2 extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "An abort occurred.") {
    const e = new.target.prototype;
    super(t), this.__proto__ = e;
  }
}
class ER extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const p = new.target.prototype;
    super(t), this.transport = e, this.errorType = "UnsupportedTransportError", this.__proto__ = p;
  }
}
class xR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const p = new.target.prototype;
    super(t), this.transport = e, this.errorType = "DisabledTransportError", this.__proto__ = p;
  }
}
class FR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, e) {
    const p = new.target.prototype;
    super(t), this.transport = e, this.errorType = "FailedToStartTransportError", this.__proto__ = p;
  }
}
class WO extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(t) {
    const e = new.target.prototype;
    super(t), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = e;
  }
}
class UR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(t, e) {
    const p = new.target.prototype;
    super(t), this.innerErrors = e, this.__proto__ = p;
  }
}
class ya {
  constructor(t, e, p) {
    this.statusCode = t, this.statusText = e, this.content = p;
  }
}
class Vp {
  get(t, e) {
    return this.send({
      ...e,
      method: "GET",
      url: t
    });
  }
  post(t, e) {
    return this.send({
      ...e,
      method: "POST",
      url: t
    });
  }
  delete(t, e) {
    return this.send({
      ...e,
      method: "DELETE",
      url: t
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(t) {
    return "";
  }
}
var x;
(function(M) {
  M[M.Trace = 0] = "Trace", M[M.Debug = 1] = "Debug", M[M.Information = 2] = "Information", M[M.Warning = 3] = "Warning", M[M.Error = 4] = "Error", M[M.Critical = 5] = "Critical", M[M.None = 6] = "None";
})(x || (x = {}));
class zb {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(t, e) {
  }
}
zb.instance = new zb();
const JR = "8.0.17";
class _1 {
  static isRequired(t, e) {
    if (t == null)
      throw new Error(`The '${e}' argument is required.`);
  }
  static isNotEmpty(t, e) {
    if (!t || t.match(/^\s*$/))
      throw new Error(`The '${e}' argument should not be empty.`);
  }
  static isIn(t, e, p) {
    if (!(t in e))
      throw new Error(`Unknown ${p} value: ${t}.`);
  }
}
class m1 {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return !m1.isNode && typeof window == "object" && typeof window.document == "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return !m1.isNode && typeof self == "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return !m1.isNode && typeof window == "object" && typeof window.document > "u";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return typeof process < "u" && process.release && process.release.name === "node";
  }
}
function ob(M, t) {
  let e = "";
  return gt(M) ? (e = `Binary data of length ${M.byteLength}`, t && (e += `. Content: '${HR(M)}'`)) : typeof M == "string" && (e = `String data of length ${M.length}`, t && (e += `. Content: '${M}'`)), e;
}
function HR(M) {
  const t = new Uint8Array(M);
  let e = "";
  return t.forEach((p) => {
    const c = p < 16 ? "0" : "";
    e += `0x${c}${p.toString(16)} `;
  }), e.substr(0, e.length - 1);
}
function gt(M) {
  return M && typeof ArrayBuffer < "u" && (M instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  M.constructor && M.constructor.name === "ArrayBuffer");
}
async function Na(M, t, e, p, c, i) {
  const s = {}, [u, l] = oM();
  s[u] = l, M.log(x.Trace, `(${t} transport) sending data. ${ob(c, i.logMessageContent)}.`);
  const W = gt(c) ? "arraybuffer" : "text", L = await e.post(p, {
    content: c,
    headers: { ...s, ...i.headers },
    responseType: W,
    timeout: i.timeout,
    withCredentials: i.withCredentials
  });
  M.log(x.Trace, `(${t} transport) request complete. Response status: ${L.statusCode}.`);
}
function YR(M) {
  return M === void 0 ? new Np(x.Information) : M === null ? zb.instance : M.log !== void 0 ? M : new Np(M);
}
class GR {
  constructor(t, e) {
    this._subject = t, this._observer = e;
  }
  dispose() {
    const t = this._subject.observers.indexOf(this._observer);
    t > -1 && this._subject.observers.splice(t, 1), this._subject.observers.length === 0 && this._subject.cancelCallback && this._subject.cancelCallback().catch((e) => {
    });
  }
}
class Np {
  constructor(t) {
    this._minLevel = t, this.out = console;
  }
  log(t, e) {
    if (t >= this._minLevel) {
      const p = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${x[t]}: ${e}`;
      switch (t) {
        case x.Critical:
        case x.Error:
          this.out.error(p);
          break;
        case x.Warning:
          this.out.warn(p);
          break;
        case x.Information:
          this.out.info(p);
          break;
        default:
          this.out.log(p);
          break;
      }
    }
  }
}
function oM() {
  let M = "X-SignalR-User-Agent";
  return m1.isNode && (M = "User-Agent"), [M, $R(JR, VR(), QR(), KR())];
}
function $R(M, t, e, p) {
  let c = "Microsoft SignalR/";
  const i = M.split(".");
  return c += `${i[0]}.${i[1]}`, c += ` (${M}; `, t && t !== "" ? c += `${t}; ` : c += "Unknown OS; ", c += `${e}`, p ? c += `; ${p}` : c += "; Unknown Runtime Version", c += ")", c;
}
function VR() {
  if (m1.isNode)
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  else
    return "";
}
function KR() {
  if (m1.isNode)
    return process.versions.node;
}
function QR() {
  return m1.isNode ? "NodeJS" : "Browser";
}
function lo(M) {
  return M.stack ? M.stack : M.message ? M.message : `${M}`;
}
function ZR() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("could not find global");
}
class jR extends Vp {
  constructor(t) {
    if (super(), this._logger = t, typeof fetch > "u" || m1.isNode) {
      const e = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._jar = new (e("tough-cookie")).CookieJar(), typeof fetch > "u" ? this._fetchType = e("node-fetch") : this._fetchType = fetch, this._fetchType = e("fetch-cookie")(this._fetchType, this._jar);
    } else
      this._fetchType = fetch.bind(ZR());
    if (typeof AbortController > "u") {
      const e = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._abortControllerType = e("abort-controller");
    } else
      this._abortControllerType = AbortController;
  }
  /** @inheritDoc */
  async send(t) {
    if (t.abortSignal && t.abortSignal.aborted)
      throw new E2();
    if (!t.method)
      throw new Error("No method defined.");
    if (!t.url)
      throw new Error("No url defined.");
    const e = new this._abortControllerType();
    let p;
    t.abortSignal && (t.abortSignal.onabort = () => {
      e.abort(), p = new E2();
    });
    let c = null;
    if (t.timeout) {
      const l = t.timeout;
      c = setTimeout(() => {
        e.abort(), this._logger.log(x.Warning, "Timeout from HTTP request."), p = new An();
      }, l);
    }
    t.content === "" && (t.content = void 0), t.content && (t.headers = t.headers || {}, gt(t.content) ? t.headers["Content-Type"] = "application/octet-stream" : t.headers["Content-Type"] = "text/plain;charset=UTF-8");
    let i;
    try {
      i = await this._fetchType(t.url, {
        body: t.content,
        cache: "no-cache",
        credentials: t.withCredentials === !0 ? "include" : "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...t.headers
        },
        method: t.method,
        mode: "cors",
        redirect: "follow",
        signal: e.signal
      });
    } catch (l) {
      throw p || (this._logger.log(x.Warning, `Error from HTTP request. ${l}.`), l);
    } finally {
      c && clearTimeout(c), t.abortSignal && (t.abortSignal.onabort = null);
    }
    if (!i.ok) {
      const l = await hO(i, "text");
      throw new Wt(l || i.statusText, i.status);
    }
    const u = await hO(i, t.responseType);
    return new ya(i.status, i.statusText, u);
  }
  getCookieString(t) {
    let e = "";
    return m1.isNode && this._jar && this._jar.getCookies(t, (p, c) => e = c.join("; ")), e;
  }
}
function hO(M, t) {
  let e;
  switch (t) {
    case "arraybuffer":
      e = M.arrayBuffer();
      break;
    case "text":
      e = M.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${t} is not supported.`);
    default:
      e = M.text();
      break;
  }
  return e;
}
class eL extends Vp {
  constructor(t) {
    super(), this._logger = t;
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new E2()) : t.method ? t.url ? new Promise((e, p) => {
      const c = new XMLHttpRequest();
      c.open(t.method, t.url, !0), c.withCredentials = t.withCredentials === void 0 ? !0 : t.withCredentials, c.setRequestHeader("X-Requested-With", "XMLHttpRequest"), t.content === "" && (t.content = void 0), t.content && (gt(t.content) ? c.setRequestHeader("Content-Type", "application/octet-stream") : c.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
      const i = t.headers;
      i && Object.keys(i).forEach((s) => {
        c.setRequestHeader(s, i[s]);
      }), t.responseType && (c.responseType = t.responseType), t.abortSignal && (t.abortSignal.onabort = () => {
        c.abort(), p(new E2());
      }), t.timeout && (c.timeout = t.timeout), c.onload = () => {
        t.abortSignal && (t.abortSignal.onabort = null), c.status >= 200 && c.status < 300 ? e(new ya(c.status, c.statusText, c.response || c.responseText)) : p(new Wt(c.response || c.responseText || c.statusText, c.status));
      }, c.onerror = () => {
        this._logger.log(x.Warning, `Error from HTTP request. ${c.status}: ${c.statusText}.`), p(new Wt(c.statusText, c.status));
      }, c.ontimeout = () => {
        this._logger.log(x.Warning, "Timeout from HTTP request."), p(new An());
      }, c.send(t.content);
    }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
}
class tL extends Vp {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(t) {
    if (super(), typeof fetch < "u" || m1.isNode)
      this._httpClient = new jR(t);
    else if (typeof XMLHttpRequest < "u")
      this._httpClient = new eL(t);
    else
      throw new Error("No usable HttpClient found.");
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new E2()) : t.method ? t.url ? this._httpClient.send(t) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
  getCookieString(t) {
    return this._httpClient.getCookieString(t);
  }
}
class A2 {
  static write(t) {
    return `${t}${A2.RecordSeparator}`;
  }
  static parse(t) {
    if (t[t.length - 1] !== A2.RecordSeparator)
      throw new Error("Message is incomplete.");
    const e = t.split(A2.RecordSeparator);
    return e.pop(), e;
  }
}
A2.RecordSeparatorCode = 30;
A2.RecordSeparator = String.fromCharCode(A2.RecordSeparatorCode);
class ML {
  // Handshake request is always JSON
  writeHandshakeRequest(t) {
    return A2.write(JSON.stringify(t));
  }
  parseHandshakeResponse(t) {
    let e, p;
    if (gt(t)) {
      const u = new Uint8Array(t), l = u.indexOf(A2.RecordSeparatorCode);
      if (l === -1)
        throw new Error("Message is incomplete.");
      const W = l + 1;
      e = String.fromCharCode.apply(null, Array.prototype.slice.call(u.slice(0, W))), p = u.byteLength > W ? u.slice(W).buffer : null;
    } else {
      const u = t, l = u.indexOf(A2.RecordSeparator);
      if (l === -1)
        throw new Error("Message is incomplete.");
      const W = l + 1;
      e = u.substring(0, W), p = u.length > W ? u.substring(W) : null;
    }
    const c = A2.parse(e), i = JSON.parse(c[0]);
    if (i.type)
      throw new Error("Expected a handshake response from the server.");
    return [p, i];
  }
}
var L0;
(function(M) {
  M[M.Invocation = 1] = "Invocation", M[M.StreamItem = 2] = "StreamItem", M[M.Completion = 3] = "Completion", M[M.StreamInvocation = 4] = "StreamInvocation", M[M.CancelInvocation = 5] = "CancelInvocation", M[M.Ping = 6] = "Ping", M[M.Close = 7] = "Close", M[M.Ack = 8] = "Ack", M[M.Sequence = 9] = "Sequence";
})(L0 || (L0 = {}));
class bL {
  constructor() {
    this.observers = [];
  }
  next(t) {
    for (const e of this.observers)
      e.next(t);
  }
  error(t) {
    for (const e of this.observers)
      e.error && e.error(t);
  }
  complete() {
    for (const t of this.observers)
      t.complete && t.complete();
  }
  subscribe(t) {
    return this.observers.push(t), new GR(this, t);
  }
}
class pL {
  constructor(t, e, p) {
    this._bufferSize = 1e5, this._messages = [], this._totalMessageCount = 0, this._waitForSequenceMessage = !1, this._nextReceivingSequenceId = 1, this._latestReceivedSequenceId = 0, this._bufferedByteCount = 0, this._reconnectInProgress = !1, this._protocol = t, this._connection = e, this._bufferSize = p;
  }
  async _send(t) {
    const e = this._protocol.writeMessage(t);
    let p = Promise.resolve();
    if (this._isInvocationMessage(t)) {
      this._totalMessageCount++;
      let c = () => {
      }, i = () => {
      };
      gt(e) ? this._bufferedByteCount += e.byteLength : this._bufferedByteCount += e.length, this._bufferedByteCount >= this._bufferSize && (p = new Promise((s, u) => {
        c = s, i = u;
      })), this._messages.push(new zL(e, this._totalMessageCount, c, i));
    }
    try {
      this._reconnectInProgress || await this._connection.send(e);
    } catch {
      this._disconnected();
    }
    await p;
  }
  _ack(t) {
    let e = -1;
    for (let p = 0; p < this._messages.length; p++) {
      const c = this._messages[p];
      if (c._id <= t.sequenceId)
        e = p, gt(c._message) ? this._bufferedByteCount -= c._message.byteLength : this._bufferedByteCount -= c._message.length, c._resolver();
      else if (this._bufferedByteCount < this._bufferSize)
        c._resolver();
      else
        break;
    }
    e !== -1 && (this._messages = this._messages.slice(e + 1));
  }
  _shouldProcessMessage(t) {
    if (this._waitForSequenceMessage)
      return t.type !== L0.Sequence ? !1 : (this._waitForSequenceMessage = !1, !0);
    if (!this._isInvocationMessage(t))
      return !0;
    const e = this._nextReceivingSequenceId;
    return this._nextReceivingSequenceId++, e <= this._latestReceivedSequenceId ? (e === this._latestReceivedSequenceId && this._ackTimer(), !1) : (this._latestReceivedSequenceId = e, this._ackTimer(), !0);
  }
  _resetSequence(t) {
    if (t.sequenceId > this._nextReceivingSequenceId) {
      this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
      return;
    }
    this._nextReceivingSequenceId = t.sequenceId;
  }
  _disconnected() {
    this._reconnectInProgress = !0, this._waitForSequenceMessage = !0;
  }
  async _resend() {
    const t = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
    await this._connection.send(this._protocol.writeMessage({ type: L0.Sequence, sequenceId: t }));
    const e = this._messages;
    for (const p of e)
      await this._connection.send(p._message);
    this._reconnectInProgress = !1;
  }
  _dispose(t) {
    t ?? (t = new Error("Unable to reconnect to server."));
    for (const e of this._messages)
      e._rejector(t);
  }
  _isInvocationMessage(t) {
    switch (t.type) {
      case L0.Invocation:
      case L0.StreamItem:
      case L0.Completion:
      case L0.StreamInvocation:
      case L0.CancelInvocation:
        return !0;
      case L0.Close:
      case L0.Sequence:
      case L0.Ping:
      case L0.Ack:
        return !1;
    }
  }
  _ackTimer() {
    this._ackTimerHandle === void 0 && (this._ackTimerHandle = setTimeout(async () => {
      try {
        this._reconnectInProgress || await this._connection.send(this._protocol.writeMessage({ type: L0.Ack, sequenceId: this._latestReceivedSequenceId }));
      } catch {
      }
      clearTimeout(this._ackTimerHandle), this._ackTimerHandle = void 0;
    }, 1e3));
  }
}
class zL {
  constructor(t, e, p, c) {
    this._message = t, this._id = e, this._resolver = p, this._rejector = c;
  }
}
const oL = 30 * 1e3, cL = 15 * 1e3, nL = 1e5;
var N0;
(function(M) {
  M.Disconnected = "Disconnected", M.Connecting = "Connecting", M.Connected = "Connected", M.Disconnecting = "Disconnecting", M.Reconnecting = "Reconnecting";
})(N0 || (N0 = {}));
class dn {
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(t, e, p, c, i, s, u) {
    return new dn(t, e, p, c, i, s, u);
  }
  constructor(t, e, p, c, i, s, u) {
    this._nextKeepAlive = 0, this._freezeEventListener = () => {
      this._logger.log(x.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    }, _1.isRequired(t, "connection"), _1.isRequired(e, "logger"), _1.isRequired(p, "protocol"), this.serverTimeoutInMilliseconds = i ?? oL, this.keepAliveIntervalInMilliseconds = s ?? cL, this._statefulReconnectBufferSize = u ?? nL, this._logger = e, this._protocol = p, this.connection = t, this._reconnectPolicy = c, this._handshakeProtocol = new ML(), this.connection.onreceive = (l) => this._processIncomingData(l), this.connection.onclose = (l) => this._connectionClosed(l), this._callbacks = {}, this._methods = {}, this._closedCallbacks = [], this._reconnectingCallbacks = [], this._reconnectedCallbacks = [], this._invocationId = 0, this._receivedHandshakeResponse = !1, this._connectionState = N0.Disconnected, this._connectionStarted = !1, this._cachedPingMessage = this._protocol.writeMessage({ type: L0.Ping });
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection && this.connection.connectionId || null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(t) {
    if (this._connectionState !== N0.Disconnected && this._connectionState !== N0.Reconnecting)
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    if (!t)
      throw new Error("The HubConnection url must be a valid url.");
    this.connection.baseUrl = t;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    return this._startPromise = this._startWithStateTransitions(), this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== N0.Disconnected)
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    this._connectionState = N0.Connecting, this._logger.log(x.Debug, "Starting HubConnection.");
    try {
      await this._startInternal(), m1.isBrowser && window.document.addEventListener("freeze", this._freezeEventListener), this._connectionState = N0.Connected, this._connectionStarted = !0, this._logger.log(x.Debug, "HubConnection connected successfully.");
    } catch (t) {
      return this._connectionState = N0.Disconnected, this._logger.log(x.Debug, `HubConnection failed to start successfully because of error '${t}'.`), Promise.reject(t);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0, this._receivedHandshakeResponse = !1;
    const t = new Promise((e, p) => {
      this._handshakeResolver = e, this._handshakeRejecter = p;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      let e = this._protocol.version;
      this.connection.features.reconnect || (e = 1);
      const p = {
        protocol: this._protocol.name,
        version: e
      };
      if (this._logger.log(x.Debug, "Sending handshake request."), await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(p)), this._logger.log(x.Information, `Using HubProtocol '${this._protocol.name}'.`), this._cleanupTimeout(), this._resetTimeoutPeriod(), this._resetKeepAliveInterval(), await t, this._stopDuringStartError)
        throw this._stopDuringStartError;
      (this.connection.features.reconnect || !1) && (this._messageBuffer = new pL(this._protocol, this.connection, this._statefulReconnectBufferSize), this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer), this.connection.features.resend = () => {
        if (this._messageBuffer)
          return this._messageBuffer._resend();
      }), this.connection.features.inherentKeepAlive || await this._sendMessage(this._cachedPingMessage);
    } catch (e) {
      throw this._logger.log(x.Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`), this._cleanupTimeout(), this._cleanupPingTimer(), await this.connection.stop(e), e;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const t = this._startPromise;
    this.connection.features.reconnect = !1, this._stopPromise = this._stopInternal(), await this._stopPromise;
    try {
      await t;
    } catch {
    }
  }
  _stopInternal(t) {
    if (this._connectionState === N0.Disconnected)
      return this._logger.log(x.Debug, `Call to HubConnection.stop(${t}) ignored because it is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === N0.Disconnecting)
      return this._logger.log(x.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    const e = this._connectionState;
    return this._connectionState = N0.Disconnecting, this._logger.log(x.Debug, "Stopping HubConnection."), this._reconnectDelayHandle ? (this._logger.log(x.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this._reconnectDelayHandle), this._reconnectDelayHandle = void 0, this._completeClose(), Promise.resolve()) : (e === N0.Connected && this._sendCloseMessage(), this._cleanupTimeout(), this._cleanupPingTimer(), this._stopDuringStartError = t || new E2("The connection was stopped before the hub handshake could complete."), this.connection.stop(t));
  }
  async _sendCloseMessage() {
    try {
      await this._sendWithProtocol(this._createCloseMessage());
    } catch {
    }
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(t, ...e) {
    const [p, c] = this._replaceStreamingParams(e), i = this._createStreamInvocation(t, e, c);
    let s;
    const u = new bL();
    return u.cancelCallback = () => {
      const l = this._createCancelInvocation(i.invocationId);
      return delete this._callbacks[i.invocationId], s.then(() => this._sendWithProtocol(l));
    }, this._callbacks[i.invocationId] = (l, W) => {
      if (W) {
        u.error(W);
        return;
      } else l && (l.type === L0.Completion ? l.error ? u.error(new Error(l.error)) : u.complete() : u.next(l.item));
    }, s = this._sendWithProtocol(i).catch((l) => {
      u.error(l), delete this._callbacks[i.invocationId];
    }), this._launchStreams(p, s), u;
  }
  _sendMessage(t) {
    return this._resetKeepAliveInterval(), this.connection.send(t);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(t) {
    return this._messageBuffer ? this._messageBuffer._send(t) : this._sendMessage(this._protocol.writeMessage(t));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(t, ...e) {
    const [p, c] = this._replaceStreamingParams(e), i = this._sendWithProtocol(this._createInvocation(t, e, !0, c));
    return this._launchStreams(p, i), i;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(t, ...e) {
    const [p, c] = this._replaceStreamingParams(e), i = this._createInvocation(t, e, !1, c);
    return new Promise((u, l) => {
      this._callbacks[i.invocationId] = (L, m) => {
        if (m) {
          l(m);
          return;
        } else L && (L.type === L0.Completion ? L.error ? l(new Error(L.error)) : u(L.result) : l(new Error(`Unexpected message type: ${L.type}`)));
      };
      const W = this._sendWithProtocol(i).catch((L) => {
        l(L), delete this._callbacks[i.invocationId];
      });
      this._launchStreams(p, W);
    });
  }
  on(t, e) {
    !t || !e || (t = t.toLowerCase(), this._methods[t] || (this._methods[t] = []), this._methods[t].indexOf(e) === -1 && this._methods[t].push(e));
  }
  off(t, e) {
    if (!t)
      return;
    t = t.toLowerCase();
    const p = this._methods[t];
    if (p)
      if (e) {
        const c = p.indexOf(e);
        c !== -1 && (p.splice(c, 1), p.length === 0 && delete this._methods[t]);
      } else
        delete this._methods[t];
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(t) {
    t && this._closedCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(t) {
    t && this._reconnectingCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(t) {
    t && this._reconnectedCallbacks.push(t);
  }
  _processIncomingData(t) {
    if (this._cleanupTimeout(), this._receivedHandshakeResponse || (t = this._processHandshakeResponse(t), this._receivedHandshakeResponse = !0), t) {
      const e = this._protocol.parseMessages(t, this._logger);
      for (const p of e)
        if (!(this._messageBuffer && !this._messageBuffer._shouldProcessMessage(p)))
          switch (p.type) {
            case L0.Invocation:
              this._invokeClientMethod(p).catch((c) => {
                this._logger.log(x.Error, `Invoke client method threw error: ${lo(c)}`);
              });
              break;
            case L0.StreamItem:
            case L0.Completion: {
              const c = this._callbacks[p.invocationId];
              if (c) {
                p.type === L0.Completion && delete this._callbacks[p.invocationId];
                try {
                  c(p);
                } catch (i) {
                  this._logger.log(x.Error, `Stream callback threw error: ${lo(i)}`);
                }
              }
              break;
            }
            case L0.Ping:
              break;
            case L0.Close: {
              this._logger.log(x.Information, "Close message received from server.");
              const c = p.error ? new Error("Server returned an error on close: " + p.error) : void 0;
              p.allowReconnect === !0 ? this.connection.stop(c) : this._stopPromise = this._stopInternal(c);
              break;
            }
            case L0.Ack:
              this._messageBuffer && this._messageBuffer._ack(p);
              break;
            case L0.Sequence:
              this._messageBuffer && this._messageBuffer._resetSequence(p);
              break;
            default:
              this._logger.log(x.Warning, `Invalid message type: ${p.type}.`);
              break;
          }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(t) {
    let e, p;
    try {
      [p, e] = this._handshakeProtocol.parseHandshakeResponse(t);
    } catch (c) {
      const i = "Error parsing handshake response: " + c;
      this._logger.log(x.Error, i);
      const s = new Error(i);
      throw this._handshakeRejecter(s), s;
    }
    if (e.error) {
      const c = "Server returned handshake error: " + e.error;
      this._logger.log(x.Error, c);
      const i = new Error(c);
      throw this._handshakeRejecter(i), i;
    } else
      this._logger.log(x.Debug, "Server handshake complete.");
    return this._handshakeResolver(), p;
  }
  _resetKeepAliveInterval() {
    this.connection.features.inherentKeepAlive || (this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this._cleanupPingTimer());
  }
  _resetTimeoutPeriod() {
    if ((!this.connection.features || !this.connection.features.inherentKeepAlive) && (this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this._pingServerHandle === void 0)) {
      let t = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
      t < 0 && (t = 0), this._pingServerHandle = setTimeout(async () => {
        if (this._connectionState === N0.Connected)
          try {
            await this._sendMessage(this._cachedPingMessage);
          } catch {
            this._cleanupPingTimer();
          }
      }, t);
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  async _invokeClientMethod(t) {
    const e = t.target.toLowerCase(), p = this._methods[e];
    if (!p) {
      this._logger.log(x.Warning, `No client method with the name '${e}' found.`), t.invocationId && (this._logger.log(x.Warning, `No result given for '${e}' method and invocation ID '${t.invocationId}'.`), await this._sendWithProtocol(this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)));
      return;
    }
    const c = p.slice(), i = !!t.invocationId;
    let s, u, l;
    for (const W of c)
      try {
        const L = s;
        s = await W.apply(this, t.arguments), i && s && L && (this._logger.log(x.Error, `Multiple results provided for '${e}'. Sending error to server.`), l = this._createCompletionMessage(t.invocationId, "Client provided multiple results.", null)), u = void 0;
      } catch (L) {
        u = L, this._logger.log(x.Error, `A callback for the method '${e}' threw error '${L}'.`);
      }
    l ? await this._sendWithProtocol(l) : i ? (u ? l = this._createCompletionMessage(t.invocationId, `${u}`, null) : s !== void 0 ? l = this._createCompletionMessage(t.invocationId, null, s) : (this._logger.log(x.Warning, `No result given for '${e}' method and invocation ID '${t.invocationId}'.`), l = this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)), await this._sendWithProtocol(l)) : s && this._logger.log(x.Error, `Result given for '${e}' method but server is not expecting a result.`);
  }
  _connectionClosed(t) {
    this._logger.log(x.Debug, `HubConnection.connectionClosed(${t}) called while in state ${this._connectionState}.`), this._stopDuringStartError = this._stopDuringStartError || t || new E2("The underlying connection was closed before the hub handshake could complete."), this._handshakeResolver && this._handshakeResolver(), this._cancelCallbacksWithError(t || new Error("Invocation canceled due to the underlying connection being closed.")), this._cleanupTimeout(), this._cleanupPingTimer(), this._connectionState === N0.Disconnecting ? this._completeClose(t) : this._connectionState === N0.Connected && this._reconnectPolicy ? this._reconnect(t) : this._connectionState === N0.Connected && this._completeClose(t);
  }
  _completeClose(t) {
    if (this._connectionStarted) {
      this._connectionState = N0.Disconnected, this._connectionStarted = !1, this._messageBuffer && (this._messageBuffer._dispose(t ?? new Error("Connection closed.")), this._messageBuffer = void 0), m1.isBrowser && window.document.removeEventListener("freeze", this._freezeEventListener);
      try {
        this._closedCallbacks.forEach((e) => e.apply(this, [t]));
      } catch (e) {
        this._logger.log(x.Error, `An onclose callback called with error '${t}' threw error '${e}'.`);
      }
    }
  }
  async _reconnect(t) {
    const e = Date.now();
    let p = 0, c = t !== void 0 ? t : new Error("Attempting to reconnect due to a unknown error."), i = this._getNextRetryDelay(p++, 0, c);
    if (i === null) {
      this._logger.log(x.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), this._completeClose(t);
      return;
    }
    if (this._connectionState = N0.Reconnecting, t ? this._logger.log(x.Information, `Connection reconnecting because of error '${t}'.`) : this._logger.log(x.Information, "Connection reconnecting."), this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((s) => s.apply(this, [t]));
      } catch (s) {
        this._logger.log(x.Error, `An onreconnecting callback called with error '${t}' threw error '${s}'.`);
      }
      if (this._connectionState !== N0.Reconnecting) {
        this._logger.log(x.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    for (; i !== null; ) {
      if (this._logger.log(x.Information, `Reconnect attempt number ${p} will start in ${i} ms.`), await new Promise((s) => {
        this._reconnectDelayHandle = setTimeout(s, i);
      }), this._reconnectDelayHandle = void 0, this._connectionState !== N0.Reconnecting) {
        this._logger.log(x.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        if (await this._startInternal(), this._connectionState = N0.Connected, this._logger.log(x.Information, "HubConnection reconnected successfully."), this._reconnectedCallbacks.length !== 0)
          try {
            this._reconnectedCallbacks.forEach((s) => s.apply(this, [this.connection.connectionId]));
          } catch (s) {
            this._logger.log(x.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${s}'.`);
          }
        return;
      } catch (s) {
        if (this._logger.log(x.Information, `Reconnect attempt failed because of error '${s}'.`), this._connectionState !== N0.Reconnecting) {
          this._logger.log(x.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`), this._connectionState === N0.Disconnecting && this._completeClose();
          return;
        }
        c = s instanceof Error ? s : new Error(s.toString()), i = this._getNextRetryDelay(p++, Date.now() - e, c);
      }
    }
    this._logger.log(x.Information, `Reconnect retries have been exhausted after ${Date.now() - e} ms and ${p} failed attempts. Connection disconnecting.`), this._completeClose();
  }
  _getNextRetryDelay(t, e, p) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds: e,
        previousRetryCount: t,
        retryReason: p
      });
    } catch (c) {
      return this._logger.log(x.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${t}, ${e}) threw error '${c}'.`), null;
    }
  }
  _cancelCallbacksWithError(t) {
    const e = this._callbacks;
    this._callbacks = {}, Object.keys(e).forEach((p) => {
      const c = e[p];
      try {
        c(null, t);
      } catch (i) {
        this._logger.log(x.Error, `Stream 'error' callback called with '${t}' threw error: ${lo(i)}`);
      }
    });
  }
  _cleanupPingTimer() {
    this._pingServerHandle && (clearTimeout(this._pingServerHandle), this._pingServerHandle = void 0);
  }
  _cleanupTimeout() {
    this._timeoutHandle && clearTimeout(this._timeoutHandle);
  }
  _createInvocation(t, e, p, c) {
    if (p)
      return c.length !== 0 ? {
        arguments: e,
        streamIds: c,
        target: t,
        type: L0.Invocation
      } : {
        arguments: e,
        target: t,
        type: L0.Invocation
      };
    {
      const i = this._invocationId;
      return this._invocationId++, c.length !== 0 ? {
        arguments: e,
        invocationId: i.toString(),
        streamIds: c,
        target: t,
        type: L0.Invocation
      } : {
        arguments: e,
        invocationId: i.toString(),
        target: t,
        type: L0.Invocation
      };
    }
  }
  _launchStreams(t, e) {
    if (t.length !== 0) {
      e || (e = Promise.resolve());
      for (const p in t)
        t[p].subscribe({
          complete: () => {
            e = e.then(() => this._sendWithProtocol(this._createCompletionMessage(p)));
          },
          error: (c) => {
            let i;
            c instanceof Error ? i = c.message : c && c.toString ? i = c.toString() : i = "Unknown error", e = e.then(() => this._sendWithProtocol(this._createCompletionMessage(p, i)));
          },
          next: (c) => {
            e = e.then(() => this._sendWithProtocol(this._createStreamItemMessage(p, c)));
          }
        });
    }
  }
  _replaceStreamingParams(t) {
    const e = [], p = [];
    for (let c = 0; c < t.length; c++) {
      const i = t[c];
      if (this._isObservable(i)) {
        const s = this._invocationId;
        this._invocationId++, e[s] = i, p.push(s.toString()), t.splice(c, 1);
      }
    }
    return [e, p];
  }
  _isObservable(t) {
    return t && t.subscribe && typeof t.subscribe == "function";
  }
  _createStreamInvocation(t, e, p) {
    const c = this._invocationId;
    return this._invocationId++, p.length !== 0 ? {
      arguments: e,
      invocationId: c.toString(),
      streamIds: p,
      target: t,
      type: L0.StreamInvocation
    } : {
      arguments: e,
      invocationId: c.toString(),
      target: t,
      type: L0.StreamInvocation
    };
  }
  _createCancelInvocation(t) {
    return {
      invocationId: t,
      type: L0.CancelInvocation
    };
  }
  _createStreamItemMessage(t, e) {
    return {
      invocationId: t,
      item: e,
      type: L0.StreamItem
    };
  }
  _createCompletionMessage(t, e, p) {
    return e ? {
      error: e,
      invocationId: t,
      type: L0.Completion
    } : {
      invocationId: t,
      result: p,
      type: L0.Completion
    };
  }
  _createCloseMessage() {
    return { type: L0.Close };
  }
}
const iL = [0, 2e3, 1e4, 3e4, null];
class mO {
  constructor(t) {
    this._retryDelays = t !== void 0 ? [...t, null] : iL;
  }
  nextRetryDelayInMilliseconds(t) {
    return this._retryDelays[t.previousRetryCount];
  }
}
class ht {
}
ht.Authorization = "Authorization";
ht.Cookie = "Cookie";
class rL extends Vp {
  constructor(t, e) {
    super(), this._innerClient = t, this._accessTokenFactory = e;
  }
  async send(t) {
    let e = !0;
    this._accessTokenFactory && (!this._accessToken || t.url && t.url.indexOf("/negotiate?") > 0) && (e = !1, this._accessToken = await this._accessTokenFactory()), this._setAuthorizationHeader(t);
    const p = await this._innerClient.send(t);
    return e && p.statusCode === 401 && this._accessTokenFactory ? (this._accessToken = await this._accessTokenFactory(), this._setAuthorizationHeader(t), await this._innerClient.send(t)) : p;
  }
  _setAuthorizationHeader(t) {
    t.headers || (t.headers = {}), this._accessToken ? t.headers[ht.Authorization] = `Bearer ${this._accessToken}` : this._accessTokenFactory && t.headers[ht.Authorization] && delete t.headers[ht.Authorization];
  }
  getCookieString(t) {
    return this._innerClient.getCookieString(t);
  }
}
var T1;
(function(M) {
  M[M.None = 0] = "None", M[M.WebSockets = 1] = "WebSockets", M[M.ServerSentEvents = 2] = "ServerSentEvents", M[M.LongPolling = 4] = "LongPolling";
})(T1 || (T1 = {}));
var U1;
(function(M) {
  M[M.Text = 1] = "Text", M[M.Binary = 2] = "Binary";
})(U1 || (U1 = {}));
let OL = class {
  constructor() {
    this._isAborted = !1, this.onabort = null;
  }
  abort() {
    this._isAborted || (this._isAborted = !0, this.onabort && this.onabort());
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
};
class RO {
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  constructor(t, e, p) {
    this._httpClient = t, this._logger = e, this._pollAbort = new OL(), this._options = p, this._running = !1, this.onreceive = null, this.onclose = null;
  }
  async connect(t, e) {
    if (_1.isRequired(t, "url"), _1.isRequired(e, "transferFormat"), _1.isIn(e, U1, "transferFormat"), this._url = t, this._logger.log(x.Trace, "(LongPolling transport) Connecting."), e === U1.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string")
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    const [p, c] = oM(), i = { [p]: c, ...this._options.headers }, s = {
      abortSignal: this._pollAbort.signal,
      headers: i,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    e === U1.Binary && (s.responseType = "arraybuffer");
    const u = `${t}&_=${Date.now()}`;
    this._logger.log(x.Trace, `(LongPolling transport) polling: ${u}.`);
    const l = await this._httpClient.get(u, s);
    l.statusCode !== 200 ? (this._logger.log(x.Error, `(LongPolling transport) Unexpected response code: ${l.statusCode}.`), this._closeError = new Wt(l.statusText || "", l.statusCode), this._running = !1) : this._running = !0, this._receiving = this._poll(this._url, s);
  }
  async _poll(t, e) {
    try {
      for (; this._running; )
        try {
          const p = `${t}&_=${Date.now()}`;
          this._logger.log(x.Trace, `(LongPolling transport) polling: ${p}.`);
          const c = await this._httpClient.get(p, e);
          c.statusCode === 204 ? (this._logger.log(x.Information, "(LongPolling transport) Poll terminated by server."), this._running = !1) : c.statusCode !== 200 ? (this._logger.log(x.Error, `(LongPolling transport) Unexpected response code: ${c.statusCode}.`), this._closeError = new Wt(c.statusText || "", c.statusCode), this._running = !1) : c.content ? (this._logger.log(x.Trace, `(LongPolling transport) data received. ${ob(c.content, this._options.logMessageContent)}.`), this.onreceive && this.onreceive(c.content)) : this._logger.log(x.Trace, "(LongPolling transport) Poll timed out, reissuing.");
        } catch (p) {
          this._running ? p instanceof An ? this._logger.log(x.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this._closeError = p, this._running = !1) : this._logger.log(x.Trace, `(LongPolling transport) Poll errored after shutdown: ${p.message}`);
        }
    } finally {
      this._logger.log(x.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this._raiseOnClose();
    }
  }
  async send(t) {
    return this._running ? Na(this._logger, "LongPolling", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  async stop() {
    this._logger.log(x.Trace, "(LongPolling transport) Stopping polling."), this._running = !1, this._pollAbort.abort();
    try {
      await this._receiving, this._logger.log(x.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const t = {}, [e, p] = oM();
      t[e] = p;
      const c = {
        headers: { ...t, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      let i;
      try {
        await this._httpClient.delete(this._url, c);
      } catch (s) {
        i = s;
      }
      i ? i instanceof Wt && (i.statusCode === 404 ? this._logger.log(x.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this._logger.log(x.Trace, `(LongPolling transport) Error sending a DELETE request: ${i}`)) : this._logger.log(x.Trace, "(LongPolling transport) DELETE request accepted.");
    } finally {
      this._logger.log(x.Trace, "(LongPolling transport) Stop finished."), this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let t = "(LongPolling transport) Firing onclose event.";
      this._closeError && (t += " Error: " + this._closeError), this._logger.log(x.Trace, t), this.onclose(this._closeError);
    }
  }
}
class aL {
  constructor(t, e, p, c) {
    this._httpClient = t, this._accessToken = e, this._logger = p, this._options = c, this.onreceive = null, this.onclose = null;
  }
  async connect(t, e) {
    return _1.isRequired(t, "url"), _1.isRequired(e, "transferFormat"), _1.isIn(e, U1, "transferFormat"), this._logger.log(x.Trace, "(SSE transport) Connecting."), this._url = t, this._accessToken && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`), new Promise((p, c) => {
      let i = !1;
      if (e !== U1.Text) {
        c(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let s;
      if (m1.isBrowser || m1.isWebWorker)
        s = new this._options.EventSource(t, { withCredentials: this._options.withCredentials });
      else {
        const u = this._httpClient.getCookieString(t), l = {};
        l.Cookie = u;
        const [W, L] = oM();
        l[W] = L, s = new this._options.EventSource(t, { withCredentials: this._options.withCredentials, headers: { ...l, ...this._options.headers } });
      }
      try {
        s.onmessage = (u) => {
          if (this.onreceive)
            try {
              this._logger.log(x.Trace, `(SSE transport) data received. ${ob(u.data, this._options.logMessageContent)}.`), this.onreceive(u.data);
            } catch (l) {
              this._close(l);
              return;
            }
        }, s.onerror = (u) => {
          i ? this._close() : c(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
        }, s.onopen = () => {
          this._logger.log(x.Information, `SSE connected to ${this._url}`), this._eventSource = s, i = !0, p();
        };
      } catch (u) {
        c(u);
        return;
      }
    });
  }
  async send(t) {
    return this._eventSource ? Na(this._logger, "SSE", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  stop() {
    return this._close(), Promise.resolve();
  }
  _close(t) {
    this._eventSource && (this._eventSource.close(), this._eventSource = void 0, this.onclose && this.onclose(t));
  }
}
class sL {
  constructor(t, e, p, c, i, s) {
    this._logger = p, this._accessTokenFactory = e, this._logMessageContent = c, this._webSocketConstructor = i, this._httpClient = t, this.onreceive = null, this.onclose = null, this._headers = s;
  }
  async connect(t, e) {
    _1.isRequired(t, "url"), _1.isRequired(e, "transferFormat"), _1.isIn(e, U1, "transferFormat"), this._logger.log(x.Trace, "(WebSockets transport) Connecting.");
    let p;
    return this._accessTokenFactory && (p = await this._accessTokenFactory()), new Promise((c, i) => {
      t = t.replace(/^http/, "ws");
      let s;
      const u = this._httpClient.getCookieString(t);
      let l = !1;
      if (m1.isNode || m1.isReactNative) {
        const W = {}, [L, m] = oM();
        W[L] = m, p && (W[ht.Authorization] = `Bearer ${p}`), u && (W[ht.Cookie] = u), s = new this._webSocketConstructor(t, void 0, {
          headers: { ...W, ...this._headers }
        });
      } else
        p && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(p)}`);
      s || (s = new this._webSocketConstructor(t)), e === U1.Binary && (s.binaryType = "arraybuffer"), s.onopen = (W) => {
        this._logger.log(x.Information, `WebSocket connected to ${t}.`), this._webSocket = s, l = !0, c();
      }, s.onerror = (W) => {
        let L = null;
        typeof ErrorEvent < "u" && W instanceof ErrorEvent ? L = W.error : L = "There was an error with the transport", this._logger.log(x.Information, `(WebSockets transport) ${L}.`);
      }, s.onmessage = (W) => {
        if (this._logger.log(x.Trace, `(WebSockets transport) data received. ${ob(W.data, this._logMessageContent)}.`), this.onreceive)
          try {
            this.onreceive(W.data);
          } catch (L) {
            this._close(L);
            return;
          }
      }, s.onclose = (W) => {
        if (l)
          this._close(W);
        else {
          let L = null;
          typeof ErrorEvent < "u" && W instanceof ErrorEvent ? L = W.error : L = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", i(new Error(L));
        }
      };
    });
  }
  send(t) {
    return this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN ? (this._logger.log(x.Trace, `(WebSockets transport) sending data. ${ob(t, this._logMessageContent)}.`), this._webSocket.send(t), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    return this._webSocket && this._close(void 0), Promise.resolve();
  }
  _close(t) {
    this._webSocket && (this._webSocket.onclose = () => {
    }, this._webSocket.onmessage = () => {
    }, this._webSocket.onerror = () => {
    }, this._webSocket.close(), this._webSocket = void 0), this._logger.log(x.Trace, "(WebSockets transport) socket closed."), this.onclose && (this._isCloseEvent(t) && (t.wasClean === !1 || t.code !== 1e3) ? this.onclose(new Error(`WebSocket closed with status code: ${t.code} (${t.reason || "no reason given"}).`)) : t instanceof Error ? this.onclose(t) : this.onclose());
  }
  _isCloseEvent(t) {
    return t && typeof t.wasClean == "boolean" && typeof t.code == "number";
  }
}
const LO = 100;
class AL {
  constructor(t, e = {}) {
    if (this._stopPromiseResolver = () => {
    }, this.features = {}, this._negotiateVersion = 1, _1.isRequired(t, "url"), this._logger = YR(e.logger), this.baseUrl = this._resolveUrl(t), e = e || {}, e.logMessageContent = e.logMessageContent === void 0 ? !1 : e.logMessageContent, typeof e.withCredentials == "boolean" || e.withCredentials === void 0)
      e.withCredentials = e.withCredentials === void 0 ? !0 : e.withCredentials;
    else
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    e.timeout = e.timeout === void 0 ? 100 * 1e3 : e.timeout;
    let p = null, c = null;
    if (m1.isNode && typeof require < "u") {
      const i = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      p = i("ws"), c = i("eventsource");
    }
    !m1.isNode && typeof WebSocket < "u" && !e.WebSocket ? e.WebSocket = WebSocket : m1.isNode && !e.WebSocket && p && (e.WebSocket = p), !m1.isNode && typeof EventSource < "u" && !e.EventSource ? e.EventSource = EventSource : m1.isNode && !e.EventSource && typeof c < "u" && (e.EventSource = c), this._httpClient = new rL(e.httpClient || new tL(this._logger), e.accessTokenFactory), this._connectionState = "Disconnected", this._connectionStarted = !1, this._options = e, this.onreceive = null, this.onclose = null;
  }
  async start(t) {
    if (t = t || U1.Binary, _1.isIn(t, U1, "transferFormat"), this._logger.log(x.Debug, `Starting connection with transfer format '${U1[t]}'.`), this._connectionState !== "Disconnected")
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    if (this._connectionState = "Connecting", this._startInternalPromise = this._startInternal(t), await this._startInternalPromise, this._connectionState === "Disconnecting") {
      const e = "Failed to start the HttpConnection before stop() was called.";
      return this._logger.log(x.Error, e), await this._stopPromise, Promise.reject(new E2(e));
    } else if (this._connectionState !== "Connected") {
      const e = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      return this._logger.log(x.Error, e), Promise.reject(new E2(e));
    }
    this._connectionStarted = !0;
  }
  send(t) {
    return this._connectionState !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this._sendQueue || (this._sendQueue = new un(this.transport)), this._sendQueue.send(t));
  }
  async stop(t) {
    if (this._connectionState === "Disconnected")
      return this._logger.log(x.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === "Disconnecting")
      return this._logger.log(x.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    this._connectionState = "Disconnecting", this._stopPromise = new Promise((e) => {
      this._stopPromiseResolver = e;
    }), await this._stopInternal(t), await this._stopPromise;
  }
  async _stopInternal(t) {
    this._stopError = t;
    try {
      await this._startInternalPromise;
    } catch {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (e) {
        this._logger.log(x.Error, `HttpConnection.transport.stop() threw error '${e}'.`), this._stopConnection();
      }
      this.transport = void 0;
    } else
      this._logger.log(x.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
  }
  async _startInternal(t) {
    let e = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory, this._httpClient._accessTokenFactory = this._accessTokenFactory;
    try {
      if (this._options.skipNegotiation)
        if (this._options.transport === T1.WebSockets)
          this.transport = this._constructTransport(T1.WebSockets), await this._startTransport(e, t);
        else
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
      else {
        let p = null, c = 0;
        do {
          if (p = await this._getNegotiationResponse(e), this._connectionState === "Disconnecting" || this._connectionState === "Disconnected")
            throw new E2("The connection was stopped during negotiation.");
          if (p.error)
            throw new Error(p.error);
          if (p.ProtocolVersion)
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          if (p.url && (e = p.url), p.accessToken) {
            const i = p.accessToken;
            this._accessTokenFactory = () => i, this._httpClient._accessToken = i, this._httpClient._accessTokenFactory = void 0;
          }
          c++;
        } while (p.url && c < LO);
        if (c === LO && p.url)
          throw new Error("Negotiate redirection limit exceeded.");
        await this._createTransport(e, this._options.transport, p, t);
      }
      this.transport instanceof RO && (this.features.inherentKeepAlive = !0), this._connectionState === "Connecting" && (this._logger.log(x.Debug, "The HttpConnection connected successfully."), this._connectionState = "Connected");
    } catch (p) {
      return this._logger.log(x.Error, "Failed to start the connection: " + p), this._connectionState = "Disconnected", this.transport = void 0, this._stopPromiseResolver(), Promise.reject(p);
    }
  }
  async _getNegotiationResponse(t) {
    const e = {}, [p, c] = oM();
    e[p] = c;
    const i = this._resolveNegotiateUrl(t);
    this._logger.log(x.Debug, `Sending negotiation request: ${i}.`);
    try {
      const s = await this._httpClient.post(i, {
        content: "",
        headers: { ...e, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (s.statusCode !== 200)
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${s.statusCode}'`));
      const u = JSON.parse(s.content);
      return (!u.negotiateVersion || u.negotiateVersion < 1) && (u.connectionToken = u.connectionId), u.useStatefulReconnect && this._options._useStatefulReconnect !== !0 ? Promise.reject(new WO("Client didn't negotiate Stateful Reconnect but the server did.")) : u;
    } catch (s) {
      let u = "Failed to complete negotiation with the server: " + s;
      return s instanceof Wt && s.statusCode === 404 && (u = u + " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this._logger.log(x.Error, u), Promise.reject(new WO(u));
    }
  }
  _createConnectUrl(t, e) {
    return e ? t + (t.indexOf("?") === -1 ? "?" : "&") + `id=${e}` : t;
  }
  async _createTransport(t, e, p, c) {
    let i = this._createConnectUrl(t, p.connectionToken);
    if (this._isITransport(e)) {
      this._logger.log(x.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = e, await this._startTransport(i, c), this.connectionId = p.connectionId;
      return;
    }
    const s = [], u = p.availableTransports || [];
    let l = p;
    for (const W of u) {
      const L = this._resolveTransportOrError(W, e, c, (l == null ? void 0 : l.useStatefulReconnect) === !0);
      if (L instanceof Error)
        s.push(`${W.transport} failed:`), s.push(L);
      else if (this._isITransport(L)) {
        if (this.transport = L, !l) {
          try {
            l = await this._getNegotiationResponse(t);
          } catch (m) {
            return Promise.reject(m);
          }
          i = this._createConnectUrl(t, l.connectionToken);
        }
        try {
          await this._startTransport(i, c), this.connectionId = l.connectionId;
          return;
        } catch (m) {
          if (this._logger.log(x.Error, `Failed to start the transport '${W.transport}': ${m}`), l = void 0, s.push(new FR(`${W.transport} failed: ${m}`, T1[W.transport])), this._connectionState !== "Connecting") {
            const X = "Failed to select transport before stop() was called.";
            return this._logger.log(x.Debug, X), Promise.reject(new E2(X));
          }
        }
      }
    }
    return s.length > 0 ? Promise.reject(new UR(`Unable to connect to the server with any of the available transports. ${s.join(" ")}`, s)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(t) {
    switch (t) {
      case T1.WebSockets:
        if (!this._options.WebSocket)
          throw new Error("'WebSocket' is not supported in your environment.");
        return new sL(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case T1.ServerSentEvents:
        if (!this._options.EventSource)
          throw new Error("'EventSource' is not supported in your environment.");
        return new aL(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
      case T1.LongPolling:
        return new RO(this._httpClient, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${t}.`);
    }
  }
  _startTransport(t, e) {
    return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (p) => {
      let c = !1;
      if (this.features.reconnect)
        try {
          this.features.disconnected(), await this.transport.connect(t, e), await this.features.resend();
        } catch {
          c = !0;
        }
      else {
        this._stopConnection(p);
        return;
      }
      c && this._stopConnection(p);
    } : this.transport.onclose = (p) => this._stopConnection(p), this.transport.connect(t, e);
  }
  _resolveTransportOrError(t, e, p, c) {
    const i = T1[t.transport];
    if (i == null)
      return this._logger.log(x.Debug, `Skipping transport '${t.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${t.transport}' because it is not supported by this client.`);
    if (dL(e, i))
      if (t.transferFormats.map((u) => U1[u]).indexOf(p) >= 0) {
        if (i === T1.WebSockets && !this._options.WebSocket || i === T1.ServerSentEvents && !this._options.EventSource)
          return this._logger.log(x.Debug, `Skipping transport '${T1[i]}' because it is not supported in your environment.'`), new ER(`'${T1[i]}' is not supported in your environment.`, i);
        this._logger.log(x.Debug, `Selecting transport '${T1[i]}'.`);
        try {
          return this.features.reconnect = i === T1.WebSockets ? c : void 0, this._constructTransport(i);
        } catch (u) {
          return u;
        }
      } else
        return this._logger.log(x.Debug, `Skipping transport '${T1[i]}' because it does not support the requested transfer format '${U1[p]}'.`), new Error(`'${T1[i]}' does not support ${U1[p]}.`);
    else
      return this._logger.log(x.Debug, `Skipping transport '${T1[i]}' because it was disabled by the client.`), new xR(`'${T1[i]}' is disabled by the client.`, i);
  }
  _isITransport(t) {
    return t && typeof t == "object" && "connect" in t;
  }
  _stopConnection(t) {
    if (this._logger.log(x.Debug, `HttpConnection.stopConnection(${t}) called while in state ${this._connectionState}.`), this.transport = void 0, t = this._stopError || t, this._stopError = void 0, this._connectionState === "Disconnected") {
      this._logger.log(x.Debug, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting")
      throw this._logger.log(x.Warning, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${t}) was called while the connection is still in the connecting state.`);
    if (this._connectionState === "Disconnecting" && this._stopPromiseResolver(), t ? this._logger.log(x.Error, `Connection disconnected with error '${t}'.`) : this._logger.log(x.Information, "Connection disconnected."), this._sendQueue && (this._sendQueue.stop().catch((e) => {
      this._logger.log(x.Error, `TransportSendQueue.stop() threw error '${e}'.`);
    }), this._sendQueue = void 0), this.connectionId = void 0, this._connectionState = "Disconnected", this._connectionStarted) {
      this._connectionStarted = !1;
      try {
        this.onclose && this.onclose(t);
      } catch (e) {
        this._logger.log(x.Error, `HttpConnection.onclose(${t}) threw error '${e}'.`);
      }
    }
  }
  _resolveUrl(t) {
    if (t.lastIndexOf("https://", 0) === 0 || t.lastIndexOf("http://", 0) === 0)
      return t;
    if (!m1.isBrowser)
      throw new Error(`Cannot resolve '${t}'.`);
    const e = window.document.createElement("a");
    return e.href = t, this._logger.log(x.Information, `Normalizing '${t}' to '${e.href}'.`), e.href;
  }
  _resolveNegotiateUrl(t) {
    const e = new URL(t);
    e.pathname.endsWith("/") ? e.pathname += "negotiate" : e.pathname += "/negotiate";
    const p = new URLSearchParams(e.searchParams);
    return p.has("negotiateVersion") || p.append("negotiateVersion", this._negotiateVersion.toString()), p.has("useStatefulReconnect") ? p.get("useStatefulReconnect") === "true" && (this._options._useStatefulReconnect = !0) : this._options._useStatefulReconnect === !0 && p.append("useStatefulReconnect", "true"), e.search = p.toString(), e.toString();
  }
}
function dL(M, t) {
  return !M || (t & M) !== 0;
}
class un {
  constructor(t) {
    this._transport = t, this._buffer = [], this._executing = !0, this._sendBufferedData = new Op(), this._transportResult = new Op(), this._sendLoopPromise = this._sendLoop();
  }
  send(t) {
    return this._bufferData(t), this._transportResult || (this._transportResult = new Op()), this._transportResult.promise;
  }
  stop() {
    return this._executing = !1, this._sendBufferedData.resolve(), this._sendLoopPromise;
  }
  _bufferData(t) {
    if (this._buffer.length && typeof this._buffer[0] != typeof t)
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof t}`);
    this._buffer.push(t), this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    for (; ; ) {
      if (await this._sendBufferedData.promise, !this._executing) {
        this._transportResult && this._transportResult.reject("Connection stopped.");
        break;
      }
      this._sendBufferedData = new Op();
      const t = this._transportResult;
      this._transportResult = void 0;
      const e = typeof this._buffer[0] == "string" ? this._buffer.join("") : un._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(e), t.resolve();
      } catch (p) {
        t.reject(p);
      }
    }
  }
  static _concatBuffers(t) {
    const e = t.map((i) => i.byteLength).reduce((i, s) => i + s), p = new Uint8Array(e);
    let c = 0;
    for (const i of t)
      p.set(new Uint8Array(i), c), c += i.byteLength;
    return p.buffer;
  }
}
class Op {
  constructor() {
    this.promise = new Promise((t, e) => [this._resolver, this._rejecter] = [t, e]);
  }
  resolve() {
    this._resolver();
  }
  reject(t) {
    this._rejecter(t);
  }
}
const uL = "json";
class qL {
  constructor() {
    this.name = uL, this.version = 2, this.transferFormat = U1.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(t, e) {
    if (typeof t != "string")
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    if (!t)
      return [];
    e === null && (e = zb.instance);
    const p = A2.parse(t), c = [];
    for (const i of p) {
      const s = JSON.parse(i);
      if (typeof s.type != "number")
        throw new Error("Invalid payload.");
      switch (s.type) {
        case L0.Invocation:
          this._isInvocationMessage(s);
          break;
        case L0.StreamItem:
          this._isStreamItemMessage(s);
          break;
        case L0.Completion:
          this._isCompletionMessage(s);
          break;
        case L0.Ping:
          break;
        case L0.Close:
          break;
        case L0.Ack:
          this._isAckMessage(s);
          break;
        case L0.Sequence:
          this._isSequenceMessage(s);
          break;
        default:
          e.log(x.Information, "Unknown message type '" + s.type + "' ignored.");
          continue;
      }
      c.push(s);
    }
    return c;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(t) {
    return A2.write(JSON.stringify(t));
  }
  _isInvocationMessage(t) {
    this._assertNotEmptyString(t.target, "Invalid payload for Invocation message."), t.invocationId !== void 0 && this._assertNotEmptyString(t.invocationId, "Invalid payload for Invocation message.");
  }
  _isStreamItemMessage(t) {
    if (this._assertNotEmptyString(t.invocationId, "Invalid payload for StreamItem message."), t.item === void 0)
      throw new Error("Invalid payload for StreamItem message.");
  }
  _isCompletionMessage(t) {
    if (t.result && t.error)
      throw new Error("Invalid payload for Completion message.");
    !t.result && t.error && this._assertNotEmptyString(t.error, "Invalid payload for Completion message."), this._assertNotEmptyString(t.invocationId, "Invalid payload for Completion message.");
  }
  _isAckMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Ack message.");
  }
  _isSequenceMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Sequence message.");
  }
  _assertNotEmptyString(t, e) {
    if (typeof t != "string" || t === "")
      throw new Error(e);
  }
}
const lL = {
  trace: x.Trace,
  debug: x.Debug,
  info: x.Information,
  information: x.Information,
  warn: x.Warning,
  warning: x.Warning,
  error: x.Error,
  critical: x.Critical,
  none: x.None
};
function fL(M) {
  const t = lL[M.toLowerCase()];
  if (typeof t < "u")
    return t;
  throw new Error(`Unknown log level: ${M}`);
}
class WL {
  configureLogging(t) {
    if (_1.isRequired(t, "logging"), hL(t))
      this.logger = t;
    else if (typeof t == "string") {
      const e = fL(t);
      this.logger = new Np(e);
    } else
      this.logger = new Np(t);
    return this;
  }
  withUrl(t, e) {
    return _1.isRequired(t, "url"), _1.isNotEmpty(t, "url"), this.url = t, typeof e == "object" ? this.httpConnectionOptions = { ...this.httpConnectionOptions, ...e } : this.httpConnectionOptions = {
      ...this.httpConnectionOptions,
      transport: e
    }, this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(t) {
    return _1.isRequired(t, "protocol"), this.protocol = t, this;
  }
  withAutomaticReconnect(t) {
    if (this.reconnectPolicy)
      throw new Error("A reconnectPolicy has already been set.");
    return t ? Array.isArray(t) ? this.reconnectPolicy = new mO(t) : this.reconnectPolicy = t : this.reconnectPolicy = new mO(), this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withServerTimeout(t) {
    return _1.isRequired(t, "milliseconds"), this._serverTimeoutInMilliseconds = t, this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withKeepAliveInterval(t) {
    return _1.isRequired(t, "milliseconds"), this._keepAliveIntervalInMilliseconds = t, this;
  }
  /** Enables and configures options for the Stateful Reconnect feature.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withStatefulReconnect(t) {
    return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._useStatefulReconnect = !0, this._statefulReconnectBufferSize = t == null ? void 0 : t.bufferSize, this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const t = this.httpConnectionOptions || {};
    if (t.logger === void 0 && (t.logger = this.logger), !this.url)
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    const e = new AL(this.url, t);
    return dn.create(e, this.logger || zb.instance, this.protocol || new qL(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
  }
}
function hL(M) {
  return M.log !== void 0;
}
class O1 {
  constructor(t, e, p) {
    this.client = t, this.method = e, this.parse = p;
  }
  subscribe(t) {
    const e = ({ payload: p, caller: c }) => {
      try {
        const i = this.parse ? this.parse(p) : p;
        t(i, c);
      } catch (i) {
        console.error(i);
      }
    };
    return this.client.on(this.method, e);
  }
}
class yt extends M0 {
  constructor(e) {
    super();
    o(this, "firstName");
    o(this, "lastName");
    o(this, "middleName");
    o(this, "birthday");
    o(this, "phone");
    o(this, "email");
    o(this, "avatar");
    o(this, "userId");
    o(this, "studentId");
    o(this, "adminId");
    o(this, "lastActivityDate");
    o(this, "onlineStatus");
    o(this, "isActive");
    o(this, "isSystem");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "syncedDate");
    o(this, "lastSeenMessageIndex");
    o(this, "internalNumber");
    o(this, "type");
    o(this, "post");
    o(this, "userName");
    e && this.update(e);
  }
  get canCall() {
    return !I1.isEmpty(this.internalNumber);
  }
  get isFirstNameEmpty() {
    return I1.isEmpty(this.firstName);
  }
  get isLastNameEmpty() {
    return I1.isEmpty(this.lastName);
  }
  get hasName() {
    return !this.isFirstNameEmpty || !this.isLastNameEmpty;
  }
  get fullName() {
    return this.isFirstNameEmpty && this.isLastNameEmpty ? this.email : this.isFirstNameEmpty ? this.lastName : this.isLastNameEmpty ? this.firstName : `${this.firstName} ${this.lastName}`;
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new yt({
      ...e,
      birthday: e.birthday ? R(e.birthday) : void 0,
      avatar: e.avatar ? g1.fromJson(e.avatar) : null,
      lastActivityDate: e.lastActivityDate ? R(e.lastActivityDate) : void 0,
      createdDate: e.createdDate ? R(e.createdDate) : void 0,
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      syncedDate: e.syncedDate ? R(e.syncedDate) : void 0
    });
  }
}
class qn extends H1 {
  constructor(e) {
    super();
    o(this, "link");
    o(this, "scenarioNodePortId");
    o(this, "title");
    o(this, "type");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new qn({
      ...e
    });
  }
}
class Nt extends M0 {
  constructor(e) {
    super();
    o(this, "index");
    o(this, "text");
    o(this, "plainText");
    o(this, "authorId");
    o(this, "author");
    o(this, "reply");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "type");
    o(this, "attachments");
    o(this, "isDraft");
    o(this, "location");
    o(this, "hasAttachments");
    o(this, "hasLocation");
    o(this, "callDurationInSec");
    o(this, "template");
    o(this, "buttons");
    o(this, "sent");
    o(this, "sentError");
    o(this, "sentErrorMessage");
    o(this, "deleting");
    o(this, "deleted");
    o(this, "deletedError");
    o(this, "deletedErrorMessage");
    o(this, "renderMethod");
    e && this.update(e);
  }
  get hasButtons() {
    return this.buttons && this.buttons.length > 0;
  }
  get hasError() {
    return this.sentError || this.deletedError;
  }
  get voice() {
    return this.type === "voice" && this.attachments[0];
  }
  get hasText() {
    return !I1.isEmpty(this.text);
  }
  get isMessageFromSystemMember() {
    var e;
    return ((e = this.author) == null ? void 0 : e.isSystem) ?? !1;
  }
  init(e) {
    this.author || (this.author = e.memberMap.get(this.authorId)), this.reply && !this.reply.author && (this.reply.author = e.memberMap.get(this.reply.authorId));
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new Nt({
      ...e,
      author: e.author ? yt.fromJson(e.author) : void 0,
      reply: e.reply ? Nt.fromJson(e.reply) : null,
      createdDate: R(e.createdDate),
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      attachments: e.attachments ? e.attachments.map(g1.fromJson) : [],
      buttons: e.buttons ? e.buttons.map(qn.fromJson) : []
    });
  }
}
class cM extends M0 {
  constructor(e) {
    super();
    o(this, "title");
    o(this, "lastMessage");
    o(this, "lastActivityDate");
    o(this, "creatorLastActivityDate");
    o(this, "channelColor");
    o(this, "lastSeenMessageIndex");
    o(this, "targetLastSeenMessageIndex");
    o(this, "membersTypingMap");
    o(this, "members");
    o(this, "type");
    o(this, "target");
    o(this, "isDraft");
    o(this, "readonly");
    o(this, "creatorUnsubscribed");
    o(this, "creatorUnsubscribedReason");
    // TODO ??
    // messageSettings: ChatConversationMessageSettings;
    o(this, "state");
    o(this, "creatorUserId");
    e && this.update(e), this.membersTypingMap = /* @__PURE__ */ new Map();
  }
  // TODO remove
  // creatorUserExternalId: string; 
  get scrollToIndex() {
    var e;
    return this.lastSeenMessageIndex ?? ((e = this.lastMessage) == null ? void 0 : e.index) ?? 0;
  }
  // get hasUserNameOrId(): boolean {
  //     return !isEmpty(this.target?.userName) || !isEmpty(this.creatorUserExternalId);
  // }
  get userName() {
    var e;
    return (e = this.target) == null ? void 0 : e.userName;
  }
  // @computed get userChannelId() {
  //     switch (this.channelType) {
  //         case ChannelType.WA:
  //             return this.creatorUserExternalId && `+${this.creatorUserExternalId}`;
  //         default:
  //             return this.creatorUserExternalId;
  //     }
  // }
  get memberMapByUserId() {
    return this.members.toMap((e) => e.userId);
  }
  get memberMap() {
    return this.members.toMap((e) => e.id);
  }
  get memberTyping() {
    return Array.from(this.membersTypingMap.keys()).map((e) => this.memberMap.get(e));
  }
  // @computed get isResponseTimeLimitExceeded() {
  //     const settings = this.messageSettings;
  //     if (!settings.responseTimeLimit) return false;
  //     if (this.creatorLastActivityDate) {
  //         const diff = moment().diff(this.creatorLastActivityDate, 'milliseconds');
  //         return diff > settings.responseTimeLimit.milliseconds;
  //     }
  //     else {
  //         return true;
  //     }
  // }
  get name() {
    var e, p, c;
    return ((e = this.target) == null ? void 0 : e.fullName) ?? ((p = this.target) == null ? void 0 : p.phone) ?? ((c = this.target) == null ? void 0 : c.userName);
  }
  get unreadMessageCount() {
    return this.lastMessage ? this.lastSeenMessageIndex == null ? this.lastMessage.index + 1 : this.lastMessage.index - this.lastSeenMessageIndex : 0;
  }
  addTypingMember(e) {
    if (this.memberMap.has(e))
      return this.membersTypingMap.has(e) && clearTimeout(this.membersTypingMap.get(e)), this.membersTypingMap.set(e, setTimeout(() => this.removeTypingMember(e), 2e3)), !0;
  }
  removeTypingMember(e) {
    this.membersTypingMap.delete(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new cM({
      ...e,
      lastMessage: e.lastMessage ? Nt.fromJson(e.lastMessage) : null,
      lastActivityDate: e.lastActivityDate ? R(e.lastActivityDate) : null,
      creatorLastActivityDate: e.creatorLastActivityDate ? R(e.creatorLastActivityDate) : null,
      channelColor: e.channelColor ?? "#ffffff",
      members: e.members ? e.members.map(yt.fromJson) : [],
      target: e.target ? yt.fromJson(e.target) : void 0,
      creatorUnsubscribed: e.creatorUnsubscribed ?? !1
      // messageSettings: json.messageSettings ? ChatConversationMessageSettings.fromJson(json.messageSettings) : undefined,
    });
  }
}
var y2 = /* @__PURE__ */ ((M) => (M.ConversationCreated = "conversationCreated", M.ConversationUpdated = "conversationUpdated", M.ConversationDeleted = "conversationDeleted", M.ConversationSynced = "conversationSynced", M.MessageSent = "messageCreated", M.MessageUpdated = "messageUpdated", M.MessageDeleted = "messageDeleted", M.MemberAdded = "memberCreated", M.MemberDeleted = "memberDeleted", M.MemberUpdated = "memberUpdated", M.MemberTyping = "memberTyping", M))(y2 || {});
class mL extends H1 {
  constructor(e) {
    super();
    o(this, "type");
    o(this, "payload");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
}
class ln extends H1 {
  constructor(e) {
    super();
    o(this, "conversation");
    e && this.update(e);
  }
  update(e) {
    super.update(e);
  }
  static fromJson(e) {
    return new ln({
      conversation: cM.fromJson(e)
    });
  }
}
class fn extends H1 {
  constructor(e) {
    super();
    o(this, "id");
    e && this.update(e);
  }
  static fromJson(e) {
    return new fn({ id: e.id });
  }
  update(e) {
    super.update(e);
  }
}
class Wn extends H1 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "lastSeenMessageIndex");
    o(this, "targetLastSeenMessageIndex");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Wn(e);
  }
  update(e) {
    super.update(e);
  }
}
class hn extends H1 {
  constructor(e) {
    super();
    o(this, "conversation");
    e && this.update(e);
  }
  static fromJson(e) {
    return new hn({
      conversation: cM.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class mn extends H1 {
  constructor(e) {
    super();
    o(this, "member");
    e && this.update(e);
  }
  static fromJson(e) {
    return new mn({
      member: yt.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class Rn extends H1 {
  constructor(e) {
    super();
    o(this, "id");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Rn({
      id: e.id
    });
  }
  update(e) {
    super.update(e);
  }
}
class Ln extends H1 {
  constructor(e) {
    super();
    o(this, "memberId");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Ln({
      memberId: e.memberId
    });
  }
  update(e) {
    super.update(e);
  }
}
class gn extends H1 {
  constructor(e) {
    super();
    o(this, "id");
    o(this, "isActive");
    o(this, "lastSeenMessageIndex");
    e && this.update(e);
  }
  static fromJson(e) {
    return new gn({
      id: e.id,
      isActive: e.isActive,
      lastSeenMessageIndex: e.lastSeenMessageIndex
    });
  }
  update(e) {
    super.update(e);
  }
}
class yn extends H1 {
  constructor(e) {
    super();
    o(this, "index");
    e && this.update(e);
  }
  static fromJson(e) {
    return new yn({
      index: e.index
    });
  }
  update(e) {
    super.update(e);
  }
}
class Nn extends H1 {
  constructor(e) {
    super();
    o(this, "member");
    o(this, "messages");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Nn({
      member: yt.fromJson(e.member),
      messages: e.messages.map(Nt.fromJson)
    });
  }
  update(e) {
    super.update(e);
  }
}
class Bn extends H1 {
  constructor(e) {
    super();
    o(this, "message");
    e && this.update(e);
  }
  static fromJson(e) {
    return new Bn({
      message: Nt.fromJson(e)
    });
  }
  update(e) {
    super.update(e);
  }
}
class RL {
  static create(t, e) {
    switch (t) {
      // conversations
      case y2.ConversationCreated:
        e = ln.fromJson(e);
        break;
      case y2.ConversationUpdated:
        e = hn.fromJson(e);
        break;
      case y2.ConversationDeleted:
        e = fn.fromJson(e);
        break;
      case y2.ConversationSynced:
        e = Wn.fromJson(e);
        break;
      // conversation
      case y2.MessageSent:
        e = Nn.fromJson(e);
        break;
      case y2.MessageUpdated:
        e = Bn.fromJson(e);
        break;
      case y2.MessageDeleted:
        e = yn.fromJson(e);
        break;
      case y2.MemberTyping:
        e = Ln.fromJson(e);
        break;
      case y2.MemberAdded:
        e = mn.fromJson(e);
        break;
      case y2.MemberDeleted:
        e = Rn.fromJson(e);
        break;
      case y2.MemberUpdated:
        e = gn.fromJson(e);
        break;
      default:
        console.error(`[ChatActionFactory] '${t}' not found`);
        break;
    }
    return new mL({ type: t, payload: e });
  }
}
class $M extends M0 {
  constructor(e) {
    super();
    o(this, "firstName");
    o(this, "lastName");
    o(this, "middleName");
    o(this, "phone");
    o(this, "email");
    o(this, "avatar");
    o(this, "adminId");
    o(this, "studentId");
    o(this, "lastSeenDate");
    o(this, "post");
    o(this, "userName");
    o(this, "roles");
    e && this.update(e);
  }
  update(e, p) {
    super.update(e, p);
  }
  static fromJson(e) {
    return new $M({
      ...e,
      avatar: e.avatar ? g1.fromJson(e.avatar) : null,
      lastSeenDate: e.lastSeenDate ? R(e.lastSeenDate) : void 0
    });
  }
}
class LL {
  constructor(t) {
    o(this, "init", () => this.client.invoke("Init", [], (t) => ({
      user: $M.fromJson(t.user),
      conversationId: t.conversationId
    })));
    o(this, "conversation", {
      fetch: (t) => this.client.invoke("GetConversation", [t], cM.fromJson),
      sync: (t, e) => this.client.invoke("SyncConversation", [t, e]),
      typing: (t, e) => this.client.invoke("MemberTyping", [t, e]),
      updated: (t) => new O1(this.client, `Conversation ${t}`, (e) => RL.create(e.type, e.payload))
    });
    o(this, "message", {
      fetch: (t, e, p) => this.client.invoke("GetMessages", [{ conversationId: t, skip: e, take: p }], (c) => c.items.map(Nt.fromJson)),
      send: (t, e, p) => this.client.invoke("SendMessage", [t, e, p]),
      clickButton: (t) => this.client.invoke("ButtonClick", [t]),
      delete: (t) => this.client.invoke("DeleteMessage", [{ id: t }]),
      update: (t) => this.client.invoke("UpdateMessage", [t])
    });
    // TODO delete?
    o(this, "user", {
      fetchInfo: (t) => this.client.invoke("GetUserInfo", [t], (e) => ({
        user: new $M({
          id: e.id,
          email: e.email,
          phone: e.phone,
          firstName: e.firstName,
          lastName: e.lastName,
          post: e.post,
          userName: e.userName
        }),
        onlineStatus: e.onlineStatus,
        contact: e.contact ? $M.fromJson(e.contact) : null,
        chats: e.chats.map(cM.fromJson)
      }))
    });
    this.client = t;
  }
}
class Ba extends ab {
  constructor(e, p) {
    super();
    o(this, "inited", !1);
    o(this, "connection");
    o(this, "connectionError", null);
    o(this, "state", N0.Disconnected);
    o(this, "connectionId", null);
    o(this, "handleTokenChanged", async (e) => {
      if (e != null) {
        this.state == N0.Connected && await this.disconnect(), await this.connect();
        return;
      }
      await this.disconnect();
    });
    this.settings = e, this.sdk = p, c0(this, {
      state: r,
      connectionId: r,
      setState: I
    }), this.toDispose(pO(() => this.state, (i) => {
      this.connectionId = i === N0.Disconnected ? null : this.connection.connectionId ?? this.connectionId, this.sdk.dispatcher.emit("hub.state.changed", { client: this, state: i, connectionId: this.connectionId });
    }));
    const c = async () => {
      var i;
      return (i = await this.sdk.tokenStorage.getTokens()) == null ? void 0 : i.accessToken;
    };
    this.connection = new WL().withUrl(this.settings.host, {
      accessTokenFactory: c,
      transport: T1.WebSockets,
      // No negotiate: the hub is on a different site than the school, so the load
      // balancer's affinity cookie is third-party and browsers that restrict those drop
      // it — the WebSocket upgrade then lands on a task that never saw the negotiated
      // connection id and the connection fails with no fallback transport. See the same
      // comment in accel-framework's BaseHubClient.
      skipNegotiation: !0
    }).withAutomaticReconnect([2e3, 3e3, 5e3, 1e4, 6e4]).build(), this.connection.on("ConnectionId", (i) => {
      this.connectionId = i;
    }), this.toDispose(() => this.connection.stop());
  }
  async init() {
    if (this.inited)
      throw new Error("[HubClient] Already inited");
    this.connection.onclose((e) => this.setState(N0.Disconnected, e)), this.connection.onreconnecting((e) => this.setState(N0.Reconnecting, e)), this.connection.onreconnected((e) => this.setState(N0.Connected)), this.sdk.dispatcher.on("auth.token.changed", this.handleTokenChanged), this.toDispose(() => this.sdk.dispatcher.off("auth.token.changed", this.handleTokenChanged)), this.settings.autoConnect !== !1 && this.handleTokenChanged(await this.sdk.tokenStorage.getTokens()), this.inited = !0;
  }
  async connect() {
    if (this.state != N0.Connected)
      try {
        this.setState(N0.Connecting), await this.connection.start(), this.setState(N0.Connected);
      } catch (e) {
        this.setState(N0.Reconnecting, e), setTimeout(() => this.connect(), 5e3);
      }
  }
  async disconnect() {
    if (this.state != N0.Disconnected)
      try {
        this.setState(N0.Disconnecting), await this.connection.stop(), this.setState(N0.Disconnected);
      } catch {
        this.setState(N0.Disconnected);
      }
  }
  on(e, p) {
    return this.connection.on(e, p), () => {
      this.connection.off(e, p);
    };
  }
  async invoke(e, p, c) {
    let i = await this.safeInvoke(e, p, c);
    return !i.success && this.connection.state != N0.Connected && await this.waitForConnection() ? await this.safeInvoke(e, p, c) : i;
  }
  async safeInvoke(e, p, c) {
    try {
      const i = await this.connection.invoke(e, p), s = c ? c(i) : i;
      return { success: !0, errors: [], body: s };
    } catch {
      return { success: !1, errors: [], body: null };
    }
  }
  setState(e, p = null) {
    this.connectionError = p, this.state = e;
  }
  /**
   * wait for reconnection or timeout
   * @param durationMs
   */
  waitForConnection() {
    return new Promise((e) => {
      const p = setTimeout(() => {
        c(), e(!1);
      }, this.settings.invokeTimeoutMs), c = pO(() => this.state, (i) => {
        i == N0.Connected && (clearTimeout(p), c(), e(!0));
      });
    });
  }
}
class gL extends ab {
  constructor(e) {
    super();
    o(this, "inited", !1);
    o(this, "hub");
    o(this, "hubClient");
    this.sdk = e, this.hubClient = "client" in e.config.chat ? e.config.chat.client : new Ba(e.config.chat.clientConfig, e), this.hub = new LL(this.hubClient);
  }
  async init() {
    this.inited || (this.sdk.dispatcher.on("hub.state.changed", this.handleStateChanged.bind(this)), this.toDispose(() => this.sdk.dispatcher.off("hub.state.changed", this.handleStateChanged)), await this.hubClient.init(), this.toDispose(this.hubClient), this.inited = !0);
  }
  async sync() {
    const e = await this.hub.init();
    if (!e.success || !e.body.conversationId)
      throw new Error("Failed to init chat: " + e.errors.map((c) => c.message).join(", "));
    const p = await this.hub.conversation.fetch(e.body.conversationId);
    if (!p.success)
      throw new Error("Failed to fetch conversation: " + p.errors.map((c) => c.message).join(", "));
    this.toDispose(this.hub.conversation.updated(e.body.conversationId).subscribe(this.handleConversationUpdated.bind(this))), this.sdk.dispatcher.emit("chat.inited", { conversation: p.body, user: e.body.user });
  }
  async handleStateChanged(e) {
    e.client == this.hubClient && e.state == N0.Connected && await this.sync();
  }
  handleConversationUpdated(e) {
    this.sdk.dispatcher.emit("chat.conversation.updated", e.payload);
  }
  disconnect() {
    this.hubClient.disconnect();
  }
}
class yL {
  constructor(t) {
    o(this, "breadcrumbs", []);
    o(this, "threads", []);
    o(this, "topics", []);
    o(this, "thread", null);
    o(this, "canModerate", !1);
    o(this, "fetched", !1);
    o(this, "banStatus", null);
    this.sdk = t, c0(this, {
      breadcrumbs: r,
      threads: r,
      topics: r,
      thread: r,
      canModerate: r,
      fetched: r,
      banStatus: r,
      canCreateTopic: Y,
      fetch: I,
      deleteTopic: I
    });
  }
  get canCreateTopic() {
    return this.thread != null && this.thread.canStudentCreateTopics && this.banStatus == null;
  }
  canDeleteTopic(t) {
    var e;
    return this.canModerate ? !0 : t.contact.id == ((e = this.sdk.account.user) == null ? void 0 : e.id) && t.commentCount == 0 ? R().diff(t.createdDate, "minutes") < 10 : !1;
  }
  async fetch(t) {
    return this.fetched = !1, await this.sdk.api.forum.thread.fetchThread(t);
  }
  async deleteTopic(t) {
    const e = await this.sdk.api.forum.topic.deleteTopic(t);
    return e.success && i0(() => {
      this.topics = this.topics.filter((p) => p.id != t);
    }), e;
  }
}
class NL extends ab {
  constructor(e, p) {
    super();
    o(this, "breadcrumbs", []);
    o(this, "topic");
    o(this, "canModerate", !1);
    o(this, "fetched", !1);
    o(this, "replyTo", null);
    o(this, "banStatus", null);
    o(this, "fetchComments", async (e, p) => {
      const c = new Wa({ take: p, page: e, topicId: this.topic.id });
      return await this.sdk.api.forum.comment.fetchTopicComments(c);
    });
    this.sdk = e, this.hub = p, c0(this, {
      breadcrumbs: r,
      topic: r,
      canModerate: r,
      fetched: r,
      replyTo: r,
      banStatus: r,
      canDeleteTopic: Y,
      canModifyTopic: Y,
      fetchTopic: I,
      updateTopic: I,
      deleteTopic: I,
      sendComment: I,
      updateComment: I,
      deleteComment: I,
      setReplyTo: I,
      fetchCommentPosition: I,
      fetchComments: I,
      setBanStatus: I,
      createCommentReaction: I,
      updateCommentReaction: I,
      deleteCommentReaction: I,
      createTopicReaction: I,
      updateTopicReaction: I,
      deleteTopicReaction: I
    });
  }
  subscribeTopicComment(e) {
    this.toDispose(
      this.hub.forum.topic.comment(this.topic.id).subscribe((p, c) => {
        i0(() => e(p));
      })
    );
  }
  subscribeTopicReaction(e) {
    this.toDispose(
      this.hub.forum.topic.reaction(this.topic.id).subscribe((p, c) => {
        i0(() => e(p, c));
      })
    );
  }
  subscribeTopicForumReaction() {
    this.toDispose(
      this.hub.forum.topic.topic(this.topic.id).subscribe(({ event: e, topic: p }, c) => {
        i0(() => {
          switch (e) {
            case "modified":
              this.topic.update({
                title: p.title,
                text: p.text,
                updatedDate: p.updatedDate,
                files: p.files,
                commentCount: p.commentCount,
                lastActivityDate: p.lastActivityDate
              });
              break;
          }
        });
      })
    );
  }
  get canDeleteTopic() {
    return this.canModerate ? !0 : this.canModifyTopic && this.topic.commentCount == 0;
  }
  get canModifyTopic() {
    var e;
    return this.canModerate ? !0 : this.topic.contact.id == ((e = this.sdk.account.user) == null ? void 0 : e.id) ? R().diff(this.topic.createdDate, "minutes") < 10 : !1;
  }
  canModifyComment(e) {
    var p;
    return this.canModerate ? !0 : e.contact.id == ((p = this.sdk.account.user) == null ? void 0 : p.id) ? R().diff(e.createdDate, "minutes") < 10 : !1;
  }
  async fetchTopic(e) {
    this.fetched = !1;
    const p = await this.sdk.api.forum.topic.fetchTopic(e);
    return p.success && i0(() => {
      this.breadcrumbs = p.body.breadcrumbs, this.topic = p.body.topic, this.canModerate = p.body.canModerate, this.banStatus = p.body.banStatus, this.fetched = !0;
    }), p;
  }
  async updateTopic(e, p) {
    return await this.sdk.api.forum.topic.updateTopic(
      this.topic.id,
      e,
      p.map((i) => i.id)
    );
  }
  async deleteTopic() {
    return await this.sdk.api.forum.topic.deleteTopic(this.topic.id);
  }
  async sendComment(e, p) {
    var i;
    const c = await this.sdk.api.forum.comment.createTopicComment(
      this.topic.id,
      e,
      ((i = this.replyTo) == null ? void 0 : i.id) ?? null,
      p.map((s) => s.id)
    );
    return c.success && i0(() => {
      this.replyTo = null;
    }), c;
  }
  async updateComment(e, p, c, i) {
    var u;
    return await this.sdk.api.forum.comment.updateTopicComment(
      e.id,
      p,
      c.map((l) => l.id),
      i || (u = e.reply) == null ? void 0 : u.id
    );
  }
  async deleteComment(e) {
    return await this.sdk.api.forum.comment.deleteTopicComment(e);
  }
  setReplyTo(e) {
    this.replyTo = e;
  }
  async fetchCommentPosition(e) {
    const p = await this.sdk.api.forum.comment.fetchTopicCommentPosition(this.topic.id, e);
    if (p.success) return p.body.position;
    throw new Error("Couldn't fetch comment position");
  }
  setBanStatus(e) {
    this.banStatus = e, e != null && (this.canModerate = !1);
  }
  async createCommentReaction(e, p) {
    return await this.sdk.api.forum.reaction.create(
      this.topic.id,
      e.id,
      p
    );
  }
  async updateCommentReaction(e, p) {
    return await this.sdk.api.forum.reaction.update(
      p,
      e
    );
  }
  async deleteCommentReaction(e) {
    return await this.sdk.api.forum.reaction.delete(e);
  }
  async createTopicReaction(e) {
    return await this.sdk.api.forum.reaction.create(
      this.topic.id,
      null,
      e
    );
  }
  async updateTopicReaction(e, p) {
    return await this.sdk.api.forum.reaction.update(
      p,
      e
    );
  }
  async deleteTopicReaction(e) {
    return await this.sdk.api.forum.reaction.delete(e);
  }
}
class BL {
  constructor(t) {
    o(this, "thread");
    o(this, "topic");
    this.sdk = t, this.thread = new yL(this.sdk), this.topic = new NL(this.sdk, this.sdk.hub);
  }
}
class vL extends Ob {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  fetchItems(t) {
    return this.sdk.api.gamification.fetchLeaders(t ?? this.filter);
  }
  createFilter(t) {
    return new la(t);
  }
}
class TL extends z2 {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.gamification.product;
  }
}
class _L extends z2 {
  constructor(t) {
    super("paging"), this.sdk = t;
  }
  get crudApi() {
    return this.sdk.api.gamification.transaction;
  }
}
class wL {
  constructor(t) {
    o(this, "leader");
    o(this, "product");
    o(this, "transaction");
    this.sdk = t, this.leader = new vL(this.sdk), this.product = new TL(this.sdk), this.transaction = new _L(this.sdk);
  }
}
class XL {
  constructor(t) {
    this.sdk = t;
  }
  async fetch() {
    return this.sdk.api.announcement.fetch();
  }
  async close(t) {
    return this.sdk.api.announcement.close(t);
  }
}
class Kp extends ab {
  constructor() {
    super();
    o(this, "course");
    o(this, "studentCourse");
    o(this, "items", []);
    o(this, "currentItem");
    o(this, "itemFetching", !1);
    o(this, "itemFetchingId");
    o(this, "filteredItems", []);
    o(this, "itemsMap", /* @__PURE__ */ new Map());
    o(this, "courseFetched", !1);
    o(this, "courseItemsFetched", !1);
    //#region Search
    o(this, "searchTerms", []);
    o(this, "isSearching", !1);
    c0(this, {
      course: r,
      studentCourse: r,
      items: r,
      currentItem: r,
      itemFetching: r,
      itemFetchingId: r,
      filteredItems: r,
      courseFetched: r,
      courseItemsFetched: r,
      inited: Y,
      searchTerms: r,
      isSearching: r,
      filterItems: I,
      clearSearch: I
    });
  }
  get inited() {
    return this.courseFetched && this.courseItemsFetched;
  }
  filterItems(e, p = this.items) {
    if (I1.isEmpty(e)) {
      this.filteredItems = p, this.searchTerms = [], this.isSearching = !1;
      return;
    }
    i0(() => {
      this.isSearching = !0, this.searchTerms = e.toLowerCase().trim().split(" ");
    }), i0(() => {
      this.filteredItems = p.map((c) => this.filterSteps(c)).filter((c) => c !== null);
    });
  }
  filterSteps(e, p = []) {
    const c = [...p, e.title].filter(Boolean).join(" ").toLowerCase();
    if (e.title && this.searchTerms.every((i) => c.includes(i)))
      return e;
    if (e.children.length > 0) {
      const i = e.children.map((s) => this.filterSteps(s, [...p, e.title])).filter((s) => s !== null);
      if (i.length > 0)
        return new Le({ ...e, children: i });
    }
    return null;
  }
  clearSearch() {
    i0(() => {
      this.searchTerms = [], this.filteredItems = this.items;
    });
  }
  //#endregion
  buildTree(e, p, c = null, i = 1) {
    const s = e.filter((l) => l.parentItemId == (c == null ? void 0 : c.id)).sort((l, W) => l.position - W.position), u = [];
    for (const l of s)
      l.course = this.course, l.parent = c, l.level = i, l.schoolTimezone = p, u.push(l), l.type == L1.Section && (l.children = this.buildTree(e, p, l, i + 1)), this.itemsMap.set(l.id, l);
    return u;
  }
  processTree(e, p = null, c = null, i = 1) {
    let s = null, u = null, l = 1;
    for (const W of e)
      if (W.studentCourse = this.studentCourse, W.course = this.course, W.parent = p, W.position = l++, W.previousItem = u ?? c, W.type == L1.Step)
        W.globalPosition = i++, s || (s = W), u && (u.nextItem = W), u = W;
      else {
        const L = this.processTree(W.children, W, u ?? c, i);
        L.firstStepItem && (W.nextItem = L.firstStepItem, u ? u.nextItem = L.firstStepItem : c && (c.nextItem = L.firstStepItem), s || (s = L.firstStepItem)), L.lastStepItem && (u = L.lastStepItem), i = L.globalPosition;
      }
    return { firstStepItem: s, lastStepItem: u, globalPosition: i };
  }
}
class SL extends Kp {
  constructor(e, p) {
    super();
    o(this, "plan");
    this.sdk = e, this.hub = p, c0(this, {
      plan: r,
      initialItem: Y,
      init: I,
      setPlan: I,
      selectCourseItem: I,
      selectCourseItemById: I,
      fetchCourse: I,
      fetchCourseItems: I,
      fetchCourseItem: I
    });
  }
  get initialItem() {
    return Array.from(this.itemsMap.values()).find((e) => e.type === L1.Step);
  }
  async init(e, p, c) {
    return await this.fetchCourse(e) ? (await this.fetchCourseItems(p, c), !0) : !1;
  }
  async setPlan(e) {
    i0(() => {
      this.plan = e;
    }), await this.fetchCourseItems(void 0, void 0, e == null ? void 0 : e.id);
  }
  async selectCourseItem(e) {
    return await this.fetchCourseItem(e) ? (i0(() => {
      this.currentItem = e;
    }), !0) : !1;
  }
  async selectCourseItemById(e, p) {
    const c = this.itemsMap.get(e);
    if (c)
      return p != null && (c.tab = p), this.selectCourseItem(c);
    throw new Error("Course item not found: " + e);
  }
  async fetchCourse(e) {
    this.courseFetched = !1;
    const p = await this.sdk.api.coursePreview.fetchCourse(e);
    return p.success && i0(() => {
      this.course = p.body.course;
    }), i0(() => {
      this.courseFetched = !0;
    }), p.success;
  }
  async fetchCourseItems(e, p, c) {
    this.courseItemsFetched = !1;
    const i = await this.sdk.api.coursePreview.fetchCourseItems(this.course.id, c);
    return i.success && (i0(() => {
      const s = this.buildTree(i.body.items, this.sdk.school.timezone);
      this.processTree(s), this.course.update({ totalItemCount: i.body.items.filter((u) => u.type == L1.Step).length }), this.items = s;
    }), e != null ? await this.selectCourseItemById(e, p) : this.initialItem != null && await this.selectCourseItem(this.initialItem)), i0(() => {
      this.courseItemsFetched = !0;
    }), i;
  }
  async fetchCourseItem(e) {
    this.itemFetching = !0;
    const p = await this.sdk.api.coursePreview.fetchCourseItem(this.course.id, e.id);
    return p.success && i0(() => {
      e.update({
        ...p.body.courseItem,
        tab: e.tab
      });
    }), i0(() => {
      this.itemFetching = !1;
    }), p.success;
  }
}
class DL extends Kp {
  constructor(t, e) {
    super(), this.sdk = t, this.hub = e, c0(this, {
      initialItem: Y,
      canLeaveFeedback: Y,
      init: I,
      selectCourseItem: I,
      selectCourseItemById: I,
      updateProgress: I,
      fetchCourseItems: I,
      fetchCourseItem: I
    });
  }
  get initialItem() {
    return this.itemsMap.get(this.studentCourse.initialCourseItemId);
  }
  get canLeaveFeedback() {
    return this.studentCourse.state == "ended" && this.studentCourse.hasFeedback == !1 && this.studentCourse.course.dontAskFeedback == !1;
  }
  async init(t, e) {
    const p = await this.sdk.api.education.studentCourse.fetchItem(t);
    if (!p.success)
      return p;
    i0(() => {
      this.course = p.body.studentCourse.course, this.studentCourse = p.body.studentCourse, this.courseFetched = !0;
    });
    const c = await this.fetchCourseItems(
      p.body.hasItemAccess ? t : this.studentCourse.currentCourseItem.id,
      p.body.hasItemAccess ? e : void 0
    );
    return c.success ? (this.toDispose(
      this.hub.education.course.itemChanged(this.studentCourse.id).subscribe((i) => {
        i0(() => {
          const s = this.itemsMap.get(i.item.id);
          s && s.update(i.item);
        });
      })
    ), this.toDispose(
      this.hub.education.course.progress(this.studentCourse.id).subscribe((i) => {
        i0(() => {
          this.updateProgress(i);
        });
      })
    ), p) : c;
  }
  async selectCourseItem(t) {
    if (!t.courseItemAvailability.result)
      throw new Error("Course item is not available");
    const e = await this.fetchCourseItem(t);
    return e.success && (i0(() => this.currentItem = t), this.sdk.dispatcher.emit("learn.currentItem.updated", { item: t })), e;
  }
  async selectCourseItemById(t, e) {
    var c;
    if (((c = this.currentItem) == null ? void 0 : c.id) === t) return !0;
    const p = this.itemsMap.get(t);
    if (p)
      return e != null ? p.tab = e : p.tab = p.firstAvailableTab, this.selectCourseItem(p);
    throw new Error("Course item not found " + t);
  }
  updateProgress(t) {
    this.studentCourse.update(t.contactCourse);
    const e = this.itemsMap.get(t.courseItemId);
    e != null && (e.progress == null ? e.progress = t.courseItemProgress : e.progress.update(t.courseItemProgress), this.sdk.dispatcher.emit("learn.studentCourse.updated", { studentCourse: this.studentCourse }), this.sdk.dispatcher.emit("learn.currentItem.updated", { item: e }));
  }
  async fetchCourseItems(t, e) {
    this.courseItemsFetched = !1;
    const p = new qa({
      studentCourseId: this.studentCourse.id,
      courseItemId: t
    }), c = await this.sdk.api.education.studentCourse.item.fetch(p);
    if (c.success) {
      const i = this.buildTree(c.body, this.sdk.school.timezone);
      this.processTree(i), this.studentCourse.update({ totalItemCount: c.body.count((s) => s.type == L1.Step) }), i0(() => this.items = i), t != null ? this.selectCourseItemById(t, e) : this.selectCourseItem(this.initialItem);
    }
    return i0(() => {
      this.courseItemsFetched = !0;
    }), c;
  }
  async fetchCourseItem(t) {
    this.itemFetching = !0, t.update({ fetching: !0 });
    const e = await this.sdk.api.education.studentCourse.item.fetchItem(this.studentCourse.id, t.id);
    return e.success && t.update({
      ...e.body,
      tab: t.tab
    }), t.update({ fetching: !1 }), i0(() => {
      this.itemFetching = !1;
    }), { success: e.success, errors: e.errors, courseItem: t };
  }
}
class CL extends ab {
  constructor(e) {
    super();
    o(this, "library");
    o(this, "items", []);
    o(this, "currentItem");
    o(this, "itemFetching", !1);
    o(this, "openedSections", []);
    o(this, "filteredItems", []);
    // search
    o(this, "searchTerms", []);
    o(this, "libraryFetched", !1);
    o(this, "libraryItemsFetched", !1);
    this.sdk = e, c0(this, {
      library: r,
      items: r,
      currentItem: r,
      itemFetching: r,
      openedSections: r,
      filteredItems: r,
      searchTerms: r,
      filterItems: I,
      initialItem: Y,
      libraryFetched: r,
      libraryItemsFetched: r,
      inited: Y,
      init: I,
      selectLibraryItem: I,
      selectItemById: I,
      fetchLibrary: I,
      fetchLibraryItems: I,
      fetchLibraryItem: I,
      buildItemTree: I,
      processItemTree: I
    });
  }
  filterItems(e, p = this.items) {
    if (u1(e)) {
      this.filteredItems = p, this.searchTerms = [];
      return;
    }
    this.searchTerms = e.toLowerCase().trim().split(" ");
    const c = (i) => {
      if (i.title && i.type === JM.Article && this.searchTerms.every((s) => i.title.toLowerCase().includes(s)))
        return i;
      if (i.children.length > 0) {
        const s = i.children.map(c).filter((u) => u !== null);
        if (s.length > 0)
          return new Z2({ ...i, children: s });
      }
      return null;
    };
    this.filteredItems = p.map(c).filter((i) => i !== null);
  }
  get initialItem() {
    return this.findInitialItem();
  }
  get inited() {
    return this.libraryFetched && this.libraryItemsFetched;
  }
  async init(e, p, c = []) {
    this.openedSections = c;
    const i = await this.fetchLibrary(e);
    return i.success ? await this.fetchLibraryItems(p) : i;
  }
  async selectLibraryItem(e) {
    if (!e.availability.result)
      throw new Error("Library item access denied");
    const p = await this.fetchLibraryItem(e);
    return p.success && i0(() => this.currentItem = e), p;
  }
  async selectItemById(e) {
    let p = this.findItem(e);
    if (p)
      return await this.selectLibraryItem(p);
    throw new Error("Library item not found " + e);
  }
  async fetchLibrary(e) {
    this.libraryFetched = !1;
    const p = await this.sdk.api.education.studentLibrary.fetchLibrary(e);
    return p.success && i0(() => {
      this.library = p.body.library;
    }), i0(() => {
      this.libraryFetched = !0;
    }), p;
  }
  async fetchLibraryItems(e) {
    this.libraryItemsFetched = !1;
    const p = await this.sdk.api.education.studentLibrary.fetchLibraryItems(this.library.id);
    if (p.success) {
      const c = p.body.items;
      for (const i of c)
        i.update({ flowBeginDate: this.library.flowBeginDate });
      i0(() => this.items = this.buildItemTree(c, null)), this.processItemTree(this.items), e != null ? await this.selectItemById(e) : this.initialItem != null && await this.selectLibraryItem(this.initialItem);
    }
    return i0(() => {
      this.libraryItemsFetched = !0;
    }), p;
  }
  async fetchLibraryItem(e) {
    this.itemFetching = !0;
    const p = await this.sdk.api.education.studentLibrary.fetchLibraryItem(this.library.id, e.id);
    return p.success && i0(() => e.update({ ...p.body.item })), i0(() => {
      this.itemFetching = !1;
    }), p;
  }
  // simplify with map instead of tree
  findItem(e, p = this.items) {
    for (const c of p) {
      if (c.id == e) return c;
      if (c.type == JM.Section) {
        const i = this.findItem(e, c.children);
        if (i != null)
          return i;
      }
    }
    return null;
  }
  findInitialItem(e = this.items) {
    for (const p of e) {
      if (p.type == JM.Article)
        return p;
      {
        const c = this.findInitialItem(p.children);
        if (c != null)
          return c;
      }
    }
    return console.warn("Couldn't find initial item"), null;
  }
  buildItemTree(e, p) {
    const c = e.filter((i) => {
      var s;
      return ((s = i.parentItem) == null ? void 0 : s.id) == p;
    }).orderBy((i) => i.position);
    for (const i of c)
      i.children = this.buildItemTree(e, i.id);
    return c;
  }
  processItemTree(e, p = null, c = null) {
    let i = c, s = 1;
    for (const u of e)
      if (u.position = s++, u.section = p, u.library = new Ne({ id: this.library.id }), u.type == JM.Article)
        u.previousItem = i, i != null && (i.nextItem = u), i = u;
      else {
        this.processItemTree(u.children, u, i);
        const l = u.lastChild;
        l != null && (i = l);
      }
  }
}
class IL extends Kp {
  constructor(e) {
    super();
    o(this, "loading", !1);
    this.sdk = e, c0(this, {
      loading: r,
      load: I
    });
  }
  /** `courseItemId` = any step of the course the student has (usually its current step). */
  async load(e) {
    i0(() => this.loading = !0);
    try {
      const p = await this.sdk.api.education.studentCourse.fetchItem(e);
      if (!p.success) return p;
      const c = p.body.studentCourse, i = await this.sdk.api.education.studentCourse.item.fetch(
        new qa({ studentCourseId: c.id })
      );
      if (!i.success) return i;
      i0(() => {
        this.course = c.course, this.studentCourse = c;
      });
      const s = this.buildTree(i.body, this.sdk.school.timezone);
      return this.processTree(s), c.update({ totalItemCount: i.body.filter((u) => u.type == L1.Step).length }), i0(() => {
        this.items = s, this.filteredItems = s, this.currentItem = this.itemsMap.get(c.initialCourseItemId);
      }), p;
    } finally {
      i0(() => this.loading = !1);
    }
  }
  /** Steps in program order (sections flattened away). */
  get steps() {
    const e = [], p = (c) => c.forEach((i) => i.type === L1.Step ? e.push(i) : p(i.children ?? []));
    return p(this.items), e;
  }
}
class kL extends Kp {
  constructor(t, e) {
    super(), this.sdk = t, this.hub = e, c0(this, {
      initialItem: Y,
      init: I,
      selectCourseItem: I,
      selectCourseItemById: I,
      completeCourseItem: I,
      resetCourseItem: I,
      blockCourseItem: I,
      unblockCourseItem: I,
      updateProgress: I,
      fetchCourse: I,
      fetchCourseItems: I,
      fetchCourseItem: I
    });
  }
  get initialItem() {
    return this.itemsMap.get(this.studentCourse.initialCourseItemId);
  }
  async init(t, e, p) {
    return !await this.fetchCourse(t) || !await this.fetchCourseItems(e, p) ? !1 : (this.toDispose(
      this.hub.education.course.itemChanged(this.studentCourse.id).subscribe((s) => {
        i0(() => {
          const u = this.itemsMap.get(s.item.id);
          u && u.update(s.item);
        });
      })
    ), this.toDispose(
      this.hub.education.course.progress(this.studentCourse.id).subscribe((s) => {
        i0(() => {
          this.updateProgress(s);
        });
      })
    ), !0);
  }
  async selectCourseItem(t) {
    if (!t.courseItemAvailability.result) return !1;
    const e = await this.fetchCourseItem(t);
    return e.success && i0(() => {
      this.currentItem = t;
    }), e;
  }
  async selectCourseItemById(t, e) {
    const p = this.itemsMap.get(t);
    return p ? (e != null && (p.tab = e), await this.selectCourseItem(p)) : (console.error("Course item not found", t), !1);
  }
  async completeCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.completeStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const p of e.body.progresses)
        this.updateProgress(p);
    return e;
  }
  async resetCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.resetStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const p of e.body.progresses)
        this.updateProgress(p);
    return e;
  }
  async blockCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.blockStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const p of e.body.progresses)
        this.updateProgress(p);
    return e;
  }
  async unblockCourseItem(t) {
    const e = await this.sdk.api.studentCoursePreview.unblockStudentCourseItem(this.studentCourse.id, t.id);
    if (e.success)
      for (const p of e.body.progresses)
        this.updateProgress(p);
    return e;
  }
  updateProgress(t) {
    this.studentCourse.update(t.contactCourse);
    const e = this.itemsMap.get(t.courseItemId);
    e && (e.progress == null ? e.progress = t.courseItemProgress : e.progress.update(t.courseItemProgress));
  }
  async fetchCourse(t) {
    this.courseFetched = !1;
    const e = await this.sdk.api.studentCoursePreview.fetchStudentCourse(t);
    return e.success && i0(() => {
      this.studentCourse = e.body.studentCourse, this.course = this.studentCourse.course;
    }), i0(() => {
      this.courseFetched = !0;
    }), e.success;
  }
  async fetchCourseItems(t, e) {
    this.courseItemsFetched = !1;
    const p = await this.sdk.api.studentCoursePreview.fetchStudentCourseItems(this.studentCourse.id);
    return p.success && (i0(() => {
      const c = this.buildTree(p.body.items, this.sdk.school.timezone);
      this.processTree(c), this.studentCourse.update({ totalItemCount: p.body.items.filter((i) => i.type === L1.Step).length }), this.items = c;
    }), t != null ? await this.selectCourseItemById(t, e) : this.initialItem != null && await this.selectCourseItem(this.initialItem)), i0(() => {
      this.courseItemsFetched = !0;
    }), p.success;
  }
  async fetchCourseItem(t) {
    this.itemFetching = !0;
    const e = await this.sdk.api.studentCoursePreview.fetchStudentCourseItem(this.studentCourse.id, t.id);
    return e.success && i0(() => {
      t.update({
        ...e.body.studentCourseItem,
        tab: t.tab
      });
    }), i0(() => {
      this.itemFetching = !1;
    }), e;
  }
}
class PL {
  constructor(t) {
    o(this, "learn");
    o(this, "library");
    // preview for courses
    o(this, "coursePreview");
    o(this, "studentCoursePreview");
    this.sdk = t, this.learn = new DL(this.sdk, this.sdk.hub), this.library = new CL(this.sdk), this.coursePreview = new SL(this.sdk, this.sdk.hub), this.studentCoursePreview = new kL(this.sdk, this.sdk.hub);
  }
  /** A fresh read-only program of one course (course page); not shared with the lesson player. */
  createCourseOverview() {
    return new IL(this.sdk);
  }
}
class EL {
  constructor(t) {
    o(this, "ready", !1);
    o(this, "words", {});
    o(this, "excludedLangs", []);
    o(this, "lang");
    o(this, "timestamp");
    this.sdk = t, c0(this, {
      ready: r,
      words: r,
      excludedLangs: r,
      langs: Y,
      fetchWords: I,
      setData: I,
      clear: I
    });
  }
  get langs() {
    return Object.keys(mp).filter((t) => !this.excludedLangs.includes(t)).map((t) => t);
  }
  async init(t) {
    this.ready || (this.clear(), await this.fetchWords(t));
  }
  async fetchWords(t) {
    const e = await this.sdk.api.loc.fetch(t, this.timestamp);
    e.success && (e.body.needSync && this.setData(t, e.body.words, e.body.timestamp, e.body.excludedLangs), i0(() => this.ready = !0));
  }
  async setData(t, e, p, c = []) {
    this.lang = t, this.words = e, this.timestamp = p, this.excludedLangs = c;
  }
  clear() {
    this.words = {}, this.timestamp = void 0, this.ready = !1, this.excludedLangs = [];
  }
}
var fo, gO;
function dM() {
  return gO || (gO = 1, fo = TypeError), fo;
}
const xL = {}, FL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xL
}, Symbol.toStringTag, { value: "Module" })), UL = /* @__PURE__ */ Oa(FL);
var Wo, yO;
function Qp() {
  if (yO) return Wo;
  yO = 1;
  var M = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && M ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, e = M && t && typeof t.get == "function" ? t.get : null, p = M && Map.prototype.forEach, c = typeof Set == "function" && Set.prototype, i = Object.getOwnPropertyDescriptor && c ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, s = c && i && typeof i.get == "function" ? i.get : null, u = c && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, W = l ? WeakMap.prototype.has : null, L = typeof WeakSet == "function" && WeakSet.prototype, m = L ? WeakSet.prototype.has : null, X = typeof WeakRef == "function" && WeakRef.prototype, D = X ? WeakRef.prototype.deref : null, y = Boolean.prototype.valueOf, S = Object.prototype.toString, B = Function.prototype.toString, Z = String.prototype.match, H = String.prototype.slice, e0 = String.prototype.replace, r0 = String.prototype.toUpperCase, G = String.prototype.toLowerCase, j = RegExp.prototype.test, v = Array.prototype.concat, E = Array.prototype.join, K = Array.prototype.slice, p0 = Math.floor, O0 = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, s0 = Object.getOwnPropertySymbols, E0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, l0 = typeof Symbol == "function" && typeof Symbol.iterator == "object", Q0 = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === l0 || !0) ? Symbol.toStringTag : null, W0 = Object.prototype.propertyIsEnumerable, $0 = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(T) {
    return T.__proto__;
  } : null);
  function $(T, _) {
    if (T === 1 / 0 || T === -1 / 0 || T !== T || T && T > -1e3 && T < 1e3 || j.call(/e/, _))
      return _;
    var F0 = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof T == "number") {
      var j0 = T < 0 ? -p0(-T) : p0(T);
      if (j0 !== T) {
        var t1 = String(j0), g0 = H.call(_, t1.length + 1);
        return e0.call(t1, F0, "$&_") + "." + e0.call(e0.call(g0, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return e0.call(_, F0, "$&_");
  }
  var x0 = UL, f1 = x0.custom, n1 = C(f1) ? f1 : null, u2 = {
    __proto__: null,
    double: '"',
    single: "'"
  }, q2 = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  Wo = function T(_, F0, j0, t1) {
    var g0 = F0 || {};
    if (b0(g0, "quoteStyle") && !b0(u2, g0.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (b0(g0, "maxStringLength") && (typeof g0.maxStringLength == "number" ? g0.maxStringLength < 0 && g0.maxStringLength !== 1 / 0 : g0.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var X2 = b0(g0, "customInspect") ? g0.customInspect : !0;
    if (typeof X2 != "boolean" && X2 !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (b0(g0, "indent") && g0.indent !== null && g0.indent !== "	" && !(parseInt(g0.indent, 10) === g0.indent && g0.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (b0(g0, "numericSeparator") && typeof g0.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var ze = g0.numericSeparator;
    if (typeof _ > "u")
      return "undefined";
    if (_ === null)
      return "null";
    if (typeof _ == "boolean")
      return _ ? "true" : "false";
    if (typeof _ == "string")
      return ve(_, g0);
    if (typeof _ == "number") {
      if (_ === 0)
        return 1 / 0 / _ > 0 ? "0" : "-0";
      var Y1 = String(_);
      return ze ? $(_, Y1) : Y1;
    }
    if (typeof _ == "bigint") {
      var J2 = String(_) + "n";
      return ze ? $(_, J2) : J2;
    }
    var lM = typeof g0.depth > "u" ? 5 : g0.depth;
    if (typeof j0 > "u" && (j0 = 0), j0 >= lM && lM > 0 && typeof _ == "object")
      return S0(_) ? "[Array]" : "[Object]";
    var oe = qM(g0, j0);
    if (typeof t1 > "u")
      t1 = [];
    else if (h0(t1, _) >= 0)
      return "[Circular]";
    function c2(we, wt, tz) {
      if (wt && (t1 = K.call(t1), t1.push(wt)), tz) {
        var Wb = {
          depth: g0.depth
        };
        return b0(g0, "quoteStyle") && (Wb.quoteStyle = g0.quoteStyle), T(we, Wb, j0 + 1, t1);
      }
      return T(we, g0, j0 + 1, t1);
    }
    if (typeof _ == "function" && !p1(_)) {
      var db = V0(_), ub = _e(_, c2);
      return "[Function" + (db ? ": " + db : " (anonymous)") + "]" + (ub.length > 0 ? " { " + E.call(ub, ", ") + " }" : "");
    }
    if (C(_)) {
      var Tt = l0 ? e0.call(String(_), /^(Symbol\(.*\))_[^)]*$/, "$1") : E0.call(_);
      return typeof _ == "object" && !l0 ? pe(Tt) : Tt;
    }
    if (jp(_)) {
      for (var Ze = "<" + G.call(String(_.nodeName)), je = _.attributes || [], _t = 0; _t < je.length; _t++)
        Ze += " " + je[_t].name + "=" + Z1(v1(je[_t].value), "double", g0);
      return Ze += ">", _.childNodes && _.childNodes.length && (Ze += "..."), Ze += "</" + G.call(String(_.nodeName)) + ">", Ze;
    }
    if (S0(_)) {
      if (_.length === 0)
        return "[]";
      var fM = _e(_, c2);
      return oe && !uM(fM) ? "[" + Qe(fM, oe) + "]" : "[ " + E.call(fM, ", ") + " ]";
    }
    if (_0(_)) {
      var WM = _e(_, c2);
      return !("cause" in Error.prototype) && "cause" in _ && !W0.call(_, "cause") ? "{ [" + String(_) + "] " + E.call(v.call("[cause]: " + c2(_.cause), WM), ", ") + " }" : WM.length === 0 ? "[" + String(_) + "]" : "{ [" + String(_) + "] " + E.call(WM, ", ") + " }";
    }
    if (typeof _ == "object" && X2) {
      if (n1 && typeof _[n1] == "function" && x0)
        return x0(_, { depth: lM - j0 });
      if (X2 !== "symbol" && typeof _.inspect == "function")
        return _.inspect();
    }
    if (f0(_)) {
      var qb = [];
      return p && p.call(_, function(we, wt) {
        qb.push(c2(wt, _, !0) + " => " + c2(we, _));
      }), vt("Map", e.call(_), qb, oe);
    }
    if (Be(_)) {
      var lb = [];
      return u && u.call(_, function(we) {
        lb.push(c2(we, _));
      }), vt("Set", s.call(_), lb, oe);
    }
    if (o2(_))
      return Ke("WeakMap");
    if (Ve(_))
      return Ke("WeakSet");
    if (w2(_))
      return Ke("WeakRef");
    if (w0(_))
      return pe(c2(Number(_)));
    if (k(_))
      return pe(c2(O0.call(_)));
    if (f(_))
      return pe(y.call(_));
    if (Z0(_))
      return pe(c2(String(_)));
    if (typeof window < "u" && _ === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && _ === globalThis || typeof eM < "u" && _ === eM)
      return "{ [object globalThis] }";
    if (!b1(_) && !p1(_)) {
      var hM = _e(_, c2), fb = $0 ? $0(_) === Object.prototype : _ instanceof Object || _.constructor === Object, mM = _ instanceof Object ? "" : "null prototype", RM = !fb && Q0 && Object(_) === _ && Q0 in _ ? H.call(q0(_), 8, -1) : mM ? "Object" : "", ez = fb || typeof _.constructor != "function" ? "" : _.constructor.name ? _.constructor.name + " " : "", LM = ez + (RM || mM ? "[" + E.call(v.call([], RM || [], mM || []), ": ") + "] " : "");
      return hM.length === 0 ? LM + "{}" : oe ? LM + "{" + Qe(hM, oe) + "}" : LM + "{ " + E.call(hM, ", ") + " }";
    }
    return String(_);
  };
  function Z1(T, _, F0) {
    var j0 = F0.quoteStyle || _, t1 = u2[j0];
    return t1 + T + t1;
  }
  function v1(T) {
    return e0.call(String(T), /"/g, "&quot;");
  }
  function i1(T) {
    return !Q0 || !(typeof T == "object" && (Q0 in T || typeof T[Q0] < "u"));
  }
  function S0(T) {
    return q0(T) === "[object Array]" && i1(T);
  }
  function b1(T) {
    return q0(T) === "[object Date]" && i1(T);
  }
  function p1(T) {
    return q0(T) === "[object RegExp]" && i1(T);
  }
  function _0(T) {
    return q0(T) === "[object Error]" && i1(T);
  }
  function Z0(T) {
    return q0(T) === "[object String]" && i1(T);
  }
  function w0(T) {
    return q0(T) === "[object Number]" && i1(T);
  }
  function f(T) {
    return q0(T) === "[object Boolean]" && i1(T);
  }
  function C(T) {
    if (l0)
      return T && typeof T == "object" && T instanceof Symbol;
    if (typeof T == "symbol")
      return !0;
    if (!T || typeof T != "object" || !E0)
      return !1;
    try {
      return E0.call(T), !0;
    } catch {
    }
    return !1;
  }
  function k(T) {
    if (!T || typeof T != "object" || !O0)
      return !1;
    try {
      return O0.call(T), !0;
    } catch {
    }
    return !1;
  }
  var V = Object.prototype.hasOwnProperty || function(T) {
    return T in this;
  };
  function b0(T, _) {
    return V.call(T, _);
  }
  function q0(T) {
    return S.call(T);
  }
  function V0(T) {
    if (T.name)
      return T.name;
    var _ = Z.call(B.call(T), /^function\s*([\w$]+)/);
    return _ ? _[1] : null;
  }
  function h0(T, _) {
    if (T.indexOf)
      return T.indexOf(_);
    for (var F0 = 0, j0 = T.length; F0 < j0; F0++)
      if (T[F0] === _)
        return F0;
    return -1;
  }
  function f0(T) {
    if (!e || !T || typeof T != "object")
      return !1;
    try {
      e.call(T);
      try {
        s.call(T);
      } catch {
        return !0;
      }
      return T instanceof Map;
    } catch {
    }
    return !1;
  }
  function o2(T) {
    if (!W || !T || typeof T != "object")
      return !1;
    try {
      W.call(T, W);
      try {
        m.call(T, m);
      } catch {
        return !0;
      }
      return T instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function w2(T) {
    if (!D || !T || typeof T != "object")
      return !1;
    try {
      return D.call(T), !0;
    } catch {
    }
    return !1;
  }
  function Be(T) {
    if (!s || !T || typeof T != "object")
      return !1;
    try {
      s.call(T);
      try {
        e.call(T);
      } catch {
        return !0;
      }
      return T instanceof Set;
    } catch {
    }
    return !1;
  }
  function Ve(T) {
    if (!m || !T || typeof T != "object")
      return !1;
    try {
      m.call(T, m);
      try {
        W.call(T, W);
      } catch {
        return !0;
      }
      return T instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function jp(T) {
    return !T || typeof T != "object" ? !1 : typeof HTMLElement < "u" && T instanceof HTMLElement ? !0 : typeof T.nodeName == "string" && typeof T.getAttribute == "function";
  }
  function ve(T, _) {
    if (T.length > _.maxStringLength) {
      var F0 = T.length - _.maxStringLength, j0 = "... " + F0 + " more character" + (F0 > 1 ? "s" : "");
      return ve(H.call(T, 0, _.maxStringLength), _) + j0;
    }
    var t1 = q2[_.quoteStyle || "single"];
    t1.lastIndex = 0;
    var g0 = e0.call(e0.call(T, t1, "\\$1"), /[\x00-\x1f]/g, Te);
    return Z1(g0, "single", _);
  }
  function Te(T) {
    var _ = T.charCodeAt(0), F0 = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[_];
    return F0 ? "\\" + F0 : "\\x" + (_ < 16 ? "0" : "") + r0.call(_.toString(16));
  }
  function pe(T) {
    return "Object(" + T + ")";
  }
  function Ke(T) {
    return T + " { ? }";
  }
  function vt(T, _, F0, j0) {
    var t1 = j0 ? Qe(F0, j0) : E.call(F0, ", ");
    return T + " (" + _ + ") {" + t1 + "}";
  }
  function uM(T) {
    for (var _ = 0; _ < T.length; _++)
      if (h0(T[_], `
`) >= 0)
        return !1;
    return !0;
  }
  function qM(T, _) {
    var F0;
    if (T.indent === "	")
      F0 = "	";
    else if (typeof T.indent == "number" && T.indent > 0)
      F0 = E.call(Array(T.indent + 1), " ");
    else
      return null;
    return {
      base: F0,
      prev: E.call(Array(_ + 1), F0)
    };
  }
  function Qe(T, _) {
    if (T.length === 0)
      return "";
    var F0 = `
` + _.prev + _.base;
    return F0 + E.call(T, "," + F0) + `
` + _.prev;
  }
  function _e(T, _) {
    var F0 = S0(T), j0 = [];
    if (F0) {
      j0.length = T.length;
      for (var t1 = 0; t1 < T.length; t1++)
        j0[t1] = b0(T, t1) ? _(T[t1], T) : "";
    }
    var g0 = typeof s0 == "function" ? s0(T) : [], X2;
    if (l0) {
      X2 = {};
      for (var ze = 0; ze < g0.length; ze++)
        X2["$" + g0[ze]] = g0[ze];
    }
    for (var Y1 in T)
      b0(T, Y1) && (F0 && String(Number(Y1)) === Y1 && Y1 < T.length || l0 && X2["$" + Y1] instanceof Symbol || (j.call(/[^\w$]/, Y1) ? j0.push(_(Y1, T) + ": " + _(T[Y1], T)) : j0.push(Y1 + ": " + _(T[Y1], T))));
    if (typeof s0 == "function")
      for (var J2 = 0; J2 < g0.length; J2++)
        W0.call(T, g0[J2]) && j0.push("[" + _(g0[J2]) + "]: " + _(T[g0[J2]], T));
    return j0;
  }
  return Wo;
}
var ho, NO;
function JL() {
  if (NO) return ho;
  NO = 1;
  var M = /* @__PURE__ */ Qp(), t = /* @__PURE__ */ dM(), e = function(u, l, W) {
    for (var L = u, m; (m = L.next) != null; L = m)
      if (m.key === l)
        return L.next = m.next, W || (m.next = /** @type {NonNullable<typeof list.next>} */
        u.next, u.next = m), m;
  }, p = function(u, l) {
    if (u) {
      var W = e(u, l);
      return W && W.value;
    }
  }, c = function(u, l, W) {
    var L = e(u, l);
    L ? L.value = W : u.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: l,
      next: u.next,
      value: W
    };
  }, i = function(u, l) {
    return u ? !!e(u, l) : !1;
  }, s = function(u, l) {
    if (u)
      return e(u, l, !0);
  };
  return ho = function() {
    var l, W = {
      assert: function(L) {
        if (!W.has(L))
          throw new t("Side channel does not contain " + M(L));
      },
      delete: function(L) {
        var m = s(l, L);
        return m && l && !l.next && (l = void 0), !!m;
      },
      get: function(L) {
        return p(l, L);
      },
      has: function(L) {
        return i(l, L);
      },
      set: function(L, m) {
        l || (l = {
          next: void 0
        }), c(
          /** @type {NonNullable<typeof $o>} */
          l,
          L,
          m
        );
      }
    };
    return W;
  }, ho;
}
var mo, BO;
function va() {
  return BO || (BO = 1, mo = Object), mo;
}
var Ro, vO;
function HL() {
  return vO || (vO = 1, Ro = Error), Ro;
}
var Lo, TO;
function YL() {
  return TO || (TO = 1, Lo = EvalError), Lo;
}
var go, _O;
function GL() {
  return _O || (_O = 1, go = RangeError), go;
}
var yo, wO;
function $L() {
  return wO || (wO = 1, yo = ReferenceError), yo;
}
var No, XO;
function VL() {
  return XO || (XO = 1, No = SyntaxError), No;
}
var Bo, SO;
function KL() {
  return SO || (SO = 1, Bo = URIError), Bo;
}
var vo, DO;
function QL() {
  return DO || (DO = 1, vo = Math.abs), vo;
}
var To, CO;
function ZL() {
  return CO || (CO = 1, To = Math.floor), To;
}
var _o, IO;
function jL() {
  return IO || (IO = 1, _o = Math.max), _o;
}
var wo, kO;
function e8() {
  return kO || (kO = 1, wo = Math.min), wo;
}
var Xo, PO;
function t8() {
  return PO || (PO = 1, Xo = Math.pow), Xo;
}
var So, EO;
function M8() {
  return EO || (EO = 1, So = Math.round), So;
}
var Do, xO;
function b8() {
  return xO || (xO = 1, Do = Number.isNaN || function(t) {
    return t !== t;
  }), Do;
}
var Co, FO;
function p8() {
  if (FO) return Co;
  FO = 1;
  var M = /* @__PURE__ */ b8();
  return Co = function(e) {
    return M(e) || e === 0 ? e : e < 0 ? -1 : 1;
  }, Co;
}
var Io, UO;
function z8() {
  return UO || (UO = 1, Io = Object.getOwnPropertyDescriptor), Io;
}
var ko, JO;
function Ta() {
  if (JO) return ko;
  JO = 1;
  var M = /* @__PURE__ */ z8();
  if (M)
    try {
      M([], "length");
    } catch {
      M = null;
    }
  return ko = M, ko;
}
var Po, HO;
function o8() {
  if (HO) return Po;
  HO = 1;
  var M = Object.defineProperty || !1;
  if (M)
    try {
      M({}, "a", { value: 1 });
    } catch {
      M = !1;
    }
  return Po = M, Po;
}
var Eo, YO;
function c8() {
  return YO || (YO = 1, Eo = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = Symbol("test"), p = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(p) !== "[object Symbol]")
      return !1;
    var c = 42;
    t[e] = c;
    for (var i in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var s = Object.getOwnPropertySymbols(t);
    if (s.length !== 1 || s[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var u = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (u.value !== c || u.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Eo;
}
var xo, GO;
function n8() {
  if (GO) return xo;
  GO = 1;
  var M = typeof Symbol < "u" && Symbol, t = c8();
  return xo = function() {
    return typeof M != "function" || typeof Symbol != "function" || typeof M("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, xo;
}
var Fo, $O;
function _a() {
  return $O || ($O = 1, Fo = typeof Reflect < "u" && Reflect.getPrototypeOf || null), Fo;
}
var Uo, VO;
function wa() {
  if (VO) return Uo;
  VO = 1;
  var M = /* @__PURE__ */ va();
  return Uo = M.getPrototypeOf || null, Uo;
}
var Jo, KO;
function i8() {
  if (KO) return Jo;
  KO = 1;
  var M = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, e = Math.max, p = "[object Function]", c = function(l, W) {
    for (var L = [], m = 0; m < l.length; m += 1)
      L[m] = l[m];
    for (var X = 0; X < W.length; X += 1)
      L[X + l.length] = W[X];
    return L;
  }, i = function(l, W) {
    for (var L = [], m = W, X = 0; m < l.length; m += 1, X += 1)
      L[X] = l[m];
    return L;
  }, s = function(u, l) {
    for (var W = "", L = 0; L < u.length; L += 1)
      W += u[L], L + 1 < u.length && (W += l);
    return W;
  };
  return Jo = function(l) {
    var W = this;
    if (typeof W != "function" || t.apply(W) !== p)
      throw new TypeError(M + W);
    for (var L = i(arguments, 1), m, X = function() {
      if (this instanceof m) {
        var Z = W.apply(
          this,
          c(L, arguments)
        );
        return Object(Z) === Z ? Z : this;
      }
      return W.apply(
        l,
        c(L, arguments)
      );
    }, D = e(0, W.length - L.length), y = [], S = 0; S < D; S++)
      y[S] = "$" + S;
    if (m = Function("binder", "return function (" + s(y, ",") + "){ return binder.apply(this,arguments); }")(X), W.prototype) {
      var B = function() {
      };
      B.prototype = W.prototype, m.prototype = new B(), B.prototype = null;
    }
    return m;
  }, Jo;
}
var Ho, QO;
function Zp() {
  if (QO) return Ho;
  QO = 1;
  var M = i8();
  return Ho = Function.prototype.bind || M, Ho;
}
var Yo, ZO;
function vn() {
  return ZO || (ZO = 1, Yo = Function.prototype.call), Yo;
}
var Go, jO;
function Xa() {
  return jO || (jO = 1, Go = Function.prototype.apply), Go;
}
var $o, e3;
function r8() {
  return e3 || (e3 = 1, $o = typeof Reflect < "u" && Reflect && Reflect.apply), $o;
}
var Vo, t3;
function O8() {
  if (t3) return Vo;
  t3 = 1;
  var M = Zp(), t = Xa(), e = vn(), p = r8();
  return Vo = p || M.call(e, t), Vo;
}
var Ko, M3;
function Sa() {
  if (M3) return Ko;
  M3 = 1;
  var M = Zp(), t = /* @__PURE__ */ dM(), e = vn(), p = O8();
  return Ko = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new t("a function is required");
    return p(M, e, i);
  }, Ko;
}
var Qo, b3;
function a8() {
  if (b3) return Qo;
  b3 = 1;
  var M = Sa(), t = /* @__PURE__ */ Ta(), e;
  try {
    e = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var p = !!e && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), c = Object, i = c.getPrototypeOf;
  return Qo = p && typeof p.get == "function" ? M([p.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(u) {
      return i(u == null ? u : c(u));
    }
  ) : !1, Qo;
}
var Zo, p3;
function s8() {
  if (p3) return Zo;
  p3 = 1;
  var M = _a(), t = wa(), e = /* @__PURE__ */ a8();
  return Zo = M ? function(c) {
    return M(c);
  } : t ? function(c) {
    if (!c || typeof c != "object" && typeof c != "function")
      throw new TypeError("getProto: not an object");
    return t(c);
  } : e ? function(c) {
    return e(c);
  } : null, Zo;
}
var jo, z3;
function A8() {
  if (z3) return jo;
  z3 = 1;
  var M = Function.prototype.call, t = Object.prototype.hasOwnProperty, e = Zp();
  return jo = e.call(M, t), jo;
}
var ec, o3;
function Tn() {
  if (o3) return ec;
  o3 = 1;
  var M, t = /* @__PURE__ */ va(), e = /* @__PURE__ */ HL(), p = /* @__PURE__ */ YL(), c = /* @__PURE__ */ GL(), i = /* @__PURE__ */ $L(), s = /* @__PURE__ */ VL(), u = /* @__PURE__ */ dM(), l = /* @__PURE__ */ KL(), W = /* @__PURE__ */ QL(), L = /* @__PURE__ */ ZL(), m = /* @__PURE__ */ jL(), X = /* @__PURE__ */ e8(), D = /* @__PURE__ */ t8(), y = /* @__PURE__ */ M8(), S = /* @__PURE__ */ p8(), B = Function, Z = function(p1) {
    try {
      return B('"use strict"; return (' + p1 + ").constructor;")();
    } catch {
    }
  }, H = /* @__PURE__ */ Ta(), e0 = /* @__PURE__ */ o8(), r0 = function() {
    throw new u();
  }, G = H ? (function() {
    try {
      return arguments.callee, r0;
    } catch {
      try {
        return H(arguments, "callee").get;
      } catch {
        return r0;
      }
    }
  })() : r0, j = n8()(), v = s8(), E = wa(), K = _a(), p0 = Xa(), O0 = vn(), s0 = {}, E0 = typeof Uint8Array > "u" || !v ? M : v(Uint8Array), l0 = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? M : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? M : ArrayBuffer,
    "%ArrayIteratorPrototype%": j && v ? v([][Symbol.iterator]()) : M,
    "%AsyncFromSyncIteratorPrototype%": M,
    "%AsyncFunction%": s0,
    "%AsyncGenerator%": s0,
    "%AsyncGeneratorFunction%": s0,
    "%AsyncIteratorPrototype%": s0,
    "%Atomics%": typeof Atomics > "u" ? M : Atomics,
    "%BigInt%": typeof BigInt > "u" ? M : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? M : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? M : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? M : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": p,
    "%Float16Array%": typeof Float16Array > "u" ? M : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? M : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? M : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? M : FinalizationRegistry,
    "%Function%": B,
    "%GeneratorFunction%": s0,
    "%Int8Array%": typeof Int8Array > "u" ? M : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? M : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? M : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": j && v ? v(v([][Symbol.iterator]())) : M,
    "%JSON%": typeof JSON == "object" ? JSON : M,
    "%Map%": typeof Map > "u" ? M : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !j || !v ? M : v((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": H,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? M : Promise,
    "%Proxy%": typeof Proxy > "u" ? M : Proxy,
    "%RangeError%": c,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? M : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? M : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !j || !v ? M : v((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? M : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": j && v ? v(""[Symbol.iterator]()) : M,
    "%Symbol%": j ? Symbol : M,
    "%SyntaxError%": s,
    "%ThrowTypeError%": G,
    "%TypedArray%": E0,
    "%TypeError%": u,
    "%Uint8Array%": typeof Uint8Array > "u" ? M : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? M : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? M : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? M : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? M : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? M : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? M : WeakSet,
    "%Function.prototype.call%": O0,
    "%Function.prototype.apply%": p0,
    "%Object.defineProperty%": e0,
    "%Object.getPrototypeOf%": E,
    "%Math.abs%": W,
    "%Math.floor%": L,
    "%Math.max%": m,
    "%Math.min%": X,
    "%Math.pow%": D,
    "%Math.round%": y,
    "%Math.sign%": S,
    "%Reflect.getPrototypeOf%": K
  };
  if (v)
    try {
      null.error;
    } catch (p1) {
      var Q0 = v(v(p1));
      l0["%Error.prototype%"] = Q0;
    }
  var W0 = function p1(_0) {
    var Z0;
    if (_0 === "%AsyncFunction%")
      Z0 = Z("async function () {}");
    else if (_0 === "%GeneratorFunction%")
      Z0 = Z("function* () {}");
    else if (_0 === "%AsyncGeneratorFunction%")
      Z0 = Z("async function* () {}");
    else if (_0 === "%AsyncGenerator%") {
      var w0 = p1("%AsyncGeneratorFunction%");
      w0 && (Z0 = w0.prototype);
    } else if (_0 === "%AsyncIteratorPrototype%") {
      var f = p1("%AsyncGenerator%");
      f && v && (Z0 = v(f.prototype));
    }
    return l0[_0] = Z0, Z0;
  }, $0 = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, $ = Zp(), x0 = /* @__PURE__ */ A8(), f1 = $.call(O0, Array.prototype.concat), n1 = $.call(p0, Array.prototype.splice), u2 = $.call(O0, String.prototype.replace), q2 = $.call(O0, String.prototype.slice), Z1 = $.call(O0, RegExp.prototype.exec), v1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, i1 = /\\(\\)?/g, S0 = function(_0) {
    var Z0 = q2(_0, 0, 1), w0 = q2(_0, -1);
    if (Z0 === "%" && w0 !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (w0 === "%" && Z0 !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var f = [];
    return u2(_0, v1, function(C, k, V, b0) {
      f[f.length] = V ? u2(b0, i1, "$1") : k || C;
    }), f;
  }, b1 = function(_0, Z0) {
    var w0 = _0, f;
    if (x0($0, w0) && (f = $0[w0], w0 = "%" + f[0] + "%"), x0(l0, w0)) {
      var C = l0[w0];
      if (C === s0 && (C = W0(w0)), typeof C > "u" && !Z0)
        throw new u("intrinsic " + _0 + " exists, but is not available. Please file an issue!");
      return {
        alias: f,
        name: w0,
        value: C
      };
    }
    throw new s("intrinsic " + _0 + " does not exist!");
  };
  return ec = function(_0, Z0) {
    if (typeof _0 != "string" || _0.length === 0)
      throw new u("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Z0 != "boolean")
      throw new u('"allowMissing" argument must be a boolean');
    if (Z1(/^%?[^%]*%?$/, _0) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var w0 = S0(_0), f = w0.length > 0 ? w0[0] : "", C = b1("%" + f + "%", Z0), k = C.name, V = C.value, b0 = !1, q0 = C.alias;
    q0 && (f = q0[0], n1(w0, f1([0, 1], q0)));
    for (var V0 = 1, h0 = !0; V0 < w0.length; V0 += 1) {
      var f0 = w0[V0], o2 = q2(f0, 0, 1), w2 = q2(f0, -1);
      if ((o2 === '"' || o2 === "'" || o2 === "`" || w2 === '"' || w2 === "'" || w2 === "`") && o2 !== w2)
        throw new s("property names with quotes must have matching quotes");
      if ((f0 === "constructor" || !h0) && (b0 = !0), f += "." + f0, k = "%" + f + "%", x0(l0, k))
        V = l0[k];
      else if (V != null) {
        if (!(f0 in V)) {
          if (!Z0)
            throw new u("base intrinsic for " + _0 + " exists, but the property is not available.");
          return;
        }
        if (H && V0 + 1 >= w0.length) {
          var Be = H(V, f0);
          h0 = !!Be, h0 && "get" in Be && !("originalValue" in Be.get) ? V = Be.get : V = V[f0];
        } else
          h0 = x0(V, f0), V = V[f0];
        h0 && !b0 && (l0[k] = V);
      }
    }
    return V;
  }, ec;
}
var tc, c3;
function Da() {
  if (c3) return tc;
  c3 = 1;
  var M = /* @__PURE__ */ Tn(), t = Sa(), e = t([M("%String.prototype.indexOf%")]);
  return tc = function(c, i) {
    var s = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      M(c, !!i)
    );
    return typeof s == "function" && e(c, ".prototype.") > -1 ? t(
      /** @type {const} */
      [s]
    ) : s;
  }, tc;
}
var Mc, n3;
function Ca() {
  if (n3) return Mc;
  n3 = 1;
  var M = /* @__PURE__ */ Tn(), t = /* @__PURE__ */ Da(), e = /* @__PURE__ */ Qp(), p = /* @__PURE__ */ dM(), c = M("%Map%", !0), i = t("Map.prototype.get", !0), s = t("Map.prototype.set", !0), u = t("Map.prototype.has", !0), l = t("Map.prototype.delete", !0), W = t("Map.prototype.size", !0);
  return Mc = !!c && /** @type {Exclude<import('.'), false>} */
  function() {
    var m, X = {
      assert: function(D) {
        if (!X.has(D))
          throw new p("Side channel does not contain " + e(D));
      },
      delete: function(D) {
        if (m) {
          var y = l(m, D);
          return W(m) === 0 && (m = void 0), y;
        }
        return !1;
      },
      get: function(D) {
        if (m)
          return i(m, D);
      },
      has: function(D) {
        return m ? u(m, D) : !1;
      },
      set: function(D, y) {
        m || (m = new c()), s(m, D, y);
      }
    };
    return X;
  }, Mc;
}
var bc, i3;
function d8() {
  if (i3) return bc;
  i3 = 1;
  var M = /* @__PURE__ */ Tn(), t = /* @__PURE__ */ Da(), e = /* @__PURE__ */ Qp(), p = Ca(), c = /* @__PURE__ */ dM(), i = M("%WeakMap%", !0), s = t("WeakMap.prototype.get", !0), u = t("WeakMap.prototype.set", !0), l = t("WeakMap.prototype.has", !0), W = t("WeakMap.prototype.delete", !0);
  return bc = i ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var m, X, D = {
        assert: function(y) {
          if (!D.has(y))
            throw new c("Side channel does not contain " + e(y));
        },
        delete: function(y) {
          if (i && y && (typeof y == "object" || typeof y == "function")) {
            if (m)
              return W(m, y);
          } else if (p && X)
            return X.delete(y);
          return !1;
        },
        get: function(y) {
          return i && y && (typeof y == "object" || typeof y == "function") && m ? s(m, y) : X && X.get(y);
        },
        has: function(y) {
          return i && y && (typeof y == "object" || typeof y == "function") && m ? l(m, y) : !!X && X.has(y);
        },
        set: function(y, S) {
          i && y && (typeof y == "object" || typeof y == "function") ? (m || (m = new i()), u(m, y, S)) : p && (X || (X = p()), X.set(y, S));
        }
      };
      return D;
    }
  ) : p, bc;
}
var pc, r3;
function Ia() {
  if (r3) return pc;
  r3 = 1;
  var M = /* @__PURE__ */ dM(), t = /* @__PURE__ */ Qp(), e = JL(), p = Ca(), c = d8(), i = c || p || e;
  return pc = function() {
    var u, l = {
      assert: function(W) {
        if (!l.has(W))
          throw new M("Side channel does not contain " + t(W));
      },
      delete: function(W) {
        return !!u && u.delete(W);
      },
      get: function(W) {
        return u && u.get(W);
      },
      has: function(W) {
        return !!u && u.has(W);
      },
      set: function(W, L) {
        u || (u = i()), u.set(W, L);
      }
    };
    return l;
  }, pc;
}
var zc, O3;
function _n() {
  if (O3) return zc;
  O3 = 1;
  var M = String.prototype.replace, t = /%20/g, e = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return zc = {
    default: e.RFC3986,
    formatters: {
      RFC1738: function(p) {
        return M.call(p, t, "+");
      },
      RFC3986: function(p) {
        return String(p);
      }
    },
    RFC1738: e.RFC1738,
    RFC3986: e.RFC3986
  }, zc;
}
var oc, a3;
function ka() {
  if (a3) return oc;
  a3 = 1;
  var M = /* @__PURE__ */ _n(), t = Ia(), e = Object.prototype.hasOwnProperty, p = Array.isArray, c = t(), i = function(v, E) {
    return c.set(v, E), v;
  }, s = function(v) {
    return c.has(v);
  }, u = function(v) {
    return c.get(v);
  }, l = function(v, E) {
    c.set(v, E);
  }, W = (function() {
    for (var j = [], v = 0; v < 256; ++v)
      j[j.length] = "%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase();
    return j;
  })(), L = function(v) {
    for (; v.length > 1; ) {
      var E = v.pop(), K = E.obj[E.prop];
      if (p(K)) {
        for (var p0 = [], O0 = 0; O0 < K.length; ++O0)
          typeof K[O0] < "u" && (p0[p0.length] = K[O0]);
        E.obj[E.prop] = p0;
      }
    }
  }, m = function(v, E) {
    for (var K = E && E.plainObjects ? { __proto__: null } : {}, p0 = 0; p0 < v.length; ++p0)
      typeof v[p0] < "u" && (K[p0] = v[p0]);
    return K;
  }, X = function j(v, E, K) {
    if (!E)
      return v;
    if (typeof E != "object" && typeof E != "function") {
      if (p(v)) {
        var p0 = v.length;
        if (K && typeof K.arrayLimit == "number" && p0 > K.arrayLimit)
          return i(m(v.concat(E), K), p0);
        v[p0] = E;
      } else if (v && typeof v == "object")
        if (s(v)) {
          var O0 = u(v) + 1;
          v[O0] = E, l(v, O0);
        } else {
          if (K && K.strictMerge)
            return [v, E];
          (K && (K.plainObjects || K.allowPrototypes) || !e.call(Object.prototype, E)) && (v[E] = !0);
        }
      else
        return [v, E];
      return v;
    }
    if (!v || typeof v != "object") {
      if (s(E)) {
        for (var s0 = Object.keys(E), E0 = K && K.plainObjects ? { __proto__: null, 0: v } : { 0: v }, l0 = 0; l0 < s0.length; l0++) {
          var Q0 = parseInt(s0[l0], 10);
          E0[Q0 + 1] = E[s0[l0]];
        }
        return i(E0, u(E) + 1);
      }
      var W0 = [v].concat(E);
      return K && typeof K.arrayLimit == "number" && W0.length > K.arrayLimit ? i(m(W0, K), W0.length - 1) : W0;
    }
    var $0 = v;
    return p(v) && !p(E) && ($0 = m(v, K)), p(v) && p(E) ? (E.forEach(function($, x0) {
      if (e.call(v, x0)) {
        var f1 = v[x0];
        f1 && typeof f1 == "object" && $ && typeof $ == "object" ? v[x0] = j(f1, $, K) : v[v.length] = $;
      } else
        v[x0] = $;
    }), v) : Object.keys(E).reduce(function($, x0) {
      var f1 = E[x0];
      if (e.call($, x0) ? $[x0] = j($[x0], f1, K) : $[x0] = f1, s(E) && !s($) && i($, u(E)), s($)) {
        var n1 = parseInt(x0, 10);
        String(n1) === x0 && n1 >= 0 && n1 > u($) && l($, n1);
      }
      return $;
    }, $0);
  }, D = function(v, E) {
    return Object.keys(E).reduce(function(K, p0) {
      return K[p0] = E[p0], K;
    }, v);
  }, y = function(j, v, E) {
    var K = j.replace(/\+/g, " ");
    if (E === "iso-8859-1")
      return K.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(K);
    } catch {
      return K;
    }
  }, S = 1024, B = function(v, E, K, p0, O0) {
    if (v.length === 0)
      return v;
    var s0 = v;
    if (typeof v == "symbol" ? s0 = Symbol.prototype.toString.call(v) : typeof v != "string" && (s0 = String(v)), K === "iso-8859-1")
      return escape(s0).replace(/%u[0-9a-f]{4}/gi, function(x0) {
        return "%26%23" + parseInt(x0.slice(2), 16) + "%3B";
      });
    for (var E0 = "", l0 = 0; l0 < s0.length; l0 += S) {
      for (var Q0 = s0.length >= S ? s0.slice(l0, l0 + S) : s0, W0 = [], $0 = 0; $0 < Q0.length; ++$0) {
        var $ = Q0.charCodeAt($0);
        if ($ === 45 || $ === 46 || $ === 95 || $ === 126 || $ >= 48 && $ <= 57 || $ >= 65 && $ <= 90 || $ >= 97 && $ <= 122 || O0 === M.RFC1738 && ($ === 40 || $ === 41)) {
          W0[W0.length] = Q0.charAt($0);
          continue;
        }
        if ($ < 128) {
          W0[W0.length] = W[$];
          continue;
        }
        if ($ < 2048) {
          W0[W0.length] = W[192 | $ >> 6] + W[128 | $ & 63];
          continue;
        }
        if ($ < 55296 || $ >= 57344) {
          W0[W0.length] = W[224 | $ >> 12] + W[128 | $ >> 6 & 63] + W[128 | $ & 63];
          continue;
        }
        $0 += 1, $ = 65536 + (($ & 1023) << 10 | Q0.charCodeAt($0) & 1023), W0[W0.length] = W[240 | $ >> 18] + W[128 | $ >> 12 & 63] + W[128 | $ >> 6 & 63] + W[128 | $ & 63];
      }
      E0 += W0.join("");
    }
    return E0;
  }, Z = function(v) {
    for (var E = [{ obj: { o: v }, prop: "o" }], K = [], p0 = 0; p0 < E.length; ++p0)
      for (var O0 = E[p0], s0 = O0.obj[O0.prop], E0 = Object.keys(s0), l0 = 0; l0 < E0.length; ++l0) {
        var Q0 = E0[l0], W0 = s0[Q0];
        typeof W0 == "object" && W0 !== null && K.indexOf(W0) === -1 && (E[E.length] = { obj: s0, prop: Q0 }, K[K.length] = W0);
      }
    return L(E), v;
  }, H = function(v) {
    return Object.prototype.toString.call(v) === "[object RegExp]";
  }, e0 = function(v) {
    return !v || typeof v != "object" ? !1 : !!(v.constructor && v.constructor.isBuffer && v.constructor.isBuffer(v));
  }, r0 = function(v, E, K, p0) {
    if (s(v)) {
      var O0 = u(v) + 1;
      return v[O0] = E, l(v, O0), v;
    }
    var s0 = [].concat(v, E);
    return s0.length > K ? i(m(s0, { plainObjects: p0 }), s0.length - 1) : s0;
  }, G = function(v, E) {
    if (p(v)) {
      for (var K = [], p0 = 0; p0 < v.length; p0 += 1)
        K[K.length] = E(v[p0]);
      return K;
    }
    return E(v);
  };
  return oc = {
    arrayToObject: m,
    assign: D,
    combine: r0,
    compact: Z,
    decode: y,
    encode: B,
    isBuffer: e0,
    isOverflow: s,
    isRegExp: H,
    markOverflow: i,
    maybeMap: G,
    merge: X
  }, oc;
}
var cc, s3;
function u8() {
  if (s3) return cc;
  s3 = 1;
  var M = Ia(), t = /* @__PURE__ */ ka(), e = /* @__PURE__ */ _n(), p = Object.prototype.hasOwnProperty, c = {
    brackets: function(B) {
      return B + "[]";
    },
    comma: "comma",
    indices: function(B, Z) {
      return B + "[" + Z + "]";
    },
    repeat: function(B) {
      return B;
    }
  }, i = Array.isArray, s = Array.prototype.push, u = function(S, B) {
    s.apply(S, i(B) ? B : [B]);
  }, l = Date.prototype.toISOString, W = e.default, L = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: W,
    formatter: e.formatters[W],
    // deprecated
    indices: !1,
    serializeDate: function(B) {
      return l.call(B);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, m = function(B) {
    return typeof B == "string" || typeof B == "number" || typeof B == "boolean" || typeof B == "symbol" || typeof B == "bigint";
  }, X = {}, D = function S(B, Z, H, e0, r0, G, j, v, E, K, p0, O0, s0, E0, l0, Q0, W0, $0) {
    for (var $ = B, x0 = $0, f1 = 0, n1 = !1; (x0 = x0.get(X)) !== void 0 && !n1; ) {
      var u2 = x0.get(B);
      if (f1 += 1, typeof u2 < "u") {
        if (u2 === f1)
          throw new RangeError("Cyclic object value");
        n1 = !0;
      }
      typeof x0.get(X) > "u" && (f1 = 0);
    }
    if (typeof K == "function" ? $ = K(Z, $) : $ instanceof Date ? $ = s0($) : H === "comma" && i($) && ($ = t.maybeMap($, function(k) {
      return k instanceof Date ? s0(k) : k;
    })), $ === null) {
      if (G)
        return l0(E && !Q0 ? E(Z, L.encoder, W0, "key", E0) : Z);
      $ = "";
    }
    if (m($) || t.isBuffer($)) {
      if (E) {
        var q2 = Q0 ? Z : E(Z, L.encoder, W0, "key", E0);
        return [l0(q2) + "=" + l0(E($, L.encoder, W0, "value", E0))];
      }
      return [l0(Z) + "=" + l0(String($))];
    }
    var Z1 = [];
    if (typeof $ > "u")
      return Z1;
    var v1;
    if (H === "comma" && i($))
      Q0 && E && ($ = t.maybeMap($, function(k) {
        return k == null ? k : E(k);
      })), v1 = [{ value: $.length > 0 ? $.join(",") || null : void 0 }];
    else if (i(K))
      v1 = K;
    else {
      var i1 = Object.keys($);
      v1 = p0 ? i1.sort(p0) : i1;
    }
    var S0 = v ? String(Z).replace(/\./g, "%2E") : String(Z), b1 = e0 && i($) && $.length === 1 ? S0 + "[]" : S0;
    if (r0 && i($) && $.length === 0)
      return b1 + "[]";
    for (var p1 = 0; p1 < v1.length; ++p1) {
      var _0 = v1[p1], Z0 = typeof _0 == "object" && _0 && typeof _0.value < "u" ? _0.value : $[_0];
      if (!(j && Z0 === null)) {
        var w0 = O0 && v ? String(_0).replace(/\./g, "%2E") : String(_0), f = i($) ? typeof H == "function" ? H(b1, w0) : b1 : b1 + (O0 ? "." + w0 : "[" + w0 + "]");
        $0.set(B, f1);
        var C = M();
        C.set(X, $0), u(Z1, S(
          Z0,
          f,
          H,
          e0,
          r0,
          G,
          j,
          v,
          H === "comma" && Q0 && i($) ? null : E,
          K,
          p0,
          O0,
          s0,
          E0,
          l0,
          Q0,
          W0,
          C
        ));
      }
    }
    return Z1;
  }, y = function(B) {
    if (!B)
      return L;
    if (typeof B.allowEmptyArrays < "u" && typeof B.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof B.encodeDotInKeys < "u" && typeof B.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (B.encoder !== null && typeof B.encoder < "u" && typeof B.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var Z = B.charset || L.charset;
    if (typeof B.charset < "u" && B.charset !== "utf-8" && B.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var H = e.default;
    if (typeof B.format < "u") {
      if (!p.call(e.formatters, B.format))
        throw new TypeError("Unknown format option provided.");
      H = B.format;
    }
    var e0 = e.formatters[H], r0 = L.filter;
    (typeof B.filter == "function" || i(B.filter)) && (r0 = B.filter);
    var G;
    if (B.arrayFormat in c ? G = B.arrayFormat : "indices" in B ? G = B.indices ? "indices" : "repeat" : G = L.arrayFormat, "commaRoundTrip" in B && typeof B.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var j = typeof B.allowDots > "u" ? B.encodeDotInKeys === !0 ? !0 : L.allowDots : !!B.allowDots;
    return {
      addQueryPrefix: typeof B.addQueryPrefix == "boolean" ? B.addQueryPrefix : L.addQueryPrefix,
      allowDots: j,
      allowEmptyArrays: typeof B.allowEmptyArrays == "boolean" ? !!B.allowEmptyArrays : L.allowEmptyArrays,
      arrayFormat: G,
      charset: Z,
      charsetSentinel: typeof B.charsetSentinel == "boolean" ? B.charsetSentinel : L.charsetSentinel,
      commaRoundTrip: !!B.commaRoundTrip,
      delimiter: typeof B.delimiter > "u" ? L.delimiter : B.delimiter,
      encode: typeof B.encode == "boolean" ? B.encode : L.encode,
      encodeDotInKeys: typeof B.encodeDotInKeys == "boolean" ? B.encodeDotInKeys : L.encodeDotInKeys,
      encoder: typeof B.encoder == "function" ? B.encoder : L.encoder,
      encodeValuesOnly: typeof B.encodeValuesOnly == "boolean" ? B.encodeValuesOnly : L.encodeValuesOnly,
      filter: r0,
      format: H,
      formatter: e0,
      serializeDate: typeof B.serializeDate == "function" ? B.serializeDate : L.serializeDate,
      skipNulls: typeof B.skipNulls == "boolean" ? B.skipNulls : L.skipNulls,
      sort: typeof B.sort == "function" ? B.sort : null,
      strictNullHandling: typeof B.strictNullHandling == "boolean" ? B.strictNullHandling : L.strictNullHandling
    };
  };
  return cc = function(S, B) {
    var Z = S, H = y(B), e0, r0;
    typeof H.filter == "function" ? (r0 = H.filter, Z = r0("", Z)) : i(H.filter) && (r0 = H.filter, e0 = r0);
    var G = [];
    if (typeof Z != "object" || Z === null)
      return "";
    var j = c[H.arrayFormat], v = j === "comma" && H.commaRoundTrip;
    e0 || (e0 = Object.keys(Z)), H.sort && e0.sort(H.sort);
    for (var E = M(), K = 0; K < e0.length; ++K) {
      var p0 = e0[K];
      if (!(typeof p0 > "u" || p0 === null)) {
        var O0 = Z[p0];
        H.skipNulls && O0 === null || u(G, D(
          O0,
          p0,
          j,
          v,
          H.allowEmptyArrays,
          H.strictNullHandling,
          H.skipNulls,
          H.encodeDotInKeys,
          H.encode ? H.encoder : null,
          H.filter,
          H.sort,
          H.allowDots,
          H.serializeDate,
          H.format,
          H.formatter,
          H.encodeValuesOnly,
          H.charset,
          E
        ));
      }
    }
    var s0 = G.join(H.delimiter), E0 = H.addQueryPrefix === !0 ? "?" : "";
    return H.charsetSentinel && (H.charset === "iso-8859-1" ? E0 += "utf8=%26%2310003%3B" + H.delimiter : E0 += "utf8=%E2%9C%93" + H.delimiter), s0.length > 0 ? E0 + s0 : "";
  }, cc;
}
var nc, A3;
function q8() {
  if (A3) return nc;
  A3 = 1;
  var M = /* @__PURE__ */ ka(), t = Object.prototype.hasOwnProperty, e = Array.isArray, p = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: M.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictMerge: !0,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, c = function(D) {
    return D.replace(/&#(\d+);/g, function(y, S) {
      return String.fromCharCode(parseInt(S, 10));
    });
  }, i = function(D, y, S) {
    if (D && typeof D == "string" && y.comma && D.indexOf(",") > -1)
      return D.split(",");
    if (y.throwOnLimitExceeded && S >= y.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + y.arrayLimit + " element" + (y.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return D;
  }, s = "utf8=%26%2310003%3B", u = "utf8=%E2%9C%93", l = function(y, S) {
    var B = { __proto__: null }, Z = S.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
    Z = Z.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var H = S.parameterLimit === 1 / 0 ? void 0 : S.parameterLimit, e0 = Z.split(
      S.delimiter,
      S.throwOnLimitExceeded && typeof H < "u" ? H + 1 : H
    );
    if (S.throwOnLimitExceeded && typeof H < "u" && e0.length > H)
      throw new RangeError("Parameter limit exceeded. Only " + H + " parameter" + (H === 1 ? "" : "s") + " allowed.");
    var r0 = -1, G, j = S.charset;
    if (S.charsetSentinel)
      for (G = 0; G < e0.length; ++G)
        e0[G].indexOf("utf8=") === 0 && (e0[G] === u ? j = "utf-8" : e0[G] === s && (j = "iso-8859-1"), r0 = G, G = e0.length);
    for (G = 0; G < e0.length; ++G)
      if (G !== r0) {
        var v = e0[G], E = v.indexOf("]="), K = E === -1 ? v.indexOf("=") : E + 1, p0, O0;
        if (K === -1 ? (p0 = S.decoder(v, p.decoder, j, "key"), O0 = S.strictNullHandling ? null : "") : (p0 = S.decoder(v.slice(0, K), p.decoder, j, "key"), p0 !== null && (O0 = M.maybeMap(
          i(
            v.slice(K + 1),
            S,
            e(B[p0]) ? B[p0].length : 0
          ),
          function(E0) {
            return S.decoder(E0, p.decoder, j, "value");
          }
        ))), O0 && S.interpretNumericEntities && j === "iso-8859-1" && (O0 = c(String(O0))), v.indexOf("[]=") > -1 && (O0 = e(O0) ? [O0] : O0), S.comma && e(O0) && O0.length > S.arrayLimit) {
          if (S.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + S.arrayLimit + " element" + (S.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          O0 = M.combine([], O0, S.arrayLimit, S.plainObjects);
        }
        if (p0 !== null) {
          var s0 = t.call(B, p0);
          s0 && (S.duplicates === "combine" || v.indexOf("[]=") > -1) ? B[p0] = M.combine(
            B[p0],
            O0,
            S.arrayLimit,
            S.plainObjects
          ) : (!s0 || S.duplicates === "last") && (B[p0] = O0);
        }
      }
    return B;
  }, W = function(D, y, S, B) {
    var Z = 0;
    if (D.length > 0 && D[D.length - 1] === "[]") {
      var H = D.slice(0, -1).join("");
      Z = Array.isArray(y) && y[H] ? y[H].length : 0;
    }
    for (var e0 = B ? y : i(y, S, Z), r0 = D.length - 1; r0 >= 0; --r0) {
      var G, j = D[r0];
      if (j === "[]" && S.parseArrays)
        M.isOverflow(e0) ? G = e0 : G = S.allowEmptyArrays && (e0 === "" || S.strictNullHandling && e0 === null) ? [] : M.combine(
          [],
          e0,
          S.arrayLimit,
          S.plainObjects
        );
      else {
        G = S.plainObjects ? { __proto__: null } : {};
        var v = j.charAt(0) === "[" && j.charAt(j.length - 1) === "]" ? j.slice(1, -1) : j, E = S.decodeDotInKeys ? v.replace(/%2E/g, ".") : v, K = parseInt(E, 10), p0 = !isNaN(K) && j !== E && String(K) === E && K >= 0 && S.parseArrays;
        if (!S.parseArrays && E === "")
          G = { 0: e0 };
        else if (p0 && K < S.arrayLimit)
          G = [], G[K] = e0;
        else {
          if (p0 && S.throwOnLimitExceeded)
            throw new RangeError("Array limit exceeded. Only " + S.arrayLimit + " element" + (S.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
          p0 ? (G[K] = e0, M.markOverflow(G, K)) : E !== "__proto__" && (G[E] = e0);
        }
      }
      e0 = G;
    }
    return e0;
  }, L = function(y, S) {
    var B = S.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y;
    if (S.depth <= 0)
      return !S.plainObjects && t.call(Object.prototype, B) && !S.allowPrototypes ? void 0 : [B];
    var Z = [], H = B.indexOf("["), e0 = H >= 0 ? B.slice(0, H) : B;
    if (e0) {
      if (!S.plainObjects && t.call(Object.prototype, e0) && !S.allowPrototypes)
        return;
      Z[Z.length] = e0;
    }
    for (var r0 = B.length, G = H, j = 0; G >= 0 && j < S.depth; ) {
      for (var v = 1, E = G + 1, K = -1; E < r0 && K < 0; ) {
        var p0 = B.charCodeAt(E);
        p0 === 91 ? v += 1 : p0 === 93 && (v -= 1, v === 0 && (K = E)), E += 1;
      }
      if (K < 0)
        return Z[Z.length] = "[" + B.slice(G) + "]", Z;
      var O0 = B.slice(G, K + 1), s0 = O0.slice(1, -1);
      if (!S.plainObjects && t.call(Object.prototype, s0) && !S.allowPrototypes)
        return;
      Z[Z.length] = O0, j += 1, G = B.indexOf("[", K + 1);
    }
    if (G >= 0) {
      if (S.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + S.depth + " and strictDepth is true");
      Z[Z.length] = "[" + B.slice(G) + "]";
    }
    return Z;
  }, m = function(y, S, B, Z) {
    if (y) {
      var H = L(y, B);
      if (H)
        return W(H, S, B, Z);
    }
  }, X = function(y) {
    if (!y)
      return p;
    if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof y.throwOnLimitExceeded < "u" && typeof y.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var S = typeof y.charset > "u" ? p.charset : y.charset, B = typeof y.duplicates > "u" ? p.duplicates : y.duplicates;
    if (B !== "combine" && B !== "first" && B !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var Z = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : p.allowDots : !!y.allowDots;
    return {
      allowDots: Z,
      allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : p.allowEmptyArrays,
      allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : p.allowPrototypes,
      allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : p.allowSparse,
      arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : p.arrayLimit,
      charset: S,
      charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : p.charsetSentinel,
      comma: typeof y.comma == "boolean" ? y.comma : p.comma,
      decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : p.decodeDotInKeys,
      decoder: typeof y.decoder == "function" ? y.decoder : p.decoder,
      delimiter: typeof y.delimiter == "string" || M.isRegExp(y.delimiter) ? y.delimiter : p.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : p.depth,
      duplicates: B,
      ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : p.interpretNumericEntities,
      parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : p.parameterLimit,
      parseArrays: y.parseArrays !== !1,
      plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : p.plainObjects,
      strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : p.strictDepth,
      strictMerge: typeof y.strictMerge == "boolean" ? !!y.strictMerge : p.strictMerge,
      strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : p.strictNullHandling,
      throwOnLimitExceeded: typeof y.throwOnLimitExceeded == "boolean" ? y.throwOnLimitExceeded : !1
    };
  };
  return nc = function(D, y) {
    var S = X(y);
    if (D === "" || D === null || typeof D > "u")
      return S.plainObjects ? { __proto__: null } : {};
    for (var B = typeof D == "string" ? l(D, S) : D, Z = S.plainObjects ? { __proto__: null } : {}, H = Object.keys(B), e0 = 0; e0 < H.length; ++e0) {
      var r0 = H[e0], G = m(r0, B[r0], S, typeof D == "string");
      Z = M.merge(Z, G, S);
    }
    return S.allowSparse === !0 ? Z : M.compact(Z);
  }, nc;
}
var ic, d3;
function l8() {
  if (d3) return ic;
  d3 = 1;
  var M = /* @__PURE__ */ u8(), t = /* @__PURE__ */ q8(), e = /* @__PURE__ */ _n();
  return ic = {
    formats: e,
    parse: t,
    stringify: M
  }, ic;
}
var f8 = /* @__PURE__ */ l8();
const W8 = /* @__PURE__ */ Hc(f8);
class h8 {
  constructor(t) {
    o(this, "axios");
    this.apiUrl = t, this.axios = Kl.create();
  }
  async execute(t, e) {
    var p, c, i;
    try {
      const s = this.buildUrl(t);
      t.headers || (t.headers = {
        "Content-Type": "application/json"
      });
      let u;
      switch (t.method) {
        case "GET": {
          const l = ((p = t.fields) == null ? void 0 : p.replace(new RegExp(`\r?
| `, "g"), "")) ?? null;
          let W = { ...t.body, fields: l };
          u = await this.axios.get(s, {
            params: W,
            headers: t.headers,
            paramsSerializer: (L) => {
              const m = JSON.parse(JSON.stringify(L));
              return W8.stringify(m);
            },
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "POST": {
          u = await this.axios.post(s, t.body, {
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "PUT": {
          u = await this.axios.put(s, t.body, {
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
        case "DELETE": {
          u = await this.axios.delete(s, {
            params: t.body,
            headers: t.headers,
            signal: t.cancellationToken.signal,
            responseType: t.responseType
          });
          break;
        }
      }
      return await this.parseResponseData(t.responseType, u);
    } catch (s) {
      return (s.response == null || s.response.data == null) && console.error("Network error", s), {
        success: !1,
        errors: ((i = (c = s.response) == null ? void 0 : c.data) == null ? void 0 : i.errors) ?? [],
        body: void 0,
        resetToken: !1,
        raw: s
      };
    }
  }
  buildUrl(t) {
    return `${this.apiUrl}/v${t.v}${t.url}`;
  }
  async parseResponseData(t = "json", e) {
    const { data: p, headers: c } = e;
    switch (t) {
      case "blob":
        if (p.type === "application/json") {
          const s = await p.text(), u = JSON.parse(s);
          return {
            success: p.success,
            body: u,
            errors: [],
            resetToken: !1,
            raw: e
          };
        } else
          return c["X-Filename"], {
            success: p.success,
            body: p,
            errors: [],
            resetToken: !1,
            raw: e
          };
      default:
      case "json":
        return {
          success: p.success,
          body: p.body,
          errors: p.errors,
          resetToken: p.resetToken,
          raw: e
        };
    }
  }
}
class m8 extends h8 {
  constructor(e) {
    super(e.apiUrl);
    o(this, "MaxAttempts", 3);
    this.config = e;
  }
  buildHeaders(e, p) {
    const c = {
      "Content-Type": "application/json",
      "X-Timezone-Offset": (/* @__PURE__ */ new Date()).getTimezoneOffset(),
      ...e.headers
    };
    return e.authorized && (p && (c.Authorization = `Bearer ${p.accessToken}`), this.config.getConnectionId && (c.ConnectionId = this.config.getConnectionId())), c;
  }
  async execute(e, p, c = 1) {
    const i = await this.config.tokenStorage.getTokens();
    e.headers = this.buildHeaders(e, i);
    let s = await super.execute(e, p);
    if (e.authorized)
      if (s.raw.status == 401) {
        if (c == this.MaxAttempts || !await this.refreshTokens(p, i))
          return s;
        s = await this.execute(e, p, c + 1);
      } else s.resetToken && await this.refreshTokens(p, i);
    return s;
  }
  async refreshTokens(e, p) {
    if (!p)
      return !1;
    const c = await e.auth.refreshToken(p.refreshToken);
    return c.success && await this.config.tokenStorage.setTokens(c.body), c.success;
  }
}
class u3 extends H1 {
  constructor(e) {
    super();
    o(this, "type");
    o(this, "id");
    o(this, "createdDate");
    o(this, "updatedDate");
    o(this, "contact");
    this.update(e);
  }
  static fromJsonBase(e) {
    return {
      id: e.id,
      type: e.type,
      createdDate: R(e.createdDate),
      updatedDate: e.updatedDate ? R(e.updatedDate) : void 0,
      contact: e.student ? l1.fromJson(e.student) : void 0
    };
  }
}
class wn extends u3 {
  constructor(e) {
    super(e);
    o(this, "achievement");
    e && this.update(e);
  }
  get key() {
    return "GamificationAchievementNotification";
  }
  static fromJson(e) {
    return new wn({
      achievement: qt.fromJson(e.achievement),
      ...u3.fromJsonBase(e)
    });
  }
}
const R8 = {
  parse: (M) => {
    switch (M.type) {
      case "gamificationAchievement":
        return wn.fromJson(M);
      default:
        throw new Error("Invalid notification type");
    }
  }
};
class L8 {
  constructor() {
    o(this, "type");
    o(this, "post");
  }
  static fromJson(t) {
    const e = t.type === "updated" ? aa(t.post, !0) : t.post;
    let p;
    switch (t.type) {
      case "updated":
        p = e, p.attachments && (p.attachments = p.attachments.map(pb.fromJson)), p.updatedDate && (p.updatedDate = R(p.updatedDate)), p.pinDate && (p.pinDate = R(p.pinDate));
        break;
      case "created":
      case "deleted":
      default:
        p = Lt.fromJson(e);
        break;
    }
    return {
      type: t.type,
      post: p
    };
  }
}
class g8 {
  constructor() {
    o(this, "type");
    o(this, "comment");
  }
  static fromJson(t) {
    const e = t.type === "updated" ? aa(t.comment, !0) : t.comment;
    e.parentId && (e.parent = { id: e.parentId }), e.replyId && !e.reply && (e.reply = { id: e.replyId });
    let p;
    switch (t.type) {
      case "updated":
        p = e, p.files && (p.files = p.files.map(D1.fromJson)), p.updatedDate && (p.updatedDate = R(p.updatedDate));
        break;
      case "created":
      case "deleted":
      default:
        p = ft.fromJson(e);
        break;
    }
    return {
      type: t.type,
      comment: p
    };
  }
}
class y8 {
  constructor(t) {
    o(this, "gamification");
    o(this, "notification");
    o(this, "user");
    o(this, "forum");
    o(this, "community");
    o(this, "education");
    o(this, "school");
    this.client = t, this.gamification = {
      balance: new O1(this.client, "GamificationBalance", (e) => e.balance)
    }, this.notification = new O1(this.client, "Notification", R8.parse), this.user = {
      notification: {
        count: new O1(this.client, "UserNotificationCount", (e) => e.count),
        new: new O1(this.client, "UserNotification", (e) => Gp.fromJson(e.notification))
      },
      email: {
        confirmed: new O1(this.client, "EmailConfirmed"),
        confirm: () => this.client.invoke("EmailConfirm", [])
      }
    }, this.community = {
      post: (e) => new O1(this.client, e ? `CommunityPostEvent:${e}` : "CommunityPostEvent", (p) => L8.fromJson(p)),
      postComment: (e) => new O1(this.client, `CommunityPostCommentEvent:${e}`, (p) => g8.fromJson(p))
    }, this.education = {
      course: {
        itemChanged: (e) => new O1(this.client, `SchoolContentItem courseId:${e}`, (p) => p),
        comment: (e) => new O1(this.client, `SchoolContentItemComment courseId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        })),
        itemComment: (e) => new O1(this.client, `SchoolContentItemComment courseItemId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        })),
        progress: (e) => new O1(this.client, `SchoolContentProgress courseId:${e}`, (p) => p2.fromJson(p))
      },
      library: {
        itemChanged: (e) => new O1(this.client, `SchoolContentItem libraryId:${e}`, (p) => p.item),
        comment: (e) => new O1(this.client, `SchoolContentItemComment libraryId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        })),
        itemComment: (e) => new O1(this.client, `SchoolContentItemComment libraryItemId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        }))
      },
      rating: {
        itemComment: (e) => new O1(this.client, `SchoolContentItemComment ratingId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        }))
      },
      comment: {
        comment: (e) => new O1(this.client, `SchoolContentItemComment commentId:${e}`, (p) => ({
          ...p,
          comment: B2.fromJson(p.comment)
        }))
      },
      task: {
        answer: (e) => new O1(this.client, `TaskAnswer ${e}`, (p) => ({
          progress: p2.fromJson(p.progress),
          answer: Jp.fromJson(p.answer)
        })),
        comment: (e) => new O1(this.client, `TaskComment ${e}`, (p) => ({
          ...p,
          comment: sb.fromJson(p.comment)
        })),
        commentTyping: (e) => new O1(this.client, `TaskCommentTyping ${e}`, (p) => ({
          commentId: p.commentId,
          event: p.event
        })),
        sendTyping: (e, p, c, i) => this.client.invoke("TaskCommentTyping", [e, p, c, i])
      }
    }, this.forum = {
      topic: {
        comment: (e) => new O1(this.client, `ForumTopicComment ${e}`, (p) => ({
          topicId: p.topicId,
          event: p.event,
          comment: Rt.fromJson(p.comment)
        })),
        reaction: (e) => new O1(this.client, `ForumTopicReaction ${e}`, (p) => ({
          topicId: p.topicId,
          commentId: p.commentId,
          reaction: mt.fromJson(p.reaction),
          event: p.event
        })),
        topic: (e) => new O1(this.client, `ForumTopic ${e}`, (p) => ({
          topic: Ab.fromJson(p.topic),
          event: p.event
        }))
      }
    }, this.school = {
      supportChatEnabled: new O1(this.client, "SchoolSupportChatChanged", (e) => e.enabled),
      schoolMigration: new O1(this.client, "SchoolMigration", (e) => Pp.fromJson(e))
    }, t.init();
  }
  get connectionId() {
    var t;
    return ((t = this.client) == null ? void 0 : t.connectionId) ?? null;
  }
}
//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc
var q3 = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
  "_"
), N8 = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), rc = [
  /^ene/i,
  /^feb/i,
  /^mar/i,
  /^abr/i,
  /^may/i,
  /^jun/i,
  /^jul/i,
  /^ago/i,
  /^sep/i,
  /^oct/i,
  /^nov/i,
  /^dic/i
], l3 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
R.defineLocale("es", {
  months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
    "_"
  ),
  monthsShort: function(M, t) {
    return M ? /-MMM-/.test(t) ? N8[M.month()] : q3[M.month()] : q3;
  },
  monthsRegex: l3,
  monthsShortRegex: l3,
  monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
  monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
  monthsParse: rc,
  longMonthsParse: rc,
  shortMonthsParse: rc,
  weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
  weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
  weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
  weekdaysParseExact: !0,
  longDateFormat: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY H:mm",
    LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
  },
  calendar: {
    sameDay: function() {
      return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    nextDay: function() {
      return "[mañana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    nextWeek: function() {
      return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    lastDay: function() {
      return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    lastWeek: function() {
      return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "en %s",
    past: "hace %s",
    s: "unos segundos",
    ss: "%d segundos",
    m: "un minuto",
    mm: "%d minutos",
    h: "una hora",
    hh: "%d horas",
    d: "un día",
    dd: "%d días",
    w: "una semana",
    ww: "%d semanas",
    M: "un mes",
    MM: "%d meses",
    y: "un año",
    yy: "%d años"
  },
  dayOfMonthOrdinalParse: /\d{1,2}º/,
  ordinal: "%dº",
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  },
  invalidDate: "Fecha inválida"
});
//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
R.defineLocale("id", {
  months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split(
    "_"
  ),
  monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
  weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
  weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
  weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
  longDateFormat: {
    LT: "HH.mm",
    LTS: "HH.mm.ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY [pukul] HH.mm",
    LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
  },
  meridiemParse: /pagi|siang|sore|malam/,
  meridiemHour: function(M, t) {
    if (M === 12 && (M = 0), t === "pagi")
      return M;
    if (t === "siang")
      return M >= 11 ? M : M + 12;
    if (t === "sore" || t === "malam")
      return M + 12;
  },
  meridiem: function(M, t, e) {
    return M < 11 ? "pagi" : M < 15 ? "siang" : M < 19 ? "sore" : "malam";
  },
  calendar: {
    sameDay: "[Hari ini pukul] LT",
    nextDay: "[Besok pukul] LT",
    nextWeek: "dddd [pukul] LT",
    lastDay: "[Kemarin pukul] LT",
    lastWeek: "dddd [lalu pukul] LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "dalam %s",
    past: "%s yang lalu",
    s: "beberapa detik",
    ss: "%d detik",
    m: "semenit",
    mm: "%d menit",
    h: "sejam",
    hh: "%d jam",
    d: "sehari",
    dd: "%d hari",
    M: "sebulan",
    MM: "%d bulan",
    y: "setahun",
    yy: "%d tahun"
  },
  week: {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6
    // The week that contains Jan 6th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair
function B8(M, t) {
  var e = M.split("_");
  return t % 10 === 1 && t % 100 !== 11 ? e[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? e[1] : e[2];
}
function Fe(M, t, e) {
  var p = {
    ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
    mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
    hh: "час_часа_часов",
    dd: "день_дня_дней",
    ww: "неделя_недели_недель",
    MM: "месяц_месяца_месяцев",
    yy: "год_года_лет"
  };
  return e === "m" ? t ? "минута" : "минуту" : M + " " + B8(p[e], +M);
}
var Oc = [
  /^янв/i,
  /^фев/i,
  /^мар/i,
  /^апр/i,
  /^ма[йя]/i,
  /^июн/i,
  /^июл/i,
  /^авг/i,
  /^сен/i,
  /^окт/i,
  /^ноя/i,
  /^дек/i
];
R.defineLocale("ru", {
  months: {
    format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split(
      "_"
    ),
    standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split(
      "_"
    )
  },
  monthsShort: {
    // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
    format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split(
      "_"
    ),
    standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split(
      "_"
    )
  },
  weekdays: {
    standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split(
      "_"
    ),
    format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split(
      "_"
    ),
    isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
  },
  weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
  monthsParse: Oc,
  longMonthsParse: Oc,
  shortMonthsParse: Oc,
  // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
  monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // копия предыдущего
  monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
  // полные названия с падежами
  monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
  // Выражение, которое соответствует только сокращённым формам
  monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
  longDateFormat: {
    LT: "H:mm",
    LTS: "H:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY г.",
    LLL: "D MMMM YYYY г., H:mm",
    LLLL: "dddd, D MMMM YYYY г., H:mm"
  },
  calendar: {
    sameDay: "[Сегодня, в] LT",
    nextDay: "[Завтра, в] LT",
    lastDay: "[Вчера, в] LT",
    nextWeek: function(M) {
      if (M.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В следующее] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В следующий] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В следующую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    lastWeek: function(M) {
      if (M.week() !== this.week())
        switch (this.day()) {
          case 0:
            return "[В прошлое] dddd, [в] LT";
          case 1:
          case 2:
          case 4:
            return "[В прошлый] dddd, [в] LT";
          case 3:
          case 5:
          case 6:
            return "[В прошлую] dddd, [в] LT";
        }
      else
        return this.day() === 2 ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "через %s",
    past: "%s назад",
    s: "несколько секунд",
    ss: Fe,
    m: Fe,
    mm: Fe,
    h: "час",
    hh: Fe,
    d: "день",
    dd: Fe,
    w: "неделя",
    ww: Fe,
    M: "месяц",
    MM: Fe,
    y: "год",
    yy: Fe
  },
  meridiemParse: /ночи|утра|дня|вечера/i,
  isPM: function(M) {
    return /^(дня|вечера)$/.test(M);
  },
  meridiem: function(M, t, e) {
    return M < 4 ? "ночи" : M < 12 ? "утра" : M < 17 ? "дня" : "вечера";
  },
  dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
  ordinal: function(M, t) {
    switch (t) {
      case "M":
      case "d":
      case "DDD":
        return M + "-й";
      case "D":
        return M + "-го";
      case "w":
      case "W":
        return M + "-я";
      default:
        return M;
    }
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire
function v8(M, t) {
  var e = M.split("_");
  return t % 10 === 1 && t % 100 !== 11 ? e[0] : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? e[1] : e[2];
}
function Ot(M, t, e) {
  var p = {
    ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
    mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
    hh: t ? "година_години_годин" : "годину_години_годин",
    dd: "день_дні_днів",
    MM: "місяць_місяці_місяців",
    yy: "рік_роки_років"
  };
  return e === "m" ? t ? "хвилина" : "хвилину" : e === "h" ? t ? "година" : "годину" : M + " " + v8(p[e], +M);
}
function T8(M, t) {
  var e = {
    nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split(
      "_"
    ),
    accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split(
      "_"
    ),
    genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split(
      "_"
    )
  }, p;
  return M === !0 ? e.nominative.slice(1, 7).concat(e.nominative.slice(0, 1)) : M ? (p = /(\[[ВвУу]\]) ?dddd/.test(t) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? "genitive" : "nominative", e[p][M.day()]) : e.nominative;
}
function $t(M) {
  return function() {
    return M + "о" + (this.hours() === 11 ? "б" : "") + "] LT";
  };
}
R.defineLocale("uk", {
  months: {
    format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split(
      "_"
    ),
    standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split(
      "_"
    )
  },
  monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split(
    "_"
  ),
  weekdays: T8,
  weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
  weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD.MM.YYYY",
    LL: "D MMMM YYYY р.",
    LLL: "D MMMM YYYY р., HH:mm",
    LLLL: "dddd, D MMMM YYYY р., HH:mm"
  },
  calendar: {
    sameDay: $t("[Сьогодні "),
    nextDay: $t("[Завтра "),
    lastDay: $t("[Вчора "),
    nextWeek: $t("[У] dddd ["),
    lastWeek: function() {
      switch (this.day()) {
        case 0:
        case 3:
        case 5:
        case 6:
          return $t("[Минулої] dddd [").call(this);
        case 1:
        case 2:
        case 4:
          return $t("[Минулого] dddd [").call(this);
      }
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "за %s",
    past: "%s тому",
    s: "декілька секунд",
    ss: Ot,
    m: Ot,
    mm: Ot,
    h: "годину",
    hh: Ot,
    d: "день",
    dd: Ot,
    M: "місяць",
    MM: Ot,
    y: "рік",
    yy: Ot
  },
  // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
  meridiemParse: /ночі|ранку|дня|вечора/,
  isPM: function(M) {
    return /^(дня|вечора)$/.test(M);
  },
  meridiem: function(M, t, e) {
    return M < 4 ? "ночі" : M < 12 ? "ранку" : M < 17 ? "дня" : "вечора";
  },
  dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
  ordinal: function(M, t) {
    switch (t) {
      case "M":
      case "d":
      case "DDD":
      case "w":
      case "W":
        return M + "-й";
      case "D":
        return M + "-го";
      default:
        return M;
    }
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 7
    // The week that contains Jan 7th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109
R.defineLocale("zh-cn", {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
    "_"
  ),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日Ah点mm分",
    LLLL: "YYYY年M月D日ddddAh点mm分",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(M, t) {
    return M === 12 && (M = 0), t === "凌晨" || t === "早上" || t === "上午" ? M : t === "下午" || t === "晚上" ? M + 12 : M >= 11 ? M : M + 12;
  },
  meridiem: function(M, t, e) {
    var p = M * 100 + t;
    return p < 600 ? "凌晨" : p < 900 ? "早上" : p < 1130 ? "上午" : p < 1230 ? "中午" : p < 1800 ? "下午" : "晚上";
  },
  calendar: {
    sameDay: "[今天]LT",
    nextDay: "[明天]LT",
    nextWeek: function(M) {
      return M.week() !== this.week() ? "[下]dddLT" : "[本]dddLT";
    },
    lastDay: "[昨天]LT",
    lastWeek: function(M) {
      return this.week() !== M.week() ? "[上]dddLT" : "[本]dddLT";
    },
    sameElse: "L"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function(M, t) {
    switch (t) {
      case "d":
      case "D":
      case "DDD":
        return M + "日";
      case "M":
        return M + "月";
      case "w":
      case "W":
        return M + "周";
      default:
        return M;
    }
  },
  relativeTime: {
    future: "%s后",
    past: "%s前",
    s: "几秒",
    ss: "%d 秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    w: "1 周",
    ww: "%d 周",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
R.defineLocale("zh-tw", {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
    "_"
  ),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日 HH:mm",
    LLLL: "YYYY年M月D日dddd HH:mm",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(M, t) {
    if (M === 12 && (M = 0), t === "凌晨" || t === "早上" || t === "上午")
      return M;
    if (t === "中午")
      return M >= 11 ? M : M + 12;
    if (t === "下午" || t === "晚上")
      return M + 12;
  },
  meridiem: function(M, t, e) {
    var p = M * 100 + t;
    return p < 600 ? "凌晨" : p < 900 ? "早上" : p < 1130 ? "上午" : p < 1230 ? "中午" : p < 1800 ? "下午" : "晚上";
  },
  calendar: {
    sameDay: "[今天] LT",
    nextDay: "[明天] LT",
    nextWeek: "[下]dddd LT",
    lastDay: "[昨天] LT",
    lastWeek: "[上]dddd LT",
    sameElse: "L"
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
  ordinal: function(M, t) {
    switch (t) {
      case "d":
      case "D":
      case "DDD":
        return M + "日";
      case "M":
        return M + "月";
      case "w":
      case "W":
        return M + "週";
      default:
        return M;
    }
  },
  relativeTime: {
    future: "%s後",
    past: "%s前",
    s: "幾秒",
    ss: "%d 秒",
    m: "1 分鐘",
    mm: "%d 分鐘",
    h: "1 小時",
    hh: "%d 小時",
    d: "1 天",
    dd: "%d 天",
    M: "1 個月",
    MM: "%d 個月",
    y: "1 年",
    yy: "%d 年"
  }
});
//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras
var _8 = {
  ss: "sekundė_sekundžių_sekundes",
  m: "minutė_minutės_minutę",
  mm: "minutės_minučių_minutes",
  h: "valanda_valandos_valandą",
  hh: "valandos_valandų_valandas",
  d: "diena_dienos_dieną",
  dd: "dienos_dienų_dienas",
  M: "mėnuo_mėnesio_mėnesį",
  MM: "mėnesiai_mėnesių_mėnesius",
  y: "metai_metų_metus",
  yy: "metai_metų_metus"
};
function w8(M, t, e, p) {
  return t ? "kelios sekundės" : p ? "kelių sekundžių" : "kelias sekundes";
}
function Zt(M, t, e, p) {
  return t ? He(e)[0] : p ? He(e)[1] : He(e)[2];
}
function f3(M) {
  return M % 10 === 0 || M > 10 && M < 20;
}
function He(M) {
  return _8[M].split("_");
}
function Vt(M, t, e, p) {
  var c = M + " ";
  return M === 1 ? c + Zt(M, t, e[0], p) : t ? c + (f3(M) ? He(e)[1] : He(e)[0]) : p ? c + He(e)[1] : c + (f3(M) ? He(e)[1] : He(e)[2]);
}
R.defineLocale("lt", {
  months: {
    format: "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split(
      "_"
    ),
    standalone: "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split(
      "_"
    ),
    isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
  },
  monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
  weekdays: {
    format: "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split(
      "_"
    ),
    standalone: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split(
      "_"
    ),
    isFormat: /dddd HH:mm/
  },
  weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
  weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
  weekdaysParseExact: !0,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "YYYY [m.] MMMM D [d.]",
    LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
    LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
    l: "YYYY-MM-DD",
    ll: "YYYY [m.] MMMM D [d.]",
    lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
    llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
  },
  calendar: {
    sameDay: "[Šiandien] LT",
    nextDay: "[Rytoj] LT",
    nextWeek: "dddd LT",
    lastDay: "[Vakar] LT",
    lastWeek: "[Praėjusį] dddd LT",
    sameElse: "L"
  },
  relativeTime: {
    future: "po %s",
    past: "prieš %s",
    s: w8,
    ss: Vt,
    m: Zt,
    mm: Vt,
    h: Zt,
    hh: Vt,
    d: Zt,
    dd: Vt,
    M: Zt,
    MM: Vt,
    y: Zt,
    yy: Vt
  },
  dayOfMonthOrdinalParse: /\d{1,2}-oji/,
  ordinal: function(M) {
    return M + "-oji";
  },
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4
    // The week that contains Jan 4th is the first week of the year.
  }
});
class X8 {
  constructor(t, e) {
    /**
     * cache tokens
     */
    o(this, "tokens", null);
    /**
     * original setTokens implementation
     */
    o(this, "setTokensImpl");
    this.storage = t, this.sdk = e, this.setTokensImpl = t.setTokens, t.setTokens = this.setTokens;
  }
  get hasTokens() {
    return this.tokens != null;
  }
  async init() {
    await this.getTokens();
  }
  async getTokens() {
    if (this.tokens) return this.tokens;
    const t = await this.storage.getTokens();
    return t && (this.tokens = t), this.tokens;
  }
  async setTokens(t, e = !0) {
    this.tokens = t, await this.setTokensImpl.bind(this.storage)(t), this.sdk.dispatcher.emit("auth.token.changed", t), e && await this.waitForUserChangeOnce();
  }
  waitForUserChangeOnce(t) {
    return new Promise((e, p) => {
      const c = setTimeout(() => {
        p(new Error("User loading timeout"));
      }, t || 1e4);
      this.sdk.dispatcher.once("auth.user.changed", () => {
        clearTimeout(c), e();
      });
    });
  }
}
class V8 {
  constructor(t, e) {
    o(this, "inited", !1);
    o(this, "school");
    o(this, "dispatcher");
    o(this, "tokenStorage");
    o(this, "api");
    o(this, "auth");
    o(this, "account");
    o(this, "content");
    o(this, "hub");
    o(this, "chat");
    o(this, "partnership");
    o(this, "community");
    o(this, "forum");
    o(this, "gamification");
    o(this, "announcement");
    // public notification: NotificationModule;
    o(this, "localization");
    /**
     * Education module contains logic for previewing courses
     */
    o(this, "education");
    this.config = e, this.dispatcher = new j6(), this.tokenStorage = new X8(t, this), this.hub = new y8("client" in e.hub ? e.hub.client : new Ba(e.hub.clientConfig, this)), this.api = new WR(e.apiClient || new m8({
      apiUrl: this.config.schoolDomain + "/api",
      tokenStorage: this.tokenStorage,
      getConnectionId: () => this.hub.connectionId
    })), this.auth = new hR(this), this.account = new NR(this), this.content = {
      courses: new fO(this, { sectionType: "course" }),
      libraries: new fO(this, { sectionType: "library" })
    }, this.chat = new gL(this), this.partnership = new XR(this), this.community = new PR(this), this.forum = new BL(this), this.gamification = new wL(this), this.announcement = new XL(this), this.education = new PL(this), this.localization = new EL(this), this.setupMoment(this.config.lang);
  }
  async init() {
    this.dispatcher.on("auth.logout", this.reset.bind(this)), await this.tokenStorage.init();
    const t = await this.api.school.fetch(this.config.schoolDomain);
    if (!t.success)
      throw new Error("Failed to fetch school settings");
    this.school = t.body, await this.tryAuthorize(), this.inited = !0, this.dispatcher.emit("sdk.inited", { school: this.school });
  }
  async tryAuthorize() {
    return this.tokenStorage.tokens ? (await this.account.fetchUser()).success : !1;
  }
  setupMoment(t) {
    switch (t) {
      case mp.zhtw:
        R.locale("zh-tw");
        break;
      case mp.zhcn:
        R.locale("zh-cn");
        break;
      default:
        R.locale(t);
        break;
    }
  }
  async reset() {
    this.community.reset();
  }
}
export {
  D1 as AccelFile,
  NR as AccountModule,
  ut as Admin,
  wh as AdminPartnerStatus,
  _h as AdminType,
  Gc as Announcement,
  XL as AnnouncementModule,
  WR as Api,
  eb as Application,
  hR as AuthModule,
  om as BonusTransactionDurationType,
  cm as BonusTransactionValidityType,
  z2 as CRUDListStore,
  gL as ChatModule,
  Vc as Community,
  On as CommunityBadge,
  H8 as CommunityBadgeFilter,
  ee as CommunityMember,
  an as CommunityMemberBadge,
  sm as CommunityMemberFilter,
  sn as CommunityMemberReport,
  dm as CommunityMemberReportFilter,
  kR as CommunityMemberReportStore,
  SR as CommunityMemberStore,
  PR as CommunityModule,
  Lt as CommunityPost,
  pb as CommunityPostAttachment,
  ft as CommunityPostComment,
  qO as CommunityPostCommentFilter,
  IR as CommunityPostCommentStore,
  Am as CommunityPostFilter,
  CR as CommunityPostStore,
  zM as CommunitySpaceItem,
  am as CommunitySpaceItemFilter,
  DR as CommunitySpaceItemStore,
  tb as ContactLicense,
  bn as ContactLicenseFilter,
  be as Course,
  me as CourseItem,
  dp as CourseItemAvailability,
  Ch as CourseItemCommentState,
  Sh as CourseItemLayoutType,
  Jp as CourseItemTaskAnswer,
  sb as CourseItemTaskAnswerComment,
  Vh as CourseItemTaskAnswerCommentFilter,
  Wc as CourseItemTaskAnswerStatus,
  Up as CourseItemTaskField,
  fc as CourseItemTaskFieldType,
  L1 as CourseItemType,
  IL as CourseOverviewStore,
  OM as CoursePlan,
  Xh as CoursePlanFilter,
  ab as Disposable,
  eh as DisposableStack,
  PL as EducationModule,
  M0 as Entity,
  yp as EventCalendarEvent,
  bm as EventCalendarEventFilter,
  j6 as EventDispatcher,
  fR as FileApi,
  V2 as FileSize,
  qm as FileSource,
  ma as FileType,
  I0 as Filter,
  Je as FlowTimeDelayCondition,
  fa as ForumBan,
  x8 as ForumBanFilter,
  BL as ForumModule,
  mt as ForumReaction,
  lt as ForumThread,
  F8 as ForumThreadFilter,
  Ab as ForumTopic,
  U8 as ForumTopicFilter,
  Yp as Gamification,
  qt as GamificationAchievement,
  em as GamificationAchievementFilter,
  pn as GamificationContactAchievement,
  gp as GamificationLeader,
  zn as GamificationLeaderAchievement,
  la as GamificationLeaderFilter,
  wL as GamificationModule,
  Mb as GamificationProduct,
  P8 as GamificationProductFilter,
  GM as GamificationTransaction,
  tm as GamificationTransactionDurationType,
  E8 as GamificationTransactionFilter,
  Mm as GamificationTransactionValidityType,
  th as HoursPer,
  Ba as HubClient,
  N0 as HubConnectionState,
  O1 as HubSubscriber,
  mp as Lang,
  Qc as LibraryItemProgress,
  Mn as LicenseSuspension,
  Ob as ListStore,
  EL as LocalizationModule,
  Tm as MemberApi,
  ph as MillisecondsPer,
  Mh as MinutesPer,
  _m as OfferApi,
  sO as PORTAL_COMMUNITY_WIDGETS,
  lh as PORTAL_DEFAULT_FONT,
  qh as PORTAL_TEXT_KEYS,
  $p as PartnershipMember,
  rm as PartnershipMemberFilter,
  XR as PartnershipModule,
  nn as PartnershipOffer,
  im as PartnershipOfferFilter,
  wm as PartnershipOrderApi,
  Y8 as PartnershipTotalsFilter,
  bb as PartnershipTransaction,
  zm as PartnershipTransactionFilter,
  rn as PartnershipTransactionRequest,
  Om as PartnershipTransactionRequestFilter,
  wR as PartnershipTransactionStore,
  AM as Product,
  jh as ProductType,
  sM as PurchaseOrder,
  tn as PurchaseOrderContent,
  Zh as PurchaseOrderFilter,
  Qh as PurchaseOrderStatus,
  Ue as RegularTimeDelayCondition,
  V8 as SDK,
  jM as School,
  Lp as SchoolApplication,
  YM as SchoolContentItem,
  B2 as SchoolContentItemComment,
  Dh as SchoolContentItemCommentFilter,
  Kh as SchoolContentItemFilter,
  xp as SchoolContentItemProgressRating,
  fO as SchoolContentModule,
  mR as SchoolContentStore,
  en as SchoolCourse,
  Pp as SchoolMigration,
  uh as SchoolMigrationStatus,
  hc as SchoolProfileSettings,
  mc as SchoolSettings,
  bh as SecondsPer,
  l1 as Student,
  tM as StudentBonusTransaction,
  nm as StudentBonusTransactionFilter,
  aM as StudentCourse,
  Le as StudentCourseItem,
  ua as StudentCourseItemBaseProgress,
  qa as StudentCourseItemFilter,
  Fp as StudentCourseItemProgress,
  Hp as StudentCourseItemTask,
  Rp as StudentCourseItemTaskAnswerField,
  k8 as StudentCourseItemTaskAnswerFieldFilter,
  Zc as StudentCourseItemTest,
  p2 as StudentCourseProgress,
  Ih as StudentCourseSectionProgress,
  Ne as StudentLibrary,
  I8 as StudentLibraryFilter,
  Z2 as StudentLibraryItem,
  JM as StudentLibraryItemType,
  Yc as StudentSession,
  zh as TicksPer,
  oh as TimeUnit,
  ch as TimeUnitUtils,
  dt as Timezone,
  X8 as TokenStorageProxy,
  Rt as TopicComment,
  Wa as TopicCommentFilter,
  vm as TransactionApi,
  Xm as TransactionRequestApi,
  H1 as Updatable,
  Gp as UserNotification,
  on as UserNotificationChannel,
  J8 as UserNotificationChannelFilter,
  pm as UserNotificationFilter,
  cn as UserNotificationSettings,
  K1 as UserNotificationType,
  Sm as UtmTagApi,
  aa as cleanOptionalObject,
  Oh as fromOptional,
  u1 as isEmpty,
  Th as parsePortalDesign,
  v2 as toOptional,
  rh as toOptionalObject
};
//# sourceMappingURL=index.es.js.map
